// @generated
// This file was automatically generated and should not be edited.

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSONScalar: { input: JSONScalar; output: JSONScalar; }
  ScalarEnumOption: { input: ScalarEnumOption; output: ScalarEnumOption; }
  StrictBoolean: { input: StrictBoolean; output: StrictBoolean; }
  StrictDecimal: { input: StrictDecimal; output: StrictDecimal; }
  StrictFloat: { input: StrictFloat; output: StrictFloat; }
  StrictInt: { input: StrictInt; output: StrictInt; }
  StrictString: { input: StrictString; output: StrictString; }
}

export interface AASequencePolymerNode extends SimplePolymerInterface {
  __typename: 'AASequencePolymerNode';
  entity: BiomoleculeEntityOrInaccessibleInfoNode;
  helmReference: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  polymerType: HELMPolymerType;
  residues: Scalars['StrictString']['output'];
}

export interface APIKeyNode {
  __typename: 'APIKeyNode';
  createdAt: Scalars['StrictString']['output'];
  key: Scalars['StrictString']['output'];
}

export interface ActionInvocationParameterNode {
  __typename: 'ActionInvocationParameterNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  isRequired: Scalars['StrictBoolean']['output'];
  isSnapshot: Scalars['StrictBoolean']['output'];
  linkedSchemaId: Maybe<Scalars['StrictString']['output']>;
  name: Scalars['StrictString']['output'];
  parameterTypeName: Scalars['StrictString']['output'];
  schemaFieldId: Maybe<Scalars['StrictString']['output']>;
  schemaFieldSelectorId: Maybe<Scalars['StrictString']['output']>;
}

export enum ActionMethod {
  ADD_FROM_RECENT = 'ADD_FROM_RECENT',
  ADD_FROM_SEARCH = 'ADD_FROM_SEARCH',
  ADD_FROM_WORKLIST = 'ADD_FROM_WORKLIST',
  ARCHIVE_ROWS_ACTION_FUNCTION = 'ARCHIVE_ROWS_ACTION_FUNCTION',
  AT_CREATION_FLOWCHART_MODIFICATION = 'AT_CREATION_FLOWCHART_MODIFICATION',
  BANNER_ACTION_CLICK = 'BANNER_ACTION_CLICK',
  BULK_ACTION = 'BULK_ACTION',
  BULK_REMOVAL_INTERFACE_ARCHIVED = 'BULK_REMOVAL_INTERFACE_ARCHIVED',
  BUTTON_CLICK = 'BUTTON_CLICK',
  CLONE_FROM_VERSION = 'CLONE_FROM_VERSION',
  CREATE_AND_REGISTER = 'CREATE_AND_REGISTER',
  CREATE_BUTTON = 'CREATE_BUTTON',
  CREATE_ENTRY = 'CREATE_ENTRY',
  CREATE_FORM_DEFINITION = 'CREATE_FORM_DEFINITION',
  CREATE_MODAL = 'CREATE_MODAL',
  DIRECT_EDIT = 'DIRECT_EDIT',
  DUPLICATE_RUN_SCHEMA_BUTTON = 'DUPLICATE_RUN_SCHEMA_BUTTON',
  GENERATE_AND_SEND_TO_OUTPUT_FILE = 'GENERATE_AND_SEND_TO_OUTPUT_FILE',
  IMPORT_TRANSFER_DATA = 'IMPORT_TRANSFER_DATA',
  INTERNAL_ADMIN_SCRIPT = 'INTERNAL_ADMIN_SCRIPT',
  INVENTORY_SHORTCUTS_ACTION_FUNCTION = 'INVENTORY_SHORTCUTS_ACTION_FUNCTION',
  IN_LINE_EDIT = 'IN_LINE_EDIT',
  ITEM_RIGHT_CLICK = 'ITEM_RIGHT_CLICK',
  LEGACY_TABLE_SUBMISSION = 'LEGACY_TABLE_SUBMISSION',
  MANUAL_TABLE_SELECT = 'MANUAL_TABLE_SELECT',
  NOTEBOOK_INSERT_MENU = 'NOTEBOOK_INSERT_MENU',
  ONBOARDING_WIZARD = 'ONBOARDING_WIZARD',
  OTHER = 'OTHER',
  PIPELINES_SET_AUTOMATICALLY = 'PIPELINES_SET_AUTOMATICALLY',
  PIPELINES_SET_BY_USER = 'PIPELINES_SET_BY_USER',
  POST_CREATION_FLOWCHART_MODIFICATION = 'POST_CREATION_FLOWCHART_MODIFICATION',
  PRINT_BARCODES_ACTION_FUNCTION = 'PRINT_BARCODES_ACTION_FUNCTION',
  PRINT_MIXTURE_GROUP_BARCODE_ACTION_FUNCTION = 'PRINT_MIXTURE_GROUP_BARCODE_ACTION_FUNCTION',
  PROCESS_TASK_UNDO_EXECUTION_FUNCTION = 'PROCESS_TASK_UNDO_EXECUTION_FUNCTION',
  REGISTER_EXISTING_MODAL = 'REGISTER_EXISTING_MODAL',
  RENAME_VERSION = 'RENAME_VERSION',
  RESET_TO_VERSION = 'RESET_TO_VERSION',
  REVERT_NOTE = 'REVERT_NOTE',
  ROUTER_EVALUATION = 'ROUTER_EVALUATION',
  SAMPLE_TESTS_DISCREPANCY_TASK_CALLBACKS = 'SAMPLE_TESTS_DISCREPANCY_TASK_CALLBACKS',
  SANITIZE_NOTE = 'SANITIZE_NOTE',
  SCAN_TO_MOVE = 'SCAN_TO_MOVE',
  SEND_TO_DOCUMENT_STEP = 'SEND_TO_DOCUMENT_STEP',
  SETTINGS_EDIT = 'SETTINGS_EDIT',
  SET_FROM_MATRIX_SCANNER = 'SET_FROM_MATRIX_SCANNER',
  SINGLE_ACTION = 'SINGLE_ACTION',
  SINGLE_REMOVAL = 'SINGLE_REMOVAL',
  SPREADSHEET_IMPORT = 'SPREADSHEET_IMPORT',
  STAMP_PLATE = 'STAMP_PLATE',
  STRUCTURED_TABLE_AXIS_DRAG_HANDLE = 'STRUCTURED_TABLE_AXIS_DRAG_HANDLE',
  STRUCTURED_TABLE_COLUMN_MENU = 'STRUCTURED_TABLE_COLUMN_MENU',
  STRUCTURED_TABLE_FORM_SUBMISSION = 'STRUCTURED_TABLE_FORM_SUBMISSION',
  STRUCTURED_TABLE_MAPPING_CONFIG_SUBMIT = 'STRUCTURED_TABLE_MAPPING_CONFIG_SUBMIT',
  STRUCTURED_TABLE_SUBMISSION = 'STRUCTURED_TABLE_SUBMISSION',
  TEMPLATE_FLOWCHART_MODIFICATION = 'TEMPLATE_FLOWCHART_MODIFICATION',
  UNARCHIVE_ROWS_ACTION_FUNCTION = 'UNARCHIVE_ROWS_ACTION_FUNCTION',
  UNDO_BUTTON = 'UNDO_BUTTON',
  UPDATE_FORM_DEFINITION = 'UPDATE_FORM_DEFINITION',
  UPLOAD = 'UPLOAD',
  UPSERT_AND_REGISTER = 'UPSERT_AND_REGISTER'
}

export interface ActionOptionGroupNode {
  __typename: 'ActionOptionGroupNode';
  actionOptions: Array<ActionOptionNode>;
  description: Maybe<Scalars['StrictString']['output']>;
  name: Scalars['StrictString']['output'];
}

export type ActionOptionGroupOrActionOptionNode = ActionOptionGroupNode | ActionOptionNode;

export interface ActionOptionNode {
  __typename: 'ActionOptionNode';
  action: PolicyAction;
  conditionOptions: Array<ConditionOptionNode>;
  description: Maybe<Scalars['StrictString']['output']>;
  disabled: Scalars['StrictBoolean']['output'];
  itemTypeOverride: Maybe<PolicyItemType>;
  name: Scalars['StrictString']['output'];
}

export enum ActionOrigin {
  ANALYSIS_TOOL = 'ANALYSIS_TOOL',
  ANALYSIS_TOOL_ANALYSIS_PAGE_DATA_FRAME_SIDEPANEL = 'ANALYSIS_TOOL_ANALYSIS_PAGE_DATA_FRAME_SIDEPANEL',
  ANALYSIS_TOOL_CHOOSE_DATA_FRAME_CREATION_VIEW = 'ANALYSIS_TOOL_CHOOSE_DATA_FRAME_CREATION_VIEW',
  ANALYSIS_TOOL_DATA_MAPPER_TOOL = 'ANALYSIS_TOOL_DATA_MAPPER_TOOL',
  ANALYSIS_TOOL_EMPTY_ANALYSIS_PAGE = 'ANALYSIS_TOOL_EMPTY_ANALYSIS_PAGE',
  ANALYSIS_TOOL_SAVE_TO_RESULTS_CONFIGURATION_VIEW = 'ANALYSIS_TOOL_SAVE_TO_RESULTS_CONFIGURATION_VIEW',
  API = 'API',
  API_V3_REST = 'API_V3_REST',
  CHEMISTRY_ITEM_PAGE_CHEMICAL_STRUCTURE_TAB = 'CHEMISTRY_ITEM_PAGE_CHEMICAL_STRUCTURE_TAB',
  COLLABORATION_MANAGEMENT_MODAL = 'COLLABORATION_MANAGEMENT_MODAL',
  CONFIG_MIGRATION = 'CONFIG_MIGRATION',
  CONFIG_MIGRATION_EXPORT_TAB = 'CONFIG_MIGRATION_EXPORT_TAB',
  CONFIG_MIGRATION_IMPORT_TAB = 'CONFIG_MIGRATION_IMPORT_TAB',
  CONFIG_MIGRATION_MANAGEMENT_HISTORY_TABLE = 'CONFIG_MIGRATION_MANAGEMENT_HISTORY_TABLE',
  CONNECTIONS_SIDEPANEL = 'CONNECTIONS_SIDEPANEL',
  CONNECTION_PAGE = 'CONNECTION_PAGE',
  CREATE_CONNECTIONS_MODAL = 'CREATE_CONNECTIONS_MODAL',
  DATASET_PAGE = 'DATASET_PAGE',
  ENTITY_PAGE_METADATA_TAB_SCHEMA_TABLE = 'ENTITY_PAGE_METADATA_TAB_SCHEMA_TABLE',
  FORMS_CREATE_FORM_DEFINITION_DESIGNER = 'FORMS_CREATE_FORM_DEFINITION_DESIGNER',
  FORMS_EDIT_FORM_DEFINITION_DESIGNER = 'FORMS_EDIT_FORM_DEFINITION_DESIGNER',
  INSIGHTS = 'INSIGHTS',
  INSIGHTS_EXPANDED_SEARCH_TOOLBAR = 'INSIGHTS_EXPANDED_SEARCH_TOOLBAR',
  INSIGHTS_SIDEPANEL = 'INSIGHTS_SIDEPANEL',
  INTERNAL_ADMIN_PAGE = 'INTERNAL_ADMIN_PAGE',
  INTERNAL_ADMIN_TOOLS_UPDATE_POLICIES_PAGE = 'INTERNAL_ADMIN_TOOLS_UPDATE_POLICIES_PAGE',
  INTERNAL_CONVERSION_TOOL = 'INTERNAL_CONVERSION_TOOL',
  INVENTORY_BOX_PAGE = 'INVENTORY_BOX_PAGE',
  INVENTORY_BOX_PAGE_GRID_CELL_TABLE = 'INVENTORY_BOX_PAGE_GRID_CELL_TABLE',
  INVENTORY_BOX_PAGE_GRID_CELL_TOOLBAR = 'INVENTORY_BOX_PAGE_GRID_CELL_TOOLBAR',
  INVENTORY_BOX_PAGE_TOOLBAR = 'INVENTORY_BOX_PAGE_TOOLBAR',
  INVENTORY_CONTAINER_PAGE = 'INVENTORY_CONTAINER_PAGE',
  INVENTORY_CONTAINER_PAGE_TOOLBAR = 'INVENTORY_CONTAINER_PAGE_TOOLBAR',
  INVENTORY_EXPANDED_SEARCH_TABLE = 'INVENTORY_EXPANDED_SEARCH_TABLE',
  INVENTORY_EXPANDED_SEARCH_TOOLBAR = 'INVENTORY_EXPANDED_SEARCH_TOOLBAR',
  INVENTORY_LOCATION_PAGE = 'INVENTORY_LOCATION_PAGE',
  INVENTORY_PLATE_PAGE = 'INVENTORY_PLATE_PAGE',
  INVENTORY_PLATE_PAGE_GRID_CELL_TABLE = 'INVENTORY_PLATE_PAGE_GRID_CELL_TABLE',
  INVENTORY_PLATE_PAGE_GRID_CELL_TOOLBAR = 'INVENTORY_PLATE_PAGE_GRID_CELL_TOOLBAR',
  INVENTORY_PLATE_PAGE_TOOLBAR = 'INVENTORY_PLATE_PAGE_TOOLBAR',
  INVENTORY_REGISTRY_SEARCH_UI = 'INVENTORY_REGISTRY_SEARCH_UI',
  INVENTORY_SIDEPANEL_CREATE = 'INVENTORY_SIDEPANEL_CREATE',
  INVENTORY_SIDEPANEL_HEADER = 'INVENTORY_SIDEPANEL_HEADER',
  INVENTORY_SIDEPANEL_ITEM = 'INVENTORY_SIDEPANEL_ITEM',
  JELLYFISH_SIDEPANEL = 'JELLYFISH_SIDEPANEL',
  LIBRARY_SIDEPANEL = 'LIBRARY_SIDEPANEL',
  MACHINE_LEARNING = 'MACHINE_LEARNING',
  MODBIO_COMPLEX_POLYMERS = 'MODBIO_COMPLEX_POLYMERS',
  MODBIO_MOD_PATTERNS = 'MODBIO_MOD_PATTERNS',
  MODBIO_MONOMER_LIBRARY_PAGE = 'MODBIO_MONOMER_LIBRARY_PAGE',
  MODBIO_NUCLEOTIDES_TAB = 'MODBIO_NUCLEOTIDES_TAB',
  MOLBIO = 'MOLBIO',
  MOLBIO_ASSEMBLY_WIZARD_MODAL = 'MOLBIO_ASSEMBLY_WIZARD_MODAL',
  MOLBIO_BIOINTELLIGENT_LINK_COMPONENT_REPLACE = 'MOLBIO_BIOINTELLIGENT_LINK_COMPONENT_REPLACE',
  MOLBIO_BULK_ASSEMBLY = 'MOLBIO_BULK_ASSEMBLY',
  MOLBIO_BULK_ASSEMBLY_BETA_BANNER = 'MOLBIO_BULK_ASSEMBLY_BETA_BANNER',
  MOLBIO_BULK_ASSEMBLY_BIN_LAYOUT = 'MOLBIO_BULK_ASSEMBLY_BIN_LAYOUT',
  MOLBIO_BULK_ASSEMBLY_CONSTRUCTS_TABLE = 'MOLBIO_BULK_ASSEMBLY_CONSTRUCTS_TABLE',
  MOLBIO_BULK_ASSEMBLY_CONSTRUCT_MODAL = 'MOLBIO_BULK_ASSEMBLY_CONSTRUCT_MODAL',
  MOLBIO_BULK_ASSEMBLY_FINALIZATION_MODAL = 'MOLBIO_BULK_ASSEMBLY_FINALIZATION_MODAL',
  MOLBIO_BULK_ASSEMBLY_FRAGMENTS_TABLE = 'MOLBIO_BULK_ASSEMBLY_FRAGMENTS_TABLE',
  MOLBIO_BULK_ASSEMBLY_FRAGMENT_MODAL = 'MOLBIO_BULK_ASSEMBLY_FRAGMENT_MODAL',
  MOLBIO_BULK_ASSEMBLY_OVERVIEW_TAB = 'MOLBIO_BULK_ASSEMBLY_OVERVIEW_TAB',
  MOLBIO_BULK_ASSEMBLY_SETTINGS_MODAL = 'MOLBIO_BULK_ASSEMBLY_SETTINGS_MODAL',
  NOTEBOOK = 'NOTEBOOK',
  NOTEBOOK_ENTRY_BOX_CREATION_TABLE = 'NOTEBOOK_ENTRY_BOX_CREATION_TABLE',
  NOTEBOOK_ENTRY_CONTAINER_CREATION_TABLE = 'NOTEBOOK_ENTRY_CONTAINER_CREATION_TABLE',
  NOTEBOOK_ENTRY_FILL_EXISTING_TABLE = 'NOTEBOOK_ENTRY_FILL_EXISTING_TABLE',
  NOTEBOOK_ENTRY_INVENTORY_UPDATE_TABLE = 'NOTEBOOK_ENTRY_INVENTORY_UPDATE_TABLE',
  NOTEBOOK_ENTRY_LEGACY_REGISTRATION_TABLE = 'NOTEBOOK_ENTRY_LEGACY_REGISTRATION_TABLE',
  NOTEBOOK_ENTRY_LEGACY_RESULTS_TABLE = 'NOTEBOOK_ENTRY_LEGACY_RESULTS_TABLE',
  NOTEBOOK_ENTRY_LEGACY_RUN = 'NOTEBOOK_ENTRY_LEGACY_RUN',
  NOTEBOOK_ENTRY_LEGACY_STAGE_ENTRY_TRANSFER_TABLE = 'NOTEBOOK_ENTRY_LEGACY_STAGE_ENTRY_TRANSFER_TABLE',
  NOTEBOOK_ENTRY_LEGACY_TRANSFER_TABLE = 'NOTEBOOK_ENTRY_LEGACY_TRANSFER_TABLE',
  NOTEBOOK_ENTRY_LOOKUP_TABLE = 'NOTEBOOK_ENTRY_LOOKUP_TABLE',
  NOTEBOOK_ENTRY_MIXTURE_PREP_TABLE = 'NOTEBOOK_ENTRY_MIXTURE_PREP_TABLE',
  NOTEBOOK_ENTRY_PLATE_CREATION_TABLE = 'NOTEBOOK_ENTRY_PLATE_CREATION_TABLE',
  NOTEBOOK_ENTRY_REGISTRATION_TABLE = 'NOTEBOOK_ENTRY_REGISTRATION_TABLE',
  NOTEBOOK_ENTRY_RESULTS_TABLE = 'NOTEBOOK_ENTRY_RESULTS_TABLE',
  NOTEBOOK_ENTRY_RUN = 'NOTEBOOK_ENTRY_RUN',
  NOTEBOOK_ENTRY_RUN_OUTPUT_SAMPLES_TABLE = 'NOTEBOOK_ENTRY_RUN_OUTPUT_SAMPLES_TABLE',
  NOTEBOOK_ENTRY_WORKFLOW_OUTPUT_TABLE = 'NOTEBOOK_ENTRY_WORKFLOW_OUTPUT_TABLE',
  NOTEBOOK_ENTRY_WORKFLOW_TASK_TABLE = 'NOTEBOOK_ENTRY_WORKFLOW_TASK_TABLE',
  NOTEBOOK_PLAIN_TABLE = 'NOTEBOOK_PLAIN_TABLE',
  NOTEBOOK_TEMPLATE_COLLECTION_PAGE = 'NOTEBOOK_TEMPLATE_COLLECTION_PAGE',
  NOTEBOOK_UNDETERMINED_STRUCTURED_TABLE = 'NOTEBOOK_UNDETERMINED_STRUCTURED_TABLE',
  PROCEDURE_DESIGNER = 'PROCEDURE_DESIGNER',
  PROCEDURE_DESIGNER_DETAILS = 'PROCEDURE_DESIGNER_DETAILS',
  PROCEDURE_DESIGNER_FLOWCHART = 'PROCEDURE_DESIGNER_FLOWCHART',
  PROCEDURE_EXPERIMENT_DESIGNER = 'PROCEDURE_EXPERIMENT_DESIGNER',
  PROJECTS_SIDEPANEL = 'PROJECTS_SIDEPANEL',
  REGISTRY_EXPANDED_SEARCH = 'REGISTRY_EXPANDED_SEARCH',
  REGISTRY_EXPANDED_SEARCH_TOOLBAR = 'REGISTRY_EXPANDED_SEARCH_TOOLBAR',
  REGISTRY_ITEM_PAGE_CHILD_ENTITY_TAB = 'REGISTRY_ITEM_PAGE_CHILD_ENTITY_TAB',
  REGISTRY_ITEM_PAGE_HISTORY_PANEL = 'REGISTRY_ITEM_PAGE_HISTORY_PANEL',
  REGISTRY_ITEM_PAGE_STORAGE_TAB = 'REGISTRY_ITEM_PAGE_STORAGE_TAB',
  REGISTRY_ITEM_PAGE_TOOLBAR = 'REGISTRY_ITEM_PAGE_TOOLBAR',
  REGISTRY_SIDEPANEL_CREATE = 'REGISTRY_SIDEPANEL_CREATE',
  REQUEST_V2_DEFINITION_CONFIG_PAGE = 'REQUEST_V2_DEFINITION_CONFIG_PAGE',
  REQUEST_V2_SIDEPANEL = 'REQUEST_V2_SIDEPANEL',
  REQUEST_V2_SUBMISSION = 'REQUEST_V2_SUBMISSION',
  RUN_PAGE = 'RUN_PAGE',
  RUN_PAGE_TOOLBAR = 'RUN_PAGE_TOOLBAR',
  SAMPLE_TESTS_BULK_UPDATE_TEST_ORDER_CONTAINER_MODAL = 'SAMPLE_TESTS_BULK_UPDATE_TEST_ORDER_CONTAINER_MODAL',
  SAMPLE_TESTS_BULK_UPDATE_TEST_ORDER_STATUS_MODAL = 'SAMPLE_TESTS_BULK_UPDATE_TEST_ORDER_STATUS_MODAL',
  SAMPLE_TESTS_CREATE_TEST_ORDERS_BUTTON = 'SAMPLE_TESTS_CREATE_TEST_ORDERS_BUTTON',
  SAMPLE_TESTS_TEST_DEFINITIONS_PAGE = 'SAMPLE_TESTS_TEST_DEFINITIONS_PAGE',
  SEARCH_EXPANDED_SEARCH_TABLE = 'SEARCH_EXPANDED_SEARCH_TABLE',
  SEARCH_EXPANDED_SEARCH_TOOLBAR = 'SEARCH_EXPANDED_SEARCH_TOOLBAR',
  SEARCH_SIDEPANEL = 'SEARCH_SIDEPANEL',
  SETTINGS_ASSAY_SCHEMA_PAGE_JSON = 'SETTINGS_ASSAY_SCHEMA_PAGE_JSON',
  SETTINGS_ASSAY_SCHEMA_PAGE_UI = 'SETTINGS_ASSAY_SCHEMA_PAGE_UI',
  SETTINGS_BOX_SCHEMA_PAGE = 'SETTINGS_BOX_SCHEMA_PAGE',
  SETTINGS_CONNECTION_SCHEMA_PAGE = 'SETTINGS_CONNECTION_SCHEMA_PAGE',
  SETTINGS_CONTAINER_SCHEMA_PAGE = 'SETTINGS_CONTAINER_SCHEMA_PAGE',
  SETTINGS_ENTITY_SCHEMA_PAGE = 'SETTINGS_ENTITY_SCHEMA_PAGE',
  SETTINGS_GENERAL_ACCESS_POLICIES_TABLE = 'SETTINGS_GENERAL_ACCESS_POLICIES_TABLE',
  SETTINGS_GENERAL_ACCESS_POLICY_PAGE = 'SETTINGS_GENERAL_ACCESS_POLICY_PAGE',
  SETTINGS_INSTRUMENT_GATEWAYS_PAGE = 'SETTINGS_INSTRUMENT_GATEWAYS_PAGE',
  SETTINGS_LOCATION_SCHEMA_PAGE = 'SETTINGS_LOCATION_SCHEMA_PAGE',
  SETTINGS_PLATE_SCHEMA_PAGE = 'SETTINGS_PLATE_SCHEMA_PAGE',
  SETTINGS_PROJECT_MODAL = 'SETTINGS_PROJECT_MODAL',
  SETTINGS_REQUEST_TASK_SCHEMA_PAGE = 'SETTINGS_REQUEST_TASK_SCHEMA_PAGE',
  SETTINGS_SCHEMA_INTERFACES_TABLE = 'SETTINGS_SCHEMA_INTERFACES_TABLE',
  SETTINGS_SCHEMA_INTERFACE_PAGE = 'SETTINGS_SCHEMA_INTERFACE_PAGE',
  SETTINGS_STUDY_SCHEMA_PAGE = 'SETTINGS_STUDY_SCHEMA_PAGE',
  SETTINGS_TASK_SCHEMA_PAGE = 'SETTINGS_TASK_SCHEMA_PAGE',
  SETTINGS_TASK_SCHEMA_PAGE_FLOWCHART_CONFIGURATION = 'SETTINGS_TASK_SCHEMA_PAGE_FLOWCHART_CONFIGURATION',
  SIDEPANEL_FOLDER_CREATE = 'SIDEPANEL_FOLDER_CREATE',
  SIDEPANEL_GLOBAL_CREATE = 'SIDEPANEL_GLOBAL_CREATE',
  SIDEPANEL_HOME_PROCESS_TASK_SUMMARY = 'SIDEPANEL_HOME_PROCESS_TASK_SUMMARY',
  SIDEPANEL_HOME_WORKLISTS = 'SIDEPANEL_HOME_WORKLISTS',
  SIDEPANEL_UNDETERMINED = 'SIDEPANEL_UNDETERMINED',
  STUDIES_SIDEPANEL = 'STUDIES_SIDEPANEL',
  STUDY_CREATION_MODAL = 'STUDY_CREATION_MODAL',
  STUDY_DESIGN_PAGE = 'STUDY_DESIGN_PAGE',
  STUDY_ITEMS_PAGE = 'STUDY_ITEMS_PAGE',
  STUDY_OVERVIEW_PAGE = 'STUDY_OVERVIEW_PAGE',
  STUDY_RUN_DETAILS_PAGE = 'STUDY_RUN_DETAILS_PAGE',
  SUCCESS_MESSAGE_POP = 'SUCCESS_MESSAGE_POP',
  TENANT_COMPARISON_PAGE = 'TENANT_COMPARISON_PAGE',
  UI_UNDETERMINED = 'UI_UNDETERMINED',
  UNIT_DICTIONARY_PAGE = 'UNIT_DICTIONARY_PAGE',
  WORKFLOWS_AUTOMATIC_TRIGGER = 'WORKFLOWS_AUTOMATIC_TRIGGER',
  WORKFLOWS_DASHBOARD = 'WORKFLOWS_DASHBOARD',
  WORKFLOWS_DIRECT_EXECUTION_MODAL_WORKFLOW_OUTPUT_TABLE = 'WORKFLOWS_DIRECT_EXECUTION_MODAL_WORKFLOW_OUTPUT_TABLE',
  WORKFLOWS_DIRECT_EXECUTION_MODAL_WORKFLOW_TASK_TABLE = 'WORKFLOWS_DIRECT_EXECUTION_MODAL_WORKFLOW_TASK_TABLE',
  WORKFLOWS_EXPANDED_SEARCH = 'WORKFLOWS_EXPANDED_SEARCH',
  WORKFLOWS_EXPANDED_SEARCH_TOOLBAR = 'WORKFLOWS_EXPANDED_SEARCH_TOOLBAR',
  WORKFLOWS_GRAPH_BUILDER_CANVAS = 'WORKFLOWS_GRAPH_BUILDER_CANVAS',
  WORKFLOWS_ROUTER_NODE_CONFIGURATION_MODAL = 'WORKFLOWS_ROUTER_NODE_CONFIGURATION_MODAL',
  WORKFLOWS_SIDEPANEL_CREATE = 'WORKFLOWS_SIDEPANEL_CREATE',
  WORKFLOWS_SINGLETON_SCHEMA_CREATION = 'WORKFLOWS_SINGLETON_SCHEMA_CREATION',
  WORKFLOWS_TASK_CREATION_MODAL = 'WORKFLOWS_TASK_CREATION_MODAL',
  WORKFLOWS_TASK_CREATION_MODAL_INSTRUCTIONS_HEADER = 'WORKFLOWS_TASK_CREATION_MODAL_INSTRUCTIONS_HEADER',
  WORKFLOWS_TASK_CREATION_MODAL_WORKFLOW_TASK_TABLE = 'WORKFLOWS_TASK_CREATION_MODAL_WORKFLOW_TASK_TABLE',
  WORKFLOWS_TASK_DETAILS_PAGE = 'WORKFLOWS_TASK_DETAILS_PAGE',
  WORKFLOWS_TASK_GROUP_CREATION_MODAL_FLOWCHART_PANE = 'WORKFLOWS_TASK_GROUP_CREATION_MODAL_FLOWCHART_PANE',
  WORKFLOWS_TASK_GROUP_FLOWCHART_PANE = 'WORKFLOWS_TASK_GROUP_FLOWCHART_PANE',
  WORKFLOWS_TASK_GROUP_INSTRUCTIONS_HEADER = 'WORKFLOWS_TASK_GROUP_INSTRUCTIONS_HEADER',
  WORKFLOWS_TASK_GROUP_METADATA_TAB = 'WORKFLOWS_TASK_GROUP_METADATA_TAB',
  WORKFLOWS_TASK_GROUP_PAGE = 'WORKFLOWS_TASK_GROUP_PAGE',
  WORKFLOWS_TASK_GROUP_WORKFLOW_OUTPUT_TABLE = 'WORKFLOWS_TASK_GROUP_WORKFLOW_OUTPUT_TABLE',
  WORKFLOWS_TASK_GROUP_WORKFLOW_TASK_TABLE = 'WORKFLOWS_TASK_GROUP_WORKFLOW_TASK_TABLE',
  WORKFLOWS_UNDETERMINED_STRUCTURED_TABLE = 'WORKFLOWS_UNDETERMINED_STRUCTURED_TABLE',
  WORKSHEET = 'WORKSHEET'
}

export type ActorNode = BenchlingAppNode | ServiceAccountActorNode | UserNode;

export type ActorOrInaccessibleInfoNode = BenchlingAppNode | InaccessibleInfoNode | ServiceAccountActorNode | UserNode;

export interface AdminListingNode {
  __typename: 'AdminListingNode';
  admins: Array<PartyNode>;
  total: Scalars['StrictInt']['output'];
}

export enum AllowedTimezone {
  AFRICA_ABIDJAN = 'AFRICA_ABIDJAN',
  AFRICA_ACCRA = 'AFRICA_ACCRA',
  AFRICA_ADDIS_ABABA = 'AFRICA_ADDIS_ABABA',
  AFRICA_ALGIERS = 'AFRICA_ALGIERS',
  AFRICA_ASMARA = 'AFRICA_ASMARA',
  AFRICA_BAMAKO = 'AFRICA_BAMAKO',
  AFRICA_BANGUI = 'AFRICA_BANGUI',
  AFRICA_BANJUL = 'AFRICA_BANJUL',
  AFRICA_BISSAU = 'AFRICA_BISSAU',
  AFRICA_BLANTYRE = 'AFRICA_BLANTYRE',
  AFRICA_BRAZZAVILLE = 'AFRICA_BRAZZAVILLE',
  AFRICA_BUJUMBURA = 'AFRICA_BUJUMBURA',
  AFRICA_CAIRO = 'AFRICA_CAIRO',
  AFRICA_CASABLANCA = 'AFRICA_CASABLANCA',
  AFRICA_CEUTA = 'AFRICA_CEUTA',
  AFRICA_CONAKRY = 'AFRICA_CONAKRY',
  AFRICA_DAKAR = 'AFRICA_DAKAR',
  AFRICA_DAR_ES_SALAAM = 'AFRICA_DAR_ES_SALAAM',
  AFRICA_DJIBOUTI = 'AFRICA_DJIBOUTI',
  AFRICA_DOUALA = 'AFRICA_DOUALA',
  AFRICA_EL_AAIUN = 'AFRICA_EL_AAIUN',
  AFRICA_FREETOWN = 'AFRICA_FREETOWN',
  AFRICA_GABORONE = 'AFRICA_GABORONE',
  AFRICA_HARARE = 'AFRICA_HARARE',
  AFRICA_JOHANNESBURG = 'AFRICA_JOHANNESBURG',
  AFRICA_JUBA = 'AFRICA_JUBA',
  AFRICA_KAMPALA = 'AFRICA_KAMPALA',
  AFRICA_KHARTOUM = 'AFRICA_KHARTOUM',
  AFRICA_KIGALI = 'AFRICA_KIGALI',
  AFRICA_KINSHASA = 'AFRICA_KINSHASA',
  AFRICA_LAGOS = 'AFRICA_LAGOS',
  AFRICA_LIBREVILLE = 'AFRICA_LIBREVILLE',
  AFRICA_LOME = 'AFRICA_LOME',
  AFRICA_LUANDA = 'AFRICA_LUANDA',
  AFRICA_LUBUMBASHI = 'AFRICA_LUBUMBASHI',
  AFRICA_LUSAKA = 'AFRICA_LUSAKA',
  AFRICA_MALABO = 'AFRICA_MALABO',
  AFRICA_MAPUTO = 'AFRICA_MAPUTO',
  AFRICA_MASERU = 'AFRICA_MASERU',
  AFRICA_MBABANE = 'AFRICA_MBABANE',
  AFRICA_MOGADISHU = 'AFRICA_MOGADISHU',
  AFRICA_MONROVIA = 'AFRICA_MONROVIA',
  AFRICA_NAIROBI = 'AFRICA_NAIROBI',
  AFRICA_NDJAMENA = 'AFRICA_NDJAMENA',
  AFRICA_NIAMEY = 'AFRICA_NIAMEY',
  AFRICA_NOUAKCHOTT = 'AFRICA_NOUAKCHOTT',
  AFRICA_OUAGADOUGOU = 'AFRICA_OUAGADOUGOU',
  AFRICA_PORTO_NOVO = 'AFRICA_PORTO_NOVO',
  AFRICA_SAO_TOME = 'AFRICA_SAO_TOME',
  AFRICA_TRIPOLI = 'AFRICA_TRIPOLI',
  AFRICA_TUNIS = 'AFRICA_TUNIS',
  AFRICA_WINDHOEK = 'AFRICA_WINDHOEK',
  AMERICA_ADAK = 'AMERICA_ADAK',
  AMERICA_ANCHORAGE = 'AMERICA_ANCHORAGE',
  AMERICA_ANGUILLA = 'AMERICA_ANGUILLA',
  AMERICA_ANTIGUA = 'AMERICA_ANTIGUA',
  AMERICA_ARAGUAINA = 'AMERICA_ARAGUAINA',
  AMERICA_ARGENTINA_BUENOS_AIRES = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  AMERICA_ARGENTINA_CATAMARCA = 'AMERICA_ARGENTINA_CATAMARCA',
  AMERICA_ARGENTINA_CORDOBA = 'AMERICA_ARGENTINA_CORDOBA',
  AMERICA_ARGENTINA_JUJUY = 'AMERICA_ARGENTINA_JUJUY',
  AMERICA_ARGENTINA_LA_RIOJA = 'AMERICA_ARGENTINA_LA_RIOJA',
  AMERICA_ARGENTINA_MENDOZA = 'AMERICA_ARGENTINA_MENDOZA',
  AMERICA_ARGENTINA_RIO_GALLEGOS = 'AMERICA_ARGENTINA_RIO_GALLEGOS',
  AMERICA_ARGENTINA_SALTA = 'AMERICA_ARGENTINA_SALTA',
  AMERICA_ARGENTINA_SAN_JUAN = 'AMERICA_ARGENTINA_SAN_JUAN',
  AMERICA_ARGENTINA_SAN_LUIS = 'AMERICA_ARGENTINA_SAN_LUIS',
  AMERICA_ARGENTINA_TUCUMAN = 'AMERICA_ARGENTINA_TUCUMAN',
  AMERICA_ARGENTINA_USHUAIA = 'AMERICA_ARGENTINA_USHUAIA',
  AMERICA_ARUBA = 'AMERICA_ARUBA',
  AMERICA_ASUNCION = 'AMERICA_ASUNCION',
  AMERICA_ATIKOKAN = 'AMERICA_ATIKOKAN',
  AMERICA_BAHIA = 'AMERICA_BAHIA',
  AMERICA_BAHIA_BANDERAS = 'AMERICA_BAHIA_BANDERAS',
  AMERICA_BARBADOS = 'AMERICA_BARBADOS',
  AMERICA_BELEM = 'AMERICA_BELEM',
  AMERICA_BELIZE = 'AMERICA_BELIZE',
  AMERICA_BLANC_SABLON = 'AMERICA_BLANC_SABLON',
  AMERICA_BOA_VISTA = 'AMERICA_BOA_VISTA',
  AMERICA_BOGOTA = 'AMERICA_BOGOTA',
  AMERICA_BOISE = 'AMERICA_BOISE',
  AMERICA_CAMBRIDGE_BAY = 'AMERICA_CAMBRIDGE_BAY',
  AMERICA_CAMPO_GRANDE = 'AMERICA_CAMPO_GRANDE',
  AMERICA_CANCUN = 'AMERICA_CANCUN',
  AMERICA_CARACAS = 'AMERICA_CARACAS',
  AMERICA_CAYENNE = 'AMERICA_CAYENNE',
  AMERICA_CAYMAN = 'AMERICA_CAYMAN',
  AMERICA_CHICAGO = 'AMERICA_CHICAGO',
  AMERICA_CHIHUAHUA = 'AMERICA_CHIHUAHUA',
  AMERICA_CIUDAD_JUAREZ = 'AMERICA_CIUDAD_JUAREZ',
  AMERICA_COSTA_RICA = 'AMERICA_COSTA_RICA',
  AMERICA_CRESTON = 'AMERICA_CRESTON',
  AMERICA_CUIABA = 'AMERICA_CUIABA',
  AMERICA_CURACAO = 'AMERICA_CURACAO',
  AMERICA_DANMARKSHAVN = 'AMERICA_DANMARKSHAVN',
  AMERICA_DAWSON = 'AMERICA_DAWSON',
  AMERICA_DAWSON_CREEK = 'AMERICA_DAWSON_CREEK',
  AMERICA_DENVER = 'AMERICA_DENVER',
  AMERICA_DETROIT = 'AMERICA_DETROIT',
  AMERICA_DOMINICA = 'AMERICA_DOMINICA',
  AMERICA_EDMONTON = 'AMERICA_EDMONTON',
  AMERICA_EIRUNEPE = 'AMERICA_EIRUNEPE',
  AMERICA_EL_SALVADOR = 'AMERICA_EL_SALVADOR',
  AMERICA_FORTALEZA = 'AMERICA_FORTALEZA',
  AMERICA_FORT_NELSON = 'AMERICA_FORT_NELSON',
  AMERICA_GLACE_BAY = 'AMERICA_GLACE_BAY',
  AMERICA_GOOSE_BAY = 'AMERICA_GOOSE_BAY',
  AMERICA_GRAND_TURK = 'AMERICA_GRAND_TURK',
  AMERICA_GRENADA = 'AMERICA_GRENADA',
  AMERICA_GUADELOUPE = 'AMERICA_GUADELOUPE',
  AMERICA_GUATEMALA = 'AMERICA_GUATEMALA',
  AMERICA_GUAYAQUIL = 'AMERICA_GUAYAQUIL',
  AMERICA_GUYANA = 'AMERICA_GUYANA',
  AMERICA_HALIFAX = 'AMERICA_HALIFAX',
  AMERICA_HAVANA = 'AMERICA_HAVANA',
  AMERICA_HERMOSILLO = 'AMERICA_HERMOSILLO',
  AMERICA_INDIANA_INDIANAPOLIS = 'AMERICA_INDIANA_INDIANAPOLIS',
  AMERICA_INDIANA_KNOX = 'AMERICA_INDIANA_KNOX',
  AMERICA_INDIANA_MARENGO = 'AMERICA_INDIANA_MARENGO',
  AMERICA_INDIANA_PETERSBURG = 'AMERICA_INDIANA_PETERSBURG',
  AMERICA_INDIANA_TELL_CITY = 'AMERICA_INDIANA_TELL_CITY',
  AMERICA_INDIANA_VEVAY = 'AMERICA_INDIANA_VEVAY',
  AMERICA_INDIANA_VINCENNES = 'AMERICA_INDIANA_VINCENNES',
  AMERICA_INDIANA_WINAMAC = 'AMERICA_INDIANA_WINAMAC',
  AMERICA_INUVIK = 'AMERICA_INUVIK',
  AMERICA_IQALUIT = 'AMERICA_IQALUIT',
  AMERICA_JAMAICA = 'AMERICA_JAMAICA',
  AMERICA_JUNEAU = 'AMERICA_JUNEAU',
  AMERICA_KENTUCKY_LOUISVILLE = 'AMERICA_KENTUCKY_LOUISVILLE',
  AMERICA_KENTUCKY_MONTICELLO = 'AMERICA_KENTUCKY_MONTICELLO',
  AMERICA_KRALENDIJK = 'AMERICA_KRALENDIJK',
  AMERICA_LA_PAZ = 'AMERICA_LA_PAZ',
  AMERICA_LIMA = 'AMERICA_LIMA',
  AMERICA_LOS_ANGELES = 'AMERICA_LOS_ANGELES',
  AMERICA_LOWER_PRINCES = 'AMERICA_LOWER_PRINCES',
  AMERICA_MACEIO = 'AMERICA_MACEIO',
  AMERICA_MANAGUA = 'AMERICA_MANAGUA',
  AMERICA_MANAUS = 'AMERICA_MANAUS',
  AMERICA_MARIGOT = 'AMERICA_MARIGOT',
  AMERICA_MARTINIQUE = 'AMERICA_MARTINIQUE',
  AMERICA_MATAMOROS = 'AMERICA_MATAMOROS',
  AMERICA_MAZATLAN = 'AMERICA_MAZATLAN',
  AMERICA_MENOMINEE = 'AMERICA_MENOMINEE',
  AMERICA_MERIDA = 'AMERICA_MERIDA',
  AMERICA_METLAKATLA = 'AMERICA_METLAKATLA',
  AMERICA_MEXICO_CITY = 'AMERICA_MEXICO_CITY',
  AMERICA_MIQUELON = 'AMERICA_MIQUELON',
  AMERICA_MONCTON = 'AMERICA_MONCTON',
  AMERICA_MONTERREY = 'AMERICA_MONTERREY',
  AMERICA_MONTEVIDEO = 'AMERICA_MONTEVIDEO',
  AMERICA_MONTSERRAT = 'AMERICA_MONTSERRAT',
  AMERICA_NASSAU = 'AMERICA_NASSAU',
  AMERICA_NEW_YORK = 'AMERICA_NEW_YORK',
  AMERICA_NOME = 'AMERICA_NOME',
  AMERICA_NORONHA = 'AMERICA_NORONHA',
  AMERICA_NORTH_DAKOTA_BEULAH = 'AMERICA_NORTH_DAKOTA_BEULAH',
  AMERICA_NORTH_DAKOTA_CENTER = 'AMERICA_NORTH_DAKOTA_CENTER',
  AMERICA_NORTH_DAKOTA_NEW_SALEM = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  AMERICA_NUUK = 'AMERICA_NUUK',
  AMERICA_OJINAGA = 'AMERICA_OJINAGA',
  AMERICA_PANAMA = 'AMERICA_PANAMA',
  AMERICA_PARAMARIBO = 'AMERICA_PARAMARIBO',
  AMERICA_PHOENIX = 'AMERICA_PHOENIX',
  AMERICA_PORTO_VELHO = 'AMERICA_PORTO_VELHO',
  AMERICA_PORT_AU_PRINCE = 'AMERICA_PORT_AU_PRINCE',
  AMERICA_PORT_OF_SPAIN = 'AMERICA_PORT_OF_SPAIN',
  AMERICA_PUERTO_RICO = 'AMERICA_PUERTO_RICO',
  AMERICA_PUNTA_ARENAS = 'AMERICA_PUNTA_ARENAS',
  AMERICA_RANKIN_INLET = 'AMERICA_RANKIN_INLET',
  AMERICA_RECIFE = 'AMERICA_RECIFE',
  AMERICA_REGINA = 'AMERICA_REGINA',
  AMERICA_RESOLUTE = 'AMERICA_RESOLUTE',
  AMERICA_RIO_BRANCO = 'AMERICA_RIO_BRANCO',
  AMERICA_SANTAREM = 'AMERICA_SANTAREM',
  AMERICA_SANTIAGO = 'AMERICA_SANTIAGO',
  AMERICA_SANTO_DOMINGO = 'AMERICA_SANTO_DOMINGO',
  AMERICA_SAO_PAULO = 'AMERICA_SAO_PAULO',
  AMERICA_SCORESBYSUND = 'AMERICA_SCORESBYSUND',
  AMERICA_SITKA = 'AMERICA_SITKA',
  AMERICA_ST_BARTHELEMY = 'AMERICA_ST_BARTHELEMY',
  AMERICA_ST_JOHNS = 'AMERICA_ST_JOHNS',
  AMERICA_ST_KITTS = 'AMERICA_ST_KITTS',
  AMERICA_ST_LUCIA = 'AMERICA_ST_LUCIA',
  AMERICA_ST_THOMAS = 'AMERICA_ST_THOMAS',
  AMERICA_ST_VINCENT = 'AMERICA_ST_VINCENT',
  AMERICA_SWIFT_CURRENT = 'AMERICA_SWIFT_CURRENT',
  AMERICA_TEGUCIGALPA = 'AMERICA_TEGUCIGALPA',
  AMERICA_THULE = 'AMERICA_THULE',
  AMERICA_TIJUANA = 'AMERICA_TIJUANA',
  AMERICA_TORONTO = 'AMERICA_TORONTO',
  AMERICA_TORTOLA = 'AMERICA_TORTOLA',
  AMERICA_VANCOUVER = 'AMERICA_VANCOUVER',
  AMERICA_WHITEHORSE = 'AMERICA_WHITEHORSE',
  AMERICA_WINNIPEG = 'AMERICA_WINNIPEG',
  AMERICA_YAKUTAT = 'AMERICA_YAKUTAT',
  ANTARCTICA_CASEY = 'ANTARCTICA_CASEY',
  ANTARCTICA_DAVIS = 'ANTARCTICA_DAVIS',
  ANTARCTICA_DUMONTDURVILLE = 'ANTARCTICA_DUMONTDURVILLE',
  ANTARCTICA_MACQUARIE = 'ANTARCTICA_MACQUARIE',
  ANTARCTICA_MAWSON = 'ANTARCTICA_MAWSON',
  ANTARCTICA_MCMURDO = 'ANTARCTICA_MCMURDO',
  ANTARCTICA_PALMER = 'ANTARCTICA_PALMER',
  ANTARCTICA_ROTHERA = 'ANTARCTICA_ROTHERA',
  ANTARCTICA_SYOWA = 'ANTARCTICA_SYOWA',
  ANTARCTICA_TROLL = 'ANTARCTICA_TROLL',
  ANTARCTICA_VOSTOK = 'ANTARCTICA_VOSTOK',
  ARCTIC_LONGYEARBYEN = 'ARCTIC_LONGYEARBYEN',
  ASIA_ADEN = 'ASIA_ADEN',
  ASIA_ALMATY = 'ASIA_ALMATY',
  ASIA_AMMAN = 'ASIA_AMMAN',
  ASIA_ANADYR = 'ASIA_ANADYR',
  ASIA_AQTAU = 'ASIA_AQTAU',
  ASIA_AQTOBE = 'ASIA_AQTOBE',
  ASIA_ASHGABAT = 'ASIA_ASHGABAT',
  ASIA_ATYRAU = 'ASIA_ATYRAU',
  ASIA_BAGHDAD = 'ASIA_BAGHDAD',
  ASIA_BAHRAIN = 'ASIA_BAHRAIN',
  ASIA_BAKU = 'ASIA_BAKU',
  ASIA_BANGKOK = 'ASIA_BANGKOK',
  ASIA_BARNAUL = 'ASIA_BARNAUL',
  ASIA_BEIRUT = 'ASIA_BEIRUT',
  ASIA_BISHKEK = 'ASIA_BISHKEK',
  ASIA_BRUNEI = 'ASIA_BRUNEI',
  ASIA_CHITA = 'ASIA_CHITA',
  ASIA_CHOIBALSAN = 'ASIA_CHOIBALSAN',
  ASIA_COLOMBO = 'ASIA_COLOMBO',
  ASIA_DAMASCUS = 'ASIA_DAMASCUS',
  ASIA_DHAKA = 'ASIA_DHAKA',
  ASIA_DILI = 'ASIA_DILI',
  ASIA_DUBAI = 'ASIA_DUBAI',
  ASIA_DUSHANBE = 'ASIA_DUSHANBE',
  ASIA_FAMAGUSTA = 'ASIA_FAMAGUSTA',
  ASIA_GAZA = 'ASIA_GAZA',
  ASIA_HEBRON = 'ASIA_HEBRON',
  ASIA_HONG_KONG = 'ASIA_HONG_KONG',
  ASIA_HOVD = 'ASIA_HOVD',
  ASIA_HO_CHI_MINH = 'ASIA_HO_CHI_MINH',
  ASIA_IRKUTSK = 'ASIA_IRKUTSK',
  ASIA_JAKARTA = 'ASIA_JAKARTA',
  ASIA_JAYAPURA = 'ASIA_JAYAPURA',
  ASIA_JERUSALEM = 'ASIA_JERUSALEM',
  ASIA_KABUL = 'ASIA_KABUL',
  ASIA_KAMCHATKA = 'ASIA_KAMCHATKA',
  ASIA_KARACHI = 'ASIA_KARACHI',
  ASIA_KATHMANDU = 'ASIA_KATHMANDU',
  ASIA_KHANDYGA = 'ASIA_KHANDYGA',
  ASIA_KOLKATA = 'ASIA_KOLKATA',
  ASIA_KRASNOYARSK = 'ASIA_KRASNOYARSK',
  ASIA_KUALA_LUMPUR = 'ASIA_KUALA_LUMPUR',
  ASIA_KUCHING = 'ASIA_KUCHING',
  ASIA_KUWAIT = 'ASIA_KUWAIT',
  ASIA_MACAU = 'ASIA_MACAU',
  ASIA_MAGADAN = 'ASIA_MAGADAN',
  ASIA_MAKASSAR = 'ASIA_MAKASSAR',
  ASIA_MANILA = 'ASIA_MANILA',
  ASIA_MUSCAT = 'ASIA_MUSCAT',
  ASIA_NICOSIA = 'ASIA_NICOSIA',
  ASIA_NOVOKUZNETSK = 'ASIA_NOVOKUZNETSK',
  ASIA_NOVOSIBIRSK = 'ASIA_NOVOSIBIRSK',
  ASIA_OMSK = 'ASIA_OMSK',
  ASIA_ORAL = 'ASIA_ORAL',
  ASIA_PHNOM_PENH = 'ASIA_PHNOM_PENH',
  ASIA_PONTIANAK = 'ASIA_PONTIANAK',
  ASIA_PYONGYANG = 'ASIA_PYONGYANG',
  ASIA_QATAR = 'ASIA_QATAR',
  ASIA_QOSTANAY = 'ASIA_QOSTANAY',
  ASIA_QYZYLORDA = 'ASIA_QYZYLORDA',
  ASIA_RIYADH = 'ASIA_RIYADH',
  ASIA_SAKHALIN = 'ASIA_SAKHALIN',
  ASIA_SAMARKAND = 'ASIA_SAMARKAND',
  ASIA_SEOUL = 'ASIA_SEOUL',
  ASIA_SHANGHAI = 'ASIA_SHANGHAI',
  ASIA_SINGAPORE = 'ASIA_SINGAPORE',
  ASIA_SREDNEKOLYMSK = 'ASIA_SREDNEKOLYMSK',
  ASIA_TAIPEI = 'ASIA_TAIPEI',
  ASIA_TASHKENT = 'ASIA_TASHKENT',
  ASIA_TBILISI = 'ASIA_TBILISI',
  ASIA_TEHRAN = 'ASIA_TEHRAN',
  ASIA_THIMPHU = 'ASIA_THIMPHU',
  ASIA_TOKYO = 'ASIA_TOKYO',
  ASIA_TOMSK = 'ASIA_TOMSK',
  ASIA_ULAANBAATAR = 'ASIA_ULAANBAATAR',
  ASIA_URUMQI = 'ASIA_URUMQI',
  ASIA_UST_NERA = 'ASIA_UST_NERA',
  ASIA_VIENTIANE = 'ASIA_VIENTIANE',
  ASIA_VLADIVOSTOK = 'ASIA_VLADIVOSTOK',
  ASIA_YAKUTSK = 'ASIA_YAKUTSK',
  ASIA_YANGON = 'ASIA_YANGON',
  ASIA_YEKATERINBURG = 'ASIA_YEKATERINBURG',
  ASIA_YEREVAN = 'ASIA_YEREVAN',
  ATLANTIC_AZORES = 'ATLANTIC_AZORES',
  ATLANTIC_BERMUDA = 'ATLANTIC_BERMUDA',
  ATLANTIC_CANARY = 'ATLANTIC_CANARY',
  ATLANTIC_CAPE_VERDE = 'ATLANTIC_CAPE_VERDE',
  ATLANTIC_FAROE = 'ATLANTIC_FAROE',
  ATLANTIC_MADEIRA = 'ATLANTIC_MADEIRA',
  ATLANTIC_REYKJAVIK = 'ATLANTIC_REYKJAVIK',
  ATLANTIC_SOUTH_GEORGIA = 'ATLANTIC_SOUTH_GEORGIA',
  ATLANTIC_STANLEY = 'ATLANTIC_STANLEY',
  ATLANTIC_ST_HELENA = 'ATLANTIC_ST_HELENA',
  AUSTRALIA_ADELAIDE = 'AUSTRALIA_ADELAIDE',
  AUSTRALIA_BRISBANE = 'AUSTRALIA_BRISBANE',
  AUSTRALIA_BROKEN_HILL = 'AUSTRALIA_BROKEN_HILL',
  AUSTRALIA_DARWIN = 'AUSTRALIA_DARWIN',
  AUSTRALIA_EUCLA = 'AUSTRALIA_EUCLA',
  AUSTRALIA_HOBART = 'AUSTRALIA_HOBART',
  AUSTRALIA_LINDEMAN = 'AUSTRALIA_LINDEMAN',
  AUSTRALIA_LORD_HOWE = 'AUSTRALIA_LORD_HOWE',
  AUSTRALIA_MELBOURNE = 'AUSTRALIA_MELBOURNE',
  AUSTRALIA_PERTH = 'AUSTRALIA_PERTH',
  AUSTRALIA_SYDNEY = 'AUSTRALIA_SYDNEY',
  CANADA_ATLANTIC = 'CANADA_ATLANTIC',
  CANADA_CENTRAL = 'CANADA_CENTRAL',
  CANADA_EASTERN = 'CANADA_EASTERN',
  CANADA_MOUNTAIN = 'CANADA_MOUNTAIN',
  CANADA_NEWFOUNDLAND = 'CANADA_NEWFOUNDLAND',
  CANADA_PACIFIC = 'CANADA_PACIFIC',
  EUROPE_AMSTERDAM = 'EUROPE_AMSTERDAM',
  EUROPE_ANDORRA = 'EUROPE_ANDORRA',
  EUROPE_ASTRAKHAN = 'EUROPE_ASTRAKHAN',
  EUROPE_ATHENS = 'EUROPE_ATHENS',
  EUROPE_BELGRADE = 'EUROPE_BELGRADE',
  EUROPE_BERLIN = 'EUROPE_BERLIN',
  EUROPE_BRATISLAVA = 'EUROPE_BRATISLAVA',
  EUROPE_BRUSSELS = 'EUROPE_BRUSSELS',
  EUROPE_BUCHAREST = 'EUROPE_BUCHAREST',
  EUROPE_BUDAPEST = 'EUROPE_BUDAPEST',
  EUROPE_BUSINGEN = 'EUROPE_BUSINGEN',
  EUROPE_CHISINAU = 'EUROPE_CHISINAU',
  EUROPE_COPENHAGEN = 'EUROPE_COPENHAGEN',
  EUROPE_DUBLIN = 'EUROPE_DUBLIN',
  EUROPE_GIBRALTAR = 'EUROPE_GIBRALTAR',
  EUROPE_GUERNSEY = 'EUROPE_GUERNSEY',
  EUROPE_HELSINKI = 'EUROPE_HELSINKI',
  EUROPE_ISLE_OF_MAN = 'EUROPE_ISLE_OF_MAN',
  EUROPE_ISTANBUL = 'EUROPE_ISTANBUL',
  EUROPE_JERSEY = 'EUROPE_JERSEY',
  EUROPE_KALININGRAD = 'EUROPE_KALININGRAD',
  EUROPE_KIROV = 'EUROPE_KIROV',
  EUROPE_KYIV = 'EUROPE_KYIV',
  EUROPE_LISBON = 'EUROPE_LISBON',
  EUROPE_LJUBLJANA = 'EUROPE_LJUBLJANA',
  EUROPE_LONDON = 'EUROPE_LONDON',
  EUROPE_LUXEMBOURG = 'EUROPE_LUXEMBOURG',
  EUROPE_MADRID = 'EUROPE_MADRID',
  EUROPE_MALTA = 'EUROPE_MALTA',
  EUROPE_MARIEHAMN = 'EUROPE_MARIEHAMN',
  EUROPE_MINSK = 'EUROPE_MINSK',
  EUROPE_MONACO = 'EUROPE_MONACO',
  EUROPE_MOSCOW = 'EUROPE_MOSCOW',
  EUROPE_OSLO = 'EUROPE_OSLO',
  EUROPE_PARIS = 'EUROPE_PARIS',
  EUROPE_PODGORICA = 'EUROPE_PODGORICA',
  EUROPE_PRAGUE = 'EUROPE_PRAGUE',
  EUROPE_RIGA = 'EUROPE_RIGA',
  EUROPE_ROME = 'EUROPE_ROME',
  EUROPE_SAMARA = 'EUROPE_SAMARA',
  EUROPE_SAN_MARINO = 'EUROPE_SAN_MARINO',
  EUROPE_SARAJEVO = 'EUROPE_SARAJEVO',
  EUROPE_SARATOV = 'EUROPE_SARATOV',
  EUROPE_SIMFEROPOL = 'EUROPE_SIMFEROPOL',
  EUROPE_SKOPJE = 'EUROPE_SKOPJE',
  EUROPE_SOFIA = 'EUROPE_SOFIA',
  EUROPE_STOCKHOLM = 'EUROPE_STOCKHOLM',
  EUROPE_TALLINN = 'EUROPE_TALLINN',
  EUROPE_TIRANE = 'EUROPE_TIRANE',
  EUROPE_ULYANOVSK = 'EUROPE_ULYANOVSK',
  EUROPE_VADUZ = 'EUROPE_VADUZ',
  EUROPE_VATICAN = 'EUROPE_VATICAN',
  EUROPE_VIENNA = 'EUROPE_VIENNA',
  EUROPE_VILNIUS = 'EUROPE_VILNIUS',
  EUROPE_VOLGOGRAD = 'EUROPE_VOLGOGRAD',
  EUROPE_WARSAW = 'EUROPE_WARSAW',
  EUROPE_ZAGREB = 'EUROPE_ZAGREB',
  EUROPE_ZURICH = 'EUROPE_ZURICH',
  GMT = 'GMT',
  INDIAN_ANTANANARIVO = 'INDIAN_ANTANANARIVO',
  INDIAN_CHAGOS = 'INDIAN_CHAGOS',
  INDIAN_CHRISTMAS = 'INDIAN_CHRISTMAS',
  INDIAN_COCOS = 'INDIAN_COCOS',
  INDIAN_COMORO = 'INDIAN_COMORO',
  INDIAN_KERGUELEN = 'INDIAN_KERGUELEN',
  INDIAN_MAHE = 'INDIAN_MAHE',
  INDIAN_MALDIVES = 'INDIAN_MALDIVES',
  INDIAN_MAURITIUS = 'INDIAN_MAURITIUS',
  INDIAN_MAYOTTE = 'INDIAN_MAYOTTE',
  INDIAN_REUNION = 'INDIAN_REUNION',
  PACIFIC_APIA = 'PACIFIC_APIA',
  PACIFIC_AUCKLAND = 'PACIFIC_AUCKLAND',
  PACIFIC_BOUGAINVILLE = 'PACIFIC_BOUGAINVILLE',
  PACIFIC_CHATHAM = 'PACIFIC_CHATHAM',
  PACIFIC_CHUUK = 'PACIFIC_CHUUK',
  PACIFIC_EASTER = 'PACIFIC_EASTER',
  PACIFIC_EFATE = 'PACIFIC_EFATE',
  PACIFIC_FAKAOFO = 'PACIFIC_FAKAOFO',
  PACIFIC_FIJI = 'PACIFIC_FIJI',
  PACIFIC_FUNAFUTI = 'PACIFIC_FUNAFUTI',
  PACIFIC_GALAPAGOS = 'PACIFIC_GALAPAGOS',
  PACIFIC_GAMBIER = 'PACIFIC_GAMBIER',
  PACIFIC_GUADALCANAL = 'PACIFIC_GUADALCANAL',
  PACIFIC_GUAM = 'PACIFIC_GUAM',
  PACIFIC_HONOLULU = 'PACIFIC_HONOLULU',
  PACIFIC_KANTON = 'PACIFIC_KANTON',
  PACIFIC_KIRITIMATI = 'PACIFIC_KIRITIMATI',
  PACIFIC_KOSRAE = 'PACIFIC_KOSRAE',
  PACIFIC_KWAJALEIN = 'PACIFIC_KWAJALEIN',
  PACIFIC_MAJURO = 'PACIFIC_MAJURO',
  PACIFIC_MARQUESAS = 'PACIFIC_MARQUESAS',
  PACIFIC_MIDWAY = 'PACIFIC_MIDWAY',
  PACIFIC_NAURU = 'PACIFIC_NAURU',
  PACIFIC_NIUE = 'PACIFIC_NIUE',
  PACIFIC_NORFOLK = 'PACIFIC_NORFOLK',
  PACIFIC_NOUMEA = 'PACIFIC_NOUMEA',
  PACIFIC_PAGO_PAGO = 'PACIFIC_PAGO_PAGO',
  PACIFIC_PALAU = 'PACIFIC_PALAU',
  PACIFIC_PITCAIRN = 'PACIFIC_PITCAIRN',
  PACIFIC_POHNPEI = 'PACIFIC_POHNPEI',
  PACIFIC_PORT_MORESBY = 'PACIFIC_PORT_MORESBY',
  PACIFIC_RAROTONGA = 'PACIFIC_RAROTONGA',
  PACIFIC_SAIPAN = 'PACIFIC_SAIPAN',
  PACIFIC_TAHITI = 'PACIFIC_TAHITI',
  PACIFIC_TARAWA = 'PACIFIC_TARAWA',
  PACIFIC_TONGATAPU = 'PACIFIC_TONGATAPU',
  PACIFIC_WAKE = 'PACIFIC_WAKE',
  PACIFIC_WALLIS = 'PACIFIC_WALLIS',
  US_ALASKA = 'US_ALASKA',
  US_ARIZONA = 'US_ARIZONA',
  US_CENTRAL = 'US_CENTRAL',
  US_EASTERN = 'US_EASTERN',
  US_HAWAII = 'US_HAWAII',
  US_MOUNTAIN = 'US_MOUNTAIN',
  US_PACIFIC = 'US_PACIFIC',
  UTC = 'UTC'
}

export interface AnalysisListingNode {
  __typename: 'AnalysisListingNode';
  analyses: Array<AnalysisNode>;
}

export interface AnalysisNode extends FolderItemInterface, HasCreationContextInterface, HasCreatorInterface, HasPermissionsInterface, PipelineInterface, SearchableInterface, StudyableInterface {
  __typename: 'AnalysisNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  /** @deprecated This field isn't used anywhere */
  createdPipelineTemplates: Array<AnalysisTemplateNode>;
  creationContext: CreationContextNode;
  creator: PrincipalInterface;
  editUrl: Scalars['StrictString']['output'];
  /** @deprecated Use `steps` or `views` */
  execution: PipelineExecutionNode;
  folder: FolderNode;
  id: Scalars['StrictString']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  project: ProjectNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  steps: Array<PipelineStepDomainNode>;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  url: Scalars['StrictString']['output'];
  views: Array<AnalysisViewNode>;
}

export type AnalysisOrInaccessibleInfoNode = AnalysisNode | InaccessibleInfoNode;

export interface AnalysisOriginNode {
  __typename: 'AnalysisOriginNode';
  analysis: AnalysisNode;
}

export interface AnalysisTemplateDataFrameVariableNode {
  __typename: 'AnalysisTemplateDataFrameVariableNode';
  description: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  replaceDataFrameColumnsSpec: Array<Scalars['JSONScalar']['output']>;
  replaceStepDataId: Scalars['StrictString']['output'];
  replaceStepDataIndex: Scalars['StrictInt']['output'];
  replaceStepId: Scalars['StrictString']['output'];
}

export type AnalysisTemplateDataFrameVariableOrInaccessibleInfoNode = AnalysisTemplateDataFrameVariableNode | InaccessibleInfoNode;

export interface AnalysisTemplateNode extends CoreObjectArchivableInterface, HasCreatorInterface, HasPermissionsInterface, PipelineInterface, SearchableInterface, StarrableInterface, TemplateCollectibleInterface {
  __typename: 'AnalysisTemplateNode';
  archiveData: ArchiveDataNode;
  archiveRecord: Maybe<ArchiveRecordNode>;
  configVariables: Array<AnalysisTemplateVariableNode>;
  createdAt: Scalars['StrictString']['output'];
  createdFromPipeline: Maybe<AnalysisOrInaccessibleInfoNode>;
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorNode: CreatorInterface;
  dataFrameVariables: Array<AnalysisTemplateDataFrameVariableNode>;
  editUrl: Scalars['StrictString']['output'];
  /** @deprecated Use `steps` or `views` */
  execution: PipelineExecutionNode;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  publishedAt: Maybe<Scalars['StrictString']['output']>;
  star: Maybe<StarNode>;
  steps: Array<PipelineStepDomainNode>;
  templateCollection: TemplateCollectionNode;
}

export type AnalysisTemplateOrInaccessibleInfoNode = AnalysisTemplateNode | InaccessibleInfoNode;

export interface AnalysisTemplateVariableNode extends CoreObjectArchivableInterface, HasPermissionsInterface {
  __typename: 'AnalysisTemplateVariableNode';
  archiveData: ArchiveDataNode;
  configVariableKey: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  pipelineStep: PipelineStepNode;
}

export type AnalysisTemplateVariableOrInaccessibleInfoNode = AnalysisTemplateVariableNode | InaccessibleInfoNode;

export interface AnalysisViewNode {
  __typename: 'AnalysisViewNode';
  lineage: Array<LineageNode>;
}

export interface AnalyticsDashboardLayoutRowNode {
  __typename: 'AnalyticsDashboardLayoutRowNode';
  analyticsQueries: Array<AnalyticsQueryNode>;
}

export interface AnalyticsDashboardLinkNode {
  __typename: 'AnalyticsDashboardLinkNode';
  id: Scalars['StrictString']['output'];
  originalAnalyticsDashboard: AnalyticsDashboardOrInaccessibleInfoNode;
  parameterValueTemplates: Array<AnalyticsParameterValueTemplateNode>;
}

export interface AnalyticsDashboardLinkParentInterface {
  analyticsDashboardLink: Maybe<AnalyticsDashboardLinkNode>;
  id: Scalars['StrictString']['output'];
}

export interface AnalyticsDashboardListingNode {
  __typename: 'AnalyticsDashboardListingNode';
  analyticsDashboards: Array<AnalyticsDashboardNode>;
}

export interface AnalyticsDashboardNode extends HasCreatorInterface, HasPermissionsInterface, SearchableInterface {
  __typename: 'AnalyticsDashboardNode';
  analyticsQueries: Array<AnalyticsQueryNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  description: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  layoutRows: Array<AnalyticsDashboardLayoutRowNode>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  parameterConfigs: Array<AnalyticsParameterConfigInterface>;
  parameterValues: Array<AnalyticsParameterValueNode>;
  permissions: PermissionsNode;
  project: ProjectNode;
  starred: Scalars['StrictBoolean']['output'];
  url: Scalars['StrictString']['output'];
}

export type AnalyticsDashboardOrInaccessibleInfoNode = AnalyticsDashboardNode | InaccessibleInfoNode;

export interface AnalyticsParameterBioentityLinkConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterBioentityLinkConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  systemName: Scalars['StrictString']['output'];
  tagSchema: Maybe<TagSchemaNode>;
}

export interface AnalyticsParameterConfigInterface {
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  systemName: Scalars['StrictString']['output'];
}

export type AnalyticsParameterConfigOrInaccessibleInfoNode = AnalyticsParameterBioentityLinkConfigNode | AnalyticsParameterDateConfigNode | AnalyticsParameterEntryLinkConfigNode | AnalyticsParameterFolderLinkConfigNode | AnalyticsParameterNumberConfigNode | AnalyticsParameterProcessLinkConfigNode | AnalyticsParameterProcessTaskLinkConfigNode | AnalyticsParameterProjectLinkConfigNode | AnalyticsParameterSelectorConfigNode | AnalyticsParameterStorableLinkConfigNode | AnalyticsParameterStringConfigNode | AnalyticsParameterStudyLinkConfigNode | AnalyticsParameterTeamLinkConfigNode | AnalyticsParameterUserLinkConfigNode | InaccessibleInfoNode;

export interface AnalyticsParameterDateConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterDateConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterEntryLinkConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterEntryLinkConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterFolderLinkConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterFolderLinkConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterNumberConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterNumberConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterProcessLinkConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterProcessLinkConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  processTaskSchema: Maybe<ProcessTaskSchemaNode>;
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterProcessTaskLinkConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterProcessTaskLinkConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  processTaskSchema: Maybe<ProcessTaskSchemaNode>;
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterProjectLinkConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterProjectLinkConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterSelectorConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterSelectorConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  schemaFieldSelector: Maybe<SchemaFieldSelectorNode>;
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterStorableLinkConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterStorableLinkConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  storableSchema: Maybe<StorableSchemaInterface>;
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterStringConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterStringConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterStudyLinkConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterStudyLinkConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  studySchema: Maybe<StudySchemaNode>;
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterTeamLinkConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterTeamLinkConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterUserLinkConfigNode extends AnalyticsParameterConfigInterface {
  __typename: 'AnalyticsParameterUserLinkConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  systemName: Scalars['StrictString']['output'];
}

export interface AnalyticsParameterValueNode {
  __typename: 'AnalyticsParameterValueNode';
  config: AnalyticsParameterConfigInterface;
  valueJson: Maybe<Scalars['JSONScalar']['output']>;
}

export enum AnalyticsParameterValueOperation {
  USE_EMBEDDING_ITEM = 'USE_EMBEDDING_ITEM',
  USE_VALUE_JSON = 'USE_VALUE_JSON'
}

export interface AnalyticsParameterValueTemplateNode {
  __typename: 'AnalyticsParameterValueTemplateNode';
  config: AnalyticsParameterConfigOrInaccessibleInfoNode;
  valueJson: Maybe<Scalars['JSONScalar']['output']>;
  valueOperation: AnalyticsParameterValueOperation;
}

export interface AnalyticsQueryNode extends HasCreatorInterface {
  __typename: 'AnalyticsQueryNode';
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  description: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  sqlQuery: Scalars['StrictString']['output'];
  visualization: AnalyticsVisualizationNode;
}

export interface AnalyticsTrackingParams {
  __typename: 'AnalyticsTrackingParams';
  actionMethod: ActionMethod;
  actionOrigin: ActionOrigin;
}

export enum AnalyticsVisualizationAggregationType {
  COUNT = 'COUNT',
  MEAN = 'MEAN',
  SUM = 'SUM'
}

export enum AnalyticsVisualizationAxisScale {
  LINEAR = 'LINEAR',
  LOG = 'LOG'
}

export interface AnalyticsVisualizationBarChartParametersNode extends AnalyticsVisualizationParametersInterface {
  __typename: 'AnalyticsVisualizationBarChartParametersNode';
  aggregationType: Maybe<AnalyticsVisualizationAggregationType>;
  barChartType: AnalyticsVisualizationBarChartType;
  dummyFieldForGraphql: Maybe<Scalars['StrictString']['output']>;
  errorBarType: Maybe<AnalyticsVisualizationErrorBarType>;
  seriesColumnName: Maybe<Scalars['StrictString']['output']>;
  sortDirection: Maybe<AnalyticsVisualizationSortDirection>;
  xAxisColumnName: Scalars['StrictString']['output'];
  yAxisColumnName: Scalars['StrictString']['output'];
  yAxisMax: Maybe<Scalars['StrictFloat']['output']>;
  yAxisMin: Maybe<Scalars['StrictFloat']['output']>;
  yAxisScale: AnalyticsVisualizationAxisScale;
}

export enum AnalyticsVisualizationBarChartType {
  STACKED = 'STACKED',
  STANDARD = 'STANDARD'
}

export enum AnalyticsVisualizationColorPalette {
  DISCRETE = 'DISCRETE',
  GRADIENT = 'GRADIENT'
}

export enum AnalyticsVisualizationErrorBarType {
  STANDARD_DEVIATION = 'STANDARD_DEVIATION',
  STANDARD_ERROR = 'STANDARD_ERROR'
}

export enum AnalyticsVisualizationGradientDirection {
  ASCENDING_METRIC_VALUES = 'ASCENDING_METRIC_VALUES',
  DESCENDING_METRIC_VALUES = 'DESCENDING_METRIC_VALUES'
}

export interface AnalyticsVisualizationHeatmapParametersNode extends AnalyticsVisualizationParametersInterface {
  __typename: 'AnalyticsVisualizationHeatmapParametersNode';
  dummyFieldForGraphql: Maybe<Scalars['StrictString']['output']>;
  gradientDirection: AnalyticsVisualizationGradientDirection;
  metricColumnName: Scalars['StrictString']['output'];
  xAxisColumnName: Scalars['StrictString']['output'];
  yAxisColumnName: Scalars['StrictString']['output'];
}

export enum AnalyticsVisualizationLegendLocation {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP = 'TOP'
}

export interface AnalyticsVisualizationLineChartParametersNode extends AnalyticsVisualizationParametersInterface {
  __typename: 'AnalyticsVisualizationLineChartParametersNode';
  dummyFieldForGraphql: Maybe<Scalars['StrictString']['output']>;
  seriesColumnName: Maybe<Scalars['StrictString']['output']>;
  xAxisColumnName: Scalars['StrictString']['output'];
  xAxisScale: AnalyticsVisualizationAxisScale;
  yAxisColumnName: Scalars['StrictString']['output'];
  yAxisIncludesZero: Scalars['StrictBoolean']['output'];
  yAxisScale: AnalyticsVisualizationAxisScale;
}

export interface AnalyticsVisualizationNode {
  __typename: 'AnalyticsVisualizationNode';
  id: Scalars['StrictString']['output'];
  parameters: AnalyticsVisualizationParametersInterface;
}

export enum AnalyticsVisualizationOutlierSetting {
  DETECT = 'DETECT',
  EXCLUDE = 'EXCLUDE'
}

export interface AnalyticsVisualizationParametersInterface {
  dummyFieldForGraphql: Maybe<Scalars['StrictString']['output']>;
}

export interface AnalyticsVisualizationPieChartParametersNode extends AnalyticsVisualizationParametersInterface {
  __typename: 'AnalyticsVisualizationPieChartParametersNode';
  aggregationType: Maybe<AnalyticsVisualizationAggregationType>;
  dummyFieldForGraphql: Maybe<Scalars['StrictString']['output']>;
  legendLocation: Maybe<AnalyticsVisualizationLegendLocation>;
  measureColumnName: Scalars['StrictString']['output'];
  showPercentageInLabel: Scalars['StrictBoolean']['output'];
  showSliceNameInLabel: Scalars['StrictBoolean']['output'];
  showValueInLabel: Scalars['StrictBoolean']['output'];
  sliceColumnName: Scalars['StrictString']['output'];
}

export enum AnalyticsVisualizationRegressionType {
  LINEAR = 'LINEAR',
  LOGISTIC = 'LOGISTIC'
}

export interface AnalyticsVisualizationScatterPlotParametersNode extends AnalyticsVisualizationParametersInterface {
  __typename: 'AnalyticsVisualizationScatterPlotParametersNode';
  aggregationType: Maybe<AnalyticsVisualizationAggregationType>;
  colorPalette: AnalyticsVisualizationColorPalette;
  dummyFieldForGraphql: Maybe<Scalars['StrictString']['output']>;
  errorBarType: Maybe<AnalyticsVisualizationErrorBarType>;
  legendLocation: Maybe<AnalyticsVisualizationLegendLocation>;
  outlierConfig: Maybe<OutlierConfigNode>;
  regressionConfig: Maybe<Scalars['JSONScalar']['output']>;
  /** @deprecated Moved to regression_config */
  regressionType: Maybe<AnalyticsVisualizationRegressionType>;
  rowIdColumnName: Maybe<Scalars['StrictString']['output']>;
  seriesColumnName: Maybe<Scalars['StrictString']['output']>;
  xAxisColumnName: Scalars['StrictString']['output'];
  xAxisScale: AnalyticsVisualizationAxisScale;
  yAxisColumnName: Scalars['StrictString']['output'];
  yAxisIncludesZero: Scalars['StrictBoolean']['output'];
  yAxisMax: Maybe<Scalars['StrictFloat']['output']>;
  yAxisMin: Maybe<Scalars['StrictFloat']['output']>;
  yAxisScale: AnalyticsVisualizationAxisScale;
}

export enum AnalyticsVisualizationSortDirection {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export interface AnalyticsVisualizationTableParametersNode extends AnalyticsVisualizationParametersInterface {
  __typename: 'AnalyticsVisualizationTableParametersNode';
  displayColumnsJson: Maybe<Scalars['JSONScalar']['output']>;
  dummyFieldForGraphql: Maybe<Scalars['StrictString']['output']>;
}

export interface AntibodyChainNode {
  __typename: 'AntibodyChainNode';
  domainRefs: Array<Scalars['StrictInt']['output']>;
  label: Maybe<Scalars['StrictString']['output']>;
  residues: Maybe<Scalars['StrictString']['output']>;
}

export interface AntibodyDisulfideBondNode {
  __typename: 'AntibodyDisulfideBondNode';
  sourceRef: Scalars['StrictInt']['output'];
  sourceResidueIndex: Scalars['StrictInt']['output'];
  targetRef: Scalars['StrictInt']['output'];
  targetResidueIndex: Scalars['StrictInt']['output'];
}

export interface AntibodyDomainInteractionNode {
  __typename: 'AntibodyDomainInteractionNode';
  disulfideBonds: Array<AntibodyDisulfideBondNode>;
  domainRefs: Array<Scalars['StrictInt']['output']>;
}

export interface AntibodyDomainLinkedSchemaNode {
  __typename: 'AntibodyDomainLinkedSchemaNode';
  domainType: AntibodyDomainType;
  schemaOrInterfaceId: Maybe<Scalars['StrictString']['output']>;
  specificity: Maybe<Scalars['StrictString']['output']>;
}

export interface AntibodyDomainNode {
  __typename: 'AntibodyDomainNode';
  entity: ProteinOrInaccessibleInfoNode;
  refs: Array<Scalars['StrictInt']['output']>;
  residues: Scalars['StrictString']['output'];
  specificity: Maybe<Scalars['StrictString']['output']>;
  type: AntibodyDomainType;
}

export enum AntibodyDomainType {
  CA = 'CA',
  CB = 'CB',
  CD = 'CD',
  CG = 'CG',
  CH1 = 'CH1',
  CH2 = 'CH2',
  CH3 = 'CH3',
  CH4 = 'CH4',
  CL = 'CL',
  H = 'H',
  J = 'J',
  L = 'L',
  VA = 'VA',
  VB = 'VB',
  VD = 'VD',
  VG = 'VG',
  VH = 'VH',
  VHH = 'VHH',
  VL = 'VL'
}

export interface AntibodyFormatChainNode {
  __typename: 'AntibodyFormatChainNode';
  domainRefs: Array<Scalars['StrictInt']['output']>;
  label: Maybe<Scalars['StrictString']['output']>;
}

export interface AntibodyFormatDomainInteractionNode {
  __typename: 'AntibodyFormatDomainInteractionNode';
  domainRefs: Array<Scalars['StrictInt']['output']>;
}

export interface AntibodyFormatDomainNode {
  __typename: 'AntibodyFormatDomainNode';
  ref: Scalars['StrictInt']['output'];
  specificity: Maybe<Scalars['StrictString']['output']>;
  type: AntibodyDomainType;
}

export interface AntibodyFormatNode {
  __typename: 'AntibodyFormatNode';
  chains: Array<AntibodyFormatChainNode>;
  domains: Array<AntibodyFormatDomainNode>;
  id: Scalars['StrictString']['output'];
  interactions: Array<AntibodyFormatDomainInteractionNode>;
  name: Scalars['StrictString']['output'];
}

export interface AntibodyNode {
  __typename: 'AntibodyNode';
  chains: Array<AntibodyChainNode>;
  currentVersionId: Scalars['StrictString']['output'];
  domains: Array<AntibodyDomainNode>;
  format: AntibodyFormatNode;
  fullHistory: Array<AntibodyVersionNode>;
  id: Scalars['StrictString']['output'];
  interactions: Array<AntibodyDomainInteractionNode>;
  outOfSync: Scalars['StrictBoolean']['output'];
  outOfSyncReason: Maybe<Scalars['StrictString']['output']>;
  version: Maybe<AntibodyVersionNode>;
}


export interface AntibodyNodeversionArgs {
  versionId: Scalars['StrictString']['input'];
}

export type AntibodyOrInaccessibleInfoNode = AntibodyNode | InaccessibleInfoNode;

export type AntibodySchemaInterfaceOrInaccessibleNode = ImplementedAntibodySchemaInterfaceNode | InaccessibleInfoNode;

export interface AntibodySchemaNode {
  __typename: 'AntibodySchemaNode';
  archived: Scalars['StrictBoolean']['output'];
  fieldDefinitions: Array<ComplexPolymerSchemaFieldDefinitionNode>;
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  type: Maybe<Scalars['StrictString']['output']>;
}

export interface AntibodyVersionNode {
  __typename: 'AntibodyVersionNode';
  chains: Array<AntibodyChainNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: UserNode;
  domains: Array<AntibodyDomainNode>;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  outOfSync: Scalars['StrictBoolean']['output'];
  outOfSyncReason: Maybe<Scalars['StrictString']['output']>;
  parent: Maybe<AntibodyVersionNode>;
}

export interface AppDefinitionOwningTenantNode {
  __typename: 'AppDefinitionOwningTenantNode';
  id: Scalars['StrictString']['output'];
  isCurrentTenant: Scalars['StrictBoolean']['output'];
}

export enum AppDefinitionVersionSubscriptions {
  V2_APP_ACTIVATE_REQUESTED = 'V2_APP_ACTIVATE_REQUESTED',
  V2_APP_DEACTIVATED = 'V2_APP_DEACTIVATED',
  V2_APP_INSTALLED = 'V2_APP_INSTALLED',
  V2_ASSAY_RUN_CREATED = 'V2_ASSAY_RUN_CREATED',
  V2_ASSAY_RUN_UPDATED_FIELDS = 'V2_ASSAY_RUN_UPDATED_FIELDS',
  V2_BETA_APP_CONFIGURATION_UPDATED = 'V2_BETA_APP_CONFIGURATION_UPDATED',
  V2_BETA_CANVAS_CREATED = 'V2_BETA_CANVAS_CREATED',
  V2_CANVAS_CREATED = 'V2_CANVAS_CREATED',
  V2_CANVAS_INITIALIZED = 'V2_CANVAS_INITIALIZED',
  V2_CANVAS_USER_INTERACTED = 'V2_CANVAS_USER_INTERACTED',
  V2_ENTITY_REGISTERED = 'V2_ENTITY_REGISTERED',
  V2_ENTRY_CREATED = 'V2_ENTRY_CREATED',
  V2_ENTRY_UPDATED_FIELDS = 'V2_ENTRY_UPDATED_FIELDS',
  V2_ENTRY_UPDATED_REVIEW_RECORD = 'V2_ENTRY_UPDATED_REVIEW_RECORD',
  V2_REQUEST_CREATED = 'V2_REQUEST_CREATED',
  V2_REQUEST_UPDATED_FIELDS = 'V2_REQUEST_UPDATED_FIELDS',
  V2_REQUEST_UPDATED_STATUS = 'V2_REQUEST_UPDATED_STATUS',
  V2_WORKFLOW_OUTPUT_CREATED = 'V2_WORKFLOW_OUTPUT_CREATED',
  V2_WORKFLOW_OUTPUT_UPDATED_FIELDS = 'V2_WORKFLOW_OUTPUT_UPDATED_FIELDS',
  V2_WORKFLOW_TASK_CREATED = 'V2_WORKFLOW_TASK_CREATED',
  V2_WORKFLOW_TASK_GROUP_CREATED = 'V2_WORKFLOW_TASK_GROUP_CREATED',
  V2_WORKFLOW_TASK_GROUP_MAPPING_COMPLETED = 'V2_WORKFLOW_TASK_GROUP_MAPPING_COMPLETED',
  V2_WORKFLOW_TASK_GROUP_UPDATED_WATCHERS = 'V2_WORKFLOW_TASK_GROUP_UPDATED_WATCHERS',
  V2_WORKFLOW_TASK_UPDATED_ASSIGNEE = 'V2_WORKFLOW_TASK_UPDATED_ASSIGNEE',
  V2_WORKFLOW_TASK_UPDATED_FIELDS = 'V2_WORKFLOW_TASK_UPDATED_FIELDS',
  V2_WORKFLOW_TASK_UPDATED_SCHEDULED_ON = 'V2_WORKFLOW_TASK_UPDATED_SCHEDULED_ON',
  V2_WORKFLOW_TASK_UPDATED_STATUS = 'V2_WORKFLOW_TASK_UPDATED_STATUS',
  V3_CUSTOM_ENTITY_CREATED = 'V3_CUSTOM_ENTITY_CREATED',
  V3_CUSTOM_ENTITY_UPDATED = 'V3_CUSTOM_ENTITY_UPDATED',
  V3_DNA_OLIGO_CREATED = 'V3_DNA_OLIGO_CREATED',
  V3_DNA_OLIGO_UPDATED = 'V3_DNA_OLIGO_UPDATED',
  V3_DNA_SEQUENCE_CREATED = 'V3_DNA_SEQUENCE_CREATED',
  V3_DNA_SEQUENCE_UPDATED = 'V3_DNA_SEQUENCE_UPDATED',
  V3_ENTRY_CREATED = 'V3_ENTRY_CREATED',
  V3_PROJECT_CREATED = 'V3_PROJECT_CREATED',
  V3_PROJECT_UPDATED = 'V3_PROJECT_UPDATED',
  V3_RNA_OLIGO_CREATED = 'V3_RNA_OLIGO_CREATED',
  V3_RNA_OLIGO_UPDATED = 'V3_RNA_OLIGO_UPDATED',
  V3_RNA_SEQUENCE_CREATED = 'V3_RNA_SEQUENCE_CREATED',
  V3_RNA_SEQUENCE_UPDATED = 'V3_RNA_SEQUENCE_UPDATED',
  V3_RUN_CREATED = 'V3_RUN_CREATED'
}

export interface AppEventSubscriptionNode extends EventSubscriptionInterface {
  __typename: 'AppEventSubscriptionNode';
  benchlingApp: BenchlingAppNode;
  destinationType: DestinationType;
  eventTypes: Array<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  logIds: Array<Scalars['StrictString']['output']>;
  name: Scalars['StrictString']['output'];
  paused: Scalars['StrictBoolean']['output'];
}

export enum AppLifecycleManagement {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL'
}

export enum AppLifecycleState {
  ACTIVATE_PENDING = 'ACTIVATE_PENDING',
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  DEACTIVATE_PENDING = 'DEACTIVATE_PENDING',
  INACTIVE = 'INACTIVE',
  INSTALLED = 'INSTALLED'
}

export interface ArchiveDataNode {
  __typename: 'ArchiveDataNode';
  archived: Scalars['StrictBoolean']['output'];
  purpose: Maybe<Scalars['StrictString']['output']>;
}

export interface ArchiveRecordNode {
  __typename: 'ArchiveRecordNode';
  purpose: Scalars['StrictString']['output'];
}

export interface AssayRecordOriginNode {
  __typename: 'AssayRecordOriginNode';
  analysisOrigin: Maybe<AnalysisOriginNode>;
  elnOrigin: ELNOriginNode;
  id: Scalars['StrictString']['output'];
  type: AssayRecordOriginType;
}

export enum AssayRecordOriginType {
  API = 'API',
  ELN = 'ELN',
  PIPELINE = 'PIPELINE'
}

export type AssaySchemaNode = RequestSchemaNode | ResultSchemaNode | RunSchemaNode;

export type AssaySchemaOrInaccessibleInfoNode = InaccessibleInfoNode | RequestSchemaNode | ResultSchemaNode | RunSchemaNode;

export type AsyncDataNode = ProcessFlowchartExecuteSchemaMapperRecordNode | ProcessFlowchartSchemaMappingRecordNode | ProcessStartAutomatedMappingRecordNode;

export enum AsyncValidationStatus {
  FAILED = 'FAILED',
  OVERRIDDEN = 'OVERRIDDEN',
  PASSED = 'PASSED',
  VALIDATING = 'VALIDATING'
}

export interface AttachmentPointNode {
  __typename: 'AttachmentPointNode';
  isAvailable: Scalars['StrictBoolean']['output'];
  isInNucleotideBond: Scalars['StrictBoolean']['output'];
  modificationType: Maybe<NucleotideModificationType>;
  monomerName: Maybe<Scalars['StrictString']['output']>;
  rGroup: Scalars['StrictInt']['output'];
}

export type AttachmentPointOrErrorNode = AttachmentPointNode | ErrorNode;

export enum Audience {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type AuthnOptionNode = GoogleOAuthAuthnOptionNode | PasswordAuthnOptionNode | SAMLAuthnOptionNode;

export interface AuthnOptionNodeInterface {
  domains: Array<Scalars['StrictString']['output']>;
  enabled: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export interface AutomationErrorFileNode {
  __typename: 'AutomationErrorFileNode';
  automationOutputFileConfig: AutomationOutputFileConfigNode;
  blob: Maybe<ResultBlobNode>;
  id: Scalars['StrictString']['output'];
  status: Status;
}

export interface AutomationInputFileConfigNode {
  __typename: 'AutomationInputFileConfigNode';
  id: Scalars['StrictInt']['output'];
  isHidden: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
}

export interface AutomationInputFileNode {
  __typename: 'AutomationInputFileNode';
  automationInputFileConfig: AutomationInputFileConfigNode;
  blob: Maybe<ResultBlobNode>;
  errors: Maybe<Scalars['JSONScalar']['output']>;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  status: Status;
  transformFiles: Array<Maybe<AutomationInputTransformFileNode>>;
}

export type AutomationInputFileOrInaccessibleInfoNode = AutomationInputFileNode | InaccessibleInfoNode;

export interface AutomationInputTransformFileNode {
  __typename: 'AutomationInputTransformFileNode';
  blob: Maybe<ResultBlobNode>;
  errors: Maybe<Scalars['JSONScalar']['output']>;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  status: Status;
  type: Scalars['StrictString']['output'];
}

export interface AutomationOutputFileConfigNode {
  __typename: 'AutomationOutputFileConfigNode';
  automationOutputFileActionType: Scalars['StrictString']['output'];
  destinationInfo: Maybe<AutomationOutputFileDestinationInfoNode>;
  id: Scalars['StrictInt']['output'];
  isHidden: Scalars['StrictBoolean']['output'];
  jsonMapperConfigJson: Maybe<Scalars['StrictString']['output']>;
  name: Scalars['StrictString']['output'];
  resultSchemaInfo: Maybe<AutomationOutputFileResultSchemaInfoNode>;
  shouldAllowAttachment: Scalars['StrictBoolean']['output'];
  shouldCreateDataset: Scalars['StrictBoolean']['output'];
  shouldPerformPlateTransfer: Scalars['StrictBoolean']['output'];
  shouldRecordImages: Scalars['StrictBoolean']['output'];
  spreadsheetProcessingLocale: Scalars['StrictString']['output'];
  tagSchemaInfo: Maybe<AutomationOutputFileTagSchemaInfoNode>;
  transformDataType: Maybe<Scalars['StrictString']['output']>;
}

export interface AutomationOutputFileDestinationInfoNode {
  __typename: 'AutomationOutputFileDestinationInfoNode';
  location: Maybe<LocationNode>;
  sourceId: Maybe<Scalars['StrictString']['output']>;
  storableSchema: Maybe<StorableSchemaInterface>;
}

export interface AutomationOutputFileNode extends HasArchiveRecordInterface {
  __typename: 'AutomationOutputFileNode';
  analysisId: Maybe<Scalars['StrictString']['output']>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  automationOutputFileConfig: AutomationOutputFileConfigNode;
  automationOutputFileType: Scalars['StrictString']['output'];
  blob: Maybe<ResultBlobNode>;
  canConfigureTimezone: Scalars['StrictBoolean']['output'];
  createdAt: Scalars['StrictString']['output'];
  createdFile: Maybe<FileOrInaccessibleInfoNode>;
  datasetId: Maybe<Scalars['StrictString']['output']>;
  errors: Maybe<Scalars['JSONScalar']['output']>;
  folderId: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  locationId: Maybe<Scalars['StrictString']['output']>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  numRowsWithErrors: Scalars['StrictInt']['output'];
  plateRecordsJson: Maybe<Scalars['JSONScalar']['output']>;
  rowLevelErrorsBlob: Maybe<ResultBlobNode>;
  runId: Maybe<Scalars['StrictString']['output']>;
  skipRowsWithErrors: Scalars['StrictBoolean']['output'];
  skipRowsWithErrorsRequired: Scalars['StrictBoolean']['output'];
  status: Status;
  timezone: Maybe<Scalars['StrictString']['output']>;
  transforms: Array<Maybe<AutomationOutputTransformFileNode>>;
}

export type AutomationOutputFileOrInaccessibleInfoNode = AutomationOutputFileNode | InaccessibleInfoNode;

export interface AutomationOutputFileResultSchemaInfoNode {
  __typename: 'AutomationOutputFileResultSchemaInfoNode';
  resultSchema: Maybe<ResultSchemaNode>;
}

export interface AutomationOutputFileTagSchemaInfoNode {
  __typename: 'AutomationOutputFileTagSchemaInfoNode';
  folder: Maybe<FolderNode>;
  sourceId: Maybe<Scalars['StrictString']['output']>;
  tagSchema: Maybe<TagSchemaNode>;
}

export interface AutomationOutputTransformFileNode {
  __typename: 'AutomationOutputTransformFileNode';
  blob: Maybe<ResultBlobNode>;
  errors: Maybe<Scalars['JSONScalar']['output']>;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  status: Status;
  type: Scalars['StrictString']['output'];
}

export interface BLASTDBNode {
  __typename: 'BLASTDBNode';
  dbType: DBType;
  epoch: Scalars['StrictString']['output'];
}

export interface BarcodeNode {
  __typename: 'BarcodeNode';
  value: Scalars['StrictString']['output'];
}

export interface BartenderServerNode {
  __typename: 'BartenderServerNode';
  id: Scalars['StrictString']['output'];
  name: Maybe<Scalars['StrictString']['output']>;
  url: Scalars['StrictString']['output'];
}

export interface BaseEntryInterface {
  entryDays: Array<EntryDayNode>;
  humanId: Maybe<Scalars['StrictString']['output']>;
}

export interface BaseEntryNode extends BaseEntryInterface, EntryLikeInterface {
  __typename: 'BaseEntryNode';
  archiveRecord: Maybe<Scalars['JSONScalar']['output']>;
  created_at: Scalars['StrictString']['output'];
  editURL: Scalars['StrictString']['output'];
  entryDays: Array<EntryDayNode>;
  humanId: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  review: Maybe<ReviewNode>;
  tagSchema: Maybe<Scalars['JSONScalar']['output']>;
  tags: Scalars['JSONScalar']['output'];
}

export interface BaseFieldDefinitionNode extends CoreObjectArchivableInterface, FieldDefinitionInterface, HasCreatorInterface, HasPermissionsInterface {
  __typename: 'BaseFieldDefinitionNode';
  archiveData: ArchiveDataNode;
  creator: PrincipalInterface;
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  isRequired: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  provenanceUri: Scalars['StrictString']['output'];
  shortDescription: Maybe<Scalars['StrictString']['output']>;
  systemName: Scalars['StrictString']['output'];
  type: FieldDefinitionType;
}

export interface BaseFolderItemInterface {
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
}

export interface BaseProcedureDataParameterSettingInterface {
  version: ProcedureDataParameterVersionNode;
}

export interface BaseProcedureEquipmentSettingInterface {
  version: ProcedureEquipmentVersionNode;
}

export interface BaseProcedureFlowchartVersionInterface {
  edges: Array<ProcedureEdgeNode>;
  id: Scalars['StrictString']['output'];
  largestTableTypeSizes: Array<LargestTableTypeSizeNode>;
  nodes: Array<BaseProcedureMethodDefinitionVersionInterface>;
  procedureFlowchart: ProcedureFlowchartNode;
}

export interface BaseProcedureMaterialInputSettingInterface {
  version: ProcedureMaterialInputVersionNode;
}

export interface BaseProcedureMethodDefinitionVersionInterface {
  analysisTemplateConfigurations: Array<ProcedureAnalysisTemplateConfigurationOrInaccessibleInfoNode>;
  dataParameterSettings: Array<BaseProcedureDataParameterSettingInterface>;
  description: Scalars['StrictString']['output'];
  dilutionPlan: DilutionPlanNode;
  equipmentSettings: Array<BaseProcedureEquipmentSettingInterface>;
  gridLayoutCoordinates: GridLayoutCoordinatesNode;
  id: Scalars['StrictString']['output'];
  materialInputSettings: Array<BaseProcedureMaterialInputSettingInterface>;
  materialOutputSettings: Array<ProcedureMaterialOutputSettingNode>;
  name: Scalars['StrictString']['output'];
  nodeId: Scalars['StrictString']['output'];
  parameterUsagesExpensive: Array<ProcedureParameterUsageNode>;
  provenanceId: Scalars['StrictString']['output'];
  sourceMethodId: Maybe<Scalars['StrictString']['output']>;
  stepGroups: Array<ProcedureStepGroupNode>;
  testDefinitions: Array<TestDefinitionOrInaccessibleInfoNode>;
}

export interface BaseSchemaInterfaceConfigInterface {
  interface: BaseSchemaInterfaceInterface;
}

export interface BaseSchemaInterfaceInterface {
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export enum BaseUnitType {
  AMOUNT = 'AMOUNT',
  CURRENT = 'CURRENT',
  LENGTH = 'LENGTH',
  LUMINOUS_INTENSITY = 'LUMINOUS_INTENSITY',
  MASS = 'MASS',
  TEMPERATURE = 'TEMPERATURE',
  TIME = 'TIME'
}

export interface BasicFolderItemNode extends FolderItemInterface, HasArchiveRecordInterface, PoliceableInterface, RegistryItemInterface, SearchableInterface, StudyableInterface, TrialSampleItemInterface, WorklistItemInterface {
  __typename: 'BasicFolderItemNode';
  allChildEntities: Array<RegistryItemInterface>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  bioentityAliasInfos: Array<BioentityAliasInfoNode>;
  childEntities: Array<RegistryItemInterface>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  convertedToItem: Maybe<RegistryItemInterface>;
  createdAt: Scalars['StrictString']['output'];
  displayLabel: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  hasExpirationTracking: Scalars['StrictBoolean']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  isStudyable: Scalars['StrictBoolean']['output'];
  isTrialSample: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  linkedContainerContents: Array<ContainerContentNode>;
  matchingChildEntities: MatchingChildEntitiesNode;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  noteJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  projectFolder: Maybe<FolderNode>;
  registrationOrigin: Maybe<RegistrationOriginNode>;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  residues: Maybe<Scalars['StrictString']['output']>;
  sampleDefinitionLinks: Maybe<Array<SampleDefinitionLinkNode>>;
  schemaValidationStateJson: Maybe<Scalars['JSONScalar']['output']>;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  testOrders: Array<TestOrderNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  validEntitiesForFieldPathInfo: Maybe<ValidEntitiesForFieldPathNode>;
}


export interface BasicFolderItemNodechildEntitiesArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface BasicFolderItemNodematchingChildEntitiesArgs {
  archivePurposes?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  childEntitySchemaId: Scalars['StrictString']['input'];
  limit?: InputMaybe<Scalars['StrictInt']['input']>;
  offset?: InputMaybe<Scalars['StrictInt']['input']>;
  queryString?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface BasicFolderItemNodetestOrdersArgs {
  statusIsOneOf?: InputMaybe<Array<TestOrderStatus>>;
}


export interface BasicFolderItemNodevalidEntitiesForFieldPathInfoArgs {
  fieldId: Scalars['StrictString']['input'];
}

export type BasicFolderItemOrInaccessibleInfoNode = BasicFolderItemNode | InaccessibleInfoNode;

export interface BatchNode extends HasArchiveRecordInterface, HasCreatorInterface, WorklistItemInterface {
  __typename: 'BatchNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  batchSchema: BatchSchemaNode;
  bioentity: RegistryItemInterface;
  concentrationJson: Maybe<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  linkedContainerContents: Array<ContainerContentNode>;
  migratedToBasicFolderItem: Maybe<BasicFolderItemOrInaccessibleInfoNode>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: Maybe<Scalars['JSONScalar']['output']>;
  tagsJson: Maybe<Scalars['JSONScalar']['output']>;
  url: Scalars['StrictString']['output'];
}

export type BatchOrInaccessibleInfoNode = BatchNode | InaccessibleInfoNode;

export enum BatchSchemaNamingScheme {
  BIOENTITY_NAME = 'BIOENTITY_NAME',
  BIOENTITY_REGISTRY_ID = 'BIOENTITY_REGISTRY_ID',
  BIOENTITY_REGISTRY_ID_WITH_DATE = 'BIOENTITY_REGISTRY_ID_WITH_DATE'
}

export interface BatchSchemaNode extends HasArchiveRecordInterface, SchemaInterface {
  __typename: 'BatchSchemaNode';
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  fileTypeName: Scalars['StrictString']['output'];
  hidden: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  namingScheme: BatchSchemaNamingScheme;
  relatedBenchlingApps: Array<BenchlingAppNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
  tagSchema: TagSchemaNode;
}


export interface BatchSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export interface BenchlingAppCanvasFeatureListingNode {
  __typename: 'BenchlingAppCanvasFeatureListingNode';
  canvasFeatures: Array<BenchlingAppFeatureNode>;
}

export enum BenchlingAppCanvasLocation {
  ENTRY = 'ENTRY',
  ENTRY_TEMPLATE = 'ENTRY_TEMPLATE'
}

export interface BenchlingAppCanvasNode {
  __typename: 'BenchlingAppCanvasNode';
  benchlingApp: BenchlingAppNode;
  enabled: Scalars['StrictBoolean']['output'];
  featureOrNull: Maybe<BenchlingAppFeatureNode>;
  featureType: BenchlingAppFeatureType;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  resourceId: Scalars['StrictString']['output'];
  session: Maybe<BenchlingAppSessionNode>;
  uiBlocks: Array<UiBlockNode>;
}

export type BenchlingAppCanvasOrInaccessibleInfoNode = BenchlingAppCanvasNode | InaccessibleInfoNode;

export interface BenchlingAppConfigArrayElementNode {
  __typename: 'BenchlingAppConfigArrayElementNode';
  elementConfigs: Array<BenchlingAppConfigurationNode>;
  name: Scalars['StrictString']['output'];
}

export interface BenchlingAppConfigurationNode {
  __typename: 'BenchlingAppConfigurationNode';
  defaultElementName: Maybe<Scalars['StrictString']['output']>;
  description: Maybe<Scalars['StrictString']['output']>;
  elementDefinition: Maybe<Array<BenchlingAppConfigurationNode>>;
  elements: Maybe<Array<BenchlingAppConfigArrayElementNode>>;
  enum: Maybe<Array<Scalars['ScalarEnumOption']['output']>>;
  fieldDefinitions: Maybe<Array<BenchlingAppSubDependencyNode>>;
  maxElements: Maybe<Scalars['StrictInt']['output']>;
  minElements: Maybe<Scalars['StrictInt']['output']>;
  name: Scalars['StrictString']['output'];
  options: Maybe<Array<BenchlingAppSubDependencyNode>>;
  output: Maybe<OutputFieldDefinitionNode>;
  requiredConfig: Scalars['StrictBoolean']['output'];
  /** @deprecated Deprecated in favor of value */
  scalarValue: Maybe<Scalars['JSONScalar']['output']>;
  subtype: Maybe<BenchlingAppSubtype>;
  type: BenchlingAppType;
  value: Maybe<Scalars['JSONScalar']['output']>;
}

export interface BenchlingAppDefinitionListingNode {
  __typename: 'BenchlingAppDefinitionListingNode';
  appDefinitions: Array<BenchlingAppDefinitionNode>;
  total: Scalars['StrictInt']['output'];
}

export interface BenchlingAppDefinitionNode extends HasOptionalCreatorInterface {
  __typename: 'BenchlingAppDefinitionNode';
  audience: Audience;
  createdAt: Scalars['StrictString']['output'];
  creator: Maybe<PrincipalInterface>;
  id: Scalars['StrictString']['output'];
  installation: Maybe<BenchlingAppNode>;
  latestReleaseVersion: Maybe<BenchlingAppDefinitionVersionNode>;
  modifiedAt: Scalars['StrictString']['output'];
  oauthCredential: Maybe<OAuthCredentialOrInaccessibleInfoNode>;
  owningTenant: AppDefinitionOwningTenantNode;
  publicKey: Maybe<Scalars['StrictString']['output']>;
  versions: Array<BenchlingAppDefinitionVersionNode>;
  webhookHeaders: Array<WebhookHeaderNode>;
  webhookSetupIsAccessible: Scalars['StrictBoolean']['output'];
  webhookUrl: Maybe<Scalars['StrictString']['output']>;
}

export type BenchlingAppDefinitionOrInaccessibleInfoNode = BenchlingAppDefinitionNode | InaccessibleInfoNode;

export interface BenchlingAppDefinitionVersionNode {
  __typename: 'BenchlingAppDefinitionVersionNode';
  allowList: Array<BenchlingAppTenantAllowListNode>;
  createdAt: Maybe<Scalars['StrictString']['output']>;
  description: Maybe<Scalars['StrictString']['output']>;
  hasSecureTextConfigs: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Maybe<Scalars['StrictString']['output']>;
  name: Scalars['StrictString']['output'];
  publicationState: PublicationState;
  subscriptions: Array<AppDefinitionVersionSubscriptions>;
  versionId: Scalars['StrictString']['output'];
}

export interface BenchlingAppFeatureNode {
  __typename: 'BenchlingAppFeatureNode';
  benchlingApp: BenchlingAppNode;
  id: Scalars['StrictInt']['output'];
  name: Scalars['StrictString']['output'];
  type: BenchlingAppFeatureType;
  userDefinedId: Scalars['StrictString']['output'];
}

export type BenchlingAppFeatureOrInaccessibleInfoNode = BenchlingAppFeatureNode | InaccessibleInfoNode;

export enum BenchlingAppFeatureType {
  APP_HOMEPAGE = 'APP_HOMEPAGE',
  ASSAY_RUN = 'ASSAY_RUN',
  CANVAS = 'CANVAS'
}

export interface BenchlingAppFieldConstraintsNode {
  __typename: 'BenchlingAppFieldConstraintsNode';
  internalType: Maybe<Scalars['StrictString']['output']>;
  isMulti: Maybe<Scalars['StrictBoolean']['output']>;
  isRequired: Maybe<Scalars['StrictBoolean']['output']>;
}

export interface BenchlingAppListingNode {
  __typename: 'BenchlingAppListingNode';
  benchlingApps: Array<BenchlingAppNode>;
  total: Scalars['StrictInt']['output'];
}

export interface BenchlingAppMessageListingNode {
  __typename: 'BenchlingAppMessageListingNode';
  messages: Array<BenchlingAppSessionMessageNode>;
  total: Scalars['StrictInt']['output'];
}

export interface BenchlingAppNode extends CreatorInterface, HasArchiveRecordInterface, HasCreatorInterface, PartyInterface, PrincipalInterface, SearchableInterface {
  __typename: 'BenchlingAppNode';
  appDefinitionId: Maybe<Scalars['StrictString']['output']>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  archived: Scalars['StrictBoolean']['output'];
  audience: Maybe<Audience>;
  avatarUrl: Maybe<Scalars['StrictString']['output']>;
  benchlingAppProjectsListing: PartyPoliceablesListingNode;
  benchlingAppRegistriesListing: PartyPoliceablesListingNode;
  configuration: Array<BenchlingAppConfigurationNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  description: Maybe<Scalars['StrictString']['output']>;
  eventSubscription: Maybe<AppEventSubscriptionNode>;
  features: Array<BenchlingAppFeatureNode>;
  handle: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  isActivityTabVisible: Scalars['StrictBoolean']['output'];
  isConfigurationTabVisible: Scalars['StrictBoolean']['output'];
  isGlobal: Scalars['StrictBoolean']['output'];
  isMissingRequiredPublicKey: Scalars['StrictBoolean']['output'];
  isPrivate: Maybe<Scalars['StrictBoolean']['output']>;
  joinedOn: Scalars['StrictString']['output'];
  lastSeen: Maybe<Scalars['StrictString']['output']>;
  lifecycleManagement: AppLifecycleManagement;
  lifecycleState: AppLifecycleState;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  oauthCredential: Maybe<OAuthCredentialOrInaccessibleInfoNode>;
  organizationRoles: Array<OrganizationRoleNode>;
  organizations: Array<OrganizationNode>;
  owningTenant: OwningTenantNode;
  permissions: PermissionsNode;
  publicKey: Maybe<Scalars['StrictString']['output']>;
  sessionListing: BenchlingAppSessionListingNode;
  sessions: Array<BenchlingAppSessionNode>;
  subscriptions: Array<BenchlingAppSubscriptions>;
  teamRoles: Array<TeamRoleNode>;
  teams: Array<TeamNode>;
  url: Scalars['StrictString']['output'];
  urlIdentifier: Scalars['StrictString']['output'];
  versionNumber: Maybe<Scalars['StrictString']['output']>;
  webhookConfigurations: Array<WebhookConfigurationOrInaccessibleInfoNode>;
}


export interface BenchlingAppNodebenchlingAppProjectsListingArgs {
  limitOffsetInput: LimitOffsetInput;
}


export interface BenchlingAppNodebenchlingAppRegistriesListingArgs {
  limitOffsetInput: LimitOffsetInput;
}


export interface BenchlingAppNodesessionListingArgs {
  limitOffsetInput: LimitOffsetInput;
}

export type BenchlingAppOrInaccessibleInfoNode = BenchlingAppNode | InaccessibleInfoNode;

export interface BenchlingAppSessionListingNode {
  __typename: 'BenchlingAppSessionListingNode';
  sessions: Array<BenchlingAppSessionNode>;
  total: Scalars['StrictInt']['output'];
}

export interface BenchlingAppSessionMessageNode {
  __typename: 'BenchlingAppSessionMessageNode';
  content: Scalars['StrictString']['output'];
  style: BenchlingAppSessionMessageStyle;
  timestamp: Scalars['StrictString']['output'];
}

export enum BenchlingAppSessionMessageStyle {
  ERROR = 'ERROR',
  INFO = 'INFO',
  NONE = 'NONE',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

export interface BenchlingAppSessionNode {
  __typename: 'BenchlingAppSessionNode';
  allMessagesListing: BenchlingAppMessageListingNode;
  createdAt: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  messages: Array<BenchlingAppSessionMessageNode>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  status: BenchlingAppSessionStatus;
}


export interface BenchlingAppSessionNodeallMessagesListingArgs {
  limitOffsetInput?: InputMaybe<LimitOffsetInput>;
}

export type BenchlingAppSessionOrInaccessibleInfoNode = BenchlingAppSessionNode | InaccessibleInfoNode;

export enum BenchlingAppSessionStatus {
  COMPLETED_WITH_WARNINGS = 'COMPLETED_WITH_WARNINGS',
  FAILED = 'FAILED',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
  TIMEOUT = 'TIMEOUT'
}

export interface BenchlingAppSubDependencyNode {
  __typename: 'BenchlingAppSubDependencyNode';
  description: Maybe<Scalars['StrictString']['output']>;
  fieldConstraints: Maybe<BenchlingAppFieldConstraintsNode>;
  name: Scalars['StrictString']['output'];
  requiredConfig: Scalars['StrictBoolean']['output'];
  type: BenchlingAppType;
  value: Maybe<Scalars['StrictString']['output']>;
}

export enum BenchlingAppSubscriptions {
  V2_APP_ACTIVATE_REQUESTED = 'V2_APP_ACTIVATE_REQUESTED',
  V2_APP_DEACTIVATED = 'V2_APP_DEACTIVATED',
  V2_APP_INSTALLED = 'V2_APP_INSTALLED',
  V2_ASSAY_RUN_CREATED = 'V2_ASSAY_RUN_CREATED',
  V2_ASSAY_RUN_UPDATED_FIELDS = 'V2_ASSAY_RUN_UPDATED_FIELDS',
  V2_BETA_APP_CONFIGURATION_UPDATED = 'V2_BETA_APP_CONFIGURATION_UPDATED',
  V2_BETA_CANVAS_CREATED = 'V2_BETA_CANVAS_CREATED',
  V2_CANVAS_CREATED = 'V2_CANVAS_CREATED',
  V2_CANVAS_INITIALIZED = 'V2_CANVAS_INITIALIZED',
  V2_CANVAS_USER_INTERACTED = 'V2_CANVAS_USER_INTERACTED',
  V2_ENTITY_REGISTERED = 'V2_ENTITY_REGISTERED',
  V2_ENTRY_CREATED = 'V2_ENTRY_CREATED',
  V2_ENTRY_UPDATED_FIELDS = 'V2_ENTRY_UPDATED_FIELDS',
  V2_ENTRY_UPDATED_REVIEW_RECORD = 'V2_ENTRY_UPDATED_REVIEW_RECORD',
  V2_REQUEST_CREATED = 'V2_REQUEST_CREATED',
  V2_REQUEST_UPDATED_FIELDS = 'V2_REQUEST_UPDATED_FIELDS',
  V2_REQUEST_UPDATED_STATUS = 'V2_REQUEST_UPDATED_STATUS',
  V2_WORKFLOW_OUTPUT_CREATED = 'V2_WORKFLOW_OUTPUT_CREATED',
  V2_WORKFLOW_OUTPUT_UPDATED_FIELDS = 'V2_WORKFLOW_OUTPUT_UPDATED_FIELDS',
  V2_WORKFLOW_TASK_CREATED = 'V2_WORKFLOW_TASK_CREATED',
  V2_WORKFLOW_TASK_GROUP_CREATED = 'V2_WORKFLOW_TASK_GROUP_CREATED',
  V2_WORKFLOW_TASK_GROUP_MAPPING_COMPLETED = 'V2_WORKFLOW_TASK_GROUP_MAPPING_COMPLETED',
  V2_WORKFLOW_TASK_GROUP_UPDATED_WATCHERS = 'V2_WORKFLOW_TASK_GROUP_UPDATED_WATCHERS',
  V2_WORKFLOW_TASK_UPDATED_ASSIGNEE = 'V2_WORKFLOW_TASK_UPDATED_ASSIGNEE',
  V2_WORKFLOW_TASK_UPDATED_FIELDS = 'V2_WORKFLOW_TASK_UPDATED_FIELDS',
  V2_WORKFLOW_TASK_UPDATED_SCHEDULED_ON = 'V2_WORKFLOW_TASK_UPDATED_SCHEDULED_ON',
  V2_WORKFLOW_TASK_UPDATED_STATUS = 'V2_WORKFLOW_TASK_UPDATED_STATUS',
  V3_CUSTOM_ENTITY_CREATED = 'V3_CUSTOM_ENTITY_CREATED',
  V3_CUSTOM_ENTITY_UPDATED = 'V3_CUSTOM_ENTITY_UPDATED',
  V3_DNA_OLIGO_CREATED = 'V3_DNA_OLIGO_CREATED',
  V3_DNA_OLIGO_UPDATED = 'V3_DNA_OLIGO_UPDATED',
  V3_DNA_SEQUENCE_CREATED = 'V3_DNA_SEQUENCE_CREATED',
  V3_DNA_SEQUENCE_UPDATED = 'V3_DNA_SEQUENCE_UPDATED',
  V3_ENTRY_CREATED = 'V3_ENTRY_CREATED',
  V3_PROJECT_CREATED = 'V3_PROJECT_CREATED',
  V3_PROJECT_UPDATED = 'V3_PROJECT_UPDATED',
  V3_RNA_OLIGO_CREATED = 'V3_RNA_OLIGO_CREATED',
  V3_RNA_OLIGO_UPDATED = 'V3_RNA_OLIGO_UPDATED',
  V3_RNA_SEQUENCE_CREATED = 'V3_RNA_SEQUENCE_CREATED',
  V3_RNA_SEQUENCE_UPDATED = 'V3_RNA_SEQUENCE_UPDATED',
  V3_RUN_CREATED = 'V3_RUN_CREATED'
}

export enum BenchlingAppSubtype {
  aa_sequence = 'aa_sequence',
  custom_entity = 'custom_entity',
  dna_oligo = 'dna_oligo',
  dna_sequence = 'dna_sequence',
  mixture = 'mixture',
  molecule = 'molecule',
  rna_oligo = 'rna_oligo',
  rna_sequence = 'rna_sequence'
}

export interface BenchlingAppTenantAllowListNode {
  __typename: 'BenchlingAppTenantAllowListNode';
  tenantId: Scalars['StrictString']['output'];
}

export enum BenchlingAppType {
  aa_sequence = 'aa_sequence',
  array = 'array',
  array_element = 'array_element',
  array_value = 'array_value',
  assay_result = 'assay_result',
  assay_run = 'assay_run',
  automation_input_generator = 'automation_input_generator',
  automation_output_processor = 'automation_output_processor',
  blob = 'blob',
  boolean = 'boolean',
  box = 'box',
  box_schema = 'box_schema',
  container = 'container',
  container_schema = 'container_schema',
  custom_entity = 'custom_entity',
  date = 'date',
  datetime = 'datetime',
  dna_alignment = 'dna_alignment',
  dna_oligo = 'dna_oligo',
  dna_sequence = 'dna_sequence',
  dropdown = 'dropdown',
  dropdown_option = 'dropdown_option',
  entity_schema = 'entity_schema',
  entry = 'entry',
  entry_schema = 'entry_schema',
  field = 'field',
  float = 'float',
  folder = 'folder',
  instance = 'instance',
  integer = 'integer',
  json = 'json',
  legacy_request = 'legacy_request',
  legacy_request_schema = 'legacy_request_schema',
  location = 'location',
  location_schema = 'location_schema',
  mixture = 'mixture',
  molecule = 'molecule',
  plate = 'plate',
  plate_schema = 'plate_schema',
  project = 'project',
  registry = 'registry',
  request = 'request',
  request_schema = 'request_schema',
  result_schema = 'result_schema',
  rna_oligo = 'rna_oligo',
  rna_sequence = 'rna_sequence',
  run_schema = 'run_schema',
  secure_text = 'secure_text',
  text = 'text',
  wf_output_schema_field = 'wf_output_schema_field',
  workflow_task_schema = 'workflow_task_schema',
  workflow_task_status = 'workflow_task_status',
  worklist = 'worklist'
}

export enum BenchlingAppUiBlockType {
  BUTTON = 'BUTTON',
  CHIP = 'CHIP',
  DROPDOWN = 'DROPDOWN',
  DROPDOWN_MULTIVALUE = 'DROPDOWN_MULTIVALUE',
  FILE_UPLOAD = 'FILE_UPLOAD',
  MARKDOWN = 'MARKDOWN',
  SEARCH_INPUT = 'SEARCH_INPUT',
  SEARCH_INPUT_MULTIVALUE = 'SEARCH_INPUT_MULTIVALUE',
  SECTION = 'SECTION',
  SELECTOR_INPUT = 'SELECTOR_INPUT',
  SELECTOR_INPUT_MULTIVALUE = 'SELECTOR_INPUT_MULTIVALUE',
  TABLE = 'TABLE',
  TEXT_INPUT = 'TEXT_INPUT'
}

export interface BenchlingExpressionNode {
  __typename: 'BenchlingExpressionNode';
  expressionJson: Maybe<Scalars['JSONScalar']['output']>;
}

export type BenchlingExpressionOrInaccessibleNode = BenchlingExpressionNode | InaccessibleInfoNode;

export interface BioentityAliasInfoNode {
  __typename: 'BioentityAliasInfoNode';
  alias: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  registryCollectionOwnerJson: Maybe<Scalars['JSONScalar']['output']>;
}

export type BiomoleculeEntityOrInaccessibleInfoNode = InaccessibleInfoNode | MoleculeNode | ProteinNode | SequenceNode;

export interface BoxNode extends GridInterface, HasArchiveRecordInterface, HasCreatorInterface, SearchableInterface, StorableInterface, StudyableInterface {
  __typename: 'BoxNode';
  ancestry: Array<StorableOrInaccessibleInfoNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  barcode: Maybe<BarcodeNode>;
  cell: Maybe<GridCellNode>;
  cells: Array<Array<Maybe<GridCellNode>>>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead. */
  creatorJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  occupiedCapacity: Maybe<Scalars['StrictInt']['output']>;
  parentStorable: Maybe<StorableOrInaccessibleInfoNode>;
  permissions: PermissionsNode;
  source: SourceInterface;
  starred: Scalars['StrictBoolean']['output'];
  storableSchema: BoxSchemaNode;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  tagsJson: Scalars['JSONScalar']['output'];
  totalCapacity: Maybe<Scalars['StrictInt']['output']>;
  validationState: Maybe<ValidationStateNode>;
}


export interface BoxNodecellArgs {
  colIndex?: InputMaybe<Scalars['StrictInt']['input']>;
  rowIndex?: InputMaybe<Scalars['StrictInt']['input']>;
}


export interface BoxNodeparentStorableArgs {
  skipAuthCheck?: InputMaybe<Scalars['StrictBoolean']['input']>;
}

export type BoxOrInaccessibleInfoNode = BoxNode | InaccessibleInfoNode;

export interface BoxSchemaNode extends GridSchemaInterface, HasArchiveRecordInterface, SchemaInterface, StorableSchemaInterface {
  __typename: 'BoxSchemaNode';
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  containerSchema: Maybe<ContainerSchemaNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  height: Scalars['StrictInt']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  numValidationFailures: Scalars['StrictInt']['output'];
  prefix: Scalars['StrictString']['output'];
  registry: RegistryNode;
  relatedBenchlingApps: Array<BenchlingAppNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
  storablesFailingValidation: Array<StorableOrInaccessibleInfoNode>;
  width: Scalars['StrictInt']['output'];
}


export interface BoxSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export interface BranchedAttachmentNode {
  __typename: 'BranchedAttachmentNode';
  displayName: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  residueIndex: Scalars['StrictInt']['output'];
}

export interface BulkAssemblyNode extends BaseFolderItemInterface, HasArchiveRecordInterface, HasAuthorsInterface, HasCreatorInterface, SearchableInterface, StudyableInterface {
  __typename: 'BulkAssemblyNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  editUrl: Scalars['StrictString']['output'];
  finalizedAt: Maybe<Scalars['StrictString']['output']>;
  finalizedResultsJson: Maybe<Scalars['JSONScalar']['output']>;
  folder: FolderNode;
  id: Scalars['StrictString']['output'];
  isFinalized: Scalars['StrictBoolean']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  versionedProcedureJson: Maybe<Scalars['JSONScalar']['output']>;
}


export interface BulkAssemblyNodeversionedProcedureJsonArgs {
  version: Scalars['StrictString']['input'];
}

export type BulkAssemblyOrInaccessibleInfoNode = BulkAssemblyNode | InaccessibleInfoNode;

export interface CapabilityNode {
  __typename: 'CapabilityNode';
  displayName: Scalars['StrictString']['output'];
  isEnabled: Scalars['StrictBoolean']['output'];
  key: Scalars['StrictString']['output'];
}

export enum ChartLibrary {
  PLOTLY = 'PLOTLY'
}

export interface ChartNode extends CoreObjectArchivableInterface, HasPermissionsInterface {
  __typename: 'ChartNode';
  archiveData: ArchiveDataNode;
  id: Scalars['StrictString']['output'];
  library: ChartLibrary;
  libraryConfig: Scalars['JSONScalar']['output'];
  libraryVersion: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  rasterConfig: Scalars['JSONScalar']['output'];
  rasterDownloadUrl: Scalars['StrictString']['output'];
  rasterExternalFileId: Scalars['StrictString']['output'];
}

export type ChartOrInaccessibleInfoNode = ChartNode | InaccessibleInfoNode;

export interface ChatSessionListingNode {
  __typename: 'ChatSessionListingNode';
  items: Array<ChatSessionNode>;
  nextToken: Scalars['StrictString']['output'];
  total: Scalars['StrictInt']['output'];
}

export interface ChatSessionNode {
  __typename: 'ChatSessionNode';
  createdAt: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Maybe<Scalars['StrictString']['output']>;
}

export type ChatSessionOrInaccessibleInfoNode = ChatSessionNode | InaccessibleInfoNode;

export interface ChemicalFormulaNode {
  __typename: 'ChemicalFormulaNode';
  value: Scalars['StrictString']['output'];
}

export type ChemicalFormulaOrErrorNode = ChemicalFormulaNode | ErrorNode;

export interface ChemicalStructureNode {
  __typename: 'ChemicalStructureNode';
  aromaticRingCount: IntPropertyOrErrorNode;
  atomCount: IntPropertyOrErrorNode;
  canonicalSmiles: Scalars['StrictString']['output'];
  chemicalFormula: ChemicalFormulaOrErrorNode;
  exactMolecularWeight: FloatPropertyOrErrorNode;
  heavyAtomCount: IntPropertyOrErrorNode;
  hydrogenAcceptorCount: IntPropertyOrErrorNode;
  hydrogenDonorCount: IntPropertyOrErrorNode;
  id: Scalars['StrictString']['output'];
  logp: FloatPropertyOrErrorNode;
  molarRefractivity: FloatPropertyOrErrorNode;
  molecularWeight: MolecularWeightOrErrorNode;
  ringCount: IntPropertyOrErrorNode;
  rotatableBondCount: IntPropertyOrErrorNode;
  sp3AtomCount: IntPropertyOrErrorNode;
  tpsa: FloatPropertyOrErrorNode;
}

export interface ChildEntityLinkConfigNode {
  __typename: 'ChildEntityLinkConfigNode';
  childEntitySchema: TagSchemaNode;
  childSchemaLinkField: SchemaFieldNode;
  childSchemaLinkFieldJson: Scalars['JSONScalar']['output'];
  hasChildTab: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictInt']['output'];
  parentEntitySchema: TagSchemaNode;
}

export interface ClientSecretNode {
  __typename: 'ClientSecretNode';
  createdAt: Scalars['StrictString']['output'];
  suffix: Scalars['StrictString']['output'];
}

export interface CollaborationNode {
  __typename: 'CollaborationNode';
  auditor: Maybe<Scalars['StrictBoolean']['output']>;
  fromOwnership: Maybe<Scalars['StrictBoolean']['output']>;
  id: Scalars['StrictString']['output'];
  organizationRole: Maybe<Scalars['StrictInt']['output']>;
  party: PartyNode;
  policy: PolicyInterface;
  resource: Maybe<RestrictedResourceOrInaccessibleInfoNode>;
  teamRole: Maybe<Scalars['StrictInt']['output']>;
}

export enum ComplexPolymerAttachmentStyle {
  DRAWN = 'DRAWN',
  LEAVING_GROUP = 'LEAVING_GROUP'
}

export interface ComplexPolymerConfigInterface {
  configValues: Array<ComplexPolymerConfigValueNode>;
  id: Scalars['StrictString']['output'];
  linkedFields: Array<ComplexPolymerSchemaFieldDefinitionNode>;
  schema: ComplexPolymerSchemaNode;
  schemaInterface: StaticSchemaInterfaceNode;
}

export interface ComplexPolymerConfigValueNode {
  __typename: 'ComplexPolymerConfigValueNode';
  allowsMultipleComponents: Scalars['StrictBoolean']['output'];
  isRequired: Scalars['StrictBoolean']['output'];
  schemaField: ComplexPolymerSchemaFieldDefinitionNode;
}

export interface ComplexPolymerConnectionNode {
  __typename: 'ComplexPolymerConnectionNode';
  attachmentStyle: Maybe<ComplexPolymerAttachmentStyle>;
  connectionType: ComplexPolymerConnectionType;
  source: ComplexPolymerConnectionSideNode;
  target: ComplexPolymerConnectionSideNode;
}

export interface ComplexPolymerConnectionSideNode {
  __typename: 'ComplexPolymerConnectionSideNode';
  modificationType: Maybe<NucleotideModificationType>;
  monomerName: Maybe<Scalars['StrictString']['output']>;
  polymerHelmReference: Scalars['StrictString']['output'];
  rGroup: Maybe<Scalars['StrictInt']['output']>;
  referencedPolymer: SimplePolymerNode;
  residueIndex: Maybe<Scalars['StrictInt']['output']>;
}

export enum ComplexPolymerConnectionType {
  COVALENT_BOND = 'COVALENT_BOND',
  HYDROGEN_BOND = 'HYDROGEN_BOND'
}

export interface ComplexPolymerInterface {
  canonicalHelm: Maybe<Scalars['StrictString']['output']>;
  currentVersion: Maybe<ComplexPolymerVersionInterface>;
  originalHelm: Maybe<Scalars['StrictString']['output']>;
  outOfSync: Scalars['StrictBoolean']['output'];
  outOfSyncReason: Maybe<Scalars['StrictString']['output']>;
  structure: Maybe<ComplexPolymerStructureNode>;
  structureGraph: Maybe<PolymerStructureGraphNode>;
  version: Maybe<ComplexPolymerVersionInterface>;
  versions: Maybe<Array<ComplexPolymerVersionInterface>>;
}


export interface ComplexPolymerInterfaceversionArgs {
  versionId: Scalars['StrictString']['input'];
}

export interface ComplexPolymerNode extends ComplexPolymerInterface, FolderItemInterface, PoliceableInterface, RegistryItemInterface, SearchableInterface, WorklistItemInterface {
  __typename: 'ComplexPolymerNode';
  allChildEntities: Array<RegistryItemInterface>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  bioentityAliasInfos: Array<BioentityAliasInfoNode>;
  canonicalHelm: Maybe<Scalars['StrictString']['output']>;
  childEntities: Array<RegistryItemInterface>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  convertedToItem: Maybe<RegistryItemInterface>;
  createdAt: Scalars['StrictString']['output'];
  currentVersion: Maybe<ComplexPolymerVersionInterface>;
  displayLabel: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  hasExpirationTracking: Scalars['StrictBoolean']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  isTrialSample: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  linkedContainerContents: Array<ContainerContentNode>;
  matchingChildEntities: MatchingChildEntitiesNode;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  noteJson: Scalars['JSONScalar']['output'];
  originalHelm: Maybe<Scalars['StrictString']['output']>;
  outOfSync: Scalars['StrictBoolean']['output'];
  outOfSyncReason: Maybe<Scalars['StrictString']['output']>;
  permissions: PermissionsNode;
  projectFolder: Maybe<FolderNode>;
  registrationOrigin: Maybe<RegistrationOriginNode>;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  residues: Maybe<Scalars['StrictString']['output']>;
  schemaValidationStateJson: Maybe<Scalars['JSONScalar']['output']>;
  structure: Maybe<ComplexPolymerStructureNode>;
  structureGraph: Maybe<PolymerStructureGraphNode>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  testOrders: Array<TestOrderNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  validEntitiesForFieldPathInfo: Maybe<ValidEntitiesForFieldPathNode>;
  version: Maybe<ComplexPolymerVersionInterface>;
  versions: Maybe<Array<ComplexPolymerVersionInterface>>;
}


export interface ComplexPolymerNodechildEntitiesArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface ComplexPolymerNodematchingChildEntitiesArgs {
  archivePurposes?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  childEntitySchemaId: Scalars['StrictString']['input'];
  limit?: InputMaybe<Scalars['StrictInt']['input']>;
  offset?: InputMaybe<Scalars['StrictInt']['input']>;
  queryString?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface ComplexPolymerNodetestOrdersArgs {
  statusIsOneOf?: InputMaybe<Array<TestOrderStatus>>;
}


export interface ComplexPolymerNodevalidEntitiesForFieldPathInfoArgs {
  fieldId: Scalars['StrictString']['input'];
}


export interface ComplexPolymerNodeversionArgs {
  versionId: Scalars['StrictString']['input'];
}

export type ComplexPolymerOrInaccessibleInfoNode = ComplexPolymerNode | InaccessibleInfoNode | OligoConjugateNode | OligoDuplexNode;

export type ComplexPolymerSchemaConfigurationNode = GenericComplexPolymerSchemaConfigNode | OligoConjugateSchemaConfigNode | OligoDuplexSchemaConfigNode;

export type ComplexPolymerSchemaConfigurationOrInaccessibleNode = GenericComplexPolymerSchemaConfigNode | InaccessibleInfoNode | OligoConjugateSchemaConfigNode | OligoDuplexSchemaConfigNode;

export interface ComplexPolymerSchemaFieldDefinitionNode {
  __typename: 'ComplexPolymerSchemaFieldDefinitionNode';
  archived: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  isRequired: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  schemaId: Maybe<Scalars['StrictString']['output']>;
  type: Scalars['StrictString']['output'];
}

export type ComplexPolymerSchemaFieldDefinitionOrInaccessibleInfoNode = ComplexPolymerSchemaFieldDefinitionNode | InaccessibleInfoNode;

export interface ComplexPolymerSchemaNode {
  __typename: 'ComplexPolymerSchemaNode';
  archived: Scalars['StrictBoolean']['output'];
  fieldDefinitions: Array<ComplexPolymerSchemaFieldDefinitionNode>;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  type: Maybe<Scalars['StrictString']['output']>;
}

export interface ComplexPolymerStructureNode {
  __typename: 'ComplexPolymerStructureNode';
  connections: Array<ComplexPolymerConnectionNode>;
  polymers: Array<SimplePolymerNode>;
}

export interface ComplexPolymerVersionInterface {
  canonicalHelm: Maybe<Scalars['StrictString']['output']>;
  creator: PrincipalInterface;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  originalHelm: Maybe<Scalars['StrictString']['output']>;
  outOfSync: Scalars['StrictBoolean']['output'];
  outOfSyncReason: Maybe<Scalars['StrictString']['output']>;
  parent: Maybe<ComplexPolymerVersionInterface>;
  structure: Maybe<ComplexPolymerStructureNode>;
  structureGraph: Maybe<PolymerStructureGraphNode>;
}

export interface ComplexPolymerVersionNode extends ComplexPolymerVersionInterface {
  __typename: 'ComplexPolymerVersionNode';
  canonicalHelm: Maybe<Scalars['StrictString']['output']>;
  creator: PrincipalInterface;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  originalHelm: Maybe<Scalars['StrictString']['output']>;
  outOfSync: Scalars['StrictBoolean']['output'];
  outOfSyncReason: Maybe<Scalars['StrictString']['output']>;
  parent: Maybe<ComplexPolymerVersionInterface>;
  structure: Maybe<ComplexPolymerStructureNode>;
  structureGraph: Maybe<PolymerStructureGraphNode>;
}

export interface ComponentLotValuesNode {
  __typename: 'ComponentLotValuesNode';
  bioentity: Maybe<RegistryItemInterface>;
  container: Maybe<ContainerNode>;
  text: Maybe<Scalars['StrictString']['output']>;
}

export interface ComponentSequenceNode {
  __typename: 'ComponentSequenceNode';
  bases: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifiedNucleotides: Array<ModifiedNucleotideNode>;
  name: Scalars['String']['output'];
  nucleotideType: NucleotideType;
  sequencePrimers: Array<ComponentSequencePrimerNode>;
  startIndex: Scalars['Int']['output'];
  type: SequenceType;
}

export interface ComponentSequencePrimerNode {
  __typename: 'ComponentSequencePrimerNode';
  active: Scalars['Boolean']['output'];
  bases: Scalars['String']['output'];
  checked: Maybe<Scalars['Boolean']['output']>;
  displayLabel: Scalars['String']['output'];
  displayMeltingTemperature: Scalars['String']['output'];
  end: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  isNew: Scalars['Boolean']['output'];
  modifiedNucleotides: Array<ModifiedNucleotideNode>;
  name: Scalars['String']['output'];
  nucleotideType: NucleotideType;
  oligoId: Maybe<Scalars['String']['output']>;
  partnerSelected: Scalars['Boolean']['output'];
  selected: Scalars['Boolean']['output'];
  start: Scalars['Int']['output'];
  strand: Strand;
}

export interface ConcatenateMolfilesNode {
  __typename: 'ConcatenateMolfilesNode';
  id: Scalars['StrictString']['output'];
  molfile: StringPropertyOrErrorNode;
}

export interface ConditionDataNode {
  __typename: 'ConditionDataNode';
  benchlingExpression: BenchlingExpressionOrInaccessibleNode;
}

export interface ConditionOptionNode {
  __typename: 'ConditionOptionNode';
  condition: PolicyCondition;
  name: Scalars['StrictString']['output'];
}

export interface ConfigChoiceNode {
  __typename: 'ConfigChoiceNode';
  displayName: Scalars['StrictString']['output'];
  required: Maybe<Scalars['StrictBoolean']['output']>;
  value: Scalars['StrictString']['output'];
}

export interface ConfigImportHistoryEntryNode {
  __typename: 'ConfigImportHistoryEntryNode';
  changelogUrl: Maybe<Scalars['StrictString']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creator: UserNode;
  description: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  name: Maybe<Scalars['StrictString']['output']>;
  sourceOrgApiIdentifier: Scalars['StrictString']['output'];
  sourceOrgName: Scalars['StrictString']['output'];
  sourceTenantGlobalIdentifier: Scalars['StrictString']['output'];
  sourceTenantSubdomain: Scalars['StrictString']['output'];
  targetOrganization: OrganizationNode;
}

export type ConfigImportHistoryEntryOrInaccessibleInfoNode = ConfigImportHistoryEntryNode | InaccessibleInfoNode;

export interface ConfigOptionNode {
  __typename: 'ConfigOptionNode';
  allowedChoices: Maybe<Array<ConfigChoiceNode>>;
  configurableByTenantAdmin: Scalars['StrictBoolean']['output'];
  description: Scalars['StrictString']['output'];
  displayName: Scalars['StrictString']['output'];
  group: Scalars['StrictString']['output'];
  key: Scalars['StrictString']['output'];
  type: Scalars['StrictString']['output'];
  value: Maybe<Scalars['JSONScalar']['output']>;
}

export interface ConfigOverrideNode {
  __typename: 'ConfigOverrideNode';
  id: Scalars['StrictString']['output'];
  key: Scalars['StrictString']['output'];
  value: Maybe<Scalars['JSONScalar']['output']>;
}

export interface ConjugateNode {
  __typename: 'ConjugateNode';
  connection: ComplexPolymerConnectionNode;
  entity: BiomoleculeEntityOrInaccessibleInfoNode;
  id: Scalars['StrictString']['output'];
  linkedMolecules: Array<LinkedMoleculeNode>;
  polymerHelmReference: Scalars['StrictString']['output'];
  residueIndex: Maybe<Scalars['StrictInt']['output']>;
}

export interface ConjugateStructureGraphNodeDataNode extends StructureGraphNodeDataInterface {
  __typename: 'ConjugateStructureGraphNodeDataNode';
  entityId: Scalars['StrictString']['output'];
  polymerRef: Scalars['StrictString']['output'];
}

export interface ConnectionNode extends HasArchiveRecordInterface, HasCreationOriginInterface, HasCreatorInterface, HasPermissionsInterface, OwnableInterface, SearchableInterface {
  __typename: 'ConnectionNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  associatedEquipment: Array<EquipmentNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creationOrigin: CreationOriginNode;
  creator: PrincipalInterface;
  dataCatalogFolder: Maybe<FolderNode>;
  fields: Scalars['JSONScalar']['output'];
  gatewayId: Scalars['StrictString']['output'];
  humanId: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  ownerInfoJson: Scalars['JSONScalar']['output'];
  ownerJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  schema: ConnectionSchemaNode;
  url: Scalars['StrictString']['output'];
}

export type ConnectionOrInaccessibleInfoNode = ConnectionNode | InaccessibleInfoNode;

export interface ConnectionSchemaNode extends PoliceableInterface, SchemaInterface {
  __typename: 'ConnectionSchemaNode';
  allConnections: Array<ConnectionNode>;
  allFields: Array<SchemaFieldNode>;
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  equipmentIds: Array<Scalars['StrictString']['output']>;
  fields: Array<SchemaFieldNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  hasData: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  integrationAdapterId: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  organization: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  prefix: Scalars['StrictString']['output'];
  relatedBenchlingApps: Array<BenchlingAppNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
}


export interface ConnectionSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export type ConnectionSchemaOrInaccessibleInfoNode = ConnectionSchemaNode | InaccessibleInfoNode;

export type ContainableItemOrInaccessibleInfoNode = BasicFolderItemNode | ComplexPolymerNode | EquipmentNode | InaccessibleInfoNode | MixtureNode | MoleculeNode | OligoConjugateNode | OligoDuplexNode | ProteinNode | SequenceNode;

export interface ContainerContentNode {
  __typename: 'ContainerContentNode';
  concentration: MeasurementNode;
  concentrationJson: Scalars['JSONScalar']['output'];
  containedItem: ContainableItemOrInaccessibleInfoNode;
  containedItemTagSchema: TagSchemaNode;
  container: Maybe<ContainerOrInaccessibleInfoNode>;
  id: Scalars['StrictInt']['output'];
  lotNumber: Scalars['StrictInt']['output'];
}


export interface ContainerContentNodecontainerArgs {
  includeArchived?: InputMaybe<Scalars['StrictBoolean']['input']>;
}

export interface ContainerNode extends HasArchiveRecordInterface, HasCreatorInterface, SearchableInterface, StorableInterface, StudyableInterface, WorklistItemInterface {
  __typename: 'ContainerNode';
  ancestry: Array<StorableOrInaccessibleInfoNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  barcode: Maybe<BarcodeNode>;
  batches: Array<BatchNode>;
  checkOutStatusInfoJson: Maybe<Scalars['JSONScalar']['output']>;
  contents: Array<ContainerContentNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead. */
  creatorJson: Scalars['JSONScalar']['output'];
  expirationInfo: ExpirationInfoNode;
  freezeThawInfo: FreezeThawInfoNode;
  gridCell: Maybe<GridCellOrInaccessibleInfoNode>;
  hasInputTransfers: Scalars['StrictBoolean']['output'];
  hasNameTemplate: Scalars['StrictBoolean']['output'];
  hasOutputTransfers: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  isFixedPlateWell: Scalars['StrictBoolean']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  parentStorable: Maybe<StorableOrInaccessibleInfoNode>;
  permissions: PermissionsNode;
  quantity: MeasurementNode;
  quantityJson: Scalars['JSONScalar']['output'];
  restrictionStatus: SampleRestrictionStatus;
  role: Maybe<ExperimentalRoleNode>;
  sampleRoles: SampleRolesNode;
  source: SourceInterface;
  starred: Scalars['StrictBoolean']['output'];
  storableSchema: ContainerSchemaNode;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  tagsJson: Scalars['JSONScalar']['output'];
  testOrders: Array<TestOrderOrInaccessibleInfoNode>;
  url: Scalars['StrictString']['output'];
  validationState: Maybe<ValidationStateNode>;
  volumeJson: Scalars['JSONScalar']['output'];
}


export interface ContainerNodeparentStorableArgs {
  skipAuthCheck?: InputMaybe<Scalars['StrictBoolean']['input']>;
}

export type ContainerOrInaccessibleInfoNode = ContainerNode | InaccessibleInfoNode;

export interface ContainerSchemaNode extends HasArchiveRecordInterface, SchemaInterface, StorableSchemaInterface {
  __typename: 'ContainerSchemaNode';
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  gridSchemas: Array<GridSchemaOrInaccessibleInfoNode>;
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  numValidationFailures: Scalars['StrictInt']['output'];
  prefix: Scalars['StrictString']['output'];
  registry: RegistryNode;
  relatedBenchlingApps: Array<BenchlingAppNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
  storablesFailingValidation: Array<StorableOrInaccessibleInfoNode>;
}


export interface ContainerSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export interface CoreObjectArchivableInterface {
  archiveData: ArchiveDataNode;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export type CoreObjectArchivableItemOrInaccessibleInfoNode = AnalysisTemplateNode | AnalysisTemplateVariableNode | BaseFieldDefinitionNode | ChartNode | DatasetNode | DropdownFieldDefinitionNode | FileNode | InaccessibleInfoNode | JellyfishNode | JellyfishSchemaNode | ProcedureMethodExecutionInstanceNode | ProcedureNode | ProcedureRunConditionReplicateNode | ProcedureRunNode | ProcedureStepExecutionInstanceNode | ProcessTaskDefinitionNode | ProcessTaskDefinitionVersionNode | RequestV2DefinitionNode | RequestV2SubmissionNode | SampleTypeNode | SchemaLinkFieldDefinitionNode | StudyNode | TentacleNode | TestDefinitionNode | UnitNode | UnitTypeNode | ValidationRuleNode | WorksheetNode;

export enum CoreTableType {
  DROPDOWN = 'DROPDOWN',
  DROPDOWN_OPTION = 'DROPDOWN_OPTION',
  ENTITY = 'ENTITY',
  RESULT = 'RESULT'
}

export interface CreationContextNode {
  __typename: 'CreationContextNode';
  entryId: Maybe<Scalars['StrictString']['output']>;
  procedureStepExecutionId: Maybe<Scalars['StrictString']['output']>;
  worksheetId: Maybe<Scalars['StrictString']['output']>;
}

export interface CreationOriginNode {
  __typename: 'CreationOriginNode';
  application: Maybe<Scalars['StrictString']['output']>;
  origin: Maybe<OriginNode>;
  originType: Maybe<CreationOriginType>;
}

export enum CreationOriginType {
  DIRECT_EXECUTION_MODAL = 'DIRECT_EXECUTION_MODAL',
  ENTRY = 'ENTRY',
  PROCESS = 'PROCESS',
  PROCESSES_REQUEST_MIGRATION = 'PROCESSES_REQUEST_MIGRATION',
  PROCESSES_SCHEMA_FIELD_MAPPER = 'PROCESSES_SCHEMA_FIELD_MAPPER',
  REQUEST_V2_SUBMISSION = 'REQUEST_V2_SUBMISSION',
  STAGE_ENTRY = 'STAGE_ENTRY'
}

export interface CreatorInterface {
  avatarUrl: Maybe<Scalars['StrictString']['output']>;
  handle: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export interface CustomFieldNode {
  __typename: 'CustomFieldNode';
  name: Scalars['StrictString']['output'];
  value: Scalars['StrictString']['output'];
}

export enum DBType {
  nucl = 'nucl',
  prot = 'prot'
}

export interface DataCatalogItemInterface {
  id: Scalars['StrictString']['output'];
  lineageParent: Maybe<DataCatalogParentOrInaccessibleInfoNode>;
  originType: Scalars['StrictString']['output'];
}

export type DataCatalogParentOrInaccessibleInfoNode = AnalysisNode | AutomationOutputFileNode | ConnectionNode | InaccessibleInfoNode | RunNode | StudyNode;

export interface DataFrameColumnNode {
  __typename: 'DataFrameColumnNode';
  displayName: Scalars['StrictString']['output'];
  systemName: Scalars['StrictString']['output'];
  type: Scalars['JSONScalar']['output'];
}

export interface DataFrameDomainNode {
  __typename: 'DataFrameDomainNode';
  columns: Array<DataFrameColumnNode>;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export interface DataFrameNode extends HasCreatorInterface {
  __typename: 'DataFrameNode';
  allColumnsJson: Array<Scalars['JSONScalar']['output']>;
  /** @deprecated Use all_columns_json instead */
  columnsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  dataFrameJson: Scalars['JSONScalar']['output'];
  dataset: Maybe<DatasetNode>;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  numRows: Scalars['StrictInt']['output'];
  randomSubsetDataFrameJson: Scalars['JSONScalar']['output'];
  size: Maybe<Scalars['StrictInt']['output']>;
  uniqueValues: Array<Maybe<Scalars['JSONScalar']['output']>>;
}


export interface DataFrameNodedataFrameJsonArgs {
  limitOffsetInput?: InputMaybe<LimitOffsetInput>;
}


export interface DataFrameNoderandomSubsetDataFrameJsonArgs {
  limit: Scalars['StrictInt']['input'];
}


export interface DataFrameNodeuniqueValuesArgs {
  columnSystemName: Scalars['StrictString']['input'];
  limit?: InputMaybe<Scalars['StrictInt']['input']>;
}

export type DataFrameOrInaccessibleNode = DataFrameNode | InaccessibleInfoNode;

export interface DataPolicyNode extends PolicyInterface {
  __typename: 'DataPolicyNode';
  id: Scalars['StrictString']['output'];
  isDefault: Scalars['StrictBoolean']['output'];
  isHidden: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  policyStatements: Array<PolicyStatementNode>;
}

export type DataPolicyOrInaccessibleInfoNode_ = DataPolicyNode | InaccessibleInfoNode;

export interface DatasetNode extends BaseFolderItemInterface, CoreObjectArchivableInterface, DataCatalogItemInterface, HasCreatorInterface, HasCustomFieldsInterface, HasDisplayIdInterface, HasPermissionsInterface, SearchableInterface, StarrableInterface, StudyableInterface {
  __typename: 'DatasetNode';
  archiveData: ArchiveDataNode;
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  customFields: Array<CustomFieldNode>;
  dataFrame: DataFrameOrInaccessibleNode;
  displayId: Maybe<Scalars['StrictString']['output']>;
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  id: Scalars['StrictString']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  lineageParent: Maybe<DataCatalogParentOrInaccessibleInfoNode>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  originType: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  star: Maybe<StarNode>;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  url: Scalars['StrictString']['output'];
}

export type DatasetOrInaccessibleInfoNode = DatasetNode | InaccessibleInfoNode;

export enum DatasetUploadStatus {
  FAILED_VALIDATION = 'FAILED_VALIDATION',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_UPLOADED = 'NOT_UPLOADED',
  SUCCEEDED = 'SUCCEEDED'
}

export interface DefaultSchemaCollaborationNode {
  __typename: 'DefaultSchemaCollaborationNode';
  organizationRole: Maybe<Scalars['StrictInt']['output']>;
  party: PartyNode;
  policy: SchemaPolicyNode;
  teamRole: Maybe<Scalars['StrictInt']['output']>;
}

export interface DefaultSchemaCollaboratorsConfigurationNode extends HasPermissionsInterface {
  __typename: 'DefaultSchemaCollaboratorsConfigurationNode';
  defaultSchemaCollaborations: Array<DefaultSchemaCollaborationNode>;
  id: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  schemaType: DefaultSchemaCollaboratorsConfigurationSchemaType;
}

export enum DefaultSchemaCollaboratorsConfigurationSchemaType {
  CONNECTION = 'CONNECTION',
  ENTITY = 'ENTITY',
  INTERFACE = 'INTERFACE',
  RESULT = 'RESULT',
  RUN = 'RUN',
  STUDY = 'STUDY',
  TEST_DEFINITION = 'TEST_DEFINITION'
}

export interface DefaultSchemaInterfaceConfigNode extends BaseSchemaInterfaceConfigInterface {
  __typename: 'DefaultSchemaInterfaceConfigNode';
  interface: BaseSchemaInterfaceInterface;
}

export enum DestinationType {
  APP = 'APP',
  EVENTBRIDGE = 'EVENTBRIDGE',
  WEBHOOK = 'WEBHOOK'
}

export enum DevPlatformVersion {
  DEPRECATED_UNVERSIONED = 'DEPRECATED_UNVERSIONED',
  V2 = 'V2',
  V2_ALPHA = 'V2_ALPHA',
  V2_BETA = 'V2_BETA',
  V3 = 'V3',
  V3_ALPHA = 'V3_ALPHA',
  V3_BETA = 'V3_BETA'
}

export enum DilutionAssignmentType {
  MULTI_POINT = 'MULTI_POINT',
  SINGLE_POINT = 'SINGLE_POINT'
}

export interface DilutionPlanNode {
  __typename: 'DilutionPlanNode';
  allowedDilutionFactors: Array<Scalars['StrictInt']['output']>;
  dilutionAssignment: DilutionAssignmentType;
}

export interface DocumentNode {
  __typename: 'DocumentNode';
  createdAt: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export type DocumentOrInaccessibleInfoNode = DocumentNode | InaccessibleInfoNode;

export interface DocumentVersionNode {
  __typename: 'DocumentVersionNode';
  document: Maybe<DocumentNode>;
  id: Scalars['StrictString']['output'];
}

export type DocumentVersionOrInaccessibleInfoNode = DocumentVersionNode | InaccessibleInfoNode;

export interface DropdownFieldDefinitionNode extends CoreObjectArchivableInterface, FieldDefinitionInterface, HasCreatorInterface, HasPermissionsInterface {
  __typename: 'DropdownFieldDefinitionNode';
  archiveData: ArchiveDataNode;
  creator: PrincipalInterface;
  dropdown: SchemaFieldSelectorOrInaccessibleInfoNode;
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  isRequired: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  provenanceUri: Scalars['StrictString']['output'];
  shortDescription: Maybe<Scalars['StrictString']['output']>;
  systemName: Scalars['StrictString']['output'];
  type: FieldDefinitionType;
}

export interface ELNOriginNode {
  __typename: 'ELNOriginNode';
  entry: Maybe<EntryLikeInterface>;
  tableName: Maybe<Scalars['StrictString']['output']>;
}

export enum EngComponent {
  ANALYSIS_TOOL = 'ANALYSIS_TOOL',
  ANALYTICS = 'ANALYTICS',
  ANTIBODIES = 'ANTIBODIES',
  ARCHIVING = 'ARCHIVING',
  AUDITING = 'AUDITING',
  BENCHLING_APPS = 'BENCHLING_APPS',
  BENCHLING_SDK = 'BENCHLING_SDK',
  BINARY_DISTS = 'BINARY_DISTS',
  BULK_ADAPTERS = 'BULK_ADAPTERS',
  BUSINESS_RULES_ENGINE = 'BUSINESS_RULES_ENGINE',
  CAPILLARY = 'CAPILLARY',
  CATCH_ALL_APP_CORE = 'CATCH_ALL_APP_CORE',
  CATCH_ALL_DEV_PRODUCTIVITY = 'CATCH_ALL_DEV_PRODUCTIVITY',
  CHANGE_DATA_CAPTURE = 'CHANGE_DATA_CAPTURE',
  CHARTING = 'CHARTING',
  CHEMISTRY = 'CHEMISTRY',
  CONFIG_MIGRATION = 'CONFIG_MIGRATION',
  CONNECT = 'CONNECT',
  CONVERSION_TOOL = 'CONVERSION_TOOL',
  CORE_OBJECT = 'CORE_OBJECT',
  CUSTOMER_INTEGRATIONS = 'CUSTOMER_INTEGRATIONS',
  DATA_EGRESS = 'DATA_EGRESS',
  DATA_FRAMES = 'DATA_FRAMES',
  DATA_INPUT = 'DATA_INPUT',
  DESKTOP_APP = 'DESKTOP_APP',
  DOMAIN_GRAPH = 'DOMAIN_GRAPH',
  EVENTS = 'EVENTS',
  EXPORTS = 'EXPORTS',
  EXTERNAL_ADMIN = 'EXTERNAL_ADMIN',
  FE_DEV_TOOLS = 'FE_DEV_TOOLS',
  FORMS = 'FORMS',
  GROWTH = 'GROWTH',
  IDENTITY = 'IDENTITY',
  INSIGHTS = 'INSIGHTS',
  INSTITUTIONS = 'INSTITUTIONS',
  INSTRUMENTS = 'INSTRUMENTS',
  INTERNAL_ADMIN = 'INTERNAL_ADMIN',
  INTERNAL_DATA = 'INTERNAL_DATA',
  INVENTORY = 'INVENTORY',
  JOBS = 'JOBS',
  LAB_AUTOMATION = 'LAB_AUTOMATION',
  LEGACY_WORKFLOWS = 'LEGACY_WORKFLOWS',
  LLM = 'LLM',
  MACHINE_LEARNING = 'MACHINE_LEARNING',
  MOBILE = 'MOBILE',
  MODIFIED_BIOLOGICS = 'MODIFIED_BIOLOGICS',
  MOLBIO = 'MOLBIO',
  MONOLITH_INFRA = 'MONOLITH_INFRA',
  NAVIGATION = 'NAVIGATION',
  NOTEBOOK = 'NOTEBOOK',
  NOTIFICATIONS = 'NOTIFICATIONS',
  PARTIES = 'PARTIES',
  PERFORMANCE = 'PERFORMANCE',
  PERMISSIONS = 'PERMISSIONS',
  PIPELINES = 'PIPELINES',
  PROCEDURES = 'PROCEDURES',
  PROD_ACCESS = 'PROD_ACCESS',
  PROJECT_FOLDER = 'PROJECT_FOLDER',
  QUERY_API = 'QUERY_API',
  REGISTRY = 'REGISTRY',
  REQUESTS = 'REQUESTS',
  RESULTS = 'RESULTS',
  SAMPLE_TESTS = 'SAMPLE_TESTS',
  SCHEMAS = 'SCHEMAS',
  SCHEMAS_UI = 'SCHEMAS_UI',
  SECURITY = 'SECURITY',
  SERVICES_INFRA = 'SERVICES_INFRA',
  SIGHTGLASS = 'SIGHTGLASS',
  STUDIES = 'STUDIES',
  TABLES = 'TABLES',
  TENANCY = 'TENANCY',
  TEST_INFRA = 'TEST_INFRA',
  TFI = 'TFI',
  UI_LIBRARY = 'UI_LIBRARY',
  UNASSIGNED = 'UNASSIGNED',
  UNITS = 'UNITS',
  V3_REST_API = 'V3_REST_API',
  VALIDATION_RULES_ENGINE = 'VALIDATION_RULES_ENGINE',
  WAREHOUSE = 'WAREHOUSE',
  WEBHOOKS = 'WEBHOOKS',
  WORKFLOWS = 'WORKFLOWS',
  WORKLISTS = 'WORKLISTS'
}

export interface EnsemblInfoNode {
  __typename: 'EnsemblInfoNode';
  currentVersion: Scalars['StrictInt']['output'];
}

export interface EntityIdNode {
  __typename: 'EntityIdNode';
  entityId: Scalars['StrictString']['output'];
  entityType: Scalars['StrictString']['output'];
}

export interface EntityMapEdgeNode {
  __typename: 'EntityMapEdgeNode';
  id: Scalars['StrictString']['output'];
  sourceId: Scalars['StrictString']['output'];
  targetId: Scalars['StrictString']['output'];
}

export interface EntityMapEntityNode {
  __typename: 'EntityMapEntityNode';
  id: Scalars['StrictString']['output'];
  schemaName: Maybe<Scalars['StrictString']['output']>;
}

export interface EntityMapInputNode {
  depth: Scalars['StrictInt']['input'];
  entityId: Scalars['StrictString']['input'];
}

export interface EntityMapNode {
  __typename: 'EntityMapNode';
  edges: Maybe<Array<EntityMapEdgeNode>>;
  entities: Maybe<Array<EntityMapEntityNode>>;
}

export type EntityMapOrInaccessibleInfoNode = EntityMapNode | InaccessibleInfoNode;

export interface EntityVersionIdInputNode {
  entityId: Scalars['StrictString']['input'];
  entityType: Scalars['StrictString']['input'];
  entityVersionId: Scalars['StrictString']['input'];
}

export interface EntityVersionIdNode {
  __typename: 'EntityVersionIdNode';
  entityId: Scalars['StrictString']['output'];
  entityType: Scalars['StrictString']['output'];
  entityVersionId: Scalars['StrictString']['output'];
}

export interface EntryDayNode {
  __typename: 'EntryDayNode';
  date: Scalars['StrictString']['output'];
  dbId: Scalars['StrictInt']['output'];
  provenanceUuid: Maybe<Scalars['StrictString']['output']>;
  sectionColor: Maybe<NotebookSectionColor>;
  title: Maybe<Scalars['StrictString']['output']>;
}

export interface EntryLikeDocumentNode extends EntryLikeInterface {
  __typename: 'EntryLikeDocumentNode';
  archiveRecord: Maybe<Scalars['JSONScalar']['output']>;
  created_at: Scalars['StrictString']['output'];
  editURL: Scalars['StrictString']['output'];
  entryDays: Array<EntryDayNode>;
  humanId: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  review: Maybe<ReviewNode>;
  tagSchema: Maybe<Scalars['JSONScalar']['output']>;
  tags: Scalars['JSONScalar']['output'];
}

export interface EntryLikeInterface {
  archiveRecord: Maybe<Scalars['JSONScalar']['output']>;
  created_at: Scalars['StrictString']['output'];
  editURL: Scalars['StrictString']['output'];
  entryDays: Array<EntryDayNode>;
  humanId: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  review: Maybe<ReviewNode>;
  tagSchema: Maybe<Scalars['JSONScalar']['output']>;
  tags: Scalars['JSONScalar']['output'];
}

export interface EntryNode extends BaseEntryInterface, FolderItemInterface, HasArchiveRecordInterface, HasPermissionsInterface, PoliceableInterface, ReviewableInterface, SearchableInterface, StarrableInterface, StudyableInterface {
  __typename: 'EntryNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  entryDays: Array<EntryDayNode>;
  folder: FolderNode;
  hasReviewCriteria: Scalars['StrictBoolean']['output'];
  humanId: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  isStudyable: Scalars['StrictBoolean']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  parentReviewLifecycles: Array<ReviewLifecycleNode>;
  permissions: PermissionsNode;
  project: ProjectNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  review: Maybe<ReviewNode>;
  reviewSource: ProjectNode;
  star: Maybe<StarNode>;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  template: Maybe<TemplateNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  /** @deprecated Use permissions from HasPermissionsInterface instead. */
  userPermissionsJson: Scalars['JSONScalar']['output'];
}

export type EntryOrInaccessibleInfoNode = EntryNode | InaccessibleInfoNode;

export interface EquipmentNode extends FolderItemInterface, PoliceableInterface, RegistryItemInterface, SearchableInterface, StudyableInterface, WorklistItemInterface {
  __typename: 'EquipmentNode';
  allChildEntities: Array<RegistryItemInterface>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  bioentityAliasInfos: Array<BioentityAliasInfoNode>;
  childEntities: Array<RegistryItemInterface>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  connectionId: Scalars['StrictString']['output'];
  convertedToItem: Maybe<RegistryItemInterface>;
  createdAt: Scalars['StrictString']['output'];
  displayLabel: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  hasExpirationTracking: Scalars['StrictBoolean']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  isStudyable: Scalars['StrictBoolean']['output'];
  isTrialSample: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  linkedContainerContents: Array<ContainerContentNode>;
  matchingChildEntities: MatchingChildEntitiesNode;
  model: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  noteJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  projectFolder: Maybe<FolderNode>;
  registrationOrigin: Maybe<RegistrationOriginNode>;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  residues: Maybe<Scalars['StrictString']['output']>;
  schemaValidationStateJson: Maybe<Scalars['JSONScalar']['output']>;
  serialNumber: Scalars['StrictString']['output'];
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  testOrders: Array<TestOrderNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  validEntitiesForFieldPathInfo: Maybe<ValidEntitiesForFieldPathNode>;
}


export interface EquipmentNodechildEntitiesArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface EquipmentNodematchingChildEntitiesArgs {
  archivePurposes?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  childEntitySchemaId: Scalars['StrictString']['input'];
  limit?: InputMaybe<Scalars['StrictInt']['input']>;
  offset?: InputMaybe<Scalars['StrictInt']['input']>;
  queryString?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface EquipmentNodetestOrdersArgs {
  statusIsOneOf?: InputMaybe<Array<TestOrderStatus>>;
}


export interface EquipmentNodevalidEntitiesForFieldPathInfoArgs {
  fieldId: Scalars['StrictString']['input'];
}

export type EquipmentOrInaccessibleInfoNode = EquipmentNode | InaccessibleInfoNode;

export interface ErrorNode {
  __typename: 'ErrorNode';
  message: Scalars['StrictString']['output'];
}

export interface EventInfoListingNode {
  __typename: 'EventInfoListingNode';
  eventInfos: Array<EventInfoNode>;
}

export interface EventInfoNode {
  __typename: 'EventInfoNode';
  deprecationDate: Maybe<Scalars['StrictString']['output']>;
  description: Scalars['StrictString']['output'];
  version: DevPlatformVersion;
  versionedEventType: Scalars['StrictString']['output'];
}

export interface EventSubscriptionInterface {
  destinationType: DestinationType;
  eventTypes: Array<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  logIds: Array<Scalars['StrictString']['output']>;
  name: Scalars['StrictString']['output'];
}

export type EventSubscriptionNode = AppEventSubscriptionNode | EventbridgeEventSubscriptionNode;

export interface EventSubscriptionsListingNode {
  __typename: 'EventSubscriptionsListingNode';
  availableAwsRegions: Array<Scalars['StrictString']['output']>;
  eventSubscriptions: Array<EventSubscriptionNode>;
}

export interface EventbridgeEventSubscriptionNode extends EventSubscriptionInterface {
  __typename: 'EventbridgeEventSubscriptionNode';
  awsAccountId: Scalars['StrictString']['output'];
  awsRegion: Scalars['StrictString']['output'];
  destinationType: DestinationType;
  eventTypes: Array<Scalars['StrictString']['output']>;
  expiresAt: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  logIds: Array<Scalars['StrictString']['output']>;
  name: Scalars['StrictString']['output'];
  paused: Scalars['StrictBoolean']['output'];
}

export interface ExecutionSampleNode {
  __typename: 'ExecutionSampleNode';
  batch: Maybe<BatchNode>;
  bioentity: Maybe<RegistryItemInterface>;
  container: Maybe<ContainerNode>;
  id: Scalars['StrictString']['output'];
  name: Maybe<Scalars['StrictString']['output']>;
  url: Maybe<Scalars['StrictString']['output']>;
}

export interface ExperimentalRoleNode {
  __typename: 'ExperimentalRoleNode';
  group: Scalars['StrictInt']['output'];
  primaryRole: PrimaryExperimentalRoleType;
  subrole: Maybe<Scalars['StrictString']['output']>;
}

export interface ExpirationInfoNode {
  __typename: 'ExpirationInfoNode';
  computedFromEntity: Maybe<ContainableItemOrInaccessibleInfoNode>;
  expirationDate: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  inheritedExpirationDate: Maybe<Scalars['StrictString']['output']>;
  isExpired: Scalars['StrictBoolean']['output'];
  isOverridden: Scalars['StrictBoolean']['output'];
  isTrackingEnabled: Scalars['StrictBoolean']['output'];
}

export interface FeatureEnablementConfigNode {
  __typename: 'FeatureEnablementConfigNode';
  configKey: Scalars['StrictString']['output'];
  enablementState: FeatureEnablementState;
  explicitlyEnabledUsers: Array<UserNode>;
}

export enum FeatureEnablementState {
  ALL_USERS = 'ALL_USERS',
  AVAILABLE_DISABLED = 'AVAILABLE_DISABLED',
  SOME_USERS = 'SOME_USERS'
}

export interface FieldDataMigrationNode {
  __typename: 'FieldDataMigrationNode';
  destinationField: Maybe<SchemaFieldNode>;
  migrationType: FieldDataMigrationType;
  numMigratedFieldValues: Maybe<Scalars['StrictInt']['output']>;
  numStartingFieldValues: Maybe<Scalars['StrictInt']['output']>;
  sourceField: Maybe<SchemaFieldNode>;
  status: FieldDataMigrationStatus;
}

export enum FieldDataMigrationStatus {
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PUBLISHED = 'PUBLISHED',
  SUCCEEDED = 'SUCCEEDED'
}

export enum FieldDataMigrationType {
  TO_EXISTING_FIELD = 'TO_EXISTING_FIELD',
  TO_NEW_FIELD = 'TO_NEW_FIELD'
}

export interface FieldDefinitionInterface {
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  isRequired: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  provenanceUri: Scalars['StrictString']['output'];
  shortDescription: Maybe<Scalars['StrictString']['output']>;
  systemName: Scalars['StrictString']['output'];
  type: FieldDefinitionType;
}

export type FieldDefinitionNode = BaseFieldDefinitionNode | DropdownFieldDefinitionNode | SchemaLinkFieldDefinitionNode;

export enum FieldDefinitionType {
  AA_PART_LINK = 'AA_PART_LINK',
  AA_SEQUENCE_LINK = 'AA_SEQUENCE_LINK',
  ASSAY_REQUEST_LINK = 'ASSAY_REQUEST_LINK',
  ASSAY_RESULT_LINK = 'ASSAY_RESULT_LINK',
  ASSAY_RUN_LINK = 'ASSAY_RUN_LINK',
  BATCH_LINK = 'BATCH_LINK',
  BLOB_LINK = 'BLOB_LINK',
  BOOLEAN = 'BOOLEAN',
  CUSTOM_ENTITY_LINK = 'CUSTOM_ENTITY_LINK',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  DNA_SEQUENCE_LINK = 'DNA_SEQUENCE_LINK',
  DROPDOWN = 'DROPDOWN',
  ENTITY_LINK = 'ENTITY_LINK',
  ENTRY_LINK = 'ENTRY_LINK',
  FLOAT = 'FLOAT',
  INTEGER = 'INTEGER',
  JSON = 'JSON',
  LONG_TEXT = 'LONG_TEXT',
  MIXTURE_LINK = 'MIXTURE_LINK',
  MOLECULE_LINK = 'MOLECULE_LINK',
  PART_LINK = 'PART_LINK',
  SAMPLE_LINK = 'SAMPLE_LINK',
  STORAGE_LINK = 'STORAGE_LINK',
  TEXT = 'TEXT',
  TRANSCRIPTION_LINK = 'TRANSCRIPTION_LINK',
  TRANSLATION_LINK = 'TRANSLATION_LINK'
}

export enum FieldMigrationStatus {
  FAILED = 'FAILED',
  LOCKED = 'LOCKED',
  MIGRATING = 'MIGRATING',
  NA = 'NA',
  PUBLISHABLE = 'PUBLISHABLE'
}

export interface FileNode extends BaseFolderItemInterface, CoreObjectArchivableInterface, DataCatalogItemInterface, HasCreatorInterface, HasCustomFieldsInterface, HasDisplayIdInterface, HasPermissionsInterface, SearchableInterface, StarrableInterface, StudyableInterface {
  __typename: 'FileNode';
  archiveData: ArchiveDataNode;
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  customFields: Array<CustomFieldNode>;
  displayId: Maybe<Scalars['StrictString']['output']>;
  downloadUrl: Maybe<Scalars['StrictString']['output']>;
  editUrl: Scalars['StrictString']['output'];
  /** @deprecated Use scratch file to access external_file_id instead. */
  externalFileId: Maybe<Scalars['StrictString']['output']>;
  /** @deprecated Use scratch file to access filename instead. */
  filename: Scalars['StrictString']['output'];
  folder: FolderNode;
  id: Scalars['StrictString']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  lineageParent: Maybe<DataCatalogParentOrInaccessibleInfoNode>;
  /** @deprecated Use scratch file to access mime_type instead. */
  mimeType: Maybe<Scalars['StrictString']['output']>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  originType: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  scratchFile: ScratchFileNode;
  /** @deprecated Use scratch file to access size instead. */
  size: Maybe<Scalars['StrictInt']['output']>;
  star: Maybe<StarNode>;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  url: Scalars['StrictString']['output'];
}

export type FileOrInaccessibleInfoNode = FileNode | InaccessibleInfoNode;

export interface FloatPropertyNode {
  __typename: 'FloatPropertyNode';
  value: Scalars['StrictFloat']['output'];
}

export type FloatPropertyOrErrorNode = ErrorNode | FloatPropertyNode;

export interface FolderItemInterface {
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
}

export type FolderItemOrInaccessibleInfoNode = AnalysisNode | BasicFolderItemNode | BulkAssemblyNode | ComplexPolymerNode | DatasetNode | EntryNode | EquipmentNode | FileNode | InaccessibleInfoNode | JellyfishNode | MixtureNode | MoleculeNode | OligoConjugateNode | OligoDuplexNode | ProcessNode | ProteinNode | ProtocolNode | RequestV2SubmissionNode | SequenceNode | StudyNode | WorksheetNode;

export type FolderItemOrStageEntryNode = AnalysisNode | BasicFolderItemNode | ComplexPolymerNode | EntryNode | EquipmentNode | MixtureNode | MoleculeNode | OligoConjugateNode | OligoDuplexNode | ProteinNode | ProtocolNode | SequenceNode | StageEntryNode;

export interface FolderNode extends HasArchiveRecordInterface, HasPermissionsInterface, PoliceableInterface, SearchableInterface, StarrableInterface {
  __typename: 'FolderNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  dbId: Scalars['StrictInt']['output'];
  description: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  modifiedAt: Maybe<Scalars['StrictString']['output']>;
  name: Scalars['StrictString']['output'];
  ownerJson: Scalars['JSONScalar']['output'];
  ownerUrl: Scalars['StrictString']['output'];
  parent: Maybe<FolderNode>;
  parentFolders: Array<FolderNode>;
  permissions: PermissionsNode;
  source: SourceInterface;
  /** @deprecated Use source instead. */
  sourceJson: Scalars['JSONScalar']['output'];
  star: Maybe<StarNode>;
  type: Scalars['StrictString']['output'];
  url: Scalars['StrictString']['output'];
}

export type FolderOrInaccessibleInfoNode = FolderNode | InaccessibleInfoNode;

export interface FormActionNode {
  __typename: 'FormActionNode';
  actionMethodIdentifier: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  invocationParameters: Array<ActionInvocationParameterNode>;
  name: Scalars['StrictString']['output'];
  version: Scalars['StrictInt']['output'];
}

export type FormActionOrInaccessibleInfoNode = FormActionNode | InaccessibleInfoNode;

export interface FormDefinitionActionConfigNode {
  __typename: 'FormDefinitionActionConfigNode';
  actionId: Scalars['StrictString']['output'];
  parameters: Array<FormFieldToActionParamNode>;
  schema: Maybe<ProcessTaskSchemaNode>;
  sectionKey: Maybe<Scalars['StrictString']['output']>;
}

export interface FormDefinitionContentNode {
  __typename: 'FormDefinitionContentNode';
  sections: Scalars['JSONScalar']['output'];
}

export interface FormDefinitionNode extends SearchableInterface, StarrableInterface, TemplateCollectibleInterface {
  __typename: 'FormDefinitionNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorNode: CreatorInterface;
  editUrl: Scalars['StrictString']['output'];
  formDefinitionVersions: Array<FormDefinitionVersionNode>;
  id: Scalars['StrictString']['output'];
  instanceUrl: Scalars['StrictString']['output'];
  isValid: Scalars['StrictBoolean']['output'];
  latestFormDefinitionVersion: FormDefinitionVersionNode;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  schema: Maybe<ProcessTaskSchemaOrInaccessibleInfoNode>;
  star: Maybe<StarNode>;
  templateCollection: TemplateCollectionNode;
}

export type FormDefinitionOrInaccessibleInfoNode = FormDefinitionNode | InaccessibleInfoNode;

export interface FormDefinitionVersionNode extends HasCreatorInterface {
  __typename: 'FormDefinitionVersionNode';
  actionConfigs: Array<FormDefinitionActionConfigNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  definition: FormDefinitionContentNode;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  publishedAt: Maybe<Scalars['StrictString']['output']>;
  version: Scalars['StrictInt']['output'];
}

export interface FormFieldToActionParamNode {
  __typename: 'FormFieldToActionParamNode';
  actionParameterId: Scalars['StrictString']['output'];
  formFieldKey: Maybe<Scalars['StrictString']['output']>;
}

export interface FormulaUnitTermNode {
  __typename: 'FormulaUnitTermNode';
  exponent: Scalars['StrictInt']['output'];
  value: UnitNode;
}

export interface FragmentMetadataNode {
  __typename: 'FragmentMetadataNode';
  homologyRegionOtherColor: Maybe<Scalars['StrictString']['output']>;
}

export interface FreezeThawInfoNode {
  __typename: 'FreezeThawInfoNode';
  freezeThawCount: Maybe<Scalars['StrictInt']['output']>;
  id: Scalars['StrictString']['output'];
  isTrackingEnabled: Scalars['StrictBoolean']['output'];
}

export enum GQLComplexPolymerType {
  ANTIBODY = 'ANTIBODY',
  OLIGO_CONJUGATE = 'OLIGO_CONJUGATE',
  OLIGO_DUPLEX = 'OLIGO_DUPLEX'
}

export interface GenericComplexPolymerSchemaConfigNode extends ComplexPolymerConfigInterface {
  __typename: 'GenericComplexPolymerSchemaConfigNode';
  configValues: Array<ComplexPolymerConfigValueNode>;
  id: Scalars['StrictString']['output'];
  linkedFields: Array<ComplexPolymerSchemaFieldDefinitionNode>;
  schema: ComplexPolymerSchemaNode;
  schemaInterface: StaticSchemaInterfaceNode;
}

export interface GoogleOAuthAuthnOptionNode extends AuthnOptionNodeInterface {
  __typename: 'GoogleOAuthAuthnOptionNode';
  domains: Array<Scalars['StrictString']['output']>;
  enabled: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export interface GridCellNode {
  __typename: 'GridCellNode';
  columnIndex: Scalars['StrictInt']['output'];
  container: ContainerOrInaccessibleInfoNode;
  gridPosition: Scalars['StrictInt']['output'];
  rowIndex: Scalars['StrictInt']['output'];
}

export type GridCellOrInaccessibleInfoNode = GridCellNode | InaccessibleInfoNode;

export enum GridCoordinatesDirections {
  ACROSS_ROWS = 'ACROSS_ROWS',
  DOWN_COLUMNS = 'DOWN_COLUMNS'
}

export interface GridInterface {
  cell: Maybe<GridCellNode>;
  cells: Array<Array<Maybe<GridCellNode>>>;
  occupiedCapacity: Maybe<Scalars['StrictInt']['output']>;
  totalCapacity: Maybe<Scalars['StrictInt']['output']>;
}


export interface GridInterfacecellArgs {
  colIndex?: InputMaybe<Scalars['StrictInt']['input']>;
  rowIndex?: InputMaybe<Scalars['StrictInt']['input']>;
}

export interface GridLayoutCoordinatesNode {
  __typename: 'GridLayoutCoordinatesNode';
  column: Scalars['StrictInt']['output'];
  row: Scalars['StrictInt']['output'];
}

export interface GridSchemaInterface {
  containerSchema: Maybe<ContainerSchemaNode>;
  height: Scalars['StrictInt']['output'];
  width: Scalars['StrictInt']['output'];
}

export type GridSchemaOrInaccessibleInfoNode = BoxSchemaNode | InaccessibleInfoNode | PlateSchemaNode;

export interface GroupInterface {
  admin: Scalars['StrictBoolean']['output'];
  adminListing: AdminListingNode;
  admins: Scalars['JSONScalar']['output'];
  member: Scalars['StrictBoolean']['output'];
  memberListing: MemberListingNode;
  /** @deprecated Use member_listing, which has pagination */
  members: Array<UserNode>;
  permissions: PermissionsNode;
}


export interface GroupInterfaceadminListingArgs {
  limitOffsetInput: LimitOffsetInput;
  optionsInput: MembersListOptionsInput;
}


export interface GroupInterfacememberListingArgs {
  limitOffsetInput: LimitOffsetInput;
  optionsInput: MembersListOptionsInput;
}

export enum HELMPolymerType {
  CHEM = 'CHEM',
  PEPTIDE = 'PEPTIDE',
  RNA = 'RNA'
}

export enum HandleType {
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP = 'TOP'
}

export interface HasArchiveRecordInterface {
  archiveRecord: Maybe<ArchiveRecordNode>;
}

export interface HasAuthorsInterface {
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
}

export interface HasConditionInterface {
  conditionData: ConditionDataNode;
}

export interface HasCreationContextInterface {
  creationContext: CreationContextNode;
}

export interface HasCreationOriginInterface {
  creationOrigin: CreationOriginNode;
}

export interface HasCreatorInterface {
  creator: PrincipalInterface;
}

export interface HasCustomFieldsInterface {
  customFields: Array<CustomFieldNode>;
  id: Scalars['StrictString']['output'];
}

export interface HasDisplayIdInterface {
  displayId: Maybe<Scalars['StrictString']['output']>;
}

export interface HasNameTemplatesInterface {
  nameTemplates: Array<NameTemplateNode>;
}

export interface HasOptionalCreatorInterface {
  creator: Maybe<PrincipalInterface>;
}

export interface HasPermissionsInterface {
  permissions: PermissionsNode;
}

export interface HasSchemaInterfacesInterface {
  interfaceConfigs: Array<BaseSchemaInterfaceConfigInterface>;
  interfaces: Array<BaseSchemaInterfaceInterface>;
}

export interface HasValidationRulesInterface {
  hasAtLeastOneValidationRule: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  simpleRules: Array<SimpleRuleNode>;
  validationRules: Array<ValidationRuleNode>;
  validationRulesTemplateAndInputsMapping: Scalars['JSONScalar']['output'];
}

export type HasValidationRulesItemOrInaccessibleInfoNode = InaccessibleInfoNode | JellyfishNode | ProcessTaskSchemaNode | TagSchemaNode;

export interface IPConfigurationInfoNode {
  __typename: 'IPConfigurationInfoNode';
  useWebIpAllowlistForWarehouse: Scalars['StrictBoolean']['output'];
  /** @deprecated Deprecated in favor of warehouseIpAllowlist */
  warehouseInfo: Maybe<WarehouseInfoNode>;
  warehouseIpAllowlist: Maybe<Array<Scalars['StrictString']['output']>>;
  webIpAllowlist: Array<Scalars['StrictString']['output']>;
}

export interface ImplementedAntibodySchemaInterfaceNode {
  __typename: 'ImplementedAntibodySchemaInterfaceNode';
  domainLinkedSchemas: Array<AntibodyDomainLinkedSchemaNode>;
  format: AntibodyFormatNode;
  id: Scalars['StrictString']['output'];
  schema: AntibodySchemaNode;
  schemaInterface: StaticSchemaInterfaceNode;
}

export interface ImplementedEquipmentSchemaInterfaceNode {
  __typename: 'ImplementedEquipmentSchemaInterfaceNode';
  id: Scalars['StrictString']['output'];
  schemaInterface: StaticSchemaInterfaceNode;
}

export type ImplementedEquipmentSchemaInterfaceOrInaccessibleInfoNode = ImplementedEquipmentSchemaInterfaceNode | InaccessibleInfoNode;

export interface ImplementedFreezeThawTrackingSchemaInterfaceNode extends BaseSchemaInterfaceConfigInterface {
  __typename: 'ImplementedFreezeThawTrackingSchemaInterfaceNode';
  interface: BaseSchemaInterfaceInterface;
  limit: Maybe<Scalars['StrictInt']['output']>;
}

export interface InaccessibleInfoNode {
  __typename: 'InaccessibleInfoNode';
  canRequestAccess: Scalars['StrictBoolean']['output'];
  invalidId: Scalars['StrictString']['output'];
}

export interface IndividualColumnMappingNode {
  __typename: 'IndividualColumnMappingNode';
  columnName: Scalars['StrictString']['output'];
  columnType: SpreadsheetColumnsMappingsColumnType;
  id: Scalars['StrictString']['output'];
  schemaField: Maybe<SchemaFieldNode>;
  spreadsheetColumnsMapping: Maybe<SpreadsheetColumnsMappingNode>;
}

export enum IngredientMeasurementUnit {
  Cells = 'Cells',
  L = 'L',
  Units = 'Units',
  g = 'g',
  kg = 'kg',
  mL = 'mL',
  mg = 'mg',
  mmol = 'mmol',
  mol = 'mol',
  nL = 'nL',
  uL = 'uL',
  ug = 'ug',
  umol = 'umol'
}

export interface IngredientNode {
  __typename: 'IngredientNode';
  amount: Maybe<Scalars['StrictString']['output']>;
  catalogIdentifier: Maybe<Scalars['StrictString']['output']>;
  componentBioentity: RegistryItemInterface;
  componentLotValues: ComponentLotValuesNode;
  id: Scalars['StrictString']['output'];
  inheritedTargetAmount: Maybe<Scalars['StrictString']['output']>;
  isCatalogIdentifierInherited: Scalars['StrictBoolean']['output'];
  isInherited: Scalars['StrictBoolean']['output'];
  mixture: MixtureNode;
  notes: Maybe<Scalars['StrictString']['output']>;
  parentIngredientAmount: Maybe<Scalars['StrictString']['output']>;
  parentIngredientId: Maybe<Scalars['StrictString']['output']>;
  source: Maybe<Scalars['StrictString']['output']>;
  units: IngredientMeasurementUnit;
}

export type IngredientOrInaccessibleInfoNode = InaccessibleInfoNode | IngredientNode;

export interface InstitutionListingNode {
  __typename: 'InstitutionListingNode';
  institutions: Array<InstitutionNode>;
  total: Scalars['StrictInt']['output'];
}

export interface InstitutionNode {
  __typename: 'InstitutionNode';
  adminEmail: Maybe<Scalars['StrictString']['output']>;
  enableEmailChangeNotifications: Scalars['StrictBoolean']['output'];
  enableExportNotifications: Scalars['StrictBoolean']['output'];
  fullName: Scalars['StrictString']['output'];
  grantsElnDesktopSync: Scalars['StrictBoolean']['output'];
  hasUnlimitedSpace: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  licensed: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  names: Array<Scalars['StrictString']['output']>;
  shortName: Maybe<Scalars['StrictString']['output']>;
  subdomains: Array<Scalars['StrictString']['output']>;
  urlIdentifier: Maybe<Scalars['StrictString']['output']>;
  verified: Scalars['StrictBoolean']['output'];
}

export interface InstitutionProjectBackupRecordNode {
  __typename: 'InstitutionProjectBackupRecordNode';
  institution: InstitutionNode;
  project: ProjectNode;
  startedAt: Scalars['StrictString']['output'];
  user: UserNode;
}

export interface InstitutionSearchInputInput {
  query: Scalars['StrictString']['input'];
}

export interface IntPropertyNode {
  __typename: 'IntPropertyNode';
  value: Scalars['StrictInt']['output'];
}

export type IntPropertyOrErrorNode = ErrorNode | IntPropertyNode;

export interface InternalAdminScriptNode {
  __typename: 'InternalAdminScriptNode';
  args: Scalars['JSONScalar']['output'];
  description: Scalars['StrictString']['output'];
  options: InternalAdminScriptOptionsNode;
  scriptName: Scalars['StrictString']['output'];
}

export interface InternalAdminScriptOptionsNode {
  __typename: 'InternalAdminScriptOptionsNode';
  interpretOutputAsUrl: Scalars['StrictBoolean']['output'];
}

export interface InventoryConfigNode {
  __typename: 'InventoryConfigNode';
  enableArchiveEntityInContainerOption: Maybe<Scalars['StrictBoolean']['output']>;
  id: Scalars['StrictString']['output'];
}

export type InventoryConfigOrInaccessibleInfoNode = InaccessibleInfoNode | InventoryConfigNode;

export interface IsContainedInComplexPolymerDataNode {
  __typename: 'IsContainedInComplexPolymerDataNode';
  errorMessage: Maybe<Scalars['StrictString']['output']>;
  isContained: Scalars['StrictBoolean']['output'];
}

export interface ItemTypeOptionNode {
  __typename: 'ItemTypeOptionNode';
  actionOptions: Array<ActionOptionGroupOrActionOptionNode>;
  description: Maybe<Scalars['StrictString']['output']>;
  itemType: PolicyItemType;
  name: Scalars['StrictString']['output'];
}

export interface JSONScalarBox {
  __typename: 'JSONScalarBox';
  value: Maybe<Scalars['JSONScalar']['output']>;
}

export type JSONScalarOrInaccessibleInfoNode = InaccessibleInfoNode | JSONScalarBox;

export interface JellyfishNode extends BaseFolderItemInterface, CoreObjectArchivableInterface, HasPermissionsInterface, HasValidationRulesInterface, SearchableInterface, StarrableInterface {
  __typename: 'JellyfishNode';
  archiveData: ArchiveDataNode;
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  description: Maybe<Scalars['StrictString']['output']>;
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  hasAtLeastOneValidationRule: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  simpleRules: Array<SimpleRuleNode>;
  star: Maybe<StarNode>;
  tentacles: Array<TentacleNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  validationRules: Array<ValidationRuleNode>;
  validationRulesTemplateAndInputsMapping: Scalars['JSONScalar']['output'];
}

export type JellyfishOrInaccessibleInfoNode = InaccessibleInfoNode | JellyfishNode;

export interface JellyfishSchemaNode extends CoreObjectArchivableInterface, HasPermissionsInterface {
  __typename: 'JellyfishSchemaNode';
  archiveData: ArchiveDataNode;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  prefix: Scalars['StrictString']['output'];
  species: Scalars['StrictString']['output'];
}

export type JellyfishSchemaOrInaccessibleInfoNode = InaccessibleInfoNode | JellyfishSchemaNode;

export enum LLMDataAccessConsentState {
  ENABLED = 'ENABLED',
  EXPLICITLY_DISABLED = 'EXPLICITLY_DISABLED',
  UNSPECIFIED = 'UNSPECIFIED'
}

export interface LLMFeatureEnablementConfigNode {
  __typename: 'LLMFeatureEnablementConfigNode';
  configKey: Scalars['StrictString']['output'];
  enablementState: LLMFeatureEnablementState;
  explicitlyEnabledUsers: Array<UserNode>;
}

export enum LLMFeatureEnablementState {
  ALL_USERS = 'ALL_USERS',
  AVAILABLE_DISABLED = 'AVAILABLE_DISABLED',
  SOME_USERS = 'SOME_USERS',
  UNAVAILABLE = 'UNAVAILABLE'
}

export interface LLMFeaturesConfigurationNode {
  __typename: 'LLMFeaturesConfigurationNode';
  dataAccessConsent: LLMDataAccessConsentState;
  featureEnablementConfigs: Array<LLMFeatureEnablementConfigNode>;
  isOpenAIEnabled: Scalars['StrictBoolean']['output'];
  notebookCheckConfig: NotebookCheckConfigNode;
}

export type LLMFeaturesConfigurationOrInaccessibleInfoNode = InaccessibleInfoNode | LLMFeaturesConfigurationNode;

export interface LabelPrintingConfigNode {
  __typename: 'LabelPrintingConfigNode';
  bartenderServers: Array<BartenderServerNode>;
  enableLabelTemplatePreview: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  tenantConfiguredPrintingMethod: LabelPrintingMethod;
  userConfiguredPrintingMethod: LabelPrintingMethod;
}

export enum LabelPrintingMethod {
  BARTENDER = 'BARTENDER',
  LEGACY_HTTP = 'LEGACY_HTTP',
  LEGACY_TCP = 'LEGACY_TCP',
  REMOTE_PRINT_SERVER = 'REMOTE_PRINT_SERVER',
  ZEBRA_BROWSER_PRINT = 'ZEBRA_BROWSER_PRINT'
}

export interface LargestTableTypeSizeNode {
  __typename: 'LargestTableTypeSizeNode';
  size: Scalars['StrictInt']['output'];
  tableKind: StructuredTableKind;
}

export enum LegacyAssaySchemaType {
  ASSAY_REQUEST = 'ASSAY_REQUEST',
  ASSAY_RESULT = 'ASSAY_RESULT',
  ASSAY_RUN = 'ASSAY_RUN'
}

export interface LimitOffsetInput {
  limit: Scalars['StrictInt']['input'];
  offset: Scalars['StrictInt']['input'];
}

export interface LineageNode {
  __typename: 'LineageNode';
  step: PipelineStepDomainNode;
  stepOutputReference: Maybe<StepOutputReferenceNode>;
}

export interface LinkedMoleculeNode {
  __typename: 'LinkedMoleculeNode';
  connection: ComplexPolymerConnectionNode;
  entity: BiomoleculeEntityOrInaccessibleInfoNode;
  id: Scalars['StrictString']['output'];
  polymerHelmReference: Scalars['StrictString']['output'];
}

export interface LocationNode extends HasArchiveRecordInterface, HasCreatorInterface, SearchableInterface, StorableInterface {
  __typename: 'LocationNode';
  allowedChildStorableSchemaApiIds: Maybe<Array<Scalars['StrictString']['output']>>;
  allowedChildStorableSchemas: Maybe<Array<StorableSchemaOrInaccessibleInfoNode>>;
  allowsNonLocationChildren: Scalars['StrictBoolean']['output'];
  ancestry: Array<StorableOrInaccessibleInfoNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  barcode: Maybe<BarcodeNode>;
  capacity: Maybe<Scalars['StrictInt']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead. */
  creatorJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  occupiedCapacity: Maybe<Scalars['StrictInt']['output']>;
  parentStorable: Maybe<StorableOrInaccessibleInfoNode>;
  permissions: PermissionsNode;
  source: SourceInterface;
  starred: Scalars['StrictBoolean']['output'];
  storableSchema: LocationSchemaNode;
  tagsJson: Scalars['JSONScalar']['output'];
  url: Scalars['StrictString']['output'];
  validationState: Maybe<ValidationStateNode>;
}


export interface LocationNodeparentStorableArgs {
  skipAuthCheck?: InputMaybe<Scalars['StrictBoolean']['input']>;
}

export type LocationOrInaccessibleInfoNode = InaccessibleInfoNode | LocationNode;

export interface LocationSchemaNode extends HasArchiveRecordInterface, SchemaInterface, StorableSchemaInterface {
  __typename: 'LocationSchemaNode';
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  numValidationFailures: Scalars['StrictInt']['output'];
  prefix: Scalars['StrictString']['output'];
  registry: RegistryNode;
  relatedBenchlingApps: Array<BenchlingAppNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
  storablesFailingValidation: Array<StorableOrInaccessibleInfoNode>;
}


export interface LocationSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export interface LookupConfigNode {
  __typename: 'LookupConfigNode';
  id: Scalars['StrictString']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  lookupSteps: Scalars['JSONScalar']['output'];
  multiFlattenLevel: Maybe<Scalars['StrictInt']['output']>;
}

export type LookupConfigOrInaccessibleInfoNode = InaccessibleInfoNode | LookupConfigNode;

export interface MatchingChildEntitiesNode {
  __typename: 'MatchingChildEntitiesNode';
  items: Array<RegistryItemInterface>;
  total: Scalars['StrictInt']['output'];
}

export interface MeasurementNode {
  __typename: 'MeasurementNode';
  unit: Maybe<UnitNode>;
  value: Maybe<Scalars['StrictFloat']['output']>;
}

export interface MemberListingNode {
  __typename: 'MemberListingNode';
  members: Array<PartyNode>;
  total: Scalars['StrictInt']['output'];
}

export enum MembersListMemberType {
  BENCHLING_APP = 'BENCHLING_APP',
  PERSON = 'PERSON'
}

export interface MembersListOptionsInput {
  includeMembersTypes: Array<MembersListMemberType>;
  includeSuspended: Scalars['StrictBoolean']['input'];
}

export interface MixtureInstructionsNode {
  __typename: 'MixtureInstructionsNode';
  id: Scalars['StrictString']['output'];
  noteJson: Scalars['JSONScalar']['output'];
}

export enum MixtureMeasurementUnit {
  L = 'L',
  Units = 'Units',
  g = 'g',
  kg = 'kg',
  mL = 'mL',
  mg = 'mg',
  nL = 'nL',
  uL = 'uL',
  ug = 'ug'
}

export interface MixtureNode extends FolderItemInterface, HasArchiveRecordInterface, PoliceableInterface, RegistryItemInterface, SearchableInterface, WorklistItemInterface {
  __typename: 'MixtureNode';
  allChildEntities: Array<RegistryItemInterface>;
  amount: Scalars['StrictString']['output'];
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  bioentityAliasInfos: Array<BioentityAliasInfoNode>;
  childEntities: Array<RegistryItemInterface>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  convertedToItem: Maybe<RegistryItemInterface>;
  createdAt: Scalars['StrictString']['output'];
  displayLabel: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  hasExpirationTracking: Scalars['StrictBoolean']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  ingredients: Array<IngredientNode>;
  inheritedCollaborations: Array<CollaborationNode>;
  instructions: Maybe<MixtureInstructionsNode>;
  isTrialSample: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  linkedContainerContents: Array<ContainerContentNode>;
  matchingChildEntities: MatchingChildEntitiesNode;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  noteJson: Scalars['JSONScalar']['output'];
  parentMixture: Maybe<MixtureOrInaccessibleInfoNode>;
  permissions: PermissionsNode;
  projectFolder: Maybe<FolderNode>;
  registrationOrigin: Maybe<RegistrationOriginNode>;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  residues: Maybe<Scalars['StrictString']['output']>;
  schemaValidationStateJson: Maybe<Scalars['JSONScalar']['output']>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  testOrders: Array<TestOrderNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  units: MixtureMeasurementUnit;
  validEntitiesForFieldPathInfo: Maybe<ValidEntitiesForFieldPathNode>;
}


export interface MixtureNodechildEntitiesArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface MixtureNodematchingChildEntitiesArgs {
  archivePurposes?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  childEntitySchemaId: Scalars['StrictString']['input'];
  limit?: InputMaybe<Scalars['StrictInt']['input']>;
  offset?: InputMaybe<Scalars['StrictInt']['input']>;
  queryString?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface MixtureNodetestOrdersArgs {
  statusIsOneOf?: InputMaybe<Array<TestOrderStatus>>;
}


export interface MixtureNodevalidEntitiesForFieldPathInfoArgs {
  fieldId: Scalars['StrictString']['input'];
}

export type MixtureOrInaccessibleInfoNode = InaccessibleInfoNode | MixtureNode;

export interface MixtureSchemaConfigurationNode {
  __typename: 'MixtureSchemaConfigurationNode';
  allowMeasuredIngredients: Scalars['StrictBoolean']['output'];
  componentLotStorageEnabled: Maybe<Scalars['StrictBoolean']['output']>;
  componentLotTextEnabled: Maybe<Scalars['StrictBoolean']['output']>;
}

export type ModelNode = APIKeyNode | AnalysisNode | AnalysisTemplateDataFrameVariableNode | AnalysisTemplateNode | AnalysisTemplateVariableNode | AnalyticsDashboardLayoutRowNode | AnalyticsDashboardLinkNode | AnalyticsDashboardNode | AnalyticsParameterBioentityLinkConfigNode | AnalyticsParameterDateConfigNode | AnalyticsParameterEntryLinkConfigNode | AnalyticsParameterFolderLinkConfigNode | AnalyticsParameterNumberConfigNode | AnalyticsParameterProcessLinkConfigNode | AnalyticsParameterProcessTaskLinkConfigNode | AnalyticsParameterProjectLinkConfigNode | AnalyticsParameterSelectorConfigNode | AnalyticsParameterStorableLinkConfigNode | AnalyticsParameterStringConfigNode | AnalyticsParameterStudyLinkConfigNode | AnalyticsParameterTeamLinkConfigNode | AnalyticsParameterUserLinkConfigNode | AnalyticsParameterValueNode | AnalyticsParameterValueTemplateNode | AnalyticsQueryNode | AnalyticsVisualizationBarChartParametersNode | AnalyticsVisualizationHeatmapParametersNode | AnalyticsVisualizationLineChartParametersNode | AnalyticsVisualizationNode | AnalyticsVisualizationPieChartParametersNode | AnalyticsVisualizationScatterPlotParametersNode | AnalyticsVisualizationTableParametersNode | AntibodyFormatChainNode | AntibodyFormatDomainInteractionNode | AntibodyFormatDomainNode | AntibodyFormatNode | AntibodyNode | AntibodyVersionNode | AutomationErrorFileNode | AutomationInputFileConfigNode | AutomationInputFileNode | AutomationInputTransformFileNode | AutomationOutputFileConfigNode | AutomationOutputFileDestinationInfoNode | AutomationOutputFileNode | AutomationOutputFileResultSchemaInfoNode | AutomationOutputFileTagSchemaInfoNode | AutomationOutputTransformFileNode | BaseEntryNode | BaseFieldDefinitionNode | BasicFolderItemNode | BatchNode | BatchSchemaNode | BenchlingAppCanvasNode | BenchlingAppDefinitionNode | BenchlingAppFeatureNode | BenchlingAppNode | BenchlingAppSessionMessageNode | BenchlingAppSessionNode | BioentityAliasInfoNode | BoxNode | BoxSchemaNode | BulkAssemblyNode | ChartNode | ChatSessionNode | ChemicalStructureNode | ChildEntityLinkConfigNode | ComplexPolymerVersionNode | ConfigImportHistoryEntryNode | ConfigOverrideNode | ConnectionNode | ConnectionSchemaNode | ContainerContentNode | ContainerNode | ContainerSchemaNode | CreationOriginNode | DataFrameColumnNode | DataFrameDomainNode | DataFrameNode | DataPolicyNode | DatasetNode | DefaultSchemaCollaborationNode | DefaultSchemaCollaboratorsConfigurationNode | DefaultSchemaInterfaceConfigNode | DilutionPlanNode | DocumentNode | DocumentVersionNode | DropdownFieldDefinitionNode | EntryDayNode | EntryLikeDocumentNode | EntryNode | EventbridgeEventSubscriptionNode | ExecutionSampleNode | FileNode | FolderNode | FormDefinitionActionConfigNode | FormDefinitionNode | FormDefinitionVersionNode | FormFieldToActionParamNode | GoogleOAuthAuthnOptionNode | GridLayoutCoordinatesNode | ImplementedFreezeThawTrackingSchemaInterfaceNode | IndividualColumnMappingNode | IngredientNode | InstitutionNode | InstitutionProjectBackupRecordNode | JellyfishNode | JellyfishSchemaNode | LocationNode | LocationSchemaNode | LookupConfigNode | MixtureInstructionsNode | MixtureNode | MoleculeNode | MoleculeVersionNode | MonomerNode | OligoConjugateVersionNode | OligoDuplexVersionNode | OrganizationNode | OrganizationRoleNode | OutlierConfigNode | PipelineExecutionNode | PipelineStepConfigNode | PipelineStepConfigVariableNode | PipelineStepDataDomainNode | PipelineStepDataNode | PipelineStepDefinitionEdgeNode | PipelineStepDefinitionNode | PipelineStepDomainNode | PipelineStepEdgeNode | PipelineStepNode | PlateNode | PlateSchemaNode | PolicyNode | PolicyStatementNode | PrinterNode | ProcedureAnalysisTemplateConfigurationNode | ProcedureDataParameterActualValueNode | ProcedureDataParameterConfirmationValueNode | ProcedureDataParameterPlannedValueNode | ProcedureDataParameterSettingNode | ProcedureDataParameterVersionNode | ProcedureEdgeNode | ProcedureEquipmentConfirmationValueNode | ProcedureEquipmentPlannedValueNode | ProcedureEquipmentSettingNode | ProcedureEquipmentVersionNode | ProcedureExecutionStepGroupNode | ProcedureFlowchartNode | ProcedureFlowchartVersionNode | ProcedureMaterialInputConfirmationValueNode | ProcedureMaterialInputPlannedValueNode | ProcedureMaterialInputSettingNode | ProcedureMaterialInputVersionNode | ProcedureMaterialOutputConfirmationValueNode | ProcedureMaterialOutputSettingNode | ProcedureMaterialOutputVersionNode | ProcedureMethodDefinitionVersionNode | ProcedureMethodExecutionInstanceAssociationNode | ProcedureMethodExecutionInstanceNode | ProcedureNode | ProcedurePlanDataParameterSettingNode | ProcedurePlanEquipmentSettingNode | ProcedurePlanFlowchartVersionNode | ProcedurePlanMaterialInputSettingNode | ProcedurePlanMethodDefinitionVersionNode | ProcedureRunConditionNode | ProcedureRunConditionReplicateNode | ProcedureRunNode | ProcedureStepDefinitionVersionNode | ProcedureStepExecutionInstanceNode | ProcedureStepGroupNode | ProcessAsyncRecordNode | ProcessEndNodeDetailsNode | ProcessFieldDefinitionNode | ProcessFlowchartConfigNode | ProcessFlowchartConfigVersionNode | ProcessFlowchartEdgeConfigNode | ProcessFlowchartExecuteSchemaMapperRecordNode | ProcessFlowchartNode | ProcessFlowchartNodeConfigNode | ProcessFlowchartSchemaFieldMapperConfigNode | ProcessFlowchartSchemaMapperConfigNode | ProcessFlowchartSchemaMapperDependencyNode | ProcessFlowchartSchemaMapperNode | ProcessFlowchartSchemaMapperSourceConfigNode | ProcessFlowchartSchemaMappingRecordNode | ProcessLineageEdgeNode | ProcessNode | ProcessOutputNode | ProcessOutputNodeDetailsNode | ProcessOutputSchemaNode | ProcessRootNodeDetailsNode | ProcessRouterFunctionNode | ProcessRouterNodeDetailsNode | ProcessStartAutomatedMappingRecordNode | ProcessTaskDefinitionNode | ProcessTaskDefinitionVersionNode | ProcessTaskExecutionOriginNode | ProcessTaskNode | ProcessTaskNodeDetailsNode | ProcessTaskSchemaNode | ProcessTaskStatusChangeNode | ProcessTaskStatusLifecycleNode | ProcessTaskStatusNode | ProcessTaskStatusTransitionNode | ProjectNode | ProteinAlignmentNode | ProteinAnnotationVersionNode | ProteinNode | ProteinVersionNode | ProtocolNode | ProvisionedCapabilityNode | PublishingRecordNode | RegistrationOriginNode | RegistryFileNamePartNode | RegistryNode | RequestFulfillmentNode | RequestNode | RequestSchemaNode | RequestTaskNode | RequestTaskSchemaNode | RequestTaskTemplateNode | RequestTemplateNode | RequestV2DefinitionNode | RequestV2SubmissionNode | ResourceFeatureAssociationNode | ResultBlobNode | ResultNode | ResultSchemaNode | ReviewChangeNode | ReviewLifecycleNode | ReviewLifecycleStageNode | ReviewLifecycleVersionNode | ReviewNode | ReviewerNode | RunNode | RunSchemaNode | S3ExternalFileNode | SAMLAuthnOptionNode | SampleDefinitionLinkNode | SampleDefinitionNode | SampleGroupNode | SampleGroupSchemaNode | SampleTypeNode | SavedSearchNode | SchemaFieldNode | SchemaFieldSelectorNode | SchemaFieldSelectorOptionNode | SchemaInterfaceFieldNode | SchemaInterfaceNode | SchemaLinkFieldDefinitionNode | SchemaPolicyNode | ScratchFileNode | SequenceAnalysisNode | SequenceNode | SequenceVersionNode | SignatureNode | SpreadsheetColumnsMappingNode | StageEntryNode | StarNode | StaticSchemaInterfaceNode | StructuredTableNode | StudyAssociationNode | StudyNode | StudySampleTestPlanNode | StudySchemaNode | SubtemplateNode | TagSchemaConstraintNode | TagSchemaNode | TaskTransitionExtensionNode | TeamNode | TeamRoleNode | TemplateCollectionNode | TemplateNode | TenantNode | TentacleNode | TestDefinitionNode | TestOrderNode | TimepointNode | TimepointRelativeTimeNode | TimepointWindowNode | TreatmentGroupNode | TrialSampleTestingStudyDesignNode | UnitNode | UnitTypeNode | UserCapabilityNode | UserNode | ValidationErrorRecordNode | ValidationRuleNode | ValidationStateNode | WarehouseLoginNode | WorkflowNode | WorklistNode | WorksheetNode | WorksheetStepGroupNode | WorksheetStepNode;

export interface ModifiedNucleotideNode {
  __typename: 'ModifiedNucleotideNode';
  baseMonomerId: Scalars['StrictString']['output'];
  phosphateMonomerId: Maybe<Scalars['StrictString']['output']>;
  position: Scalars['StrictInt']['output'];
  sugarMonomerId: Scalars['StrictString']['output'];
}

export interface MolecularWeightNode {
  __typename: 'MolecularWeightNode';
  value: Scalars['StrictFloat']['output'];
}

export type MolecularWeightOrErrorNode = ErrorNode | MolecularWeightNode;

export interface MoleculeInComplexPolymerNode {
  __typename: 'MoleculeInComplexPolymerNode';
  attachmentPoints: Array<Maybe<AttachmentPointOrErrorNode>>;
  chemicalStructureImage: SVGOrErrorNode;
  id: Scalars['StrictString']['output'];
}

export type MoleculeInComplexPolymerOrInaccessibleNode = InaccessibleInfoNode | MoleculeInComplexPolymerNode;

export interface MoleculeNode extends FolderItemInterface, HasArchiveRecordInterface, PoliceableInterface, RegistryItemInterface, SearchableInterface, StudyableInterface, WorklistItemInterface {
  __typename: 'MoleculeNode';
  allChildEntities: Array<RegistryItemInterface>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  bioentityAliasInfos: Array<BioentityAliasInfoNode>;
  canonicalSmiles: Scalars['StrictString']['output'];
  childEntities: Array<RegistryItemInterface>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  convertedToItem: Maybe<RegistryItemInterface>;
  createdAt: Scalars['StrictString']['output'];
  currentVersion: MoleculeVersionNode;
  displayLabel: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  hasExpirationTracking: Scalars['StrictBoolean']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  imageData: SVGOrErrorNode;
  inheritedCollaborations: Array<CollaborationNode>;
  isContainedInComplexPolymer: Scalars['StrictBoolean']['output'];
  isContainedInComplexPolymerData: IsContainedInComplexPolymerDataNode;
  isStudyable: Scalars['StrictBoolean']['output'];
  isTrialSample: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  linkedContainerContents: Array<ContainerContentNode>;
  matchingChildEntities: MatchingChildEntitiesNode;
  modifiedAt: Scalars['StrictString']['output'];
  molfile: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  noteJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  projectFolder: Maybe<FolderNode>;
  registrationOrigin: Maybe<RegistrationOriginNode>;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  residues: Maybe<Scalars['StrictString']['output']>;
  schemaValidationStateJson: Maybe<Scalars['JSONScalar']['output']>;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  testOrders: Array<TestOrderNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  validEntitiesForFieldPathInfo: Maybe<ValidEntitiesForFieldPathNode>;
  version: MoleculeVersionNode;
  versions: Array<MoleculeVersionNode>;
}


export interface MoleculeNodechildEntitiesArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface MoleculeNodeimageDataArgs {
  referenceSubstructure?: InputMaybe<Scalars['StrictString']['input']>;
  shouldHighlight?: InputMaybe<Scalars['StrictBoolean']['input']>;
}


export interface MoleculeNodematchingChildEntitiesArgs {
  archivePurposes?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  childEntitySchemaId: Scalars['StrictString']['input'];
  limit?: InputMaybe<Scalars['StrictInt']['input']>;
  offset?: InputMaybe<Scalars['StrictInt']['input']>;
  queryString?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface MoleculeNodetestOrdersArgs {
  statusIsOneOf?: InputMaybe<Array<TestOrderStatus>>;
}


export interface MoleculeNodevalidEntitiesForFieldPathInfoArgs {
  fieldId: Scalars['StrictString']['input'];
}


export interface MoleculeNodeversionArgs {
  versionId: Scalars['StrictString']['input'];
}

export type MoleculeOrInaccessibleInfoNode = InaccessibleInfoNode | MoleculeNode;

export interface MoleculePolymerNode extends SimplePolymerInterface {
  __typename: 'MoleculePolymerNode';
  chemicalStructureImage: SVGOrErrorNode;
  entity: BiomoleculeEntityOrInaccessibleInfoNode;
  helmReference: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  polymerType: HELMPolymerType;
  smiles: Scalars['StrictString']['output'];
}

export interface MoleculeVersionNode extends HasCreatorInterface {
  __typename: 'MoleculeVersionNode';
  chemicalStructure: ChemicalStructureNode;
  creator: PrincipalInterface;
  id: Scalars['StrictString']['output'];
  imageData: SVGOrErrorNode;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  parentId: Maybe<Scalars['StrictString']['output']>;
}


export interface MoleculeVersionNodeimageDataArgs {
  referenceSubstructure?: InputMaybe<Scalars['StrictString']['input']>;
  shouldHighlight?: InputMaybe<Scalars['StrictBoolean']['input']>;
}

export enum MonomerCapGroup {
  CH3 = 'CH3',
  H = 'H',
  NH2 = 'NH2',
  OH = 'OH'
}

export enum MonomerMonomerType {
  BACKBONE = 'BACKBONE',
  BRANCH = 'BRANCH'
}

export enum MonomerNaturalAnalogue {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  D_LOWER = 'D_LOWER',
  G = 'G',
  H = 'H',
  K = 'K',
  M = 'M',
  N = 'N',
  P_LOWER = 'P_LOWER',
  R = 'R',
  R_LOWER = 'R_LOWER',
  S = 'S',
  T = 'T',
  U = 'U',
  V = 'V',
  W = 'W',
  Y = 'Y'
}

export interface MonomerNode extends HasArchiveRecordInterface {
  __typename: 'MonomerNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  attachmentPoints: Array<MonomerCapGroup>;
  calculatedExactMolecularWeight: Maybe<Scalars['StrictFloat']['output']>;
  calculatedMolecularWeight: Maybe<Scalars['StrictFloat']['output']>;
  canonicalSmiles: Scalars['StrictString']['output'];
  chemicalStructureImage: SVGOrErrorNode;
  color: Maybe<Scalars['StrictString']['output']>;
  customMolecularWeight: Maybe<Scalars['StrictFloat']['output']>;
  id: Scalars['StrictString']['output'];
  isNatural: Scalars['StrictBoolean']['output'];
  molecularWeight: Scalars['StrictFloat']['output'];
  molfile: Maybe<Scalars['StrictString']['output']>;
  monomerType: MonomerMonomerType;
  name: Scalars['StrictString']['output'];
  naturalAnalogue: MonomerNaturalAnalogue;
  originalSmiles: Scalars['StrictString']['output'];
  polymerType: MonomerPolymerType;
  symbol: Scalars['StrictString']['output'];
  visualSymbol: Maybe<MonomerVisualSymbol>;
}

export type MonomerOrInaccessibleInfoNode = InaccessibleInfoNode | MonomerNode;

export enum MonomerPolymerType {
  RNA = 'RNA'
}

export enum MonomerVisualSymbol {
  CLOVER_FILLED = 'CLOVER_FILLED',
  CLOVER_HOLLOW = 'CLOVER_HOLLOW',
  DIAMOND_DASHED = 'DIAMOND_DASHED',
  DIAMOND_FILLED = 'DIAMOND_FILLED',
  DIAMOND_HOLLOW = 'DIAMOND_HOLLOW',
  DYAD_FILLED = 'DYAD_FILLED',
  DYAD_HOLLOW = 'DYAD_HOLLOW',
  LETTERS_C = 'LETTERS_C',
  LETTERS_CO = 'LETTERS_CO',
  LETTERS_M = 'LETTERS_M',
  LETTERS_MP = 'LETTERS_MP',
  LETTERS_P = 'LETTERS_P',
  LETTERS_PS = 'LETTERS_PS',
  LETTERS_R = 'LETTERS_R',
  LETTERS_RS = 'LETTERS_RS',
  LETTERS_S = 'LETTERS_S',
  LETTERS_SP = 'LETTERS_SP',
  RECTANGLE_FILLED = 'RECTANGLE_FILLED',
  RECTANGLE_HOLLOW = 'RECTANGLE_HOLLOW',
  STAR_FILLED = 'STAR_FILLED',
  STAR_HOLLOW = 'STAR_HOLLOW',
  TRIAD_FILLED = 'TRIAD_FILLED',
  TRIAD_HOLLOW = 'TRIAD_HOLLOW',
  TRIANGLE_FILLED = 'TRIANGLE_FILLED',
  TRIANGLE_HOLLOW = 'TRIANGLE_HOLLOW'
}

export interface NameTemplateNode {
  __typename: 'NameTemplateNode';
  linkedItemId: Scalars['StrictString']['output'];
  nameTemplateParts: Array<NameTemplatePartNode>;
  shouldOrderPartsBySequence: Scalars['StrictBoolean']['output'];
  templateType: NameTemplateType;
}

export interface NameTemplatePartNode {
  __typename: 'NameTemplatePartNode';
  datetimeFormat: Maybe<Scalars['StrictString']['output']>;
  fieldId: Maybe<Scalars['StrictString']['output']>;
  text: Maybe<Scalars['StrictString']['output']>;
  type: NameTemplatePartType;
}

export enum NameTemplatePartType {
  ANTIBODY_DOMAIN = 'ANTIBODY_DOMAIN',
  BARCODE = 'BARCODE',
  BARCODE_NUMBER = 'BARCODE_NUMBER',
  CHILD_ENTITY_LOT_NUMBER = 'CHILD_ENTITY_LOT_NUMBER',
  COMPLEX_POLYMER_COMPONENT = 'COMPLEX_POLYMER_COMPONENT',
  CONCENTRATION_UNITS = 'CONCENTRATION_UNITS',
  CONCENTRATION_VALUE = 'CONCENTRATION_VALUE',
  CONTAINED_ENTITY_NAME = 'CONTAINED_ENTITY_NAME',
  CONTAINER_CREATED_AT_DATE = 'CONTAINER_CREATED_AT_DATE',
  CONTAINER_CREATED_AT_YEAR = 'CONTAINER_CREATED_AT_YEAR',
  CREATED_AT_DATE = 'CREATED_AT_DATE',
  CREATED_AT_YEAR = 'CREATED_AT_YEAR',
  FIELD = 'FIELD',
  FILL_DATE = 'FILL_DATE',
  FILL_YEAR = 'FILL_YEAR',
  HOISTED_FIELD = 'HOISTED_FIELD',
  LINKED_BIOENTITY_REGISTRY_IDENTIFIER = 'LINKED_BIOENTITY_REGISTRY_IDENTIFIER',
  PARENT_STORABLE_BARCODE = 'PARENT_STORABLE_BARCODE',
  PARENT_STORABLE_NAME = 'PARENT_STORABLE_NAME',
  POSITION = 'POSITION',
  PROCEDURE_NAME = 'PROCEDURE_NAME',
  PROCEDURE_RUN_ID = 'PROCEDURE_RUN_ID',
  PROJECT = 'PROJECT',
  QUANTITY_UNITS = 'QUANTITY_UNITS',
  QUANTITY_VALUE = 'QUANTITY_VALUE',
  REGISTRY_IDENTIFIER_NUMBER = 'REGISTRY_IDENTIFIER_NUMBER',
  REGISTRY_IDENTIFIER_NUMBER_BASE_26 = 'REGISTRY_IDENTIFIER_NUMBER_BASE_26',
  RESTRICTION_STATUS = 'RESTRICTION_STATUS',
  SAMPLE_LOT_NUMBER = 'SAMPLE_LOT_NUMBER',
  SEPARATOR = 'SEPARATOR',
  STUDY_ID = 'STUDY_ID',
  STUDY_NAME = 'STUDY_NAME',
  TEXT = 'TEXT'
}

export enum NameTemplateType {
  CONTAINER = 'CONTAINER',
  ENTITY = 'ENTITY',
  PROCEDURE_RUN = 'PROCEDURE_RUN',
  STUDY = 'STUDY'
}

export type NewRawDataNode = ChartNode | DataFrameDomainNode | ScratchFileNode;

export interface NotebookCheckConfigNode {
  __typename: 'NotebookCheckConfigNode';
  defaultGuidelines: Scalars['StrictString']['output'];
  guidelines: Maybe<Scalars['StrictString']['output']>;
}

export enum NotebookSectionColor {
  BLUE = 'BLUE',
  CONTRAST_BLUE = 'CONTRAST_BLUE',
  CONTRAST_GREEN = 'CONTRAST_GREEN',
  CONTRAST_GREY = 'CONTRAST_GREY',
  CONTRAST_INDIGO = 'CONTRAST_INDIGO',
  CONTRAST_ORANGE = 'CONTRAST_ORANGE',
  CONTRAST_RED = 'CONTRAST_RED',
  CONTRAST_VIOLET = 'CONTRAST_VIOLET',
  CONTRAST_YELLOW = 'CONTRAST_YELLOW',
  DEFAULT = 'DEFAULT',
  GREEN = 'GREEN',
  INDIGO = 'INDIGO',
  ORANGE = 'ORANGE',
  RED = 'RED',
  VIOLET = 'VIOLET',
  YELLOW = 'YELLOW'
}

export enum NotificationOptOutPreferenceKeys {
  ORG_NOTIFICATION_OPT_OUT = 'ORG_NOTIFICATION_OPT_OUT',
  PROCESSES_NOTIFICATION_OPT_OUT = 'PROCESSES_NOTIFICATION_OPT_OUT',
  REQUESTS_V2_NOTIFICATION_OPT_OUT = 'REQUESTS_V2_NOTIFICATION_OPT_OUT',
  STUDIES_NOTIFICATION_OPT_OUT = 'STUDIES_NOTIFICATION_OPT_OUT'
}

export interface NotificationSchedulableInterface {
  notificationSchedules: Array<NotificationScheduleDataNode>;
}

export interface NotificationScheduleDataNode {
  __typename: 'NotificationScheduleDataNode';
  deliveryDateExpr: Scalars['JSONScalar']['output'];
  recipientExpr: Scalars['JSONScalar']['output'];
  scheduleEvalVersion: Scalars['StrictString']['output'];
}

export interface NucleotideImageNode {
  __typename: 'NucleotideImageNode';
  chemicalStructureImage: SVGOrErrorNode;
  id: Scalars['StrictString']['output'];
  warnings: Array<Scalars['StrictString']['output']>;
}

export interface NucleotideInComplexPolymerNode {
  __typename: 'NucleotideInComplexPolymerNode';
  attachmentPoints: Array<Maybe<AttachmentPointOrErrorNode>>;
  baseChemicalStructureImage: SVGOrErrorNode;
  id: Scalars['StrictString']['output'];
  phosphateChemicalStructureImage: SVGOrErrorNode;
  sugarChemicalStructureImage: SVGOrErrorNode;
}

export type NucleotideInComplexPolymerOrInaccessibleNode = InaccessibleInfoNode | NucleotideInComplexPolymerNode;

export enum NucleotideModificationType {
  BASE = 'BASE',
  PHOSPHATE = 'PHOSPHATE',
  SUGAR = 'SUGAR'
}

export interface NucleotideSequencePolymerNode extends SimplePolymerInterface {
  __typename: 'NucleotideSequencePolymerNode';
  bases: Scalars['StrictString']['output'];
  entity: BiomoleculeEntityOrInaccessibleInfoNode;
  helmReference: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedNucleotides: Array<ModifiedNucleotideNode>;
  nucleotideType: NucleotideType;
  polymerType: HELMPolymerType;
}

export interface NucleotideStructureGraphNodeDataNode extends StructureGraphNodeDataInterface {
  __typename: 'NucleotideStructureGraphNodeDataNode';
  base: Scalars['StrictString']['output'];
  entityId: Scalars['StrictString']['output'];
  modifiedNucleotide: Maybe<ModifiedNucleotideNode>;
  nucleotideType: NucleotideType;
  polymerRef: Scalars['StrictString']['output'];
  residueIndex: Scalars['StrictInt']['output'];
}

export enum NucleotideType {
  DNA = 'DNA',
  RNA = 'RNA'
}

export interface OAuthCredentialNode {
  __typename: 'OAuthCredentialNode';
  clientId: Scalars['StrictString']['output'];
  clientSecrets: Array<ClientSecretNode>;
}

export type OAuthCredentialOrInaccessibleInfoNode = InaccessibleInfoNode | OAuthCredentialNode;

export enum OligoAwareFolderItemType {
  basic_folder_item = 'basic_folder_item',
  dna_sequence = 'dna_sequence',
  entry = 'entry',
  mixed = 'mixed',
  mixture = 'mixture',
  molecule = 'molecule',
  oligo = 'oligo',
  protein = 'protein',
  protocol = 'protocol',
  rna_oligo = 'rna_oligo',
  rna_sequence = 'rna_sequence',
  sequence = 'sequence'
}

export interface OligoConjugateInterface {
  branchedAttachments: Array<BranchedAttachmentNode>;
  conjugates: Array<ConjugateNode>;
  oligo: Maybe<NucleotideSequencePolymerNode>;
  resolvedAttachments: Array<ResolvedAttachmentNode>;
}

export interface OligoConjugateNode extends ComplexPolymerInterface, FolderItemInterface, OligoConjugateInterface, PoliceableInterface, RegistryItemInterface, SearchableInterface, WorklistItemInterface {
  __typename: 'OligoConjugateNode';
  allChildEntities: Array<RegistryItemInterface>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  bioentityAliasInfos: Array<BioentityAliasInfoNode>;
  branchedAttachments: Array<BranchedAttachmentNode>;
  canonicalHelm: Maybe<Scalars['StrictString']['output']>;
  childEntities: Array<RegistryItemInterface>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  conjugates: Array<ConjugateNode>;
  conjugatesSchemaFields: Maybe<Array<ComplexPolymerSchemaFieldDefinitionOrInaccessibleInfoNode>>;
  convertedToItem: Maybe<RegistryItemInterface>;
  createdAt: Scalars['StrictString']['output'];
  currentVersion: Maybe<ComplexPolymerVersionInterface>;
  displayLabel: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  hasExpirationTracking: Scalars['StrictBoolean']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  isTrialSample: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  linkedContainerContents: Array<ContainerContentNode>;
  matchingChildEntities: MatchingChildEntitiesNode;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  noteJson: Scalars['JSONScalar']['output'];
  oligo: Maybe<NucleotideSequencePolymerNode>;
  oligoSchemaField: Maybe<ComplexPolymerSchemaFieldDefinitionOrInaccessibleInfoNode>;
  originalHelm: Maybe<Scalars['StrictString']['output']>;
  outOfSync: Scalars['StrictBoolean']['output'];
  outOfSyncReason: Maybe<Scalars['StrictString']['output']>;
  permissions: PermissionsNode;
  projectFolder: Maybe<FolderNode>;
  registrationOrigin: Maybe<RegistrationOriginNode>;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  residues: Maybe<Scalars['StrictString']['output']>;
  resolvedAttachments: Array<ResolvedAttachmentNode>;
  schemaValidationStateJson: Maybe<Scalars['JSONScalar']['output']>;
  structure: Maybe<ComplexPolymerStructureNode>;
  structureGraph: Maybe<PolymerStructureGraphNode>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  testOrders: Array<TestOrderNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  validEntitiesForFieldPathInfo: Maybe<ValidEntitiesForFieldPathNode>;
  version: Maybe<ComplexPolymerVersionInterface>;
  versions: Maybe<Array<ComplexPolymerVersionInterface>>;
}


export interface OligoConjugateNodechildEntitiesArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface OligoConjugateNodematchingChildEntitiesArgs {
  archivePurposes?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  childEntitySchemaId: Scalars['StrictString']['input'];
  limit?: InputMaybe<Scalars['StrictInt']['input']>;
  offset?: InputMaybe<Scalars['StrictInt']['input']>;
  queryString?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface OligoConjugateNodetestOrdersArgs {
  statusIsOneOf?: InputMaybe<Array<TestOrderStatus>>;
}


export interface OligoConjugateNodevalidEntitiesForFieldPathInfoArgs {
  fieldId: Scalars['StrictString']['input'];
}


export interface OligoConjugateNodeversionArgs {
  versionId: Scalars['StrictString']['input'];
}

export interface OligoConjugateSchemaConfigNode extends ComplexPolymerConfigInterface {
  __typename: 'OligoConjugateSchemaConfigNode';
  configValues: Array<ComplexPolymerConfigValueNode>;
  conjugatesSchemaFields: Array<ComplexPolymerSchemaFieldDefinitionNode>;
  id: Scalars['StrictString']['output'];
  linkedFields: Array<ComplexPolymerSchemaFieldDefinitionNode>;
  oligoSchemaField: ComplexPolymerSchemaFieldDefinitionNode;
  schema: ComplexPolymerSchemaNode;
  schemaInterface: StaticSchemaInterfaceNode;
}

export interface OligoConjugateVersionNode extends ComplexPolymerVersionInterface, OligoConjugateInterface {
  __typename: 'OligoConjugateVersionNode';
  branchedAttachments: Array<BranchedAttachmentNode>;
  canonicalHelm: Maybe<Scalars['StrictString']['output']>;
  conjugates: Array<ConjugateNode>;
  creator: PrincipalInterface;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  oligo: Maybe<NucleotideSequencePolymerNode>;
  originalHelm: Maybe<Scalars['StrictString']['output']>;
  outOfSync: Scalars['StrictBoolean']['output'];
  outOfSyncReason: Maybe<Scalars['StrictString']['output']>;
  parent: Maybe<ComplexPolymerVersionInterface>;
  resolvedAttachments: Array<ResolvedAttachmentNode>;
  structure: Maybe<ComplexPolymerStructureNode>;
  structureGraph: Maybe<PolymerStructureGraphNode>;
}

export interface OligoDuplexInterface {
  forwardStrand: Maybe<OligoStrandNode>;
  offset: Maybe<Scalars['StrictInt']['output']>;
  reverseStrand: Maybe<OligoStrandNode>;
}

export interface OligoDuplexNode extends ComplexPolymerInterface, FolderItemInterface, OligoDuplexInterface, PoliceableInterface, RegistryItemInterface, SearchableInterface, WorklistItemInterface {
  __typename: 'OligoDuplexNode';
  allChildEntities: Array<RegistryItemInterface>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  bioentityAliasInfos: Array<BioentityAliasInfoNode>;
  canonicalHelm: Maybe<Scalars['StrictString']['output']>;
  childEntities: Array<RegistryItemInterface>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  conjugatesSchemaFields: Maybe<Array<ComplexPolymerSchemaFieldDefinitionOrInaccessibleInfoNode>>;
  convertedToItem: Maybe<RegistryItemInterface>;
  createdAt: Scalars['StrictString']['output'];
  currentVersion: Maybe<ComplexPolymerVersionInterface>;
  displayLabel: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  forwardStrand: Maybe<OligoStrandNode>;
  forwardStrandSchemaField: Maybe<ComplexPolymerSchemaFieldDefinitionOrInaccessibleInfoNode>;
  hasExpirationTracking: Scalars['StrictBoolean']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  isTrialSample: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  linkedContainerContents: Array<ContainerContentNode>;
  matchingChildEntities: MatchingChildEntitiesNode;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  noteJson: Scalars['JSONScalar']['output'];
  offset: Maybe<Scalars['StrictInt']['output']>;
  originalHelm: Maybe<Scalars['StrictString']['output']>;
  outOfSync: Scalars['StrictBoolean']['output'];
  outOfSyncReason: Maybe<Scalars['StrictString']['output']>;
  permissions: PermissionsNode;
  projectFolder: Maybe<FolderNode>;
  registrationOrigin: Maybe<RegistrationOriginNode>;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  residues: Maybe<Scalars['StrictString']['output']>;
  reverseStrand: Maybe<OligoStrandNode>;
  reverseStrandSchemaField: Maybe<ComplexPolymerSchemaFieldDefinitionOrInaccessibleInfoNode>;
  schemaValidationStateJson: Maybe<Scalars['JSONScalar']['output']>;
  structure: Maybe<ComplexPolymerStructureNode>;
  structureGraph: Maybe<PolymerStructureGraphNode>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  testOrders: Array<TestOrderNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  validEntitiesForFieldPathInfo: Maybe<ValidEntitiesForFieldPathNode>;
  version: Maybe<ComplexPolymerVersionInterface>;
  versions: Maybe<Array<ComplexPolymerVersionInterface>>;
}


export interface OligoDuplexNodechildEntitiesArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface OligoDuplexNodematchingChildEntitiesArgs {
  archivePurposes?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  childEntitySchemaId: Scalars['StrictString']['input'];
  limit?: InputMaybe<Scalars['StrictInt']['input']>;
  offset?: InputMaybe<Scalars['StrictInt']['input']>;
  queryString?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface OligoDuplexNodetestOrdersArgs {
  statusIsOneOf?: InputMaybe<Array<TestOrderStatus>>;
}


export interface OligoDuplexNodevalidEntitiesForFieldPathInfoArgs {
  fieldId: Scalars['StrictString']['input'];
}


export interface OligoDuplexNodeversionArgs {
  versionId: Scalars['StrictString']['input'];
}

export interface OligoDuplexSchemaConfigNode extends ComplexPolymerConfigInterface {
  __typename: 'OligoDuplexSchemaConfigNode';
  configValues: Array<ComplexPolymerConfigValueNode>;
  conjugatesSchemaFields: Array<ComplexPolymerSchemaFieldDefinitionNode>;
  forwardStrandSchemaField: ComplexPolymerSchemaFieldDefinitionNode;
  id: Scalars['StrictString']['output'];
  linkedFields: Array<ComplexPolymerSchemaFieldDefinitionNode>;
  reverseStrandSchemaField: ComplexPolymerSchemaFieldDefinitionNode;
  schema: ComplexPolymerSchemaNode;
  schemaInterface: StaticSchemaInterfaceNode;
}

export interface OligoDuplexVersionNode extends ComplexPolymerVersionInterface, OligoDuplexInterface {
  __typename: 'OligoDuplexVersionNode';
  canonicalHelm: Maybe<Scalars['StrictString']['output']>;
  creator: PrincipalInterface;
  forwardStrand: Maybe<OligoStrandNode>;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  offset: Maybe<Scalars['StrictInt']['output']>;
  originalHelm: Maybe<Scalars['StrictString']['output']>;
  outOfSync: Scalars['StrictBoolean']['output'];
  outOfSyncReason: Maybe<Scalars['StrictString']['output']>;
  parent: Maybe<ComplexPolymerVersionInterface>;
  reverseStrand: Maybe<OligoStrandNode>;
  structure: Maybe<ComplexPolymerStructureNode>;
  structureGraph: Maybe<PolymerStructureGraphNode>;
}

export interface OligoStrandNode {
  __typename: 'OligoStrandNode';
  branchedAttachments: Array<BranchedAttachmentNode>;
  conjugates: Array<ConjugateNode>;
  oligo: NucleotideSequencePolymerNode;
  resolvedAttachments: Array<ResolvedAttachmentNode>;
}

export interface OrganizationListingNode {
  __typename: 'OrganizationListingNode';
  organizations: Array<OrganizationNode>;
  total: Scalars['StrictInt']['output'];
}

export interface OrganizationListingSearchInput {
  institutionId?: InputMaybe<Scalars['StrictString']['input']>;
  query: Scalars['StrictString']['input'];
}

export interface OrganizationNode extends GroupInterface, HasPermissionsInterface, PartyInterface, SearchableInterface {
  __typename: 'OrganizationNode';
  admin: Scalars['StrictBoolean']['output'];
  adminListing: AdminListingNode;
  admins: Scalars['JSONScalar']['output'];
  /** @deprecated Deprecated in favor of admins on GroupNodeMixin */
  adminsJson: Scalars['JSONScalar']['output'];
  autoProvisionedCapabilities: Array<ProvisionedCapabilityNode>;
  avatarUrl: Maybe<Scalars['StrictString']['output']>;
  disablePersonalOwnables: Scalars['StrictBoolean']['output'];
  disablePublic: Scalars['StrictBoolean']['output'];
  email: Scalars['StrictString']['output'];
  handle: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  joinedOn: Scalars['StrictString']['output'];
  member: Scalars['StrictBoolean']['output'];
  memberListing: MemberListingNode;
  /** @deprecated Use member_listing, which has pagination */
  members: Array<UserNode>;
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  reviewLifecycles: Array<ReviewLifecycleNode>;
  schemaCollaborationDefaultConfigurations: Array<DefaultSchemaCollaboratorsConfigurationNode>;
  teams: Array<TeamNode>;
  urlIdentifier: Scalars['StrictString']['output'];
}


export interface OrganizationNodeadminListingArgs {
  limitOffsetInput: LimitOffsetInput;
  optionsInput: MembersListOptionsInput;
}


export interface OrganizationNodememberListingArgs {
  limitOffsetInput: LimitOffsetInput;
  optionsInput: MembersListOptionsInput;
}

export type OrganizationOrInaccessibleInfoNode = InaccessibleInfoNode | OrganizationNode;

export enum OrganizationRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

export interface OrganizationRoleNode {
  __typename: 'OrganizationRoleNode';
  organization: OrganizationNode;
  role: OrganizationRole;
  user: UserNode;
}

export type OriginEntryNode = DocumentNode | EntryNode | StageEntryNode;

export type OriginNode = EntryNode | ProcessNode | StageEntryNode;

export interface OutlierConfigNode {
  __typename: 'OutlierConfigNode';
  outlierSetting: AnalyticsVisualizationOutlierSetting;
  qValue: Scalars['StrictFloat']['output'];
}

export interface OutputFieldDefinitionNode {
  __typename: 'OutputFieldDefinitionNode';
  fieldDefinitions: Array<BenchlingAppSubDependencyNode>;
}

export interface OwnableInterface {
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  name: Scalars['StrictString']['output'];
  ownerInfoJson: Scalars['JSONScalar']['output'];
  ownerJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
}

export interface OwningTenantNode {
  __typename: 'OwningTenantNode';
  id: Scalars['StrictString']['output'];
  isCurrentTenant: Scalars['StrictBoolean']['output'];
}

export interface PartyInterface {
  avatarUrl: Maybe<Scalars['StrictString']['output']>;
  handle: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export type PartyNode = BenchlingAppNode | OrganizationNode | ServiceAccountActorNode | TeamNode | UserNode;

export type PartyNodeOrInaccessibleInfoNode = BenchlingAppNode | InaccessibleInfoNode | OrganizationNode | ServiceAccountActorNode | TeamNode | UserNode;

export interface PartyPoliceableNode {
  __typename: 'PartyPoliceableNode';
  collaborations: Array<CollaborationNode>;
  effectivePolicyStatements: Array<PolicyStatementNode>;
  party: PartyNode;
  policeable: PoliceableInterface;
}

export interface PartyPoliceablesListingNode {
  __typename: 'PartyPoliceablesListingNode';
  partyPoliceables: Array<PartyPoliceableNode>;
  total: Scalars['StrictInt']['output'];
}

export interface PasswordAuthnOptionNode extends AuthnOptionNodeInterface {
  __typename: 'PasswordAuthnOptionNode';
  domains: Array<Scalars['StrictString']['output']>;
  enabled: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export enum PerSchemaTableType {
  MULTI = 'MULTI',
  STANDARD = 'STANDARD'
}

export interface PermissionControlsNode {
  __typename: 'PermissionControlsNode';
  folderPermissionsEnabled: Scalars['StrictBoolean']['output'];
  permissionedFolders: PermissionedFolderSummaryNode;
  tenantHasWarehouse: Scalars['StrictBoolean']['output'];
}

export enum PermissionIntentFilter {
  ADMIN = 'ADMIN',
  APPEND = 'APPEND',
  READ = 'READ',
  WRITE = 'WRITE'
}

export interface PermissionedFolderSummaryNode {
  __typename: 'PermissionedFolderSummaryNode';
  restricted: RestrictedFolderListingNode;
  total: Scalars['StrictInt']['output'];
}

export interface PermissionsNode {
  __typename: 'PermissionsNode';
  admin: Scalars['StrictBoolean']['output'];
  appendable: Scalars['StrictBoolean']['output'];
  archivable: Maybe<Scalars['StrictBoolean']['output']>;
  batchesWritable: Maybe<Scalars['StrictBoolean']['output']>;
  bioentitiesAppendable: Maybe<Scalars['StrictBoolean']['output']>;
  canAccept: Maybe<Scalars['StrictBoolean']['output']>;
  canAddRemoveAdmins: Maybe<Scalars['StrictBoolean']['output']>;
  canAddRemoveEditors: Maybe<Scalars['StrictBoolean']['output']>;
  canAddRemoveViewers: Maybe<Scalars['StrictBoolean']['output']>;
  canChangeStudyableAssignment: Maybe<Scalars['StrictBoolean']['output']>;
  canCreateRequest: Maybe<Scalars['StrictBoolean']['output']>;
  canCreateTeams: Maybe<Scalars['StrictBoolean']['output']>;
  canEditBarcodes: Maybe<Scalars['StrictBoolean']['output']>;
  canEditContainer: Maybe<Scalars['StrictBoolean']['output']>;
  canEditNamesAndAliases: Maybe<Scalars['StrictBoolean']['output']>;
  canEditNamesAndBarcodes: Maybe<Scalars['StrictBoolean']['output']>;
  canEditRestrictedSampleUsers: Maybe<Scalars['StrictBoolean']['output']>;
  canEditStatus: Maybe<Scalars['StrictBoolean']['output']>;
  canExecuteRequest: Maybe<Scalars['StrictBoolean']['output']>;
  canManageCollaborators: Maybe<Scalars['StrictBoolean']['output']>;
  canManageRoles: Maybe<Scalars['StrictBoolean']['output']>;
  canReassignRlcReviewer: Maybe<Scalars['StrictBoolean']['output']>;
  canReject: Maybe<Scalars['StrictBoolean']['output']>;
  canRestrictSamples: Maybe<Scalars['StrictBoolean']['output']>;
  canRetract: Maybe<Scalars['StrictBoolean']['output']>;
  canSendForReview: Maybe<Scalars['StrictBoolean']['output']>;
  canUnrestrictSamples: Maybe<Scalars['StrictBoolean']['output']>;
  definitionDeletable: Maybe<Scalars['StrictBoolean']['output']>;
  definitionEditable: Maybe<Scalars['StrictBoolean']['output']>;
  definitionListable: Maybe<Scalars['StrictBoolean']['output']>;
  deletable: Maybe<Scalars['StrictBoolean']['output']>;
  locationsCreatable: Maybe<Scalars['StrictBoolean']['output']>;
  movable: Maybe<Scalars['StrictBoolean']['output']>;
  objectsCreatable: Maybe<Scalars['StrictBoolean']['output']>;
  objectsRegisterable: Maybe<Scalars['StrictBoolean']['output']>;
  /** @deprecated Compare to parent node's owner field instead */
  owner: Maybe<Scalars['StrictBoolean']['output']>;
  polymerFeaturesEditable: Maybe<Scalars['StrictBoolean']['output']>;
  polymerResiduesEditable: Maybe<Scalars['StrictBoolean']['output']>;
  readable: Scalars['StrictBoolean']['output'];
  registryIdsChangeable: Maybe<Scalars['StrictBoolean']['output']>;
  subfolderCreatable: Maybe<Scalars['StrictBoolean']['output']>;
  tagsEditable: Maybe<Scalars['StrictBoolean']['output']>;
  unarchivable: Maybe<Scalars['StrictBoolean']['output']>;
  unregisterable: Maybe<Scalars['StrictBoolean']['output']>;
  writable: Scalars['StrictBoolean']['output'];
}

export interface PipelineExecutionNode {
  __typename: 'PipelineExecutionNode';
  id: Scalars['StrictString']['output'];
  steps: Array<PipelineStepNode>;
}

export interface PipelineInterface {
  createdAt: Scalars['StrictString']['output'];
  /** @deprecated Use `steps` or `views` */
  execution: PipelineExecutionNode;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  steps: Array<PipelineStepDomainNode>;
}

export interface PipelineStepConfigNode {
  __typename: 'PipelineStepConfigNode';
  variables: Array<PipelineStepConfigVariableNode>;
}

export interface PipelineStepConfigVariableNode {
  __typename: 'PipelineStepConfigVariableNode';
  name: Scalars['StrictString']['output'];
  value: Maybe<Scalars['JSONScalar']['output']>;
}

export interface PipelineStepDataDomainNode {
  __typename: 'PipelineStepDataDomainNode';
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  /** @deprecated Use rawDatas instead */
  newRawDatas: Array<NewRawDataNode>;
  rawDatas: Array<NewRawDataNode>;
}

export enum PipelineStepDataKind {
  CHART = 'CHART',
  DATASET = 'DATASET',
  FILE = 'FILE'
}

export interface PipelineStepDataNode {
  __typename: 'PipelineStepDataNode';
  charts: Array<ChartOrInaccessibleInfoNode>;
  dataFrames: Array<DataFrameNode>;
  id: Scalars['StrictString']['output'];
  kind: PipelineStepDataKind;
  name: Scalars['StrictString']['output'];
  scratchFiles: Array<ScratchFileOrInaccessibleInfoNode>;
}

export interface PipelineStepDefinitionEdgeNode {
  __typename: 'PipelineStepDefinitionEdgeNode';
  child: PipelineStepDefinitionNode;
  childStepData: PipelineStepDataNode;
  parent: PipelineStepDefinitionNode;
  parentStepData: PipelineStepDataNode;
}

export interface PipelineStepDefinitionNode {
  __typename: 'PipelineStepDefinitionNode';
  id: Scalars['StrictString']['output'];
  incomingEdges: Array<PipelineStepDefinitionEdgeNode>;
  outgoingEdges: Array<PipelineStepDefinitionEdgeNode>;
  step: PipelineStepNode;
  stepType: PipelineStepType;
  stepVersion: Scalars['StrictInt']['output'];
}

export interface PipelineStepDomainNode {
  __typename: 'PipelineStepDomainNode';
  config: Maybe<Scalars['JSONScalar']['output']>;
  id: Scalars['StrictString']['output'];
  incomingEdges: Array<PipelineStepEdgeNode>;
  inputStepDatas: Array<PipelineStepDataDomainNode>;
  outgoingEdges: Array<PipelineStepEdgeNode>;
  outputStepDatas: Array<PipelineStepDataDomainNode>;
  statusCode: PipelineStepStatusCode;
  statusMessage: Maybe<Scalars['StrictString']['output']>;
  stepType: PipelineStepType;
  stepVersion: Scalars['StrictInt']['output'];
}

export interface PipelineStepEdgeNode {
  __typename: 'PipelineStepEdgeNode';
  fromStep: PipelineStepDomainNode;
  fromStepData: PipelineStepDataDomainNode;
  fromStepDataIndex: Maybe<Scalars['StrictInt']['output']>;
  toStep: PipelineStepDomainNode;
  toStepData: PipelineStepDataDomainNode;
  toStepDataIndex: Maybe<Scalars['StrictInt']['output']>;
}

export interface PipelineStepNode {
  __typename: 'PipelineStepNode';
  config: Maybe<PipelineStepConfigNode>;
  definition: PipelineStepDefinitionNode;
  id: Scalars['StrictString']['output'];
  inputStepDatas: Array<PipelineStepDataNode>;
  modifiedAt: Scalars['StrictString']['output'];
  outputStepDatas: Array<PipelineStepDataNode>;
  statusCode: PipelineStepStatusCode;
  statusMessage: Maybe<Scalars['StrictString']['output']>;
}

export enum PipelineStepStatusCode {
  BLOCKED = 'BLOCKED',
  FAILED = 'FAILED',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
  WAITING = 'WAITING'
}

export enum PipelineStepType {
  AGGREGATE_DATASET = 'AGGREGATE_DATASET',
  ANOVA = 'ANOVA',
  BIN_DATA = 'BIN_DATA',
  CHAI1 = 'CHAI1',
  CHART_VIEW = 'CHART_VIEW',
  COMPUTED_COLUMN = 'COMPUTED_COLUMN',
  CONNECTION_DATA_DATASET = 'CONNECTION_DATA_DATASET',
  CONVERT_ASM_TO_CSV = 'CONVERT_ASM_TO_CSV',
  CONVERT_TO_ASM = 'CONVERT_TO_ASM',
  CREATE_DATASET_FROM_FILE = 'CREATE_DATASET_FROM_FILE',
  DATASET_VIEW = 'DATASET_VIEW',
  DATA_CATALOG_DATASET = 'DATA_CATALOG_DATASET',
  DATA_CATALOG_FILE = 'DATA_CATALOG_FILE',
  EXPERIMENT_OPTIMIZATION_BOOTSTRAP = 'EXPERIMENT_OPTIMIZATION_BOOTSTRAP',
  EXPERIMENT_OPTIMIZATION_CLEAN_DATA = 'EXPERIMENT_OPTIMIZATION_CLEAN_DATA',
  EXPERIMENT_OPTIMIZATION_EXPLANATION = 'EXPERIMENT_OPTIMIZATION_EXPLANATION',
  EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE = 'EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE',
  EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY = 'EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY',
  EXPERIMENT_OPTIMIZATION_RECOMMENDATION = 'EXPERIMENT_OPTIMIZATION_RECOMMENDATION',
  EXPERIMENT_OPTIMIZATION_TRAINING = 'EXPERIMENT_OPTIMIZATION_TRAINING',
  EXPLORATORY_DATA_ANALYSIS = 'EXPLORATORY_DATA_ANALYSIS',
  EXPORT_DATA_CATALOG_DATASET = 'EXPORT_DATA_CATALOG_DATASET',
  EXPORT_DATA_CATALOG_FILE = 'EXPORT_DATA_CATALOG_FILE',
  EXTRACT_OR_REMOVE_LINES = 'EXTRACT_OR_REMOVE_LINES',
  FILTER_DATASET = 'FILTER_DATASET',
  FIND_AND_REPLACE = 'FIND_AND_REPLACE',
  FLAG_ROWS = 'FLAG_ROWS',
  HIDE_COLUMNS = 'HIDE_COLUMNS',
  INITIALIZE_DATASET = 'INITIALIZE_DATASET',
  INTERPOLATE_MARKDOWN = 'INTERPOLATE_MARKDOWN',
  JOIN = 'JOIN',
  LAYOUT = 'LAYOUT',
  LOOK_UP = 'LOOK_UP',
  MAP_COLUMNS = 'MAP_COLUMNS',
  NOTEBOOK_TABLE_DATASET = 'NOTEBOOK_TABLE_DATASET',
  PARAMETER_OPTIMIZATION_CONFIGURATION = 'PARAMETER_OPTIMIZATION_CONFIGURATION',
  PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION = 'PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION',
  PARAMETER_OPTIMIZATION_MODELING = 'PARAMETER_OPTIMIZATION_MODELING',
  PARAMETER_OPTIMIZATION_PREDICTION = 'PARAMETER_OPTIMIZATION_PREDICTION',
  PIVOT_DATASET = 'PIVOT_DATASET',
  PLATE_SCHEMA_DATASET = 'PLATE_SCHEMA_DATASET',
  PROCEDURE_RUN_DATA_FRAMES = 'PROCEDURE_RUN_DATA_FRAMES',
  PROMOTE_DATASET = 'PROMOTE_DATASET',
  REGISTRY_SCHEMA_DATASET = 'REGISTRY_SCHEMA_DATASET',
  REGRESSION = 'REGRESSION',
  REGRESSION_INTERPOLATION = 'REGRESSION_INTERPOLATION',
  RENAME_COLUMNS = 'RENAME_COLUMNS',
  REORDER_COLUMNS = 'REORDER_COLUMNS',
  RETYPE_COLUMNS = 'RETYPE_COLUMNS',
  SAVE_TO_RESULTS = 'SAVE_TO_RESULTS',
  SEND_TO_CONNECTION = 'SEND_TO_CONNECTION',
  SEND_TO_DOCUMENT = 'SEND_TO_DOCUMENT',
  SORT_COLUMNS = 'SORT_COLUMNS',
  TABLE_VIEW = 'TABLE_VIEW',
  TEMPLATE_INPUT = 'TEMPLATE_INPUT',
  THIRD_PARTY = 'THIRD_PARTY',
  T_TEST = 'T_TEST',
  UNION_DATASETS = 'UNION_DATASETS',
  UNPIVOT_DATASET = 'UNPIVOT_DATASET',
  UPLOAD_CSV_DATASET = 'UPLOAD_CSV_DATASET',
  USER_DEFINED_FUNCTION = 'USER_DEFINED_FUNCTION',
  WINDOW_FUNCTIONS = 'WINDOW_FUNCTIONS'
}

export interface PlateNode extends GridInterface, HasArchiveRecordInterface, HasCreatorInterface, SearchableInterface, StorableInterface, StudyableInterface, WorklistItemInterface {
  __typename: 'PlateNode';
  ancestry: Array<StorableOrInaccessibleInfoNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  barcode: Maybe<BarcodeNode>;
  cell: Maybe<GridCellNode>;
  cells: Array<Array<Maybe<GridCellNode>>>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead. */
  creatorJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  occupiedCapacity: Maybe<Scalars['StrictInt']['output']>;
  parentStorable: Maybe<StorableOrInaccessibleInfoNode>;
  permissions: PermissionsNode;
  restrictionStatus: SampleRestrictionStatus;
  sampleRoles: SampleRolesNode;
  source: SourceInterface;
  starred: Scalars['StrictBoolean']['output'];
  storableSchema: PlateSchemaNode;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  tagsJson: Scalars['JSONScalar']['output'];
  testOrderAssociations: Array<TestOrderPlateAssociationNode>;
  totalCapacity: Maybe<Scalars['StrictInt']['output']>;
  validationState: Maybe<ValidationStateNode>;
}


export interface PlateNodecellArgs {
  colIndex?: InputMaybe<Scalars['StrictInt']['input']>;
  rowIndex?: InputMaybe<Scalars['StrictInt']['input']>;
}


export interface PlateNodeparentStorableArgs {
  skipAuthCheck?: InputMaybe<Scalars['StrictBoolean']['input']>;
}

export type PlateOrInaccessibleInfoNode = InaccessibleInfoNode | PlateNode;

export interface PlateSchemaNode extends GridSchemaInterface, HasArchiveRecordInterface, SchemaInterface, StorableSchemaInterface {
  __typename: 'PlateSchemaNode';
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  containerSchema: Maybe<ContainerSchemaNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  height: Scalars['StrictInt']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  numValidationFailures: Scalars['StrictInt']['output'];
  plateSchemaType: PlateSchemaType;
  prefix: Scalars['StrictString']['output'];
  registry: RegistryNode;
  relatedBenchlingApps: Array<BenchlingAppNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
  storablesFailingValidation: Array<StorableOrInaccessibleInfoNode>;
  width: Scalars['StrictInt']['output'];
}


export interface PlateSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export enum PlateSchemaType {
  FIXED_PLATE = 'FIXED_PLATE',
  MATRIX_PLATE = 'MATRIX_PLATE'
}

export interface PoliceableInterface {
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
}

export type PoliceableOrInaccessibleInfoNode = BasicFolderItemNode | ComplexPolymerNode | ConnectionSchemaNode | EntryNode | EquipmentNode | FolderNode | InaccessibleInfoNode | MixtureNode | MoleculeNode | OligoConjugateNode | OligoDuplexNode | ProjectNode | ProteinNode | RegistryNode | RequestSchemaNode | ResultSchemaNode | RunSchemaNode | SchemaInterfaceNode | SequenceNode | StudySchemaNode | TagSchemaNode | TemplateCollectionNode | TestDefinitionNode | WorklistNode;

export enum PolicyAction {
  ADMIN = 'ADMIN',
  APPEND = 'APPEND',
  ARCHIVE = 'ARCHIVE',
  CHANGE_ASSIGNMENT_OF_OBJECTS = 'CHANGE_ASSIGNMENT_OF_OBJECTS',
  CHANGE_REGISTRY_IDENTIFIER = 'CHANGE_REGISTRY_IDENTIFIER',
  CREATE = 'CREATE',
  CREATE_LOCATION = 'CREATE_LOCATION',
  CREATE_REQUEST = 'CREATE_REQUEST',
  CREATE_SUBFOLDER = 'CREATE_SUBFOLDER',
  CREATE_TEST_ORDERS = 'CREATE_TEST_ORDERS',
  EDIT_BARCODES = 'EDIT_BARCODES',
  EDIT_CHEMICAL_STRUCTURE = 'EDIT_CHEMICAL_STRUCTURE',
  EDIT_CONTAINER = 'EDIT_CONTAINER',
  EDIT_FIELDS_IF_IN_PROGRESS = 'EDIT_FIELDS_IF_IN_PROGRESS',
  EDIT_FIELDS_IF_PENDING_INVALID = 'EDIT_FIELDS_IF_PENDING_INVALID',
  EDIT_FIELDS_IF_TERMINAL = 'EDIT_FIELDS_IF_TERMINAL',
  EDIT_NAMES_AND_ALIASES = 'EDIT_NAMES_AND_ALIASES',
  EDIT_NAMES_AND_BARCODES = 'EDIT_NAMES_AND_BARCODES',
  EDIT_POLYMER_FEATURES = 'EDIT_POLYMER_FEATURES',
  EDIT_RESIDUES = 'EDIT_RESIDUES',
  EDIT_RESTRICTED_SAMPLE_USERS = 'EDIT_RESTRICTED_SAMPLE_USERS',
  EDIT_SCHEMA_AND_FIELDS = 'EDIT_SCHEMA_AND_FIELDS',
  EDIT_STATUS = 'EDIT_STATUS',
  EXECUTE_REQUEST = 'EXECUTE_REQUEST',
  LIST_DEFINITION = 'LIST_DEFINITION',
  MANAGE_CAPABILITIES = 'MANAGE_CAPABILITIES',
  MANAGE_COLLABORATORS = 'MANAGE_COLLABORATORS',
  READ = 'READ',
  READ_APP_CONFIG = 'READ_APP_CONFIG',
  READ_APP_SESSION = 'READ_APP_SESSION',
  REGISTER = 'REGISTER',
  RESTRICT_SAMPLES = 'RESTRICT_SAMPLES',
  RETRACT_REVIEW = 'RETRACT_REVIEW',
  REVOKE_USER_CREDENTIALS = 'REVOKE_USER_CREDENTIALS',
  SUSPEND_USER = 'SUSPEND_USER',
  UNKNOWN = 'UNKNOWN',
  UNREGISTER = 'UNREGISTER',
  UNRESTRICT_SAMPLES = 'UNRESTRICT_SAMPLES',
  WRITE = 'WRITE',
  WRITE_APP_CONFIG = 'WRITE_APP_CONFIG',
  WRITE_APP_SESSION = 'WRITE_APP_SESSION'
}

export enum PolicyCondition {
  ALWAYS = 'ALWAYS',
  IS_ASSIGNEE = 'IS_ASSIGNEE',
  IS_AUTHOR = 'IS_AUTHOR',
  UNKNOWN = 'UNKNOWN'
}

export interface PolicyInterface {
  id: Scalars['StrictString']['output'];
  isDefault: Scalars['StrictBoolean']['output'];
  isHidden: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  policyStatements: Array<PolicyStatementNode>;
}

export enum PolicyItemType {
  ANALYSIS = 'ANALYSIS',
  ANALYTICS_DASHBOARD = 'ANALYTICS_DASHBOARD',
  APP_DEFINITION = 'APP_DEFINITION',
  ASSEMBLY = 'ASSEMBLY',
  BATCH = 'BATCH',
  BENCHLING_APP = 'BENCHLING_APP',
  BENCHLING_APP_SESSION = 'BENCHLING_APP_SESSION',
  BIOENTITY = 'BIOENTITY',
  BOX = 'BOX',
  BUSINESS_RULE = 'BUSINESS_RULE',
  CHAT_SESSION = 'CHAT_SESSION',
  CONFIG_MIGRATION_HISTORY = 'CONFIG_MIGRATION_HISTORY',
  CONNECTION = 'CONNECTION',
  CONTAINER = 'CONTAINER',
  EVENT_SUBSCRIPTION = 'EVENT_SUBSCRIPTION',
  FILE = 'FILE',
  FOLDER_OR_PROJECT = 'FOLDER_OR_PROJECT',
  INSTRUMENT = 'INSTRUMENT',
  LOCATION = 'LOCATION',
  MONOMER = 'MONOMER',
  NON_LOCATION_STORABLE = 'NON_LOCATION_STORABLE',
  NOTEBOOK = 'NOTEBOOK',
  ORGANIZATION = 'ORGANIZATION',
  OTHER = 'OTHER',
  PLATE = 'PLATE',
  PROCEDURE = 'PROCEDURE',
  PROCESS_OUTPUT = 'PROCESS_OUTPUT',
  PROCESS_TASK = 'PROCESS_TASK',
  PROCESS_TASK_GROUP = 'PROCESS_TASK_GROUP',
  PROTOCOL = 'PROTOCOL',
  REGISTRY = 'REGISTRY',
  REQUEST = 'REQUEST',
  REQUEST_V2_DEFINITION = 'REQUEST_V2_DEFINITION',
  REQUEST_V2_SUBMISSION = 'REQUEST_V2_SUBMISSION',
  REVIEW_PROCESS = 'REVIEW_PROCESS',
  SAMPLE_TYPE = 'SAMPLE_TYPE',
  SCHEMA = 'SCHEMA',
  STUDY = 'STUDY',
  TEAM = 'TEAM',
  TEMPLATE_COLLECTION = 'TEMPLATE_COLLECTION',
  TENANT = 'TENANT',
  TEST_ORDER = 'TEST_ORDER',
  UNIT_TYPE = 'UNIT_TYPE',
  UNKNOWN = 'UNKNOWN',
  USER = 'USER',
  WAREHOUSE_LOGIN = 'WAREHOUSE_LOGIN',
  WORKFLOW = 'WORKFLOW',
  WORKLIST = 'WORKLIST',
  WORKSHEET = 'WORKSHEET'
}

export interface PolicyListingNode {
  __typename: 'PolicyListingNode';
  policies: Array<PolicyInterface>;
  total: Scalars['StrictInt']['output'];
}

export interface PolicyNode extends PolicyInterface {
  __typename: 'PolicyNode';
  id: Scalars['StrictString']['output'];
  isDefault: Scalars['StrictBoolean']['output'];
  isHidden: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  policyStatements: Array<PolicyStatementNode>;
}

export interface PolicyStatementNode {
  __typename: 'PolicyStatementNode';
  action: PolicyAction;
  condition: PolicyCondition;
  itemType: PolicyItemType;
}

export interface PolicyTemplateNode {
  __typename: 'PolicyTemplateNode';
  itemTypeOptions: Array<ItemTypeOptionNode>;
}

export enum PolicyTemplateType {
  DATA = 'DATA',
  SCHEMA = 'SCHEMA'
}

export enum PolicyType {
  data_policy = 'data_policy',
  policy = 'policy',
  schema_policy = 'schema_policy'
}

export interface PolymerFeatureNode {
  __typename: 'PolymerFeatureNode';
  color: Scalars['StrictString']['output'];
  metadata: Maybe<FragmentMetadataNode>;
  name: Scalars['StrictString']['output'];
  referencedEntityVersionId: Maybe<EntityVersionIdNode>;
  regions: Array<PolymerFeatureRegionNode>;
  strand: Scalars['StrictInt']['output'];
  type: PolymerFeatureType;
}

export interface PolymerFeatureRegionNode {
  __typename: 'PolymerFeatureRegionNode';
  end: Scalars['StrictInt']['output'];
  start: Scalars['StrictInt']['output'];
}

export enum PolymerFeatureType {
  ANNOTATION = 'ANNOTATION',
  FRAGMENT = 'FRAGMENT',
  PART = 'PART',
  PRIMER = 'PRIMER',
  TRANSLATION = 'TRANSLATION'
}

export type PolymerOrInaccessibleInfoNode = InaccessibleInfoNode | ProteinNode | SequenceNode;

export interface PolymerStructureGraphNode {
  __typename: 'PolymerStructureGraphNode';
  edges: Array<StructureGraphEdgeNode>;
  nodes: Array<StructureGraphNodeNode>;
}

export interface PositionNode {
  __typename: 'PositionNode';
  x: Scalars['StrictFloat']['output'];
  y: Scalars['StrictFloat']['output'];
}

export enum PrimaryExperimentalRoleType {
  BLANK = 'BLANK',
  CONTROL = 'CONTROL',
  SAMPLE = 'SAMPLE',
  STANDARD = 'STANDARD'
}

export interface PrincipalInterface {
  avatarUrl: Maybe<Scalars['StrictString']['output']>;
  handle: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  joinedOn: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  urlIdentifier: Scalars['StrictString']['output'];
}

export interface PrinterNode {
  __typename: 'PrinterNode';
  address: Scalars['StrictString']['output'];
  description: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  port: Maybe<Scalars['StrictInt']['output']>;
  registry: RegistryNode;
}

export interface ProcedureAnalysisTemplateConfigurationNode {
  __typename: 'ProcedureAnalysisTemplateConfigurationNode';
  analysisTemplate: AnalysisTemplateNode;
  configJson: Scalars['JSONScalar']['output'];
}

export type ProcedureAnalysisTemplateConfigurationOrInaccessibleInfoNode = InaccessibleInfoNode | ProcedureAnalysisTemplateConfigurationNode;

export interface ProcedureDataParameterActualValueNode {
  __typename: 'ProcedureDataParameterActualValueNode';
  comment: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  value: Scalars['JSONScalar']['output'];
}

export interface ProcedureDataParameterConfirmationValueNode {
  __typename: 'ProcedureDataParameterConfirmationValueNode';
  comment: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  value: Scalars['JSONScalar']['output'];
}

export interface ProcedureDataParameterPlannedValueNode {
  __typename: 'ProcedureDataParameterPlannedValueNode';
  id: Scalars['StrictString']['output'];
  parameterVersion: ProcedureDataParameterVersionNode;
  value: Scalars['JSONScalar']['output'];
}

export interface ProcedureDataParameterSettingNode extends BaseProcedureDataParameterSettingInterface {
  __typename: 'ProcedureDataParameterSettingNode';
  values: Array<ProcedureDataParameterPlannedValueNode>;
  version: ProcedureDataParameterVersionNode;
}

export interface ProcedureDataParameterVersionNode {
  __typename: 'ProcedureDataParameterVersionNode';
  confirmationMethod: ProcedureParameterConfirmationMethod;
  dataType: Scalars['JSONScalar']['output'];
  description: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  maximum: Maybe<Scalars['JSONScalar']['output']>;
  minimum: Maybe<Scalars['JSONScalar']['output']>;
  name: Scalars['StrictString']['output'];
  procedureDataParameterId: Scalars['StrictString']['output'];
  restValueField: Scalars['JSONScalar']['output'];
}

export interface ProcedureEdgeNode {
  __typename: 'ProcedureEdgeNode';
  sourceId: Scalars['StrictString']['output'];
  targetId: Scalars['StrictString']['output'];
  type: ProcedureEdgeType;
}

export enum ProcedureEdgeType {
  MATERIAL_EDGE = 'MATERIAL_EDGE',
  METHOD_EDGE = 'METHOD_EDGE'
}

export interface ProcedureEquipmentConfirmationValueNode {
  __typename: 'ProcedureEquipmentConfirmationValueNode';
  comment: Scalars['StrictString']['output'];
  equipment: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
}

export interface ProcedureEquipmentPlannedValueNode {
  __typename: 'ProcedureEquipmentPlannedValueNode';
  equipment: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  parameterVersion: ProcedureEquipmentVersionNode;
}

export interface ProcedureEquipmentSettingNode extends BaseProcedureEquipmentSettingInterface {
  __typename: 'ProcedureEquipmentSettingNode';
  values: Array<ProcedureEquipmentPlannedValueNode>;
  version: ProcedureEquipmentVersionNode;
}

export interface ProcedureEquipmentVersionNode {
  __typename: 'ProcedureEquipmentVersionNode';
  allowedEquipmentModels: Maybe<Scalars['JSONScalar']['output']>;
  confirmationMethod: ProcedureParameterConfirmationMethod;
  dataType: Scalars['JSONScalar']['output'];
  description: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  procedureEquipmentId: Scalars['StrictString']['output'];
  restEquipmentField: Scalars['JSONScalar']['output'];
}

export interface ProcedureExecutionStepGroupNode {
  __typename: 'ProcedureExecutionStepGroupNode';
  group: ProcedureStepGroupType;
  steps: Array<ProcedureStepExecutionInstanceNode>;
}

export interface ProcedureFlowchartNode {
  __typename: 'ProcedureFlowchartNode';
  id: Scalars['StrictString']['output'];
  latestFlowchartVersion: ProcedureFlowchartVersionOrInaccessibleInfoNode;
  parent: Maybe<ProcedureNode>;
  publishedFlowchartVersion: Maybe<ProcedureFlowchartVersionNode>;
}

export interface ProcedureFlowchartVersionNode extends BaseProcedureFlowchartVersionInterface {
  __typename: 'ProcedureFlowchartVersionNode';
  createdAt: Scalars['StrictString']['output'];
  edges: Array<ProcedureEdgeNode>;
  id: Scalars['StrictString']['output'];
  largestTableTypeSizes: Array<LargestTableTypeSizeNode>;
  nodes: Array<ProcedureMethodDefinitionVersionNode>;
  procedureFlowchart: ProcedureFlowchartNode;
}

export type ProcedureFlowchartVersionOrInaccessibleInfoNode = InaccessibleInfoNode | ProcedureFlowchartVersionNode;

export enum ProcedureInvalidReason {
  EMPTY_STEP_NAME = 'EMPTY_STEP_NAME',
  NO_FLOWCHART = 'NO_FLOWCHART'
}

export interface ProcedureMaterialInputConfirmationValueNode {
  __typename: 'ProcedureMaterialInputConfirmationValueNode';
  amount: Scalars['JSONScalar']['output'];
  comment: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  material: Scalars['JSONScalar']['output'];
}

export interface ProcedureMaterialInputPlannedValueNode {
  __typename: 'ProcedureMaterialInputPlannedValueNode';
  amount: Maybe<Scalars['JSONScalar']['output']>;
  container: Maybe<Scalars['JSONScalar']['output']>;
  id: Scalars['StrictString']['output'];
  material: Scalars['JSONScalar']['output'];
  parameterVersion: ProcedureMaterialInputVersionNode;
}

export interface ProcedureMaterialInputSettingNode extends BaseProcedureMaterialInputSettingInterface {
  __typename: 'ProcedureMaterialInputSettingNode';
  values: Array<ProcedureMaterialInputPlannedValueNode>;
  version: ProcedureMaterialInputVersionNode;
}

export interface ProcedureMaterialInputVersionNode {
  __typename: 'ProcedureMaterialInputVersionNode';
  amountUnit: Maybe<Scalars['JSONScalar']['output']>;
  confirmationMethod: ProcedureParameterConfirmationMethod;
  dataType: Scalars['JSONScalar']['output'];
  description: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  procedureMaterialInputId: Scalars['StrictString']['output'];
  restAmountField: Scalars['JSONScalar']['output'];
  restMaterialField: Scalars['JSONScalar']['output'];
}

export interface ProcedureMaterialOutputConfirmationValueNode {
  __typename: 'ProcedureMaterialOutputConfirmationValueNode';
  comment: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  material: Scalars['JSONScalar']['output'];
  materialOutputVersion: ProcedureMaterialOutputVersionNode;
}

export interface ProcedureMaterialOutputSettingNode {
  __typename: 'ProcedureMaterialOutputSettingNode';
  version: ProcedureMaterialOutputVersionNode;
}

export interface ProcedureMaterialOutputVersionNode {
  __typename: 'ProcedureMaterialOutputVersionNode';
  confirmationMethod: ProcedureParameterConfirmationMethod;
  dataType: Scalars['JSONScalar']['output'];
  description: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  procedureMaterialOutputId: Scalars['StrictString']['output'];
  restMaterialField: Scalars['JSONScalar']['output'];
}

export interface ProcedureMethodDefinitionVersionNode extends BaseProcedureMethodDefinitionVersionInterface {
  __typename: 'ProcedureMethodDefinitionVersionNode';
  analysisTemplateConfigurations: Array<ProcedureAnalysisTemplateConfigurationOrInaccessibleInfoNode>;
  dataParameterSettings: Array<ProcedureDataParameterSettingNode>;
  description: Scalars['StrictString']['output'];
  dilutionPlan: DilutionPlanNode;
  equipmentSettings: Array<ProcedureEquipmentSettingNode>;
  gridLayoutCoordinates: GridLayoutCoordinatesNode;
  id: Scalars['StrictString']['output'];
  materialInputSettings: Array<ProcedureMaterialInputSettingNode>;
  materialOutputSettings: Array<ProcedureMaterialOutputSettingNode>;
  name: Scalars['StrictString']['output'];
  nodeId: Scalars['StrictString']['output'];
  parameterUsagesExpensive: Array<ProcedureParameterUsageNode>;
  provenanceId: Scalars['StrictString']['output'];
  sourceMethodId: Maybe<Scalars['StrictString']['output']>;
  stepGroups: Array<ProcedureStepGroupNode>;
  testDefinitions: Array<TestDefinitionOrInaccessibleInfoNode>;
}

export type ProcedureMethodDefinitionVersionOrInaccessibleInfoNode = InaccessibleInfoNode | ProcedureMethodDefinitionVersionNode;

export interface ProcedureMethodExecutionInstanceAssociationNode {
  __typename: 'ProcedureMethodExecutionInstanceAssociationNode';
  id: Scalars['StrictString']['output'];
  sourceProcedureMethodExecutionInstance: ProcedureMethodExecutionInstanceNode;
  targetProcedureMethodExecutionInstance: ProcedureMethodExecutionInstanceNode;
}

export type ProcedureMethodExecutionInstanceAssociationOrInaccessibleInfoNode = InaccessibleInfoNode | ProcedureMethodExecutionInstanceAssociationNode;

export interface ProcedureMethodExecutionInstanceNode extends CoreObjectArchivableInterface, HasPermissionsInterface {
  __typename: 'ProcedureMethodExecutionInstanceNode';
  archiveData: ArchiveDataNode;
  createdRetestOrders: Array<TestOrderOrInaccessibleInfoNode>;
  dataParameterActualValues: Array<ProcedureDataParameterActualValueNode>;
  dataParameterConfirmationValues: Array<ProcedureDataParameterConfirmationValueNode>;
  dataParameterPlannedValues: Array<ProcedureDataParameterPlannedValueNode>;
  equipmentConfirmationValues: Array<ProcedureEquipmentConfirmationValueNode>;
  equipmentPlannedValues: Array<ProcedureEquipmentPlannedValueNode>;
  id: Scalars['StrictString']['output'];
  materialInputConfirmationValues: Array<ProcedureMaterialInputConfirmationValueNode>;
  materialInputPlannedValues: Array<ProcedureMaterialInputPlannedValueNode>;
  materialOutputConfirmationStep: Maybe<ProcedureStepExecutionInstanceNode>;
  materialOutputConfirmationValues: Array<ProcedureMaterialOutputConfirmationValueNode>;
  methodTask: Maybe<ProcessTaskOrInaccessibleInfoNode>;
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  planMethodDefinitionVersion: ProcedurePlanMethodDefinitionVersionNode;
  /** @deprecated Contains parameter fields that will no longer be accurate with collapsed flowcharts. Use planMethodDefinitionVersion instead */
  planMethodVersion: ProcedureMethodDefinitionVersionNode;
  procedureRun: ProcedureRunNode;
  procedureRunConditionReplicate: ProcedureRunConditionReplicateNode;
  /** @deprecated Deprecated in favor of procedure_run_condition_replicate */
  procedureRunConditionReplicates: Array<ProcedureRunConditionReplicateNode>;
  sourceProcedureMethodExecutionInstanceAssociations: Array<ProcedureMethodExecutionInstanceAssociationOrInaccessibleInfoNode>;
  stepGroups: Array<ProcedureExecutionStepGroupNode>;
  targetProcedureMethodExecutionInstanceAssociations: Array<ProcedureMethodExecutionInstanceAssociationOrInaccessibleInfoNode>;
  taskTransitionExtensions: Array<TaskTransitionExtensionNode>;
  templateMethodVersion: ProcedureMethodDefinitionVersionOrInaccessibleInfoNode;
  testOrders: Array<TestOrderOrInaccessibleInfoNode>;
  worksheet: WorksheetOrInaccessibleInfoNode;
}

export type ProcedureMethodExecutionInstanceOrInaccessibleInfoNode = InaccessibleInfoNode | ProcedureMethodExecutionInstanceNode;

export interface ProcedureNode extends CoreObjectArchivableInterface, HasCreatorInterface, HasPermissionsInterface, PublishableInterface, SearchableInterface, StarrableInterface, TemplateCollectibleInterface {
  __typename: 'ProcedureNode';
  archiveData: ArchiveDataNode;
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorNode: CreatorInterface;
  currentPublishingRecord: Maybe<PublishingRecordOrInaccessibleInfoNode>;
  editUrl: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  invalidReasonsExpensive: Maybe<Array<ProcedureInvalidReason>>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  procedureFlowchart: ProcedureFlowchartNode;
  procedureType: ProcedureType;
  processFlowchartConfig: Maybe<ProcessFlowchartConfigNode>;
  publishingRecords: Array<PublishingRecordOrInaccessibleInfoNode>;
  star: Maybe<StarNode>;
  templateCollection: TemplateCollectionNode;
}

export type ProcedureOrInaccessibleInfoNode = InaccessibleInfoNode | ProcedureNode;

export enum ProcedureParameterConfirmationMethod {
  PLATE_MAP = 'PLATE_MAP',
  TABLE = 'TABLE'
}

export interface ProcedureParameterUsageNode {
  __typename: 'ProcedureParameterUsageNode';
  parameterVersionId: Scalars['StrictString']['output'];
  stepId: Scalars['StrictString']['output'];
  tableUuid: Maybe<Scalars['StrictString']['output']>;
  valueType: ProcedureParameterUsageValueType;
}

export enum ProcedureParameterUsageValueType {
  CONFIRMATION = 'CONFIRMATION',
  MEASUREMENT = 'MEASUREMENT'
}

export interface ProcedurePlanDataParameterSettingNode extends BaseProcedureDataParameterSettingInterface {
  __typename: 'ProcedurePlanDataParameterSettingNode';
  version: ProcedureDataParameterVersionNode;
}

export interface ProcedurePlanEquipmentSettingNode extends BaseProcedureEquipmentSettingInterface {
  __typename: 'ProcedurePlanEquipmentSettingNode';
  version: ProcedureEquipmentVersionNode;
}

export interface ProcedurePlanFlowchartVersionNode extends BaseProcedureFlowchartVersionInterface {
  __typename: 'ProcedurePlanFlowchartVersionNode';
  edges: Array<ProcedureEdgeNode>;
  id: Scalars['StrictString']['output'];
  largestTableTypeSizes: Array<LargestTableTypeSizeNode>;
  nodes: Array<ProcedurePlanMethodDefinitionVersionNode>;
  procedureFlowchart: ProcedureFlowchartNode;
}

export interface ProcedurePlanMaterialInputSettingNode extends BaseProcedureMaterialInputSettingInterface {
  __typename: 'ProcedurePlanMaterialInputSettingNode';
  templateValues: Array<ProcedureMaterialInputPlannedValueNode>;
  version: ProcedureMaterialInputVersionNode;
}

export interface ProcedurePlanMethodDefinitionVersionNode extends BaseProcedureMethodDefinitionVersionInterface {
  __typename: 'ProcedurePlanMethodDefinitionVersionNode';
  analysisTemplateConfigurations: Array<ProcedureAnalysisTemplateConfigurationOrInaccessibleInfoNode>;
  dataParameterSettings: Array<ProcedurePlanDataParameterSettingNode>;
  description: Scalars['StrictString']['output'];
  dilutionPlan: DilutionPlanNode;
  equipmentSettings: Array<ProcedurePlanEquipmentSettingNode>;
  gridLayoutCoordinates: GridLayoutCoordinatesNode;
  id: Scalars['StrictString']['output'];
  materialInputSettings: Array<ProcedurePlanMaterialInputSettingNode>;
  materialOutputSettings: Array<ProcedureMaterialOutputSettingNode>;
  name: Scalars['StrictString']['output'];
  nodeId: Scalars['StrictString']['output'];
  parameterUsagesExpensive: Array<ProcedureParameterUsageNode>;
  provenanceId: Scalars['StrictString']['output'];
  sourceMethodId: Maybe<Scalars['StrictString']['output']>;
  stepGroups: Array<ProcedureStepGroupNode>;
  testDefinitions: Array<TestDefinitionOrInaccessibleInfoNode>;
}

export interface ProcedureRunConditionNode {
  __typename: 'ProcedureRunConditionNode';
  description: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  procedureRun: ProcedureRunNode;
  procedureRunConditionReplicates: Array<ProcedureRunConditionReplicateNode>;
}

export interface ProcedureRunConditionReplicateNode extends CoreObjectArchivableInterface, HasPermissionsInterface {
  __typename: 'ProcedureRunConditionReplicateNode';
  archiveData: ArchiveDataNode;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  procedureRunCondition: ProcedureRunConditionNode;
  processRootTask: Maybe<ProcessTaskOrInaccessibleInfoNode>;
  replicateNumber: Scalars['StrictInt']['output'];
}

export enum ProcedureRunDataEntryMode {
  ALL_CONDITION_REPLICATES_TOGETHER = 'ALL_CONDITION_REPLICATES_TOGETHER',
  INDIVIDUAL_CONDITION_REPLICATES = 'INDIVIDUAL_CONDITION_REPLICATES'
}

export interface ProcedureRunNode extends CoreObjectArchivableInterface, HasCreatorInterface, HasDisplayIdInterface, HasPermissionsInterface {
  __typename: 'ProcedureRunNode';
  analyses: Array<AnalysisOrInaccessibleInfoNode>;
  archiveData: ArchiveDataNode;
  conditions: Array<ProcedureRunConditionNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  currentProcedureFlowchartVersion: ProcedurePlanFlowchartVersionNode;
  defaultDataEntryMode: ProcedureRunDataEntryMode;
  description: Scalars['StrictString']['output'];
  displayId: Maybe<Scalars['StrictString']['output']>;
  flowchartIsExpanded: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  methodExecutionInstances: Array<ProcedureMethodExecutionInstanceNode>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  procedureFlowchart: Maybe<ProcedureFlowchartNode>;
  procedureType: ProcedureType;
  /** @deprecated Collapsed flowcharts will not have a root level task. Use processRootTask on the condition replicates instead. */
  processFlowchartTask: Maybe<ProcessTaskOrInaccessibleInfoNode>;
  processFlowchartTaskGroup: Maybe<ProcessOrInaccessibleInfoNode>;
  study: StudyOrInaccessibleInfoNode;
  templateProcedureFlowchartVersion: ProcedureFlowchartVersionOrInaccessibleInfoNode;
}

export type ProcedureRunOrInaccessibleInfoNode = InaccessibleInfoNode | ProcedureRunNode;

export interface ProcedureStepDefinitionVersionNode {
  __typename: 'ProcedureStepDefinitionVersionNode';
  documentVersion: Maybe<DocumentVersionNode>;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export type ProcedureStepDefinitionVersionOrInaccessibleInfoNode = InaccessibleInfoNode | ProcedureStepDefinitionVersionNode;

export interface ProcedureStepExecutionInstanceNode extends CoreObjectArchivableInterface, HasPermissionsInterface {
  __typename: 'ProcedureStepExecutionInstanceNode';
  archiveData: ArchiveDataNode;
  document: DocumentOrInaccessibleInfoNode;
  id: Scalars['StrictString']['output'];
  methodExecutionInstance: ProcedureMethodExecutionInstanceNode;
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  planStepVersion: Maybe<ProcedureStepDefinitionVersionNode>;
  templateStepVersion: Maybe<ProcedureStepDefinitionVersionOrInaccessibleInfoNode>;
}

export type ProcedureStepExecutionInstanceOrInaccessibleInfoNode = InaccessibleInfoNode | ProcedureStepExecutionInstanceNode;

export interface ProcedureStepGroupNode {
  __typename: 'ProcedureStepGroupNode';
  group: ProcedureStepGroupType;
  steps: Array<ProcedureStepDefinitionVersionNode>;
}

export enum ProcedureStepGroupType {
  POST_RUN = 'POST_RUN',
  PRE_RUN = 'PRE_RUN',
  RUN = 'RUN'
}

export enum ProcedureType {
  ASSAY = 'ASSAY',
  RECIPE = 'RECIPE'
}

export interface ProcessAsyncRecordNode {
  __typename: 'ProcessAsyncRecordNode';
  asyncData: AsyncDataNode;
  details: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  status: ProcessAsyncRecordStatus;
}

export type ProcessAsyncRecordOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessAsyncRecordNode;

export enum ProcessAsyncRecordStatus {
  ACTIVE = 'ACTIVE',
  FAILED = 'FAILED'
}

export enum ProcessClientOrigin {
  ASSAYS = 'ASSAYS',
  PROCESSES = 'PROCESSES',
  RECIPES = 'RECIPES'
}

export enum ProcessDisplayNameAssays {
  PROCEDURE = 'PROCEDURE',
  PROCEDURE_METHOD = 'PROCEDURE_METHOD',
  PROCEDURE_STEP = 'PROCEDURE_STEP'
}

export enum ProcessDisplayNameProcesses {
  DIRECT = 'DIRECT',
  ENTRY = 'ENTRY',
  FLOWCHART = 'FLOWCHART'
}

export enum ProcessDisplayNameRecipes {
  PROCEDURE = 'PROCEDURE',
  PROCEDURE_METHOD = 'PROCEDURE_METHOD',
  PROCEDURE_STEP = 'PROCEDURE_STEP'
}

export interface ProcessEndNodeDetailsNode {
  __typename: 'ProcessEndNodeDetailsNode';
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  nodeConfig: ProcessFlowchartConfigNode;
  type: ProcessFlowchartNodeDetailsType;
}

export interface ProcessEndNodesBlockedByExpressionsNode {
  __typename: 'ProcessEndNodesBlockedByExpressionsNode';
  blockedEndNode: ProcessEndNodeDetailsNode;
  blockingExpression: BenchlingExpressionOrInaccessibleNode;
  fromSchemas: Array<ProcessTaskSchemaOrProcessOutputSchemaOrInaccessible>;
}

export enum ProcessExecutionType {
  DIRECT = 'DIRECT',
  ENTRY = 'ENTRY',
  FLOWCHART = 'FLOWCHART',
  PROCEDURE = 'PROCEDURE',
  PROCEDURE_METHOD = 'PROCEDURE_METHOD',
  PROCEDURE_STEP = 'PROCEDURE_STEP'
}

export interface ProcessFieldDefinitionNode {
  __typename: 'ProcessFieldDefinitionNode';
  fieldClientIdentifier: Scalars['StrictString']['output'];
  fieldDefinition: FieldDefinitionNode;
  fieldGroupKey: Maybe<Scalars['StrictString']['output']>;
  fieldIdentifier: Scalars['StrictString']['output'];
  isFieldMappable: Scalars['StrictBoolean']['output'];
  isFieldRoutable: Scalars['StrictBoolean']['output'];
}

export interface ProcessFlowchartConfigNode {
  __typename: 'ProcessFlowchartConfigNode';
  currentFlowchartConfigVersion: Maybe<ProcessFlowchartConfigVersionNode>;
  flowchartConfigVersion: Maybe<ProcessFlowchartConfigVersionNode>;
  flowchartConfigVersions: Array<ProcessFlowchartConfigVersionNode>;
  id: Scalars['StrictString']['output'];
  schema: ProcessTaskSchemaOrInaccessibleInfoNode;
  /** @deprecated Deprecated in favor of schema */
  taskSchema: ProcessTaskSchemaNode;
}


export interface ProcessFlowchartConfigNodeflowchartConfigVersionArgs {
  id?: InputMaybe<Scalars['StrictString']['input']>;
}

export type ProcessFlowchartConfigOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessFlowchartConfigNode;

export interface ProcessFlowchartConfigVersionNode {
  __typename: 'ProcessFlowchartConfigVersionNode';
  availableSchemas: Array<ProcessTaskSchemaOrInaccessibleInfoNode>;
  flowchartConfig: ProcessFlowchartConfigNode;
  id: Scalars['StrictString']['output'];
  isFlowchartModifiableAfterCreation: Scalars['StrictBoolean']['output'];
  isFlowchartModifiableOnCreation: Scalars['StrictBoolean']['output'];
  schemaMapperConfigs: Array<ProcessFlowchartSchemaMapperConfigNode>;
  templateFlowchart: Maybe<ProcessFlowchartNode>;
}

export type ProcessFlowchartConfigVersionOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessFlowchartConfigVersionNode;

export interface ProcessFlowchartEdgeConfigNode {
  __typename: 'ProcessFlowchartEdgeConfigNode';
  fromNodeConfig: ProcessFlowchartNodeConfigNode;
  id: Scalars['StrictString']['output'];
  toNodeConfig: ProcessFlowchartNodeConfigNode;
}

export interface ProcessFlowchartExecuteSchemaMapperRecordNode {
  __typename: 'ProcessFlowchartExecuteSchemaMapperRecordNode';
  id: Scalars['StrictString']['output'];
  schemaMapper: ProcessFlowchartSchemaMapperNode;
  task: ProcessTaskNode;
}

export interface ProcessFlowchartNode {
  __typename: 'ProcessFlowchartNode';
  edgeConfigs: Array<ProcessFlowchartEdgeConfigNode>;
  id: Scalars['StrictString']['output'];
  nodeConfigs: Array<ProcessFlowchartNodeConfigNode>;
  numNodes: Scalars['StrictInt']['output'];
}

export type ProcessFlowchartNodeConfigDetailsNode = ProcessEndNodeDetailsNode | ProcessOutputNodeDetailsNode | ProcessRootNodeDetailsNode | ProcessRouterNodeDetailsNode | ProcessTaskNodeDetailsNode;

export interface ProcessFlowchartNodeConfigNode {
  __typename: 'ProcessFlowchartNodeConfigNode';
  flowchart: Maybe<ProcessFlowchartNode>;
  flowchartConfigVersion: ProcessFlowchartConfigVersionNode;
  id: Scalars['StrictString']['output'];
  inboundSchemaMappers: Array<ProcessFlowchartSchemaMapperNode>;
  migratedToNodeConfig: Maybe<ProcessFlowchartNodeConfigNode>;
  name: Scalars['StrictString']['output'];
  nodeDetails: ProcessFlowchartNodeConfigDetailsNode;
  outboundSchemaMapperDependencies: Array<ProcessFlowchartSchemaMapperDependencyNode>;
}

export enum ProcessFlowchartNodeDetailsType {
  END_NODE_DETAILS = 'END_NODE_DETAILS',
  OUTPUT_NODE_DETAILS = 'OUTPUT_NODE_DETAILS',
  ROOT_NODE_DETAILS = 'ROOT_NODE_DETAILS',
  ROUTER_NODE_DETAILS = 'ROUTER_NODE_DETAILS',
  TASK_NODE_DETAILS = 'TASK_NODE_DETAILS'
}

export type ProcessFlowchartOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessFlowchartNode;

export interface ProcessFlowchartPlatformFeatureEntry {
  __typename: 'ProcessFlowchartPlatformFeatureEntry';
  enabled: Scalars['StrictBoolean']['output'];
  feature: ProcessFlowchartPlatformFeatureType;
}

export enum ProcessFlowchartPlatformFeatureType {
  ALLOW_BRANCHING_TRANSITIONS = 'ALLOW_BRANCHING_TRANSITIONS',
  ALLOW_COMPLEX_TRANSITIONS = 'ALLOW_COMPLEX_TRANSITIONS',
  ALLOW_CONTROL_FLOW_TOKEN_CONFIGURATION = 'ALLOW_CONTROL_FLOW_TOKEN_CONFIGURATION',
  ALLOW_FIELD_CONFIGURATION = 'ALLOW_FIELD_CONFIGURATION',
  ALLOW_LOOPS = 'ALLOW_LOOPS',
  ALLOW_MERGING_TRANSITIONS = 'ALLOW_MERGING_TRANSITIONS',
  ALLOW_ROUTERS = 'ALLOW_ROUTERS',
  ALLOW_STOP_NODES = 'ALLOW_STOP_NODES',
  CAN_CONFIGURE_AT_CREATION_MODIFICATION = 'CAN_CONFIGURE_AT_CREATION_MODIFICATION',
  CAN_CONFIGURE_POST_CREATION_MODIFICATION = 'CAN_CONFIGURE_POST_CREATION_MODIFICATION'
}

export interface ProcessFlowchartSchemaFieldMapperConfigNode {
  __typename: 'ProcessFlowchartSchemaFieldMapperConfigNode';
  fromProcessTaskDefinitionVersion: ProcessTaskDefinitionVersionOrInaccessibleInfoNode;
  fromSchema: ProcessTaskSchemaOrProcessOutputSchemaOrInaccessible;
  id: Scalars['StrictString']['output'];
  lookupConfig: LookupConfigNode;
  mapsFromType: ProcessMapperTokenType;
  resultMustBeNonNullToMap: Scalars['StrictBoolean']['output'];
  toProcessFieldDefinition: ProcessFieldDefinitionNode;
  toSchemaField: Scalars['JSONScalar']['output'];
}

export interface ProcessFlowchartSchemaMapperConfigNode {
  __typename: 'ProcessFlowchartSchemaMapperConfigNode';
  id: Scalars['StrictString']['output'];
  mapsToType: ProcessMapperTokenType;
  schemaFieldMapperConfigs: Array<ProcessFlowchartSchemaFieldMapperConfigNode>;
  schemaMapperSourceConfigs: Array<ProcessFlowchartSchemaMapperSourceConfigNode>;
  toProcessTaskDefinitionVersion: ProcessTaskDefinitionVersionOrInaccessibleInfoNode;
  toSchema: ProcessTaskSchemaOrProcessOutputSchemaOrInaccessible;
  type: ProcessSchemaMapperType;
}

export interface ProcessFlowchartSchemaMapperDependencyNode {
  __typename: 'ProcessFlowchartSchemaMapperDependencyNode';
  fieldMapperConfigs: Array<ProcessFlowchartSchemaFieldMapperConfigNode>;
  fromNodeConfig: ProcessFlowchartNodeConfigNode;
  id: Scalars['StrictString']['output'];
  schemaMapperSourceConfig: Maybe<ProcessFlowchartSchemaMapperSourceConfigNode>;
}

export interface ProcessFlowchartSchemaMapperNode {
  __typename: 'ProcessFlowchartSchemaMapperNode';
  fromSchemas: Array<ProcessTaskSchemaOrProcessOutputSchemaOrInaccessible>;
  id: Scalars['StrictString']['output'];
  schemaMapperConfig: Maybe<ProcessFlowchartSchemaMapperConfigNode>;
  schemaMapperDependencies: Array<ProcessFlowchartSchemaMapperDependencyNode>;
  toNodeConfig: ProcessFlowchartNodeConfigNode;
  toSchema: ProcessTaskSchemaOrProcessOutputSchemaOrInaccessible;
}

export interface ProcessFlowchartSchemaMapperSourceConfigNode {
  __typename: 'ProcessFlowchartSchemaMapperSourceConfigNode';
  id: Scalars['StrictString']['output'];
  mapsFromType: ProcessMapperTokenType;
  processTaskDefinitionVersion: ProcessTaskDefinitionVersionOrInaccessibleInfoNode;
}

export interface ProcessFlowchartSchemaMappingRecordNode {
  __typename: 'ProcessFlowchartSchemaMappingRecordNode';
  id: Scalars['StrictString']['output'];
  schemaMapper: ProcessFlowchartSchemaMapperNode;
}

export interface ProcessFlowchartTaskDataNode {
  __typename: 'ProcessFlowchartTaskDataNode';
  nodeConfig: ProcessFlowchartNodeConfigNode;
  task: ProcessTaskNode;
}

export interface ProcessFlowchartTypeConfiguratorNode {
  __typename: 'ProcessFlowchartTypeConfiguratorNode';
  allowableTaskTypes: Array<Scalars['StrictString']['output']>;
  flowchartTypeName: Scalars['StrictString']['output'];
  platformFlowchartFeatures: Array<ProcessFlowchartPlatformFeatureEntry>;
}

export interface ProcessLineageEdgeNode {
  __typename: 'ProcessLineageEdgeNode';
  fromVertex: ProcessLineageVertexNode;
  id: Scalars['StrictString']['output'];
  toVertex: ProcessLineageVertexNode;
}

export type ProcessLineageVertexNode = ProcessOutputNode | ProcessTaskNode;

export enum ProcessMapperTokenType {
  PROCESS_OUTPUT = 'PROCESS_OUTPUT',
  PROCESS_TASK = 'PROCESS_TASK'
}

export interface ProcessMappersBlockedByExpressionsNode {
  __typename: 'ProcessMappersBlockedByExpressionsNode';
  blockingExpressions: Array<BenchlingExpressionOrInaccessibleNode>;
  blockingRouters: Array<ProcessRouterNodeDetailsNode>;
  schemaMapper: ProcessFlowchartSchemaMapperNode;
}

export interface ProcessNode extends BaseFolderItemInterface, HasArchiveRecordInterface, HasAuthorsInterface, HasCreationOriginInterface, HasCreatorInterface, SearchableInterface {
  __typename: 'ProcessNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  childProcesses: Array<ProcessOrInaccessibleInfoNode>;
  createdAt: Scalars['StrictString']['output'];
  creationOrigin: CreationOriginNode;
  creator: PrincipalInterface;
  editUrl: Scalars['StrictString']['output'];
  flowchartConfigVersion: Maybe<ProcessFlowchartConfigVersionNode>;
  flowchartNodeUrl: Maybe<Scalars['StrictString']['output']>;
  flowchartPredecessorNodes: Array<ProcessFlowchartNodeConfigNode>;
  flowchartRootProcess: Maybe<ProcessOrInaccessibleInfoNode>;
  folder: FolderNode;
  hasTasksWithFailedMappings: Maybe<Scalars['StrictBoolean']['output']>;
  humanId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  isMappingInProgressForFlowchartRootedAtProcess: Scalars['StrictBoolean']['output'];
  isMappingInProgressFromProcess: Scalars['StrictBoolean']['output'];
  isMappingInProgressToProcess: Scalars['StrictBoolean']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  nodeConfig: Maybe<ProcessFlowchartNodeConfigNode>;
  outputs: Array<ProcessOutputNode>;
  permissions: PermissionsNode;
  processTaskDefinitionVersion: Maybe<ProcessTaskDefinitionVersionOrInaccessibleInfoNode>;
  processTaskSchema: ProcessTaskSchemaNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  requestV2Submission: Maybe<RequestV2SubmissionOrInaccessibleInfoNode>;
  /** @deprecated Deprecated in favor of responsibleParties */
  responsibleTeam: Maybe<TeamNode>;
  rootProcess: Maybe<ProcessOrInaccessibleInfoNode>;
  taskSchemaOrInaccessible: ProcessTaskSchemaOrInaccessibleInfoNode;
  taskStatusCounts: Array<ProcessTaskStatusSummaryItemNode>;
  tasks: Array<ProcessTaskNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  watchers: Array<UserNode>;
}


export interface ProcessNodeflowchartNodeUrlArgs {
  rootTaskId?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface ProcessNodeflowchartPredecessorNodesArgs {
  rootTaskId?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface ProcessNodeisMappingInProgressForFlowchartRootedAtProcessArgs {
  rootTaskId?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface ProcessNodetaskStatusCountsArgs {
  rootTaskId?: InputMaybe<Scalars['StrictString']['input']>;
}

export type ProcessOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessNode;

export interface ProcessOutputNode extends HasArchiveRecordInterface, HasCreationOriginInterface, HasCreatorInterface, HasPermissionsInterface, SearchableInterface {
  __typename: 'ProcessOutputNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  creationOrigin: CreationOriginNode;
  creator: PrincipalInterface;
  fields: Scalars['JSONScalar']['output'];
  flowchartPredecessorNodes: Array<ProcessFlowchartNodeConfigNode>;
  humanId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  lineageEdgesFrom: Array<ProcessLineageEdgeNode>;
  lineageEdgesTo: Array<ProcessLineageEdgeNode>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  process: ProcessNode;
  schema: ProcessOutputSchemaNode;
  task: ProcessTaskNode;
}

export interface ProcessOutputNodeDetailsNode {
  __typename: 'ProcessOutputNodeDetailsNode';
  id: Scalars['StrictString']['output'];
  outputSchema: ProcessOutputSchemaOrInaccessibleInfoNode;
  processTaskDefinitionVersion: Maybe<ProcessTaskDefinitionVersionOrInaccessibleInfoNode>;
  type: ProcessFlowchartNodeDetailsType;
}

export type ProcessOutputOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessOutputNode;

export interface ProcessOutputSchemaNode extends SchemaInterface, _ProcessSchemaBaseInterface {
  __typename: 'ProcessOutputSchemaNode';
  allFields: Scalars['JSONScalar']['output'];
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  directExecutionModalAutopopulateTaskIds: Scalars['StrictBoolean']['output'];
  fields: Scalars['JSONScalar']['output'];
  fieldsJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  organization: Scalars['JSONScalar']['output'];
  prefix: Scalars['StrictString']['output'];
  processExecutionType: ProcessExecutionType;
  processTaskSchemaName: Scalars['StrictString']['output'];
  relatedBenchlingApps: Array<BenchlingAppNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
  taskFinderLookupConfig: Maybe<LookupConfigNode>;
  taskSchema: ProcessTaskSchemaNode;
}


export interface ProcessOutputSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export type ProcessOutputSchemaOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessOutputSchemaNode;

export enum ProcessPlatformFeatureType {
  ARE_OUTPUTS_VISIBLE = 'ARE_OUTPUTS_VISIBLE',
  ARE_SCHEMA_FIELDS_VISIBLE = 'ARE_SCHEMA_FIELDS_VISIBLE',
  CAN_COMPLETE_TASKS_WITH_NO_OUTPUTS = 'CAN_COMPLETE_TASKS_WITH_NO_OUTPUTS',
  CAN_COPY_TASKS = 'CAN_COPY_TASKS',
  CAN_CREATE_OUTPUTS_WHEN_TASK_IS_PENDING = 'CAN_CREATE_OUTPUTS_WHEN_TASK_IS_PENDING',
  CAN_CREATE_REQUEST_V2 = 'CAN_CREATE_REQUEST_V2',
  CAN_CREATE_SCHEMAS_WITHOUT_ADMIN_PERMS = 'CAN_CREATE_SCHEMAS_WITHOUT_ADMIN_PERMS',
  CAN_CREATE_TASKS = 'CAN_CREATE_TASKS',
  CAN_CREATE_TASK_GROUPS = 'CAN_CREATE_TASK_GROUPS',
  CAN_EDIT_ASSIGNEE = 'CAN_EDIT_ASSIGNEE',
  CAN_EDIT_RESPONSIBLE_PARTIES = 'CAN_EDIT_RESPONSIBLE_PARTIES',
  CAN_EDIT_SCHEDULED_ON_DATE = 'CAN_EDIT_SCHEDULED_ON_DATE',
  CAN_EDIT_SCHEMA_FIELDS = 'CAN_EDIT_SCHEMA_FIELDS',
  CAN_EDIT_STATUS_FROM_UI = 'CAN_EDIT_STATUS_FROM_UI',
  CAN_EDIT_STUDIES_METADATA = 'CAN_EDIT_STUDIES_METADATA',
  CAN_EDIT_TASK_GROUPS = 'CAN_EDIT_TASK_GROUPS',
  CAN_MANUALLY_CREATE_OUTPUTS = 'CAN_MANUALLY_CREATE_OUTPUTS',
  CAN_UPDATE_SCHEMAS_WITHOUT_ADMIN_PERMS = 'CAN_UPDATE_SCHEMAS_WITHOUT_ADMIN_PERMS',
  CAPILLARY_CREATE = 'CAPILLARY_CREATE',
  CAPILLARY_UPDATE = 'CAPILLARY_UPDATE',
  CONFIG_MIGRATION = 'CONFIG_MIGRATION',
  IS_DIRECTLY_ARCHIVEABLE = 'IS_DIRECTLY_ARCHIVEABLE',
  IS_DIRECTLY_EXECUTABLE = 'IS_DIRECTLY_EXECUTABLE',
  IS_STUDYABLE = 'IS_STUDYABLE',
  SCHEMA_CONFIG = 'SCHEMA_CONFIG',
  TASK_NODE_EXTENSION = 'TASK_NODE_EXTENSION',
  WAREHOUSE_PER_SCHEMA_TABLE = 'WAREHOUSE_PER_SCHEMA_TABLE',
  WORKFLOWS_SEARCH = 'WORKFLOWS_SEARCH'
}

export type ProcessResponsiblePartyNode = TeamNode | UserNode;

export interface ProcessRootNodeDetailsNode {
  __typename: 'ProcessRootNodeDetailsNode';
  id: Scalars['StrictString']['output'];
  processTaskDefinitionVersion: Maybe<ProcessTaskDefinitionVersionOrInaccessibleInfoNode>;
  taskSchema: ProcessTaskSchemaOrInaccessibleInfoNode;
  type: ProcessFlowchartNodeDetailsType;
}

export interface ProcessRouterFunctionNode {
  __typename: 'ProcessRouterFunctionNode';
  edgeConfig: ProcessFlowchartEdgeConfigNode;
  expression: BenchlingExpressionOrInaccessibleNode;
  id: Scalars['StrictString']['output'];
  isDefault: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  routerNodeDetails: ProcessRouterNodeDetailsNode;
}

export interface ProcessRouterNodeDetailsNode {
  __typename: 'ProcessRouterNodeDetailsNode';
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  nodeConfig: ProcessFlowchartNodeConfigNode;
  routerFunctions: Array<ProcessRouterFunctionNode>;
  type: ProcessFlowchartNodeDetailsType;
}

export enum ProcessSchemaMapperType {
  BENCHLING_APP = 'BENCHLING_APP',
  FIELD_MAPPER = 'FIELD_MAPPER'
}

export enum ProcessSingletonTaskSchemaName {
  ASSAY_STEP_TASK_SCHEMA_NAME = 'ASSAY_STEP_TASK_SCHEMA_NAME',
  ASSAY_UNIT_OPERATION_TASK_SCHEMA_NAME = 'ASSAY_UNIT_OPERATION_TASK_SCHEMA_NAME',
  DISCREPANCY_TASK_SCHEMA_NAME = 'DISCREPANCY_TASK_SCHEMA_NAME',
  RECIPE_STEP_TASK_SCHEMA_NAME = 'RECIPE_STEP_TASK_SCHEMA_NAME',
  RECIPE_UNIT_OPERATION_TASK_SCHEMA_NAME = 'RECIPE_UNIT_OPERATION_TASK_SCHEMA_NAME'
}

export interface ProcessStartAutomatedMappingRecordNode {
  __typename: 'ProcessStartAutomatedMappingRecordNode';
  blockedEndNodesAndExpressions: Array<ProcessEndNodesBlockedByExpressionsNode>;
  blockedMappersAndExpressions: Array<ProcessMappersBlockedByExpressionsNode>;
  id: Scalars['StrictString']['output'];
  task: ProcessTaskNode;
}

export type ProcessTaskAssigneeNode = UserNode;

export interface ProcessTaskDefinitionNode extends CoreObjectArchivableInterface, HasCreatorInterface, HasPermissionsInterface {
  __typename: 'ProcessTaskDefinitionNode';
  archiveData: ArchiveDataNode;
  creator: PrincipalInterface;
  id: Scalars['StrictString']['output'];
  latestVersion: Maybe<ProcessTaskDefinitionVersionNode>;
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
}

export type ProcessTaskDefinitionOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessTaskDefinitionNode;

export type ProcessTaskDefinitionVersionApplicationDataNode = InaccessibleInfoNode | ProcedureMethodDefinitionVersionNode;

export interface ProcessTaskDefinitionVersionNode extends CoreObjectArchivableInterface, HasCreatorInterface, HasPermissionsInterface {
  __typename: 'ProcessTaskDefinitionVersionNode';
  applicationData: Maybe<ProcessTaskDefinitionVersionApplicationDataNode>;
  archiveData: ArchiveDataNode;
  creator: PrincipalInterface;
  id: Scalars['StrictString']['output'];
  inputFieldDefinitions: Array<ProcessFieldDefinitionNode>;
  name: Scalars['StrictString']['output'];
  outputFieldDefinitions: Maybe<Array<ProcessFieldDefinitionNode>>;
  permissions: PermissionsNode;
  processTaskDefinition: ProcessTaskDefinitionNode;
  processTaskSchema: ProcessTaskSchemaOrInaccessibleInfoNode;
}

export type ProcessTaskDefinitionVersionOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessTaskDefinitionVersionNode;

export interface ProcessTaskExecutionFlowchartData {
  __typename: 'ProcessTaskExecutionFlowchartData';
  edgeConfigs: Array<ProcessFlowchartEdgeConfigNode>;
  flowchartProcesses: Array<ProcessNode>;
  flowchartTasks: Array<ProcessFlowchartTaskDataNode>;
  nodeConfigs: Array<ProcessFlowchartNodeConfigNode>;
  rootTask: ProcessTaskNode;
}

export interface ProcessTaskExecutionOriginNode {
  __typename: 'ProcessTaskExecutionOriginNode';
  createdAt: Scalars['StrictString']['output'];
  executionEntry: Maybe<EntryNode>;
  executionType: ProcessTaskExecutionOriginType;
}

export enum ProcessTaskExecutionOriginType {
  API = 'API',
  ENTRY = 'ENTRY',
  MODAL = 'MODAL'
}

export interface ProcessTaskNode extends HasArchiveRecordInterface, HasCreationOriginInterface, HasCreatorInterface, HasPermissionsInterface, SearchableInterface, StudyableInterface {
  __typename: 'ProcessTaskNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  assignee: Maybe<ProcessTaskAssigneeNode>;
  clientOrigin: ProcessClientOrigin;
  createdAt: Scalars['StrictString']['output'];
  creationOrigin: CreationOriginNode;
  creator: PrincipalInterface;
  executionFlowchart: Maybe<ProcessFlowchartNode>;
  executionFlowchartData: Maybe<ProcessTaskExecutionFlowchartData>;
  executionOrigin: Maybe<ProcessTaskExecutionOriginNode>;
  executionType: ProcessExecutionType;
  executor: Maybe<CreatorInterface>;
  fields: Scalars['JSONScalar']['output'];
  flowchartPredecessorNodes: Array<ProcessFlowchartNodeConfigNode>;
  humanId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  isMappingInProgressForFlowchartRootedAtTask: Scalars['StrictBoolean']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  lastStatusChange: ProcessTaskStatusChangeNode;
  lineageEdgesFrom: Array<ProcessLineageEdgeNode>;
  lineageEdgesTo: Array<ProcessLineageEdgeNode>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  outputs: Array<ProcessOutputNode>;
  permissions: PermissionsNode;
  procedureMethodExecutionInstance: Maybe<ProcedureMethodExecutionInstanceOrInaccessibleInfoNode>;
  procedureRun: Maybe<ProcedureRunNode>;
  procedureStepExecutionInstance: Maybe<ProcedureStepExecutionInstanceOrInaccessibleInfoNode>;
  process: ProcessNode;
  processAsyncRecords: Array<ProcessAsyncRecordNode>;
  processTaskDefinitionVersion: Maybe<ProcessTaskDefinitionVersionOrInaccessibleInfoNode>;
  responsibleParties: Array<ProcessResponsiblePartyNode>;
  rootTask: Maybe<ProcessTaskNode>;
  scheduledOnDate: Maybe<Scalars['StrictString']['output']>;
  /** @deprecated Deprecated in favor of task_schema */
  schema: ProcessTaskSchemaNode;
  sortValue: Scalars['StrictString']['output'];
  status: ProcessTaskStatusNode;
  statusChanges: Array<ProcessTaskStatusChangeNode>;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  taskSchema: ProcessTaskSchemaOrInaccessibleInfoNode;
  url: Scalars['StrictString']['output'];
}

export interface ProcessTaskNodeDetailsNode {
  __typename: 'ProcessTaskNodeDetailsNode';
  id: Scalars['StrictString']['output'];
  processTaskDefinitionVersion: Maybe<ProcessTaskDefinitionVersionOrInaccessibleInfoNode>;
  schema: ProcessTaskSchemaOrInaccessibleInfoNode;
  type: ProcessFlowchartNodeDetailsType;
}

export type ProcessTaskOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessTaskNode;

export interface ProcessTaskSchemaNode extends HasValidationRulesInterface, SchemaInterface, _ProcessSchemaBaseInterface {
  __typename: 'ProcessTaskSchemaNode';
  allFields: Scalars['JSONScalar']['output'];
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  canOnlyBePartOfFlowchart: Scalars['StrictBoolean']['output'];
  canSetAssigneeOnTaskCreation: Scalars['StrictBoolean']['output'];
  clientOrigin: ProcessClientOrigin;
  /** @deprecated Deprecated in favor of defaultCreationFolderOrInaccessible */
  defaultCreationFolder: Maybe<FolderNode>;
  defaultCreationFolderOrInaccessible: Maybe<FolderOrInaccessibleInfoNode>;
  /** @deprecated Deprecated in favor of defaultEntryExecutionFolderOrInaccessible */
  defaultEntryExecutionFolder: Maybe<FolderNode>;
  defaultEntryExecutionFolderOrInaccessible: Maybe<FolderOrInaccessibleInfoNode>;
  /** @deprecated Deprecated in favor of responsibleParties */
  defaultResponsibleTeam: Maybe<TeamNode>;
  entryTemplate: Maybe<TemplateNode>;
  executionType: ProcessExecutionType;
  fields: Scalars['JSONScalar']['output'];
  fieldsJson: Scalars['JSONScalar']['output'];
  flowchartConfig: Maybe<ProcessFlowchartConfigNode>;
  forms: Array<FormDefinitionOrInaccessibleInfoNode>;
  hasAtLeastOneValidationRule: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  isPropagateWatchersEnabled: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  organization: Scalars['JSONScalar']['output'];
  outputSchema: Maybe<ProcessOutputSchemaNode>;
  prefix: Scalars['StrictString']['output'];
  relatedBenchlingApps: Array<BenchlingAppNode>;
  relevantForms: Array<FormDefinitionOrInaccessibleInfoNode>;
  requestV2Definitions: Array<RequestV2DefinitionOrInaccessibleInfoNode>;
  responsibleParties: Array<ProcessResponsiblePartyNode>;
  responsiblePartyLookupConfigs: Array<LookupConfigNode>;
  simpleRules: Array<SimpleRuleNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
  statusLifecycle: ProcessTaskStatusLifecycleNode;
  taskGroupInstructions: Maybe<Scalars['StrictString']['output']>;
  taskGroupPrefix: Scalars['StrictString']['output'];
  usesArchivedTaskSchema: Scalars['StrictBoolean']['output'];
  validationRules: Array<ValidationRuleNode>;
  validationRulesTemplateAndInputsMapping: Scalars['JSONScalar']['output'];
}


export interface ProcessTaskSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}


export interface ProcessTaskSchemaNodeformsArgs {
  isValid?: InputMaybe<Scalars['StrictBoolean']['input']>;
}

export type ProcessTaskSchemaOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessTaskSchemaNode;

export type ProcessTaskSchemaOrProcessOutputSchemaOrInaccessible = InaccessibleInfoNode | ProcessOutputSchemaNode | ProcessTaskSchemaNode;

export interface ProcessTaskStatusChangeNode extends HasCreatorInterface {
  __typename: 'ProcessTaskStatusChangeNode';
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  id: Scalars['StrictString']['output'];
  newStatus: ProcessTaskStatusNode;
  task: ProcessTaskNode;
}

export interface ProcessTaskStatusLifecycleNode {
  __typename: 'ProcessTaskStatusLifecycleNode';
  id: Scalars['StrictString']['output'];
  initialStatus: ProcessTaskStatusNode;
  name: Scalars['StrictString']['output'];
  schemaExecutionType: ProcessExecutionType;
  transitions: Array<ProcessTaskStatusTransitionNode>;
}

export type ProcessTaskStatusLifecycleOrInaccessibleInfoNode = InaccessibleInfoNode | ProcessTaskStatusLifecycleNode;

export interface ProcessTaskStatusNode {
  __typename: 'ProcessTaskStatusNode';
  displayName: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  statusType: ProcessTaskStatusType;
}

export interface ProcessTaskStatusSummaryItemNode {
  __typename: 'ProcessTaskStatusSummaryItemNode';
  count: Scalars['StrictInt']['output'];
  status: ProcessTaskStatusNode;
}

export interface ProcessTaskStatusTransitionNode {
  __typename: 'ProcessTaskStatusTransitionNode';
  id: Scalars['StrictString']['output'];
  inStatus: ProcessTaskStatusNode;
  isAutomatedTransition: Scalars['StrictBoolean']['output'];
  outStatus: ProcessTaskStatusNode;
}

export enum ProcessTaskStatusType {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  INVALID = 'INVALID',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  SKIPPED = 'SKIPPED'
}

export interface ProjectNode extends HasArchiveRecordInterface, HasOptionalCreatorInterface, PoliceableInterface, SourceInterface {
  __typename: 'ProjectNode';
  alwaysShowAncestorFolderNames: Scalars['StrictBoolean']['output'];
  archiveRecord: Maybe<ArchiveRecordNode>;
  archived: Scalars['StrictBoolean']['output'];
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creator: Maybe<PrincipalInterface>;
  /** @deprecated Use creator instead. */
  creatorJson: Maybe<Scalars['JSONScalar']['output']>;
  dataModsEnabled: Scalars['StrictBoolean']['output'];
  description: Maybe<Scalars['StrictString']['output']>;
  hidden: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  locked: Scalars['StrictBoolean']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  ownerInfoJson: Scalars['JSONScalar']['output'];
  ownerJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  public: Scalars['StrictBoolean']['output'];
  /** @deprecated Use review_lifecycles instead. */
  reviewLifecycle: Maybe<ReviewLifecycleNode>;
  reviewLifecycles: Array<ReviewLifecycleNode>;
  reviewSummaryJson: Maybe<Scalars['JSONScalar']['output']>;
  rootFolder: FolderNode;
  sourceType: Scalars['StrictString']['output'];
  starred: Scalars['StrictBoolean']['output'];
  url: Scalars['StrictString']['output'];
}

export type ProjectOrInaccessibleInfoNode = InaccessibleInfoNode | ProjectNode;

export interface ProteinAlignmentNode extends SearchableInterface {
  __typename: 'ProteinAlignmentNode';
  createdAt: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  protein: ProteinNode;
}

export type ProteinAlignmentOrInaccessibleInfoNode = InaccessibleInfoNode | ProteinAlignmentNode;

export interface ProteinAnnotationVersionNode {
  __typename: 'ProteinAnnotationVersionNode';
  annotationId: Scalars['StrictString']['output'];
  annotationType: Scalars['StrictString']['output'];
  color: Scalars['StrictString']['output'];
  dbId: Scalars['StrictInt']['output'];
  end: Scalars['StrictInt']['output'];
  name: Scalars['StrictString']['output'];
  notes: Scalars['StrictString']['output'];
  start: Scalars['StrictInt']['output'];
}

export interface ProteinNode extends FolderItemInterface, PoliceableInterface, RegistryItemInterface, SearchableInterface, StudyableInterface, WorklistItemInterface {
  __typename: 'ProteinNode';
  alignmentsJson: Scalars['JSONScalar']['output'];
  allChildEntities: Array<RegistryItemInterface>;
  alphafoldPredictionInProgress: Scalars['StrictBoolean']['output'];
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  bioentityAliasInfos: Array<BioentityAliasInfoNode>;
  childEntities: Array<RegistryItemInterface>;
  clonedFrom: Maybe<ProteinOrInaccessibleInfoNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  convertedToItem: Maybe<RegistryItemInterface>;
  createdAt: Scalars['StrictString']['output'];
  currentVersionJsonIfShowResidues: Maybe<Scalars['JSONScalar']['output']>;
  displayLabel: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  experimentalCurrentVersion: ProteinVersionNode;
  folder: FolderNode;
  hasExpirationTracking: Scalars['StrictBoolean']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  isContainedInComplexPolymer: Scalars['StrictBoolean']['output'];
  isContainedInComplexPolymerData: IsContainedInComplexPolymerDataNode;
  isLatest: Scalars['StrictBoolean']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  isTrialSample: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  latestVersionId: Maybe<Scalars['StrictInt']['output']>;
  length: Scalars['StrictInt']['output'];
  linkedAlignmentsJson: Scalars['JSONScalar']['output'];
  linkedContainerContents: Array<ContainerContentNode>;
  matchingChildEntities: MatchingChildEntitiesNode;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  noteJson: Scalars['JSONScalar']['output'];
  partContainerCount: Scalars['StrictInt']['output'];
  permissions: PermissionsNode;
  projectFolder: Maybe<FolderNode>;
  registrationOrigin: Maybe<RegistrationOriginNode>;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  residues: Maybe<Scalars['StrictString']['output']>;
  schemaValidationStateJson: Maybe<Scalars['JSONScalar']['output']>;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  testOrders: Array<TestOrderNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  translationContainerCount: Scalars['StrictInt']['output'];
  validEntitiesForFieldPathInfo: Maybe<ValidEntitiesForFieldPathNode>;
  version: ProteinVersionOrInaccessibleInfoNode;
  versionJson: Scalars['JSONScalar']['output'];
  versionsJson: Scalars['JSONScalar']['output'];
}


export interface ProteinNodechildEntitiesArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface ProteinNodeisLatestArgs {
  versionId?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface ProteinNodematchingChildEntitiesArgs {
  archivePurposes?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  childEntitySchemaId: Scalars['StrictString']['input'];
  limit?: InputMaybe<Scalars['StrictInt']['input']>;
  offset?: InputMaybe<Scalars['StrictInt']['input']>;
  queryString?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface ProteinNodetestOrdersArgs {
  statusIsOneOf?: InputMaybe<Array<TestOrderStatus>>;
}


export interface ProteinNodevalidEntitiesForFieldPathInfoArgs {
  fieldId: Scalars['StrictString']['input'];
}


export interface ProteinNodeversionArgs {
  dbId?: InputMaybe<Scalars['StrictInt']['input']>;
}


export interface ProteinNodeversionJsonArgs {
  versionId?: InputMaybe<Scalars['StrictString']['input']>;
}

export type ProteinOrInaccessibleInfoNode = InaccessibleInfoNode | ProteinNode;

export interface ProteinVersionNode extends HasCreatorInterface {
  __typename: 'ProteinVersionNode';
  aminoAcids: Scalars['StrictString']['output'];
  annotations: Array<ProteinAnnotationVersionNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorJson: Scalars['JSONScalar']['output'];
  dbId: Scalars['StrictInt']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  parentId: Maybe<Scalars['StrictInt']['output']>;
  protein: ProteinNode;
  versionJson: Scalars['JSONScalar']['output'];
}

export type ProteinVersionOrInaccessibleInfoNode = InaccessibleInfoNode | ProteinVersionNode;

export interface ProteinVersionSpecifierInput {
  proteinId: Scalars['StrictString']['input'];
  versionDbId: Scalars['StrictInt']['input'];
}

export interface ProtocolNode extends FolderItemInterface, HasCreatorInterface, SearchableInterface {
  __typename: 'ProtocolNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorJson: Scalars['JSONScalar']['output'];
  discussUrl: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  featured: Scalars['StrictBoolean']['output'];
  folder: FolderNode;
  id: Scalars['StrictString']['output'];
  linkType: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
}

export type ProtocolOrInaccessibleInfoNode = InaccessibleInfoNode | ProtocolNode;

export interface ProvisionedCapabilityNode {
  __typename: 'ProvisionedCapabilityNode';
  accessLevel: UserAccessLevel;
  capability: CapabilityNode;
  id: Scalars['StrictString']['output'];
}

export enum PublicationState {
  LIMITED_AVAILABILITY = 'LIMITED_AVAILABILITY',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export interface PublishableInterface {
  currentPublishingRecord: Maybe<PublishingRecordOrInaccessibleInfoNode>;
  id: Scalars['StrictString']['output'];
  publishingRecords: Array<PublishingRecordOrInaccessibleInfoNode>;
}

export interface PublishedDataTableColumnsNode {
  __typename: 'PublishedDataTableColumnsNode';
  publishedDataTableColumnsJson: Maybe<Scalars['JSONScalar']['output']>;
  resultSchemaId: Scalars['StrictString']['output'];
}

export interface PublishingRecordNode {
  __typename: 'PublishingRecordNode';
  id: Scalars['StrictString']['output'];
  index: Scalars['StrictInt']['output'];
  publishableId: Scalars['StrictString']['output'];
  publishableVersionId: Scalars['StrictString']['output'];
  publishedAt: Scalars['StrictString']['output'];
  publishedByUser: UserNode;
  publishingStatus: PublishingStatus;
  unpublishedAt: Maybe<Scalars['StrictString']['output']>;
  unpublishedByUser: Maybe<UserNode>;
  versionDescription: Maybe<Scalars['StrictString']['output']>;
  versionName: Scalars['StrictString']['output'];
}

export type PublishingRecordOrInaccessibleInfoNode = InaccessibleInfoNode | PublishingRecordNode;

export enum PublishingStatus {
  EFFECTIVE = 'EFFECTIVE',
  SUPERSEDED = 'SUPERSEDED',
  WITHDRAWN = 'WITHDRAWN'
}

export interface Query {
  __typename: 'Query';
  _nodes: Array<ModelNode>;
  allAnalysisTemplates: Array<AnalysisTemplateNode>;
  allAntibodyFormats: Array<AntibodyFormatNode>;
  allConfigImportHistoryEntries: Array<ConfigImportHistoryEntryNode>;
  allImplementedAntibodySchemaInterfaces: Array<ImplementedAntibodySchemaInterfaceNode>;
  allProcedures: Array<ProcedureNode>;
  allProcessTaskDefinitions: Array<ProcessTaskDefinitionNode>;
  allRequestV2Definitions: Array<RequestV2DefinitionNode>;
  allSampleTypes: Array<SampleTypeNode>;
  allSchemaInterfaces: Array<BaseSchemaInterfaceInterface>;
  allTestDefinitions: Array<TestDefinitionNode>;
  allowedTimezone: Maybe<AllowedTimezone>;
  analyses: Array<AnalysisOrInaccessibleInfoNode>;
  analysis: AnalysisOrInaccessibleInfoNode;
  analysisListing: AnalysisListingNode;
  analysisTemplate: AnalysisTemplateOrInaccessibleInfoNode;
  analysisTemplateDataFrameVariable: AnalysisTemplateDataFrameVariableOrInaccessibleInfoNode;
  analysisTemplateDataFrameVariables: Array<AnalysisTemplateDataFrameVariableOrInaccessibleInfoNode>;
  analysisTemplateListing: Array<AnalysisTemplateNode>;
  analysisTemplateVariable: AnalysisTemplateVariableOrInaccessibleInfoNode;
  analysisTemplateVariables: Array<AnalysisTemplateVariableOrInaccessibleInfoNode>;
  analysisTemplates: Array<AnalysisTemplateOrInaccessibleInfoNode>;
  analyticsDashboard: AnalyticsDashboardOrInaccessibleInfoNode;
  analyticsDashboardListing: AnalyticsDashboardListingNode;
  analyticsDashboards: Array<AnalyticsDashboardOrInaccessibleInfoNode>;
  antibody: AntibodyOrInaccessibleInfoNode;
  assaySchema: AssaySchemaOrInaccessibleInfoNode;
  /** @deprecated Deprecated in favor of fetching the schema types separately */
  assaySchemas: Array<AssaySchemaNode>;
  assemblyHistory: Maybe<VisualHistoryEventOrInaccessibleInfoNode>;
  assignedProcessTaskStatusSummaries: Array<ProcessTaskStatusSummaryItemNode>;
  authnOptions: Array<AuthnOptionNode>;
  automationInputFile: AutomationInputFileOrInaccessibleInfoNode;
  automationOutputFile: AutomationOutputFileOrInaccessibleInfoNode;
  automationOutputFiles: Array<AutomationOutputFileOrInaccessibleInfoNode>;
  batch: BatchOrInaccessibleInfoNode;
  /** @deprecated Batches and batch schemas are deprecated */
  batchSchemas: Array<BatchSchemaNode>;
  batches: Array<BatchOrInaccessibleInfoNode>;
  benchlingApp: BenchlingAppOrInaccessibleInfoNode;
  benchlingAppCanvas: BenchlingAppCanvasOrInaccessibleInfoNode;
  benchlingAppCanvasById: BenchlingAppCanvasOrInaccessibleInfoNode;
  benchlingAppCanvasFeaturesForLocation: BenchlingAppCanvasFeatureListingNode;
  benchlingAppDefinition: BenchlingAppDefinitionOrInaccessibleInfoNode;
  benchlingAppDefinitionDeveloperListing: BenchlingAppDefinitionListingNode;
  /** @deprecated Do not get app feature by DB id, Use benchlingAppFeatureByAppAndFeatureId instead */
  benchlingAppFeature: BenchlingAppFeatureNode;
  benchlingAppFeatureByAppAndFeatureId: BenchlingAppFeatureOrInaccessibleInfoNode;
  benchlingAppListing: BenchlingAppListingNode;
  benchlingAppResourceFeatureAssociations: Array<ResourceFeatureAssociationNode>;
  benchlingAppSession: BenchlingAppSessionOrInaccessibleInfoNode;
  benchlingApps: Array<BenchlingAppNode>;
  bioentities: Array<RegistryItemOrInaccessibleInfoNode>;
  bioentity: RegistryItemOrInaccessibleInfoNode;
  blastDbs: Array<BLASTDBNode>;
  boxSchemas: Array<BoxSchemaNode>;
  boxes: Array<BoxOrInaccessibleInfoNode>;
  bulkAssemblies: Array<BulkAssemblyOrInaccessibleInfoNode>;
  bulkAssembly: BulkAssemblyOrInaccessibleInfoNode;
  bulkAssemblyValidationJson: Scalars['JSONScalar']['output'];
  capabilities: Array<CapabilityNode>;
  chart: ChartOrInaccessibleInfoNode;
  charts: Array<ChartOrInaccessibleInfoNode>;
  chatSession: ChatSessionOrInaccessibleInfoNode;
  chatSessionListing: ChatSessionListingNode;
  collectibles: Array<TemplateCollectibleOrInaccessibleInfoNode>;
  collectiblesListing: TemplateCollectiblesListingNode;
  complexPolymer: ComplexPolymerOrInaccessibleInfoNode;
  complexPolymerSchemaConfiguration: Maybe<ComplexPolymerSchemaConfigurationOrInaccessibleNode>;
  complexPolymerSchemaConfigurations: Array<ComplexPolymerSchemaConfigurationNode>;
  complexPolymerSchemas: Array<ComplexPolymerSchemaNode>;
  componentSequence: Maybe<ComponentSequenceNode>;
  componentSequencePrimer: Maybe<ComponentSequencePrimerNode>;
  concatenateMolfiles: ConcatenateMolfilesNode;
  configImportHistoryEntries: Array<ConfigImportHistoryEntryOrInaccessibleInfoNode>;
  configImportHistoryEntry: ConfigImportHistoryEntryOrInaccessibleInfoNode;
  connection: ConnectionOrInaccessibleInfoNode;
  connectionSchema: ConnectionSchemaOrInaccessibleInfoNode;
  connectionSchemas: Array<ConnectionSchemaNode>;
  connections: Array<ConnectionOrInaccessibleInfoNode>;
  container: ContainerOrInaccessibleInfoNode;
  containerSchemas: Array<ContainerSchemaNode>;
  containers: Array<ContainerOrInaccessibleInfoNode>;
  coreObjectArchivableItems: Array<CoreObjectArchivableItemOrInaccessibleInfoNode>;
  currentTenant: TenantNode;
  currentTenantInstitutionListing: InstitutionListingNode;
  currentTenantOrganizationListing: OrganizationListingNode;
  /** @deprecated Unpaginated and deprecated. Use Query.current_tenant_organization_listing instead. */
  currentTenantOrganizations: Array<OrganizationNode>;
  currentTenantTeamListing: TeamListingNode;
  /** @deprecated Unpaginated and deprecated. Use Query.current_tenant_team_listing instead. */
  currentTenantTeams: Array<TeamNode>;
  currentTenantUserListing: UserListingOrInaccessibleInfoNode;
  currentUser: Maybe<ActorNode>;
  dataFrame: DataFrameOrInaccessibleNode;
  dataFrames: Array<DataFrameOrInaccessibleNode>;
  dataPolicy: DataPolicyOrInaccessibleInfoNode_;
  dataset: DatasetOrInaccessibleInfoNode;
  datasets: Array<DatasetOrInaccessibleInfoNode>;
  directBioentities: Array<RegistryItemOrInaccessibleInfoNode>;
  directBioentity: RegistryItemOrInaccessibleInfoNode;
  directStorable: StorableOrInaccessibleInfoNode;
  directStorables: Array<StorableOrInaccessibleInfoNode>;
  displayNameAssays: Array<ProcessDisplayNameAssays>;
  displayNameProcesses: Array<ProcessDisplayNameProcesses>;
  displayNameRecipes: Array<ProcessDisplayNameRecipes>;
  document: DocumentOrInaccessibleInfoNode;
  documentVersion: DocumentVersionOrInaccessibleInfoNode;
  documentVersions: Array<DocumentVersionOrInaccessibleInfoNode>;
  documents: Array<DocumentOrInaccessibleInfoNode>;
  drawnAttachmentValidationError: Maybe<Scalars['StrictString']['output']>;
  ensemblInfo: EnsemblInfoNode;
  entityMap: EntityMapOrInaccessibleInfoNode;
  entries: Array<EntryOrInaccessibleInfoNode>;
  entry: EntryOrInaccessibleInfoNode;
  equipment: EquipmentOrInaccessibleInfoNode;
  error400: Maybe<Scalars['StrictString']['output']>;
  error500: Maybe<Scalars['StrictString']['output']>;
  eventInfoListing: EventInfoListingNode;
  eventSubscriptionsListing: EventSubscriptionsListingNode;
  file: FileOrInaccessibleInfoNode;
  files: Array<FileOrInaccessibleInfoNode>;
  folder: FolderOrInaccessibleInfoNode;
  folderItem: FolderItemOrInaccessibleInfoNode;
  folders: Array<FolderOrInaccessibleInfoNode>;
  foo: Maybe<Scalars['StrictString']['output']>;
  formAction: FormActionOrInaccessibleInfoNode;
  formDefinition: FormDefinitionOrInaccessibleInfoNode;
  formDefinitions: Array<FormDefinitionNode>;
  gridCoordinatesDirections: Array<GridCoordinatesDirections>;
  hasValidationRulesItem: HasValidationRulesItemOrInaccessibleInfoNode;
  implementedAntibodySchemaInterface: Maybe<AntibodySchemaInterfaceOrInaccessibleNode>;
  implementedEquipmentSchemaInterface: Maybe<ImplementedEquipmentSchemaInterfaceOrInaccessibleInfoNode>;
  ingredient: IngredientOrInaccessibleInfoNode;
  internalAdminScript: InternalAdminScriptNode;
  internalAdminScriptNames: Array<Scalars['StrictString']['output']>;
  inventoryConfig: InventoryConfigOrInaccessibleInfoNode;
  jellyfish: JellyfishOrInaccessibleInfoNode;
  jellyfishSchema: JellyfishSchemaOrInaccessibleInfoNode;
  jellyfishSchemas: Array<JellyfishSchemaOrInaccessibleInfoNode>;
  jellyfishes: Array<JellyfishOrInaccessibleInfoNode>;
  labelPrintingConfig: LabelPrintingConfigNode;
  location: LocationOrInaccessibleInfoNode;
  locationSchemas: Array<LocationSchemaNode>;
  lookupConfig: LookupConfigOrInaccessibleInfoNode;
  mixture: MixtureOrInaccessibleInfoNode;
  mixtures: Array<MixtureOrInaccessibleInfoNode>;
  molecule: MoleculeOrInaccessibleInfoNode;
  moleculeImage: SVGOrErrorNode;
  moleculeInComplexPolymer: MoleculeInComplexPolymerOrInaccessibleNode;
  monomer: MonomerOrInaccessibleInfoNode;
  monomers: Array<MonomerNode>;
  notificationOptOutPreferenceKeys: Maybe<NotificationOptOutPreferenceKeys>;
  nucleotideImage: NucleotideImageNode;
  nucleotideInComplexPolymer: NucleotideInComplexPolymerOrInaccessibleNode;
  oligos: Array<SequenceOrInaccessibleInfoNode>;
  organization: OrganizationOrInaccessibleInfoNode;
  organizations: Array<OrganizationOrInaccessibleInfoNode>;
  parties: Array<PartyNodeOrInaccessibleInfoNode>;
  pendingTableRows: Array<ResultNode>;
  plateSchemas: Array<PlateSchemaNode>;
  plates: Array<PlateOrInaccessibleInfoNode>;
  policeable: PoliceableOrInaccessibleInfoNode;
  policyListing: PolicyListingNode;
  policyTemplate: PolicyTemplateNode;
  polymer: PolymerOrInaccessibleInfoNode;
  polymers: Array<PolymerOrInaccessibleInfoNode>;
  procedure: ProcedureOrInaccessibleInfoNode;
  procedureFlowchartVersion: ProcedureFlowchartVersionOrInaccessibleInfoNode;
  procedureMethodExecutionInstance: ProcedureMethodExecutionInstanceOrInaccessibleInfoNode;
  procedureMethodExecutionInstanceAssociation: ProcedureMethodExecutionInstanceAssociationOrInaccessibleInfoNode;
  procedureMethodExecutionInstanceAssociations: Array<ProcedureMethodExecutionInstanceAssociationOrInaccessibleInfoNode>;
  procedureMethodExecutionInstances: Array<ProcedureMethodExecutionInstanceOrInaccessibleInfoNode>;
  procedureRun: ProcedureRunOrInaccessibleInfoNode;
  procedureRuns: Array<ProcedureRunOrInaccessibleInfoNode>;
  procedureStepExecutionInstance: ProcedureStepExecutionInstanceOrInaccessibleInfoNode;
  procedureStepExecutionInstances: Array<ProcedureStepExecutionInstanceOrInaccessibleInfoNode>;
  procedures: Array<ProcedureOrInaccessibleInfoNode>;
  proceduresListing: Array<ProcedureNode>;
  process: ProcessOrInaccessibleInfoNode;
  processAsyncRecords: Array<ProcessAsyncRecordOrInaccessibleInfoNode>;
  processFlowchart: ProcessFlowchartOrInaccessibleInfoNode;
  processFlowchartConfig: ProcessFlowchartConfigOrInaccessibleInfoNode;
  processFlowchartConfigVersion: ProcessFlowchartConfigVersionOrInaccessibleInfoNode;
  processFlowchartTypeConfigurator: ProcessFlowchartTypeConfiguratorNode;
  processFlowcharts: Array<ProcessFlowchartOrInaccessibleInfoNode>;
  processOutput: ProcessOutputOrInaccessibleInfoNode;
  processOutputSchema: ProcessOutputSchemaOrInaccessibleInfoNode;
  processOutputSchemasSupportingPlatformFeature: Array<ProcessOutputSchemaNode>;
  processOutputs: Array<ProcessOutputOrInaccessibleInfoNode>;
  processSingletonTaskSchemas: Array<ProcessTaskSchemaOrInaccessibleInfoNode>;
  processTask: ProcessTaskOrInaccessibleInfoNode;
  processTaskDefinition: ProcessTaskDefinitionOrInaccessibleInfoNode;
  processTaskDefinitionVersion: ProcessTaskDefinitionVersionOrInaccessibleInfoNode;
  processTaskDefinitionVersions: Array<ProcessTaskDefinitionVersionOrInaccessibleInfoNode>;
  processTaskDefinitions: Array<ProcessTaskDefinitionOrInaccessibleInfoNode>;
  processTaskDefinitionsSupportingPlatformFeature: Array<ProcessTaskDefinitionNode>;
  processTaskSchema: ProcessTaskSchemaOrInaccessibleInfoNode;
  processTaskSchemasSupportingPlatformFeature: Array<ProcessTaskSchemaNode>;
  processTaskStatusLifecycle: ProcessTaskStatusLifecycleOrInaccessibleInfoNode;
  processTaskStatusLifecycles: Array<ProcessTaskStatusLifecycleNode>;
  processTaskStatuses: Array<ProcessTaskStatusNode>;
  processTaskStatusesForClientOrigin: Array<ProcessTaskStatusNode>;
  processTasks: Array<ProcessTaskOrInaccessibleInfoNode>;
  processes: Array<ProcessOrInaccessibleInfoNode>;
  project: ProjectOrInaccessibleInfoNode;
  projects: Array<ProjectOrInaccessibleInfoNode>;
  protein: ProteinOrInaccessibleInfoNode;
  proteinAlignments: Array<ProteinAlignmentOrInaccessibleInfoNode>;
  proteinVersions: Array<ProteinVersionOrInaccessibleInfoNode>;
  proteins: Array<ProteinOrInaccessibleInfoNode>;
  protocols: Array<ProtocolOrInaccessibleInfoNode>;
  recentSavedSearches: Array<SavedSearchNode>;
  recentWorklists: RecentWorklistListingNode;
  registries: Array<RegistryNode>;
  registry: RegistryOrInaccessibleInfoNode;
  relevantTemplatesListing: RelevantTemplatesListingNode;
  remainingAlphafoldExecutions: Scalars['StrictInt']['output'];
  request: RequestOrInaccessibleInfoNode;
  requestSchema: RequestSchemaOrInaccessibleInfoNode;
  requestSchemas: Array<RequestSchemaNode>;
  requestTaskSchema: RequestTaskSchemaOrInaccessibleInfoNode;
  requestTaskSchemas: Array<RequestTaskSchemaNode>;
  requestTemplate: RequestTemplateOrInaccessibleInfoNode;
  requestTemplates: Array<RequestTemplateNode>;
  requestV2Definition: RequestV2DefinitionOrInaccessibleInfoNode;
  requestV2Definitions: Array<RequestV2DefinitionOrInaccessibleInfoNode>;
  requestV2Submission: RequestV2SubmissionOrInaccessibleInfoNode;
  requestV2Submissions: Array<RequestV2SubmissionOrInaccessibleInfoNode>;
  requests: Array<RequestOrInaccessibleInfoNode>;
  resourceFeatureAssociation: ResourceFeatureAssociationOrInaccessibleInfoNode;
  result: ResultOrInaccessibleInfoNode;
  resultBlob: ResultBlobOrInaccessibleInfoNode;
  resultBlobs: Array<ResultBlobOrInaccessibleInfoNode>;
  resultSchema: Maybe<ResultSchemaOrInaccessibleInfoNode>;
  resultSchemaPublishedDataTableColumns: Array<PublishedDataTableColumnsNode>;
  resultSchemas: Array<ResultSchemaNode>;
  results: Array<ResultOrInaccessibleInfoNode>;
  review: ReviewOrInaccessibleInfoNode;
  reviewLifecycle: ReviewLifecycleOrInaccessibleInfoNode;
  reviewLifecycleStage: ReviewLifecycleStageOrInaccessibleInfoNode;
  reviewLifecycles: Array<ReviewLifecycleOrInaccessibleInfoNode>;
  reviewable: ReviewableOrInaccessibleInfoNode;
  run: RunOrInaccessibleInfoNode;
  runSchema: Maybe<RunSchemaOrInaccessibleInfoNode>;
  runSchemas: Array<RunSchemaNode>;
  runs: Array<RunOrInaccessibleInfoNode>;
  sampleDefinition: SampleDefinitionOrInaccessibleInfoNode;
  sampleDefinitions: Array<SampleDefinitionOrInaccessibleInfoNode>;
  sampleType: SampleTypeOrInaccessibleInfoNode;
  sampleTypes: Array<SampleTypeOrInaccessibleInfoNode>;
  savedSearch: Maybe<SavedSearchOrInaccessibleInfoNode>;
  savedSearchDataPolicies: SavedSearchDataPoliciesNode;
  savedSearches: Array<SavedSearchNode>;
  savedSearchesForSection: Array<SavedSearchNode>;
  schema: SchemaOrInaccessibleInfoNode;
  schemaFieldSelector: SchemaFieldSelectorOrInaccessibleInfoNode;
  schemaFieldSelectorOption: SchemaFieldSelectorOptionOrInaccessibleInfoNode;
  schemaFieldSelectors: Array<SchemaFieldSelectorNode>;
  schemaInterface: SchemaInterfaceOrInaccessibleInfoNode;
  /** @deprecated This duplicates `SchemaInterfacesQuery:schema_interfaces`. See that field instead. */
  schemaInterfaceListing: SchemaInterfaceListingNode;
  /** @deprecated (1) If you need all (Custom and Static) Schema Interfaces, then use `SchemaInterfacesQuery:all_schema_interfaces`. (2) If you only need all Custom Schema Interfaces without filters or with an `organization_id` filter, then implement a new, properly named `all_custom_schema_interfaces` field. You can copy `resolve_all_schema_interfaces` and substitute in `CustomSchemaInterfaceConnector`. (3) If you only need all (Custom and Static) Schema Interfaces with a `schema_id` filter, then query the `TagSchemaNode:interfaces` field. That field also correctly handles context-based auth to the Interfaces. This deprecated field does not, so implemented Interfaces that are inaccessible will NOT be returned. */
  schemaInterfaces: Array<SchemaInterfaceNode>;
  schemaPolicy: SchemaPolicyOrInaccessibleInfoNode;
  schemaPolicyListing: SchemaPolicyListingNode;
  searchableItems: Array<SearchableInterfaceOrInaccessibleInfoNode>;
  sequence: SequenceOrInaccessibleInfoNode;
  sequenceAlignments: Array<SequenceAnalysisOrInaccessibleInfoNode>;
  sequenceVersions: Array<SequenceVersionOrInaccessibleInfoNode>;
  sequences: Array<SequenceOrInaccessibleInfoNode>;
  signedFile: SignedFileOrInaccessibleInfoNode;
  smilesChemicalStructureImage: SmilesChemicalStructureImageNode;
  sources: Array<SourceInterface>;
  spreadsheetColumnsMappings: Array<SpreadsheetColumnsMappingNode>;
  stageEntries: Array<StageEntryOrInaccessibleInfoNode>;
  stageEntry: StageEntryOrInaccessibleInfoNode;
  starrableItems: Array<StarrableItemOrInaccessibleInfoNode>;
  starredTagSchemas: Array<TagSchemaNode>;
  storable: StorableOrInaccessibleInfoNode;
  storableSchema: StorableSchemaOrInaccessibleInfoNode;
  storableSchemas: Array<StorableSchemaOrInaccessibleInfoNode>;
  storables: Array<StorableOrInaccessibleInfoNode>;
  structuredTable: StructuredTableOrInaccessibleInfoNode;
  studies: Array<StudyOrInaccessibleInfoNode>;
  study: StudyOrInaccessibleInfoNode;
  studySampleTestPlan: StudySampleTestPlanOrInaccessibleInfoNode;
  studySampleTestPlans: Array<StudySampleTestPlanOrInaccessibleInfoNode>;
  studySchema: StudySchemaOrInaccessibleInfoNode;
  studySchemas: Array<StudySchemaNode>;
  studyableItem: StudyableOrInaccessibleInfoNode;
  studyableItems: Array<StudyableOrInaccessibleInfoNode>;
  subtemplate: SubtemplateOrInaccessibleInfoNode;
  subtemplates: Array<SubtemplateNode>;
  tagSchema: TagSchemaOrInaccessibleInfoNode;
  tagSchemaChips: Array<TagSchemaOrInaccessibleInfoNode>;
  tagSchemas: Array<TagSchemaNode>;
  tagSchemasListing: TagSchemaListingNode;
  team: TeamOrInaccessibleInfoNode;
  template: TemplateOrInaccessibleInfoNode;
  templateCollection: TemplateCollectionOrInaccessibleInfoNode;
  /** @deprecated Use templateCollectionsListing instead */
  templateCollectionListing: TemplateCollectionListingNode;
  /** @deprecated Use templateCollectionsListing instead */
  templateCollections: Array<TemplateCollectionNode>;
  templateCollectionsByIds: Array<TemplateCollectionOrInaccessibleInfoNode>;
  templateCollectionsListing: TemplateCollectionListingNode;
  templates: Array<TemplateNode>;
  templatesByIds: Array<TemplateOrInaccessibleInfoNode>;
  tenants: Array<TenantNode>;
  testDefinition: TestDefinitionOrInaccessibleInfoNode;
  testDefinitions: Array<TestDefinitionOrInaccessibleInfoNode>;
  testOrder: TestOrderOrInaccessibleInfoNode;
  testOrders: Array<TestOrderOrInaccessibleInfoNode>;
  treatmentGroup: TreatmentGroupOrInaccessibleInfoNode;
  treatmentGroups: Array<TreatmentGroupOrInaccessibleInfoNode>;
  unit: UnitNode;
  unitBySymbol: UnitBySymbolNode;
  unitType: UnitTypeNode;
  unitTypes: Array<UnitTypeNode>;
  units: Array<UnitNode>;
  user: UserOrInaccessibleInfoNode;
  users: Array<UserOrInaccessibleInfoNode>;
  validationRule: ValidationRuleOrInaccessibleInfoNode;
  validationRules: Array<ValidationRuleOrInaccessibleInfoNode>;
  visualHistory: VisualHistoryOrInaccessibleInfoNode;
  warehouseModelListing: WarehouseModelListingNode;
  /** @deprecated Usages should be replaced with WarehouseModelListingNode */
  warehouseTableListing: WarehouseTableListingNode;
  webhookResponse: WebhookResponseOrInaccessibleInfoNode;
  workflows: Array<WorkflowOrInaccessibleInfoNode>;
  worklist: WorklistOrInaccessibleInfoNode;
  worklists: Array<WorklistOrInaccessibleInfoNode>;
  worksheet: WorksheetOrInaccessibleInfoNode;
  worksheets: Array<WorksheetOrInaccessibleInfoNode>;
}


export interface Query_nodesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryallSchemaInterfacesArgs {
  organizationIdFilter?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface QueryanalysesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryanalysisArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryanalysisTemplateArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryanalysisTemplateDataFrameVariableArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryanalysisTemplateDataFrameVariablesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryanalysisTemplateListingArgs {
  excludeArchived?: InputMaybe<Scalars['StrictBoolean']['input']>;
}


export interface QueryanalysisTemplateVariableArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryanalysisTemplateVariablesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryanalysisTemplatesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryanalyticsDashboardArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryanalyticsDashboardsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryantibodyArgs {
  antibodyId: Scalars['StrictString']['input'];
}


export interface QueryassaySchemaArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryassemblyHistoryArgs {
  entityId: Scalars['StrictString']['input'];
}


export interface QueryassignedProcessTaskStatusSummariesArgs {
  processTaskStatusTypes: Array<InputMaybe<ProcessTaskStatusType>>;
}


export interface QueryautomationInputFileArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryautomationOutputFileArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryautomationOutputFilesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerybatchArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerybatchesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerybenchlingAppArgs {
  forDeveloper?: InputMaybe<Scalars['StrictBoolean']['input']>;
  id: Scalars['StrictString']['input'];
}


export interface QuerybenchlingAppCanvasArgs {
  featureType: Scalars['StrictString']['input'];
  resourceId: Scalars['StrictString']['input'];
}


export interface QuerybenchlingAppCanvasByIdArgs {
  canvasId: Scalars['StrictString']['input'];
}


export interface QuerybenchlingAppCanvasFeaturesForLocationArgs {
  location: BenchlingAppCanvasLocation;
}


export interface QuerybenchlingAppDefinitionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerybenchlingAppFeatureArgs {
  id: Scalars['StrictInt']['input'];
}


export interface QuerybenchlingAppFeatureByAppAndFeatureIdArgs {
  appInstallationId: Scalars['StrictString']['input'];
  featureDeveloperId: Scalars['StrictString']['input'];
}


export interface QuerybenchlingAppListingArgs {
  forDeveloper?: InputMaybe<Scalars['StrictBoolean']['input']>;
  limitOffsetInput: LimitOffsetInput;
}


export interface QuerybenchlingAppSessionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerybenchlingAppsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerybioentitiesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerybioentityArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryboxesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerybulkAssembliesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerybulkAssemblyArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerybulkAssemblyValidationJsonArgs {
  procedureJson: Scalars['JSONScalar']['input'];
}


export interface QuerychartArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerychartsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerychatSessionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerychatSessionListingArgs {
  nextToken?: InputMaybe<Scalars['StrictString']['input']>;
  pageSize?: InputMaybe<Scalars['StrictInt']['input']>;
}


export interface QuerycollectiblesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerycollectiblesListingArgs {
  archiveFilter?: InputMaybe<Array<InputMaybe<Scalars['StrictString']['input']>>>;
  limitOffsetInput?: InputMaybe<LimitOffsetInput>;
  searchInput?: InputMaybe<Scalars['StrictString']['input']>;
  typeFilter?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}


export interface QuerycomplexPolymerArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerycomplexPolymerSchemaConfigurationArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface QuerycomplexPolymerSchemasArgs {
  interfaceId?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface QuerycomponentSequenceArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerycomponentSequencePrimerArgs {
  id: Scalars['Int']['input'];
}


export interface QueryconcatenateMolfilesArgs {
  molfiles?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  monomerOrMoleculeIds: Array<Scalars['StrictString']['input']>;
}


export interface QueryconfigImportHistoryEntriesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryconfigImportHistoryEntryArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryconnectionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryconnectionSchemaArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryconnectionsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerycontainerArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerycontainersArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerycoreObjectArchivableItemsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerycurrentTenantInstitutionListingArgs {
  limitOffsetInput: LimitOffsetInput;
  searchInput: InstitutionSearchInputInput;
}


export interface QuerycurrentTenantOrganizationListingArgs {
  limitOffsetInput: LimitOffsetInput;
  searchInput: OrganizationListingSearchInput;
}


export interface QuerycurrentTenantTeamListingArgs {
  limitOffsetInput: LimitOffsetInput;
  searchInput: TeamListingSearchInput;
  sortInput: TeamListingSortInput;
}


export interface QuerycurrentTenantUserListingArgs {
  limitOffsetInput: LimitOffsetInput;
  searchInput: UserListingSearchInput;
  sortInput: UserListingSortInput;
}


export interface QuerydataFrameArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerydataFramesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerydataPolicyArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerydatasetArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerydatasetsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerydirectBioentitiesArgs {
  inputs: Array<InputMaybe<RegistryInput>>;
}


export interface QuerydirectBioentityArgs {
  input: RegistryInput;
}


export interface QuerydirectStorableArgs {
  input: StorableInput;
}


export interface QuerydirectStorablesArgs {
  inputs: Array<InputMaybe<StorableInput>>;
}


export interface QuerydocumentArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerydocumentVersionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerydocumentVersionsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerydocumentsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerydrawnAttachmentValidationErrorArgs {
  molfile: Scalars['StrictString']['input'];
}


export interface QueryentityMapArgs {
  entityMapInput: EntityMapInputNode;
}


export interface QueryentriesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryentryArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryequipmentArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryfileArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryfilesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryfolderArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryfolderItemArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryfoldersArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryformActionArgs {
  actionIdentifier: Scalars['StrictString']['input'];
  schemaId: Scalars['StrictString']['input'];
}


export interface QueryformDefinitionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryformDefinitionsArgs {
  includeArchived?: InputMaybe<Scalars['StrictBoolean']['input']>;
  includeInvalid?: InputMaybe<Scalars['StrictBoolean']['input']>;
  schemaId?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface QueryhasValidationRulesItemArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryimplementedAntibodySchemaInterfaceArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface QueryimplementedEquipmentSchemaInterfaceArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface QueryingredientArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryinternalAdminScriptArgs {
  scriptName: Scalars['StrictString']['input'];
}


export interface QueryjellyfishArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryjellyfishSchemaArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryjellyfishSchemasArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryjellyfishesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerylocationArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerylookupConfigArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerymixtureArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerymixturesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerymoleculeArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerymoleculeImageArgs {
  mol: Scalars['StrictString']['input'];
}


export interface QuerymoleculeInComplexPolymerArgs {
  complexPolymerId?: InputMaybe<Scalars['StrictString']['input']>;
  moleculeId?: InputMaybe<Scalars['StrictString']['input']>;
  polymerRef: Scalars['StrictString']['input'];
}


export interface QuerymonomerArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerynucleotideImageArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerynucleotideInComplexPolymerArgs {
  complexPolymerId?: InputMaybe<Scalars['StrictString']['input']>;
  complexPolymerType: GQLComplexPolymerType;
  oligoId?: InputMaybe<Scalars['StrictString']['input']>;
  polymerRef: Scalars['StrictString']['input'];
  residueIndex: Scalars['StrictInt']['input'];
}


export interface QueryoligosArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryorganizationArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryorganizationsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerypartiesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerypendingTableRowsArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryplatesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerypoliceableArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerypolicyListingArgs {
  limitOffsetInput?: InputMaybe<LimitOffsetInput>;
  policyType?: InputMaybe<PolicyType>;
}


export interface QuerypolicyTemplateArgs {
  policyType: PolicyTemplateType;
}


export interface QuerypolymerArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerypolymersArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryprocedureArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocedureFlowchartVersionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocedureMethodExecutionInstanceArgs {
  id?: InputMaybe<Scalars['StrictString']['input']>;
  worksheetId?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface QueryprocedureMethodExecutionInstanceAssociationArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocedureMethodExecutionInstanceAssociationsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryprocedureMethodExecutionInstancesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  worksheetId?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface QueryprocedureRunArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocedureRunsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryprocedureStepExecutionInstanceArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocedureStepExecutionInstancesArgs {
  documentId?: InputMaybe<Scalars['StrictString']['input']>;
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}


export interface QueryproceduresArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryproceduresListingArgs {
  excludeArchived?: InputMaybe<Scalars['StrictBoolean']['input']>;
  procedureTypes?: InputMaybe<Array<InputMaybe<ProcedureType>>>;
}


export interface QueryprocessArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocessAsyncRecordsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryprocessFlowchartArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocessFlowchartConfigArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocessFlowchartConfigVersionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocessFlowchartTypeConfiguratorArgs {
  flowchartTypeName: Scalars['StrictString']['input'];
}


export interface QueryprocessFlowchartsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryprocessOutputArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocessOutputSchemaArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocessOutputSchemasSupportingPlatformFeatureArgs {
  platformFeature: ProcessPlatformFeatureType;
}


export interface QueryprocessOutputsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryprocessSingletonTaskSchemasArgs {
  names: Array<InputMaybe<ProcessSingletonTaskSchemaName>>;
  orgId: Scalars['StrictString']['input'];
}


export interface QueryprocessTaskArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocessTaskDefinitionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocessTaskDefinitionVersionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocessTaskDefinitionVersionsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryprocessTaskDefinitionsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryprocessTaskDefinitionsSupportingPlatformFeatureArgs {
  platformFeature: ProcessPlatformFeatureType;
}


export interface QueryprocessTaskSchemaArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocessTaskSchemasSupportingPlatformFeatureArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  platformFeature: ProcessPlatformFeatureType;
}


export interface QueryprocessTaskStatusLifecycleArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprocessTaskStatusesForClientOriginArgs {
  clientOrigin: ProcessClientOrigin;
}


export interface QueryprocessTasksArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryprocessesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryprojectArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryprojectsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryproteinArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryproteinAlignmentsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryproteinVersionsArgs {
  proteinVersionSpecifiers: Array<ProteinVersionSpecifierInput>;
}


export interface QueryproteinsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryprotocolsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryrecentWorklistsArgs {
  limitOffsetInput: LimitOffsetInput;
}


export interface QueryregistryArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryrelevantTemplatesListingArgs {
  limitOffsetInput?: InputMaybe<LimitOffsetInput>;
  searchInput: RelevantTemplatesListingSearchInput;
}


export interface QueryrequestArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryrequestSchemaArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryrequestTaskSchemaArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryrequestTemplateArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryrequestV2DefinitionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryrequestV2DefinitionsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryrequestV2SubmissionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryrequestV2SubmissionsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryrequestsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryresourceFeatureAssociationArgs {
  featureType: Scalars['StrictString']['input'];
  resourceId: Scalars['StrictString']['input'];
}


export interface QueryresultArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryresultBlobArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryresultBlobsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryresultSchemaArgs {
  id?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface QueryresultSchemaPublishedDataTableColumnsArgs {
  resultSchemaIds: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryresultsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryreviewArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryreviewLifecycleArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryreviewLifecycleStageArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryreviewLifecyclesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryreviewableArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryrunArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryrunSchemaArgs {
  id?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface QueryrunsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerysampleDefinitionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerysampleDefinitionsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerysampleTypeArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerysampleTypesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerysavedSearchArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerysavedSearchesForSectionArgs {
  section: SearchSection;
}


export interface QueryschemaArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryschemaFieldSelectorArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryschemaFieldSelectorOptionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryschemaFieldSelectorsArgs {
  includeArchived?: InputMaybe<Scalars['StrictBoolean']['input']>;
}


export interface QueryschemaInterfaceArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryschemaInterfaceListingArgs {
  paginationParameters?: InputMaybe<SequencePaginationParameters>;
}


export interface QueryschemaInterfacesArgs {
  organizationId?: InputMaybe<Scalars['StrictString']['input']>;
  schemaId?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface QueryschemaPolicyArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryschemaPolicyListingArgs {
  limitOffsetInput: LimitOffsetInput;
}


export interface QuerysearchableItemsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerysequenceArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerysequenceAlignmentsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerysequenceVersionsArgs {
  sequenceVersionSpecifiers: Array<SequenceVersionSpecifierInput>;
}


export interface QuerysequencesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerysignedFileArgs {
  addHtmlContentTypeHeader: Scalars['StrictBoolean']['input'];
  apiId: Scalars['StrictString']['input'];
  owningEntityApiId?: InputMaybe<Scalars['StrictString']['input']>;
  url: Scalars['StrictString']['input'];
  versionId?: InputMaybe<Scalars['StrictInt']['input']>;
}


export interface QuerysmilesChemicalStructureImageArgs {
  smiles: Scalars['StrictString']['input'];
}


export interface QueryspreadsheetColumnsMappingsArgs {
  assaySchemaId?: InputMaybe<Scalars['StrictString']['input']>;
  tagSchemaId?: InputMaybe<Scalars['StrictString']['input']>;
  uploadFlow?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface QuerystageEntriesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerystageEntryArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerystarrableItemsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerystorableArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerystorableSchemaArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerystorableSchemasArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerystorablesArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerystructuredTableArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerystudiesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerystudyArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerystudySampleTestPlanArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerystudySampleTestPlansArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerystudySchemaArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerystudyableItemArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerystudyableItemsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerysubtemplateArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerytagSchemaArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerytagSchemaChipsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerytagSchemasListingArgs {
  limitOffsetInput?: InputMaybe<LimitOffsetInput>;
  searchInput?: InputMaybe<TagSchemaListingSearchInput>;
}


export interface QueryteamArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerytemplateArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerytemplateCollectionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerytemplateCollectionListingArgs {
  archivePurposes?: InputMaybe<Array<InputMaybe<Scalars['StrictString']['input']>>>;
  limitOffsetInput?: InputMaybe<LimitOffsetInput>;
  onlySubtemplates?: InputMaybe<Scalars['StrictBoolean']['input']>;
  searchInput?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface QuerytemplateCollectionsArgs {
  limitOffsetInput?: InputMaybe<LimitOffsetInput>;
  onlySubtemplates?: InputMaybe<Scalars['StrictBoolean']['input']>;
  searchInput?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface QuerytemplateCollectionsByIdsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerytemplateCollectionsListingArgs {
  limitOffsetInput?: InputMaybe<LimitOffsetInput>;
  searchInput?: InputMaybe<TemplateCollectionListingSearchInput>;
}


export interface QuerytemplatesByIdsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QuerytestDefinitionArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerytestDefinitionsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerytestOrderArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerytestOrdersArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QuerytreatmentGroupArgs {
  id: Scalars['StrictString']['input'];
}


export interface QuerytreatmentGroupsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryunitArgs {
  id: Scalars['StrictString']['input'];
  versionNumber?: InputMaybe<Scalars['StrictInt']['input']>;
}


export interface QueryunitBySymbolArgs {
  symbol: Scalars['StrictString']['input'];
}


export interface QueryunitTypeArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryunitsArgs {
  ids: Array<Scalars['StrictString']['input']>;
  versionNumbers?: InputMaybe<Array<Scalars['StrictInt']['input']>>;
}


export interface QueryuserArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryusersArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryvalidationRuleArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryvalidationRulesArgs {
  ids: Array<Scalars['StrictString']['input']>;
}


export interface QueryvisualHistoryArgs {
  entityVersionId: EntityVersionIdInputNode;
}


export interface QuerywebhookResponseArgs {
  appDefId: Scalars['StrictString']['input'];
  messageId: Scalars['StrictString']['input'];
}


export interface QueryworkflowsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryworklistArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryworklistsArgs {
  ids: Array<InputMaybe<Scalars['StrictString']['input']>>;
}


export interface QueryworksheetArgs {
  id: Scalars['StrictString']['input'];
}


export interface QueryworksheetsArgs {
  ids: Array<Scalars['StrictString']['input']>;
}

export interface RecentWorklistListingNode {
  __typename: 'RecentWorklistListingNode';
  total: Scalars['StrictInt']['output'];
  worklists: Array<WorklistNode>;
}

export interface RecordInterface {
  allTagsJson: Scalars['JSONScalar']['output'];
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  origin: AssayRecordOriginNode;
  permissions: PermissionsNode;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
}

export interface RecordSchemaInterface {
  allFields: Array<SchemaFieldNode>;
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  fields: Array<SchemaFieldNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  hasData: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  organizationJson: Scalars['JSONScalar']['output'];
  publishedDataTableColumnsJson: Maybe<Scalars['JSONScalar']['output']>;
  relatedBenchlingApps: Array<BenchlingAppNode>;
  schemaType: LegacyAssaySchemaType;
  sqlIdentifier: Scalars['StrictString']['output'];
}


export interface RecordSchemaInterfaceallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export interface RegistrationOriginNode {
  __typename: 'RegistrationOriginNode';
  createdAt: Scalars['StrictString']['output'];
  originEntry: Maybe<OriginEntryNode>;
}

export interface RegistryFileNamePartNode {
  __typename: 'RegistryFileNamePartNode';
  datetimeFormat: Maybe<Scalars['StrictString']['output']>;
  fieldId: Maybe<Scalars['StrictString']['output']>;
  text: Maybe<Scalars['StrictString']['output']>;
  type: NameTemplatePartType;
}

export interface RegistryInput {
  customSyntaxName?: InputMaybe<Scalars['StrictString']['input']>;
  id: Scalars['StrictString']['input'];
}

export interface RegistryItemInterface {
  allChildEntities: Array<RegistryItemInterface>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  bioentityAliasInfos: Array<BioentityAliasInfoNode>;
  childEntities: Array<RegistryItemInterface>;
  convertedToItem: Maybe<RegistryItemInterface>;
  createdAt: Scalars['StrictString']['output'];
  displayLabel: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  hasExpirationTracking: Scalars['StrictBoolean']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  isTrialSample: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  linkedContainerContents: Array<ContainerContentNode>;
  matchingChildEntities: MatchingChildEntitiesNode;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  noteJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  projectFolder: Maybe<FolderNode>;
  registrationOrigin: Maybe<RegistrationOriginNode>;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  residues: Maybe<Scalars['StrictString']['output']>;
  schemaValidationStateJson: Maybe<Scalars['JSONScalar']['output']>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  testOrders: Array<TestOrderNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  validEntitiesForFieldPathInfo: Maybe<ValidEntitiesForFieldPathNode>;
}


export interface RegistryItemInterfacechildEntitiesArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface RegistryItemInterfacematchingChildEntitiesArgs {
  archivePurposes?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  childEntitySchemaId: Scalars['StrictString']['input'];
  limit?: InputMaybe<Scalars['StrictInt']['input']>;
  offset?: InputMaybe<Scalars['StrictInt']['input']>;
  queryString?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface RegistryItemInterfacetestOrdersArgs {
  statusIsOneOf?: InputMaybe<Array<TestOrderStatus>>;
}


export interface RegistryItemInterfacevalidEntitiesForFieldPathInfoArgs {
  fieldId: Scalars['StrictString']['input'];
}

export type RegistryItemOrInaccessibleInfoNode = BasicFolderItemNode | ComplexPolymerNode | EquipmentNode | InaccessibleInfoNode | MixtureNode | MoleculeNode | OligoConjugateNode | OligoDuplexNode | ProteinNode | SequenceNode;

export enum RegistryLabelingStrategy {
  DELETE_NAMES = 'DELETE_NAMES',
  IDS_FROM_NAMES = 'IDS_FROM_NAMES',
  KEEP_NAMES = 'KEEP_NAMES',
  NEW_IDS = 'NEW_IDS',
  REPLACE_ID_AND_NAME_FROM_PARTS = 'REPLACE_ID_AND_NAME_FROM_PARTS',
  REPLACE_NAMES_FROM_PARTS = 'REPLACE_NAMES_FROM_PARTS',
  SET_FROM_NAME_PARTS = 'SET_FROM_NAME_PARTS'
}

export interface RegistryNode extends HasArchiveRecordInterface, HasOptionalCreatorInterface, PoliceableInterface, SourceInterface {
  __typename: 'RegistryNode';
  alwaysShowAncestorFolderNames: Scalars['StrictBoolean']['output'];
  archiveRecord: Maybe<ArchiveRecordNode>;
  archived: Scalars['StrictBoolean']['output'];
  areSettingsAdminOnly: Scalars['StrictBoolean']['output'];
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creator: Maybe<PrincipalInterface>;
  /** @deprecated Use creator instead. */
  creatorJson: Maybe<Scalars['JSONScalar']['output']>;
  dataModsEnabled: Scalars['StrictBoolean']['output'];
  description: Maybe<Scalars['StrictString']['output']>;
  disablePersonalCollections: Scalars['StrictBoolean']['output'];
  hidden: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  locationSchemas: Array<LocationSchemaNode>;
  locked: Scalars['StrictBoolean']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  numBioentityValidationFailures: Scalars['StrictInt']['output'];
  numLocationValidationFailures: Scalars['StrictInt']['output'];
  organization: OrganizationNode;
  ownerInfoJson: Scalars['JSONScalar']['output'];
  ownerJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  public: Scalars['StrictBoolean']['output'];
  reviewSummaryJson: Maybe<Scalars['JSONScalar']['output']>;
  rootFolder: FolderNode;
  schemaFieldSelectors: Array<SchemaFieldSelectorNode>;
  sourceType: Scalars['StrictString']['output'];
  starred: Scalars['StrictBoolean']['output'];
  tagSchemas: Array<TagSchemaNode>;
  url: Scalars['StrictString']['output'];
  useStrictValidation: Scalars['StrictBoolean']['output'];
}

export type RegistryOrInaccessibleInfoNode = InaccessibleInfoNode | RegistryNode;

export enum RelationshipType {
  MANY_TO_MANY = 'MANY_TO_MANY',
  MANY_TO_ONE = 'MANY_TO_ONE',
  ONE_TO_MANY = 'ONE_TO_MANY',
  ONE_TO_ONE = 'ONE_TO_ONE',
  UNKNOWN = 'UNKNOWN'
}

export interface RelevantItemsNode {
  __typename: 'RelevantItemsNode';
  bulkAssembliesCreatingAsAmplifiedFragment: Array<BulkAssemblyNode>;
  bulkAssembliesCreatingAsConstruct: Array<BulkAssemblyNode>;
  bulkAssembliesUsingAsFragment: Array<BulkAssemblyNode>;
  filesMentioning: Array<FolderItemOrStageEntryNode>;
  processOutputs: Array<ProcessOutputNode>;
  processTasks: Array<ProcessTaskNode>;
  sequencesUsingAsPrimer: Array<SequenceUsingAsPrimerNode>;
  tagged: Array<FolderItemOrStageEntryNode>;
  workflows: Array<WorkflowRelevantItemNode>;
}

export interface RelevantTableNode {
  __typename: 'RelevantTableNode';
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export type RelevantTemplateClasses = SubtemplateNode | TemplateNode;

export interface RelevantTemplateNode {
  __typename: 'RelevantTemplateNode';
  id: Scalars['StrictString']['output'];
  relevantTables: Array<RelevantTableNode>;
  template: RelevantTemplateClasses;
}

export interface RelevantTemplatesListingNode {
  __typename: 'RelevantTemplatesListingNode';
  accessibleCollections: Array<TemplateCollectionNode>;
  relevantTemplates: Array<RelevantTemplateNode>;
  totalInaccessible: Scalars['StrictInt']['output'];
  totalPostFiltering: Scalars['StrictInt']['output'];
}

export interface RelevantTemplatesListingSearchInput {
  collectionIds?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  schemaId: Scalars['StrictString']['input'];
  searchTerm?: InputMaybe<Scalars['StrictString']['input']>;
}

export interface RequestFulfillmentNode {
  __typename: 'RequestFulfillmentNode';
  id: Scalars['StrictString']['output'];
  sampleGroup: Maybe<SampleGroupNode>;
  status: Scalars['StrictString']['output'];
  task: Maybe<RequestTaskNode>;
}

export interface RequestNode extends HasCreatorInterface, HasPermissionsInterface, SearchableInterface {
  __typename: 'RequestNode';
  assigneesJson: Scalars['JSONScalar']['output'];
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorJson: Scalars['JSONScalar']['output'];
  fulfillments: Array<RequestFulfillmentNode>;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  project: ProjectNode;
  requestStatus: RequestStatus;
  requestorJson: Maybe<Scalars['JSONScalar']['output']>;
  sampleGroups: Array<SampleGroupNode>;
  scheduledOn: Maybe<Scalars['StrictString']['output']>;
  schema: RequestSchemaNode;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  tasks: Array<RequestTaskNode>;
}

export type RequestOrInaccessibleInfoNode = InaccessibleInfoNode | RequestNode;

export interface RequestSchemaNode extends HasArchiveRecordInterface, PoliceableInterface, SchemaInterface {
  __typename: 'RequestSchemaNode';
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  fieldsJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  name: Scalars['StrictString']['output'];
  organizationJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  prefix: Scalars['StrictString']['output'];
  relatedBenchlingApps: Array<BenchlingAppNode>;
  requestTaskSchemas: Array<RequestTaskSchemaNode>;
  requestTemplates: Array<RequestTemplateNode>;
  sampleGroupSchema: Maybe<SampleGroupSchemaNode>;
  schemaType: LegacyAssaySchemaType;
  sqlIdentifier: Scalars['StrictString']['output'];
}


export interface RequestSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export type RequestSchemaOrInaccessibleInfoNode = InaccessibleInfoNode | RequestSchemaNode;

export enum RequestStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  REQUESTED = 'REQUESTED',
  SCHEDULED = 'SCHEDULED'
}

export interface RequestTaskNode {
  __typename: 'RequestTaskNode';
  id: Scalars['StrictString']['output'];
  request: RequestNode;
  sampleGroups: Array<SampleGroupNode>;
  schema: RequestTaskSchemaNode;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
}

export interface RequestTaskSchemaNode extends HasArchiveRecordInterface, SchemaInterface {
  __typename: 'RequestTaskSchemaNode';
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  organizationJson: Scalars['JSONScalar']['output'];
  relatedBenchlingApps: Array<BenchlingAppNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
}


export interface RequestTaskSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export type RequestTaskSchemaOrInaccessibleInfoNode = InaccessibleInfoNode | RequestTaskSchemaNode;

export interface RequestTaskTemplateNode {
  __typename: 'RequestTaskTemplateNode';
  autoAdd: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  schema: RequestTaskSchemaNode;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
}

export interface RequestTemplateNode {
  __typename: 'RequestTemplateNode';
  assigneesJson: Scalars['JSONScalar']['output'];
  defaultProject: Maybe<ProjectNode>;
  id: Scalars['StrictString']['output'];
  schema: RequestSchemaNode;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  taskTemplates: Array<RequestTaskTemplateNode>;
  templateSpecJson: Scalars['JSONScalar']['output'];
}

export type RequestTemplateOrInaccessibleInfoNode = InaccessibleInfoNode | RequestTemplateNode;

export interface RequestV2DefinitionNode extends CoreObjectArchivableInterface, HasCreatorInterface, HasPermissionsInterface, SearchableInterface, StarrableInterface, TemplateCollectibleInterface {
  __typename: 'RequestV2DefinitionNode';
  archiveData: ArchiveDataNode;
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorNode: CreatorInterface;
  description: Maybe<Scalars['StrictString']['output']>;
  editUrl: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  prefix: Scalars['StrictString']['output'];
  star: Maybe<StarNode>;
  templateCollection: TemplateCollectionNode;
  templateDocument: DocumentNode;
  workflowTaskSchema: ProcessTaskSchemaOrInaccessibleInfoNode;
}

export type RequestV2DefinitionOrInaccessibleInfoNode = InaccessibleInfoNode | RequestV2DefinitionNode;

export enum RequestV2StatusType {
  CANCELLED = 'CANCELLED',
  DISCARDED = 'DISCARDED',
  DRAFT = 'DRAFT',
  FULFILLED = 'FULFILLED',
  SENT = 'SENT'
}

export interface RequestV2SubmissionAssigneeNode {
  __typename: 'RequestV2SubmissionAssigneeNode';
  firstAssignees: Array<UserNode>;
  totalNumberOfAssignees: Scalars['StrictInt']['output'];
}

export type RequestV2SubmissionAssigneeOrInaccessibleInfoNode = InaccessibleInfoNode | RequestV2SubmissionAssigneeNode;

export interface RequestV2SubmissionNode extends BaseFolderItemInterface, CoreObjectArchivableInterface, HasAuthorsInterface, HasDisplayIdInterface, HasPermissionsInterface, SearchableInterface, StudyableInterface {
  __typename: 'RequestV2SubmissionNode';
  archiveData: ArchiveDataNode;
  archiveRecord: Maybe<ArchiveRecordNode>;
  assignees: RequestV2SubmissionAssigneeOrInaccessibleInfoNode;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creator: CreatorInterface;
  definition: RequestV2DefinitionOrInaccessibleInfoNode;
  displayId: Maybe<Scalars['StrictString']['output']>;
  document: DocumentNode;
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  id: Scalars['StrictString']['output'];
  isAsyncWorkInProgress: Scalars['StrictBoolean']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  status: RequestV2StatusType;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  watchers: Array<UserNode>;
  workflowTaskGroup: Maybe<ProcessOrInaccessibleInfoNode>;
}

export type RequestV2SubmissionOrInaccessibleInfoNode = InaccessibleInfoNode | RequestV2SubmissionNode;

export interface ResolvedAttachmentNode {
  __typename: 'ResolvedAttachmentNode';
  chemicalStructureImage: Maybe<SVGOrErrorNode>;
  connectionsInvolved: Array<ComplexPolymerConnectionNode>;
  displayName: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  molfile: Scalars['StrictString']['output'];
  polymers: Array<SimplePolymerNode>;
}

export interface ResourceFeatureAssociationAppSummaryNode {
  __typename: 'ResourceFeatureAssociationAppSummaryNode';
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export interface ResourceFeatureAssociationNode {
  __typename: 'ResourceFeatureAssociationNode';
  appSummary: ResourceFeatureAssociationAppSummaryNode;
  featureId: Scalars['StrictInt']['output'];
  resourceId: Scalars['StrictString']['output'];
}

export type ResourceFeatureAssociationOrInaccessibleInfoNode = InaccessibleInfoNode | ResourceFeatureAssociationNode;

export interface RestrictedFolderListingNode {
  __typename: 'RestrictedFolderListingNode';
  folders: Array<InaccessibleInfoNode>;
  total: Scalars['StrictInt']['output'];
}

export interface RestrictedResourceNode {
  __typename: 'RestrictedResourceNode';
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  type: Scalars['StrictString']['output'];
}

export type RestrictedResourceOrInaccessibleInfoNode = InaccessibleInfoNode | RestrictedResourceNode;

export interface ResultBlobNode {
  __typename: 'ResultBlobNode';
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  pdfPreviewFileJson: Maybe<Scalars['JSONScalar']['output']>;
  previewFileJson: Maybe<Scalars['JSONScalar']['output']>;
  uploadStatus: Maybe<Scalars['StrictString']['output']>;
  url: Scalars['StrictString']['output'];
}

export type ResultBlobOrInaccessibleInfoNode = InaccessibleInfoNode | ResultBlobNode;

export interface ResultListingNode {
  __typename: 'ResultListingNode';
  resultCountBySchemaId: Maybe<Scalars['JSONScalar']['output']>;
  results: Array<ResultNode>;
  total: Scalars['StrictInt']['output'];
}

export interface ResultNode extends HasArchiveRecordInterface, HasCreatorInterface, RecordInterface {
  __typename: 'ResultNode';
  allTagsJson: Scalars['JSONScalar']['output'];
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  origin: AssayRecordOriginNode;
  permissions: PermissionsNode;
  schema: Maybe<ResultSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
}

export type ResultOrInaccessibleInfoNode = InaccessibleInfoNode | ResultNode;

export interface ResultSchemaNode extends HasArchiveRecordInterface, PoliceableInterface, RecordSchemaInterface, SchemaInterface {
  __typename: 'ResultSchemaNode';
  allFields: Array<SchemaFieldNode>;
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  derivedParent: Maybe<ResultSchemaNode>;
  fields: Array<SchemaFieldNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  hasData: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  name: Scalars['StrictString']['output'];
  organizationJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  publishedDataTableColumnsJson: Maybe<Scalars['JSONScalar']['output']>;
  relatedBenchlingApps: Array<BenchlingAppNode>;
  schemaType: LegacyAssaySchemaType;
  spreadsheetColumnsMappings: Array<SpreadsheetColumnsMappingNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
}


export interface ResultSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export type ResultSchemaOrInaccessibleInfoNode = InaccessibleInfoNode | ResultSchemaNode;

export enum ReviewAction {
  ACCEPT = 'ACCEPT',
  COMMENT = 'COMMENT',
  REJECT = 'REJECT',
  RETRACT = 'RETRACT',
  SEND_FOR_REVIEW = 'SEND_FOR_REVIEW'
}

export interface ReviewChangeNode {
  __typename: 'ReviewChangeNode';
  action: Maybe<ReviewAction>;
  createdAt: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  message: Maybe<Scalars['StrictString']['output']>;
  newStage: Maybe<ReviewLifecycleStageNode>;
  newStatus: Maybe<ReviewStatus>;
  previousStage: Maybe<ReviewLifecycleStageNode>;
  reviewLifecycleVersion: Maybe<ReviewLifecycleVersionNode>;
  signature: Maybe<SignatureNode>;
  user: UserNode;
  wasEsigned: Maybe<Scalars['StrictBoolean']['output']>;
}

export enum ReviewLifecycleActionType {
  ACCEPT = 'ACCEPT',
  APPROVE = 'APPROVE',
  COMPLETE = 'COMPLETE',
  REVIEW = 'REVIEW',
  SELF_REVIEW = 'SELF_REVIEW',
  WITNESS = 'WITNESS'
}

export interface ReviewLifecycleNode {
  __typename: 'ReviewLifecycleNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  currentVersion: ReviewLifecycleVersionNode;
  id: Scalars['StrictString']['output'];
  numProjectsUsingReviewLifecycle: Scalars['StrictInt']['output'];
  organization: OrganizationNode;
}

export type ReviewLifecycleOrInaccessibleInfoNode = InaccessibleInfoNode | ReviewLifecycleNode;

export interface ReviewLifecycleStageNode {
  __typename: 'ReviewLifecycleStageNode';
  action: ReviewLifecycleActionType;
  description: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  isTeamReassignable: Maybe<Scalars['StrictBoolean']['output']>;
  name: Scalars['StrictString']['output'];
  reviewerType: ReviewerType;
  selectedTeam: Maybe<TeamNode>;
  sequentialPositionIndex: Maybe<Scalars['StrictInt']['output']>;
}

export type ReviewLifecycleStageOrInaccessibleInfoNode = InaccessibleInfoNode | ReviewLifecycleStageNode;

export enum ReviewLifecycleTerminalState {
  ACCEPTED = 'ACCEPTED',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  REVIEWED = 'REVIEWED',
  SELF_REVIEWED = 'SELF_REVIEWED',
  WITNESSED = 'WITNESSED'
}

export enum ReviewLifecycleType {
  PARALLEL = 'PARALLEL',
  SELF_REVIEW = 'SELF_REVIEW',
  SEQUENTIAL = 'SEQUENTIAL'
}

export interface ReviewLifecycleVersionNode {
  __typename: 'ReviewLifecycleVersionNode';
  id: Scalars['StrictInt']['output'];
  lifecycleType: ReviewLifecycleType;
  name: Scalars['StrictString']['output'];
  reviewLifecycle: ReviewLifecycleNode;
  reviewStages: Array<ReviewLifecycleStageNode>;
  terminalState: ReviewLifecycleTerminalState;
}

export interface ReviewNode extends HasAuthorsInterface {
  __typename: 'ReviewNode';
  activeReviewLifecycleVersion: Maybe<ReviewLifecycleVersionNode>;
  auditorsJson: Array<Scalars['JSONScalar']['output']>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  history: Maybe<Array<Maybe<Scalars['JSONScalar']['output']>>>;
  id: Scalars['StrictString']['output'];
  lastUsedReviewLifecycleVersion: Maybe<ReviewLifecycleVersionNode>;
  reviewChanges: Array<ReviewChangeNode>;
  /** @deprecated Use active_review_lifecycle_version instead */
  reviewLifecycle: Maybe<ReviewLifecycleNode>;
  /** @deprecated Use active_review_lifecycle_version instead */
  reviewLifecycleVersion: Maybe<ReviewLifecycleVersionNode>;
  reviewSender: Maybe<UserNode>;
  reviewers: Maybe<Array<ReviewerNode>>;
  status: ReviewStatus;
}

export type ReviewOrInaccessibleInfoNode = InaccessibleInfoNode | ReviewNode;

export enum ReviewStatus {
  ACCEPTANCE_SNAPSHOT_IN_PROGRESS = 'ACCEPTANCE_SNAPSHOT_IN_PROGRESS',
  ACCEPTED = 'ACCEPTED',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  REJECTED = 'REJECTED',
  RETRACTED = 'RETRACTED',
  REVIEW_SNAPSHOT_IN_PROGRESS = 'REVIEW_SNAPSHOT_IN_PROGRESS'
}

export interface ReviewableInterface {
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  parentReviewLifecycles: Array<ReviewLifecycleNode>;
  review: Maybe<ReviewNode>;
  reviewSource: ProjectNode;
  /** @deprecated Use permissions from HasPermissionsInterface instead. */
  userPermissionsJson: Scalars['JSONScalar']['output'];
}

export type ReviewableOrInaccessibleInfoNode = EntryNode | InaccessibleInfoNode | TrialSampleTestingStudyDesignNode | WorksheetNode;

export interface ReviewerNode {
  __typename: 'ReviewerNode';
  id: Scalars['StrictString']['output'];
  isTeamReassignable: Scalars['StrictBoolean']['output'];
  isUserValidReviewer: Scalars['StrictBoolean']['output'];
  reviewStage: ReviewLifecycleStageNode;
  reviewStatus: ReviewerStatus;
  updatedAt: Maybe<Scalars['StrictString']['output']>;
  user: Maybe<UserNode>;
}

export enum ReviewerStatus {
  BLOCKED = 'BLOCKED',
  FINISHED = 'FINISHED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export enum ReviewerType {
  AUTHOR = 'AUTHOR',
  PROJECT_MEMBERS = 'PROJECT_MEMBERS',
  TEAM = 'TEAM'
}

export interface RunNode extends HasArchiveRecordInterface, HasCreatorInterface, RecordInterface, SearchableInterface {
  __typename: 'RunNode';
  allTagsJson: Scalars['JSONScalar']['output'];
  apiId: Scalars['StrictString']['output'];
  archiveRecord: Maybe<ArchiveRecordNode>;
  automationErrorFiles: Array<AutomationErrorFileNode>;
  automationInputFiles: Array<AutomationInputFileNode>;
  automationOutputFiles: Array<AutomationOutputFileNode>;
  connection: Maybe<ConnectionNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorJson: Scalars['JSONScalar']['output'];
  equipment: Maybe<EquipmentNode>;
  id: Scalars['StrictString']['output'];
  isInEntry: Scalars['StrictBoolean']['output'];
  linkedResults: ResultListingNode;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  origin: AssayRecordOriginNode;
  permissions: PermissionsNode;
  schema: RunSchemaNode;
  shouldRecordEquipment: Scalars['StrictBoolean']['output'];
  studyIds: Array<Scalars['StrictString']['output']>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
}


export interface RunNodelinkedResultsArgs {
  limitOffsetInput: LimitOffsetInput;
}

export type RunOrInaccessibleInfoNode = InaccessibleInfoNode | RunNode;

export interface RunSchemaNode extends HasArchiveRecordInterface, PoliceableInterface, RecordSchemaInterface, SchemaInterface {
  __typename: 'RunSchemaNode';
  allFields: Array<SchemaFieldNode>;
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  allowCreateRunFromNlad: Scalars['StrictBoolean']['output'];
  allowInsertRunFromInbox: Scalars['StrictBoolean']['output'];
  archiveRecord: Maybe<ArchiveRecordNode>;
  automationInputFileConfigsJson: Maybe<Scalars['JSONScalar']['output']>;
  automationOutputFileConfigsJson: Maybe<Scalars['JSONScalar']['output']>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  connectionSchema: Maybe<ConnectionSchemaNode>;
  derivedParent: Maybe<RunSchemaNode>;
  fields: Array<SchemaFieldNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  hasData: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  name: Scalars['StrictString']['output'];
  organizationJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  publishedDataTableColumnsJson: Maybe<Scalars['JSONScalar']['output']>;
  relatedBenchlingApps: Array<BenchlingAppNode>;
  /** @deprecated Prefer automation_input_file_configs_json */
  robotInstructionsConfigJson: Maybe<Scalars['JSONScalar']['output']>;
  schemaType: LegacyAssaySchemaType;
  shouldRecordEquipment: Scalars['StrictBoolean']['output'];
  sqlIdentifier: Scalars['StrictString']['output'];
}


export interface RunSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export type RunSchemaOrInaccessibleInfoNode = InaccessibleInfoNode | RunSchemaNode;

export interface S3ExternalFileNode {
  __typename: 'S3ExternalFileNode';
  guessedMimeType: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  presignedUrl: Scalars['StrictString']['output'];
}

export interface SAMLAuthnOptionNode extends AuthnOptionNodeInterface {
  __typename: 'SAMLAuthnOptionNode';
  domains: Array<Scalars['StrictString']['output']>;
  enabled: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  logoUrl: Maybe<Scalars['StrictString']['output']>;
  metadataUrl: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export enum SIName {
  METER = 'METER',
  MOLE = 'MOLE',
  SECOND = 'SECOND'
}

export interface SVGNode {
  __typename: 'SVGNode';
  base64Svg: Scalars['StrictString']['output'];
}

export type SVGOrErrorNode = ErrorNode | SVGNode;

export interface SampleDefinitionLinkNode {
  __typename: 'SampleDefinitionLinkNode';
  sampleDefinition: Maybe<SampleDefinitionOrInaccessibleInfoNode>;
  study: StudyOrInaccessibleInfoNode;
}

export interface SampleDefinitionNode extends SearchableInterface {
  __typename: 'SampleDefinitionNode';
  allowsNewSubjects: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  isReadyForExecution: Scalars['StrictBoolean']['output'];
  label: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  sampleType: SampleTypeNode;
  studyDesign: TrialSampleTestingStudyDesignNode;
  treatmentGroup: TreatmentGroupNode;
  visit: Scalars['StrictString']['output'];
}

export type SampleDefinitionOrInaccessibleInfoNode = InaccessibleInfoNode | SampleDefinitionNode;

export interface SampleDefinitionSummaryNode {
  __typename: 'SampleDefinitionSummaryNode';
  discrepancyCount: Scalars['StrictInt']['output'];
  receivedCount: Scalars['StrictInt']['output'];
  sampleDefinition: SampleDefinitionNode;
  testOrderSummaries: Array<TestOrderSummaryNode>;
}

export interface SampleGroupNode {
  __typename: 'SampleGroupNode';
  id: Scalars['StrictString']['output'];
  samples: Array<ExecutionSampleNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
}

export interface SampleGroupSchemaNode extends SchemaInterface {
  __typename: 'SampleGroupSchemaNode';
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  relatedBenchlingApps: Array<BenchlingAppNode>;
}


export interface SampleGroupSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export enum SampleRestrictionStatus {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  RESTRICTED = 'RESTRICTED',
  UNRESTRICTED = 'UNRESTRICTED'
}

export type SampleRolePartyNode = BenchlingAppNode | TeamNode | UserNode;

export interface SampleRolesNode {
  __typename: 'SampleRolesNode';
  /** @deprecated Deprecated in favor of restrictedSampleUsers */
  authorizedUsers: Array<SampleRolePartyNode>;
  id: Scalars['StrictString']['output'];
  /** @deprecated Deprecated in favor of isCurrentUserRestrictedSampleUser */
  isCurrentUserAuthorized: Scalars['StrictBoolean']['output'];
  isCurrentUserRestrictedSampleUser: Scalars['StrictBoolean']['output'];
  isCurrentUserSampleOwner: Scalars['StrictBoolean']['output'];
  restrictedSampleUsers: Array<SampleRolePartyNode>;
  sampleOwners: Array<SampleRolePartyNode>;
}

export interface SampleSummaryNode {
  __typename: 'SampleSummaryNode';
  sampleDefinitionSummaries: Array<SampleDefinitionSummaryNode>;
  uncategorizedSampleDefinitionSummary: Maybe<UncategorizedSampleDefinitionSummaryNode>;
}

export interface SampleTypeNode extends CoreObjectArchivableInterface, HasPermissionsInterface {
  __typename: 'SampleTypeNode';
  archiveData: ArchiveDataNode;
  createdAt: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  label: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
}

export type SampleTypeOrInaccessibleInfoNode = InaccessibleInfoNode | SampleTypeNode;

export interface SavedSearchDataPoliciesNode {
  __typename: 'SavedSearchDataPoliciesNode';
  adminPolicy: DataPolicyOrInaccessibleInfoNode_;
  editPolicy: DataPolicyOrInaccessibleInfoNode_;
  readPolicy: DataPolicyOrInaccessibleInfoNode_;
}

export interface SavedSearchNode extends HasCreatorInterface, OwnableInterface {
  __typename: 'SavedSearchNode';
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  description: Scalars['StrictString']['output'];
  hasAccessToFiltersAndSection: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  lastUsed: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  ownerInfoJson: Scalars['JSONScalar']['output'];
  ownerJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  searchParams: SavedSearchParamsNode;
  section: SearchSection;
  unauthorizedCollaborators: Array<SavedSearchUnauthorizedCollaboratorNode>;
}


export interface SavedSearchNodeunauthorizedCollaboratorsArgs {
  collaboratorIds: Array<InputMaybe<Scalars['StrictString']['input']>>;
}

export type SavedSearchOrInaccessibleInfoNode = InaccessibleInfoNode | SavedSearchNode;

export interface SavedSearchParamsNode {
  __typename: 'SavedSearchParamsNode';
  filtersJson: Scalars['JSONScalar']['output'];
  groupField: Maybe<Scalars['StrictString']['output']>;
  query: Scalars['StrictString']['output'];
  sorts: Maybe<Array<SavedSearchSortNode>>;
}

export interface SavedSearchSortNode {
  __typename: 'SavedSearchSortNode';
  key: Scalars['StrictString']['output'];
  reverse: Scalars['StrictBoolean']['output'];
}

export interface SavedSearchUnauthorizedCollaboratorNode {
  __typename: 'SavedSearchUnauthorizedCollaboratorNode';
  apiId: Scalars['StrictString']['output'];
  role: Maybe<Scalars['StrictInt']['output']>;
}

export interface SchemaFieldNode {
  __typename: 'SchemaFieldNode';
  activeMigrationFieldStatus: FieldMigrationStatus;
  apiId: Scalars['StrictString']['output'];
  appliedFieldset: Maybe<SchemaInterfaceNode>;
  childEntityLinkConfig: Maybe<ChildEntityLinkConfigNode>;
  dependencyStrings: Array<Scalars['StrictString']['output']>;
  dependentsSummaries: Array<Scalars['StrictString']['output']>;
  displayName: Scalars['StrictString']['output'];
  fieldType: Scalars['StrictString']['output'];
  formulaDescription: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictInt']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  isParentLink: Scalars['StrictBoolean']['output'];
  isRequired: Scalars['StrictBoolean']['output'];
  /** @deprecated Use display or system name instead */
  name: Scalars['StrictString']['output'];
  numFieldValues: Scalars['StrictInt']['output'];
  numMigratedFieldValues: Maybe<Scalars['StrictInt']['output']>;
  relatedBenchlingApps: Array<BenchlingAppNode>;
  requiredLinkJson: Maybe<Scalars['JSONScalar']['output']>;
  schemaFieldSelectorId: Maybe<Scalars['StrictString']['output']>;
  systemName: Scalars['StrictString']['output'];
}

export type SchemaFieldOrInaccessibleInfoNode = InaccessibleInfoNode | SchemaFieldNode;

export interface SchemaFieldSelectorNode extends HasArchiveRecordInterface {
  __typename: 'SchemaFieldSelectorNode';
  allSchemaFieldSelectorOptions: Array<SchemaFieldSelectorOptionNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  registry: RegistryNode;
  relatedSchemasAndInterfaces: Array<SchemaOrInterfaceOrInaccessibleInfoNode>;
  schemaFieldSelectorOptions: Array<SchemaFieldSelectorOptionNode>;
}

export interface SchemaFieldSelectorOptionNode extends HasArchiveRecordInterface {
  __typename: 'SchemaFieldSelectorOptionNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  schemaFieldSelector: SchemaFieldSelectorNode;
}

export type SchemaFieldSelectorOptionOrInaccessibleInfoNode = InaccessibleInfoNode | SchemaFieldSelectorOptionNode;

export type SchemaFieldSelectorOrInaccessibleInfoNode = InaccessibleInfoNode | SchemaFieldSelectorNode;

export interface SchemaInterface {
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  relatedBenchlingApps: Array<BenchlingAppNode>;
}


export interface SchemaInterfaceallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export interface SchemaInterfaceBaseBioentityTypeNode {
  __typename: 'SchemaInterfaceBaseBioentityTypeNode';
  folderItemType: Scalars['StrictString']['output'];
  sequenceType: Maybe<Scalars['StrictString']['output']>;
}

export interface SchemaInterfaceFieldNode {
  __typename: 'SchemaInterfaceFieldNode';
  apiId: Scalars['StrictString']['output'];
  displayName: Scalars['StrictString']['output'];
  fieldType: Scalars['StrictString']['output'];
  id: Scalars['StrictInt']['output'];
  isComputed: Scalars['StrictBoolean']['output'];
  isMulti: Scalars['StrictBoolean']['output'];
  isRequired: Scalars['StrictBoolean']['output'];
  requiredLinkJson: Maybe<Scalars['JSONScalar']['output']>;
  schemaFieldSelectorId: Maybe<Scalars['StrictString']['output']>;
  systemName: Scalars['StrictString']['output'];
  tooltipText: Maybe<Scalars['StrictString']['output']>;
}

export interface SchemaInterfaceListingNode {
  __typename: 'SchemaInterfaceListingNode';
  lastSeenApiId: Maybe<Scalars['StrictString']['output']>;
  schemaInterfaces: Array<SchemaInterfaceNode>;
}

export interface SchemaInterfaceNode extends BaseSchemaInterfaceInterface, HasArchiveRecordInterface, HasNameTemplatesInterface, PoliceableInterface {
  __typename: 'SchemaInterfaceNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  baseBioentityType: Maybe<SchemaInterfaceBaseBioentityTypeNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  constraint: Maybe<TagSchemaConstraintNode>;
  createdAt: Scalars['StrictString']['output'];
  fields: Array<SchemaInterfaceFieldNode>;
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  labelingStrategies: Array<RegistryLabelingStrategy>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  nameTemplates: Array<NameTemplateNode>;
  organization: OrganizationNode;
  permissions: PermissionsNode;
  prefix: Scalars['StrictString']['output'];
  schemas: Array<TagSchemaNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
}

export type SchemaInterfaceOrInaccessibleInfoNode = InaccessibleInfoNode | SchemaInterfaceNode;

export interface SchemaLinkFieldDefinitionNode extends CoreObjectArchivableInterface, FieldDefinitionInterface, HasCreatorInterface, HasPermissionsInterface {
  __typename: 'SchemaLinkFieldDefinitionNode';
  archiveData: ArchiveDataNode;
  creator: PrincipalInterface;
  folderItemType: Maybe<SchemaLinkFolderItemType>;
  id: Scalars['StrictString']['output'];
  interface: Maybe<SchemaInterfaceOrInaccessibleInfoNode>;
  isMulti: Scalars['StrictBoolean']['output'];
  isRequired: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  provenanceUri: Scalars['StrictString']['output'];
  schema: Maybe<SchemaOrInaccessibleInfoNode>;
  shortDescription: Maybe<Scalars['StrictString']['output']>;
  systemName: Scalars['StrictString']['output'];
  type: FieldDefinitionType;
}

export enum SchemaLinkFolderItemType {
  BASIC_FOLDER_ITEM = 'BASIC_FOLDER_ITEM',
  MIXTURE = 'MIXTURE',
  MOLECULE = 'MOLECULE',
  PROTEIN = 'PROTEIN',
  SEQUENCE = 'SEQUENCE'
}

export type SchemaOrInaccessibleInfoNode = BatchSchemaNode | BoxSchemaNode | ConnectionSchemaNode | ContainerSchemaNode | InaccessibleInfoNode | LocationSchemaNode | PlateSchemaNode | ProcessOutputSchemaNode | ProcessTaskSchemaNode | RequestSchemaNode | RequestTaskSchemaNode | ResultSchemaNode | RunSchemaNode | SampleGroupSchemaNode | StudySchemaNode | TagSchemaNode;

export type SchemaOrInterfaceOrInaccessibleInfoNode = BatchSchemaNode | BoxSchemaNode | ConnectionSchemaNode | ContainerSchemaNode | InaccessibleInfoNode | LocationSchemaNode | PlateSchemaNode | ProcessOutputSchemaNode | ProcessTaskSchemaNode | RequestSchemaNode | RequestTaskSchemaNode | ResultSchemaNode | RunSchemaNode | SampleGroupSchemaNode | SchemaInterfaceNode | StudySchemaNode | TagSchemaNode;

export interface SchemaPolicyListingNode {
  __typename: 'SchemaPolicyListingNode';
  schemaPolicies: Array<SchemaPolicyNode>;
  total: Scalars['StrictInt']['output'];
}

export interface SchemaPolicyNode extends HasPermissionsInterface, PolicyInterface {
  __typename: 'SchemaPolicyNode';
  id: Scalars['StrictString']['output'];
  isDefault: Scalars['StrictBoolean']['output'];
  isHidden: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  policyStatements: Array<PolicyStatementNode>;
}

export type SchemaPolicyOrInaccessibleInfoNode = InaccessibleInfoNode | SchemaPolicyNode;

export interface ScratchFileNode extends HasCreatorInterface {
  __typename: 'ScratchFileNode';
  creator: PrincipalInterface;
  downloadUrl: Maybe<Scalars['StrictString']['output']>;
  externalFileId: Maybe<Scalars['StrictString']['output']>;
  filename: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  mimeType: Maybe<Scalars['StrictString']['output']>;
  name: Scalars['StrictString']['output'];
  size: Maybe<Scalars['StrictInt']['output']>;
  uploadStatus: Scalars['StrictString']['output'];
}

export type ScratchFileOrInaccessibleInfoNode = InaccessibleInfoNode | ScratchFileNode;

export enum SearchSection {
  ANALYTICS = 'ANALYTICS',
  CONNECTIONS = 'CONNECTIONS',
  GLOBAL = 'GLOBAL',
  JELLYFISH = 'JELLYFISH',
  LIBRARY = 'LIBRARY',
  PROCESSES = 'PROCESSES',
  PROJECT_ITEMS = 'PROJECT_ITEMS',
  REGISTRIES = 'REGISTRIES',
  REQUESTS = 'REQUESTS',
  REQUESTS_V2 = 'REQUESTS_V2',
  STORAGE = 'STORAGE',
  STUDIES = 'STUDIES'
}

export interface SearchableInterface {
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export type SearchableInterfaceOrInaccessibleInfoNode = AnalysisNode | AnalysisTemplateNode | AnalyticsDashboardNode | BasicFolderItemNode | BenchlingAppNode | BoxNode | BulkAssemblyNode | ComplexPolymerNode | ConnectionNode | ContainerNode | DatasetNode | EntryNode | EquipmentNode | FileNode | FolderNode | FormDefinitionNode | InaccessibleInfoNode | JellyfishNode | LocationNode | MixtureNode | MoleculeNode | OligoConjugateNode | OligoDuplexNode | OrganizationNode | PlateNode | ProcedureNode | ProcessNode | ProcessOutputNode | ProcessTaskNode | ProteinAlignmentNode | ProteinNode | ProtocolNode | RequestNode | RequestV2DefinitionNode | RequestV2SubmissionNode | RunNode | SampleDefinitionNode | SequenceAnalysisNode | SequenceNode | StageEntryNode | StudyNode | SubtemplateNode | TeamNode | TemplateCollectionNode | TemplateNode | TestDefinitionNode | TestOrderNode | TreatmentGroupNode | UserNode | WorkflowNode | WorklistNode | WorksheetNode;

export interface SequenceAnalysisNode extends SearchableInterface {
  __typename: 'SequenceAnalysisNode';
  attachedFileCount: Scalars['StrictInt']['output'];
  createdAt: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  sequence: SequenceNode;
}

export type SequenceAnalysisOrInaccessibleInfoNode = InaccessibleInfoNode | SequenceAnalysisNode;

export enum SequenceFeature {
  ANNOTATIONS = 'ANNOTATIONS',
  CHEMICAL_MODIFICATIONS = 'CHEMICAL_MODIFICATIONS',
  PARTS = 'PARTS',
  PRIMERS = 'PRIMERS',
  TRANSLATIONS = 'TRANSLATIONS'
}

export interface SequenceNode extends FolderItemInterface, HasCreatorInterface, PoliceableInterface, RegistryItemInterface, SearchableInterface, StudyableInterface, WorklistItemInterface {
  __typename: 'SequenceNode';
  allChildEntities: Array<RegistryItemInterface>;
  analysesJson: Scalars['JSONScalar']['output'];
  annotationsJson: Scalars['JSONScalar']['output'];
  archiveRecord: Maybe<ArchiveRecordNode>;
  assemblyJson: Maybe<Scalars['JSONScalar']['output']>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  bases: Scalars['StrictString']['output'];
  basesIfShowResidues: Maybe<Scalars['StrictString']['output']>;
  bioentityAliasInfos: Array<BioentityAliasInfoNode>;
  childEntities: Array<RegistryItemInterface>;
  circular: Scalars['StrictBoolean']['output'];
  clonedFrom: Maybe<SequenceOrInaccessibleInfoNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  color: Scalars['StrictString']['output'];
  convertedToItem: Maybe<RegistryItemInterface>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  customSyntaxString: Maybe<Scalars['StrictString']['output']>;
  displayLabel: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  existingFeatures: Array<SequenceFeature>;
  experimentalCurrentVersion: SequenceVersionNode;
  finalized: Scalars['StrictBoolean']['output'];
  folder: FolderNode;
  fragmentResultsJson: Scalars['JSONScalar']['output'];
  hasExpirationTracking: Scalars['StrictBoolean']['output'];
  hasSnapshot: Scalars['StrictBoolean']['output'];
  helmString: Maybe<Scalars['StrictString']['output']>;
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  idtString: Maybe<Scalars['StrictString']['output']>;
  inheritedCollaborations: Array<CollaborationNode>;
  isContainedInComplexPolymer: Scalars['StrictBoolean']['output'];
  isContainedInComplexPolymerData: IsContainedInComplexPolymerDataNode;
  isStudyable: Scalars['StrictBoolean']['output'];
  isTrialSample: Scalars['StrictBoolean']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  latestVersionId: Maybe<Scalars['StrictInt']['output']>;
  length: Scalars['StrictInt']['output'];
  linkedContainerContents: Array<ContainerContentNode>;
  locked: Scalars['StrictBoolean']['output'];
  matchingChildEntities: MatchingChildEntitiesNode;
  modifiedAt: Scalars['StrictString']['output'];
  modifiedNucleotides: Array<ModifiedNucleotideNode>;
  name: Scalars['StrictString']['output'];
  noteJson: Scalars['JSONScalar']['output'];
  nucleotideType: NucleotideType;
  parentJson: Maybe<Scalars['JSONScalar']['output']>;
  partContainerCount: Scalars['StrictInt']['output'];
  partsJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  primerPairsJson: Scalars['JSONScalar']['output'];
  projectFolder: Maybe<FolderNode>;
  registrationOrigin: Maybe<RegistrationOriginNode>;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  residues: Maybe<Scalars['StrictString']['output']>;
  schemaValidationStateJson: Maybe<Scalars['JSONScalar']['output']>;
  sequencePrimersJson: Scalars['JSONScalar']['output'];
  sequenceType: SequenceType;
  snapshotUrl: Scalars['StrictString']['output'];
  startIndex: Scalars['StrictInt']['output'];
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  testOrders: Array<TestOrderNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  transcriptionContainerCount: Scalars['StrictInt']['output'];
  transcriptionMatches: Array<TranscriptionMatchNode>;
  translationGroupsJson: Scalars['JSONScalar']['output'];
  translationsJson: Scalars['JSONScalar']['output'];
  validEntitiesForFieldPathInfo: Maybe<ValidEntitiesForFieldPathNode>;
  version: SequenceVersionOrInaccessibleInfoNode;
  versionsJson: Scalars['JSONScalar']['output'];
}


export interface SequenceNodechildEntitiesArgs {
  schemaId: Scalars['StrictString']['input'];
}


export interface SequenceNodecustomSyntaxStringArgs {
  syntaxName?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface SequenceNodematchingChildEntitiesArgs {
  archivePurposes?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  childEntitySchemaId: Scalars['StrictString']['input'];
  limit?: InputMaybe<Scalars['StrictInt']['input']>;
  offset?: InputMaybe<Scalars['StrictInt']['input']>;
  queryString?: InputMaybe<Scalars['StrictString']['input']>;
}


export interface SequenceNodetestOrdersArgs {
  statusIsOneOf?: InputMaybe<Array<TestOrderStatus>>;
}


export interface SequenceNodevalidEntitiesForFieldPathInfoArgs {
  fieldId: Scalars['StrictString']['input'];
}


export interface SequenceNodeversionArgs {
  dbId?: InputMaybe<Scalars['StrictInt']['input']>;
}

export type SequenceOrInaccessibleInfoNode = InaccessibleInfoNode | SequenceNode;

export interface SequencePaginationParameters {
  lastSeenApiId?: InputMaybe<Scalars['StrictString']['input']>;
  limit: Scalars['StrictInt']['input'];
}

export enum SequenceType {
  ds = 'ds',
  oligo = 'oligo',
  ss = 'ss'
}

export interface SequenceUsingAsPrimerNode {
  __typename: 'SequenceUsingAsPrimerNode';
  bindPosition: Scalars['StrictInt']['output'];
  bindStrand: Scalars['StrictInt']['output'];
  id: Scalars['StrictString']['output'];
  primerId: Scalars['StrictInt']['output'];
  sequence: SequenceNode;
}

export interface SequenceVersionNode {
  __typename: 'SequenceVersionNode';
  annotationsJson: Scalars['JSONScalar']['output'];
  bases: Scalars['StrictString']['output'];
  circular: Scalars['StrictBoolean']['output'];
  dbId: Scalars['StrictInt']['output'];
  modifiedNucleotidesJson: Scalars['JSONScalar']['output'];
  partsJson: Scalars['JSONScalar']['output'];
  primerPairsJson: Scalars['JSONScalar']['output'];
  sequence: SequenceNode;
  sequencePrimersJson: Scalars['JSONScalar']['output'];
  startIndex: Scalars['StrictInt']['output'];
  translationGroupsJson: Scalars['JSONScalar']['output'];
  translationsJson: Scalars['JSONScalar']['output'];
}

export type SequenceVersionOrInaccessibleInfoNode = InaccessibleInfoNode | SequenceVersionNode;

export interface SequenceVersionSpecifierInput {
  sequenceId: Scalars['StrictString']['input'];
  versionDbId: Scalars['StrictInt']['input'];
}

export interface ServiceAccountActorNode extends CreatorInterface, PartyInterface, PrincipalInterface {
  __typename: 'ServiceAccountActorNode';
  avatarUrl: Maybe<Scalars['StrictString']['output']>;
  handle: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  joinedOn: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  urlIdentifier: Scalars['StrictString']['output'];
}

export interface SignatureNode {
  __typename: 'SignatureNode';
  authenticationMethod: Maybe<Scalars['StrictString']['output']>;
  createdAt: Scalars['StrictString']['output'];
  gdprRedactedAt: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  ipAddress: Maybe<Scalars['StrictString']['output']>;
  reviewHistoryUiVersion: Scalars['StrictInt']['output'];
  user: UserNode;
  userEmail: Scalars['StrictString']['output'];
  userFullName: Scalars['StrictString']['output'];
  version: Scalars['StrictInt']['output'];
}

export interface SignedFileNode {
  __typename: 'SignedFileNode';
  redirectUrl: Scalars['StrictString']['output'];
  signedUrl: Scalars['StrictString']['output'];
}

export type SignedFileOrInaccessibleInfoNode = InaccessibleInfoNode | SignedFileNode;

export interface SimplePolymerInterface {
  entity: BiomoleculeEntityOrInaccessibleInfoNode;
  helmReference: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  polymerType: HELMPolymerType;
}

export type SimplePolymerNode = AASequencePolymerNode | MoleculePolymerNode | NucleotideSequencePolymerNode;

export interface SimpleRuleNode {
  __typename: 'SimpleRuleNode';
  constantInputs: Scalars['JSONScalar']['output'];
  schemaFieldApiIdentifier: Scalars['StrictString']['output'];
  validationRuleId: Scalars['StrictString']['output'];
  validationRuleTemplateId: Scalars['StrictString']['output'];
}

export interface SmilesChemicalStructureImageNode {
  __typename: 'SmilesChemicalStructureImageNode';
  chemicalStructureImage: SVGOrErrorNode;
  smiles: Scalars['StrictString']['output'];
}

export enum SortDirection {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export interface SourceInterface {
  alwaysShowAncestorFolderNames: Scalars['StrictBoolean']['output'];
  archiveRecord: Maybe<ArchiveRecordNode>;
  archived: Scalars['StrictBoolean']['output'];
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  creator: Maybe<PrincipalInterface>;
  /** @deprecated Use creator instead. */
  creatorJson: Maybe<Scalars['JSONScalar']['output']>;
  dataModsEnabled: Scalars['StrictBoolean']['output'];
  description: Maybe<Scalars['StrictString']['output']>;
  hidden: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  locked: Scalars['StrictBoolean']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  ownerInfoJson: Scalars['JSONScalar']['output'];
  ownerJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  public: Scalars['StrictBoolean']['output'];
  reviewSummaryJson: Maybe<Scalars['JSONScalar']['output']>;
  rootFolder: FolderNode;
  sourceType: Scalars['StrictString']['output'];
  starred: Scalars['StrictBoolean']['output'];
  url: Scalars['StrictString']['output'];
}

export interface SpreadsheetColumnsMappingNode extends HasCreatorInterface {
  __typename: 'SpreadsheetColumnsMappingNode';
  assaySchema: Maybe<ResultSchemaNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  id: Scalars['StrictString']['output'];
  individualColumnMappings: Array<IndividualColumnMappingNode>;
  name: Scalars['StrictString']['output'];
  tagSchema: Maybe<TagSchemaNode>;
  uploadFlow: UploadFlowType;
}

export enum SpreadsheetColumnsMappingsColumnType {
  ADD_DEDUCT_AMOUNT = 'ADD_DEDUCT_AMOUNT',
  ALIAS = 'ALIAS',
  ALLOWED_CHILD_STORABLE_SCHEMAS = 'ALLOWED_CHILD_STORABLE_SCHEMAS',
  ALLOWS_NON_LOCATION_CHILDREN = 'ALLOWS_NON_LOCATION_CHILDREN',
  BARCODE = 'BARCODE',
  BATCH_NAME = 'BATCH_NAME',
  BOX_SCHEMA_FIELD = 'BOX_SCHEMA_FIELD',
  CAPILLARY_CHEMICAL_STRUCTURE_INPUT = 'CAPILLARY_CHEMICAL_STRUCTURE_INPUT',
  COMPLEX_POLYMER_COMPONENT = 'COMPLEX_POLYMER_COMPONENT',
  COMPLEX_POLYMER_CONNECTION = 'COMPLEX_POLYMER_CONNECTION',
  CONCENTRATION_UNITS = 'CONCENTRATION_UNITS',
  CONTAINER_SCHEMA_FIELD = 'CONTAINER_SCHEMA_FIELD',
  CUSTOM_FIELD = 'CUSTOM_FIELD',
  CUSTOM_MOD_SYNTAX = 'CUSTOM_MOD_SYNTAX',
  DATASET = 'DATASET',
  DATA_TABLE_MATCHER = 'DATA_TABLE_MATCHER',
  DATA_TABLE_VALUE = 'DATA_TABLE_VALUE',
  DESCRIPTION = 'DESCRIPTION',
  EXPIRATION_DATE_OVERRIDE = 'EXPIRATION_DATE_OVERRIDE',
  FILENAME = 'FILENAME',
  FINAL_CONCENTRATION_VALUE = 'FINAL_CONCENTRATION_VALUE',
  FINAL_QUANTITY_VALUE = 'FINAL_QUANTITY_VALUE',
  FOLDER_PATH_FORWARD_SLASH = 'FOLDER_PATH_FORWARD_SLASH',
  FREEZE_THAW_COUNT = 'FREEZE_THAW_COUNT',
  HELM = 'HELM',
  IDT = 'IDT',
  IGNORE = 'IGNORE',
  INGREDIENT_AMOUNT = 'INGREDIENT_AMOUNT',
  INGREDIENT_CATALOG_IDENTIFIER = 'INGREDIENT_CATALOG_IDENTIFIER',
  INGREDIENT_COMPONENT_BIOENTITY_LABEL = 'INGREDIENT_COMPONENT_BIOENTITY_LABEL',
  INGREDIENT_COMPONENT_LOT_BIOENTITY_LABEL = 'INGREDIENT_COMPONENT_LOT_BIOENTITY_LABEL',
  INGREDIENT_COMPONENT_LOT_CONTAINER_BARCODE = 'INGREDIENT_COMPONENT_LOT_CONTAINER_BARCODE',
  INGREDIENT_COMPONENT_LOT_TEXT = 'INGREDIENT_COMPONENT_LOT_TEXT',
  INGREDIENT_MIXTURE_LABEL = 'INGREDIENT_MIXTURE_LABEL',
  INGREDIENT_NOTES = 'INGREDIENT_NOTES',
  INGREDIENT_UNITS = 'INGREDIENT_UNITS',
  INGREDIENT_UPDATED_COMPONENT_BIOENTITY_LABEL = 'INGREDIENT_UPDATED_COMPONENT_BIOENTITY_LABEL',
  INPUT_BATCH_NAME = 'INPUT_BATCH_NAME',
  INPUT_BIOENTITY_LABEL = 'INPUT_BIOENTITY_LABEL',
  INPUT_CONCENTRATION_VALUE = 'INPUT_CONCENTRATION_VALUE',
  INPUT_CONTAINER_BARCODE = 'INPUT_CONTAINER_BARCODE',
  INPUT_GRID_BARCODE = 'INPUT_GRID_BARCODE',
  INPUT_GRID_COORDINATES = 'INPUT_GRID_COORDINATES',
  LOCATION_CAPACITY = 'LOCATION_CAPACITY',
  LOCATION_SCHEMA_FIELD = 'LOCATION_SCHEMA_FIELD',
  MOLFILE = 'MOLFILE',
  MY_COLLECTION_ID = 'MY_COLLECTION_ID',
  NEW_BARCODE = 'NEW_BARCODE',
  NEW_BIOENTITY_NAME = 'NEW_BIOENTITY_NAME',
  NEW_REGISTRY_ID = 'NEW_REGISTRY_ID',
  NUMBER_OF_CONTAINERS = 'NUMBER_OF_CONTAINERS',
  OLIGO_DUPLEX_OFFSET = 'OLIGO_DUPLEX_OFFSET',
  ORG_COLLECTION_ID = 'ORG_COLLECTION_ID',
  OUTPUT_CONTAINER_BARCODE = 'OUTPUT_CONTAINER_BARCODE',
  OUTPUT_GRID_BARCODE = 'OUTPUT_GRID_BARCODE',
  OUTPUT_GRID_COORDINATES = 'OUTPUT_GRID_COORDINATES',
  PARENT_STORABLE_BARCODE = 'PARENT_STORABLE_BARCODE',
  PARENT_STORABLE_GRID_COORDINATES = 'PARENT_STORABLE_GRID_COORDINATES',
  PLATE_SCHEMA_FIELD = 'PLATE_SCHEMA_FIELD',
  PROCESS_OUTPUT_SCHEMA_FIELD = 'PROCESS_OUTPUT_SCHEMA_FIELD',
  PROCESS_TASK = 'PROCESS_TASK',
  PROCESS_TASK_ASSIGNEE = 'PROCESS_TASK_ASSIGNEE',
  PROCESS_TASK_SCHEMA_FIELD = 'PROCESS_TASK_SCHEMA_FIELD',
  QUANTITY_UNITS = 'QUANTITY_UNITS',
  REGISTRATION_TABLE_EXISTING_BIOENTITY = 'REGISTRATION_TABLE_EXISTING_BIOENTITY',
  RESIDUES = 'RESIDUES',
  RESULT_SCHEMA_FIELD = 'RESULT_SCHEMA_FIELD',
  SAMPLE_AUTHORIZED_USERS = 'SAMPLE_AUTHORIZED_USERS',
  SAMPLE_GROUP_SCHEMA_FIELD = 'SAMPLE_GROUP_SCHEMA_FIELD',
  SAMPLE_OWNERS = 'SAMPLE_OWNERS',
  SAMPLE_RESTRICTION_STATUS = 'SAMPLE_RESTRICTION_STATUS',
  SCHEMA_FIELD = 'SCHEMA_FIELD',
  SMILES = 'SMILES',
  SOURCE_FINAL_QUANTITY_VALUE = 'SOURCE_FINAL_QUANTITY_VALUE',
  STAGE_RUN_NAME = 'STAGE_RUN_NAME',
  STAGE_RUN_SAMPLE_NAME = 'STAGE_RUN_SAMPLE_NAME',
  STORABLE_NAME = 'STORABLE_NAME',
  STUDY_LABELS = 'STUDY_LABELS',
  TABLE_COLUMN = 'TABLE_COLUMN',
  TRANSFER_QUANTITY = 'TRANSFER_QUANTITY',
  TRIAL_SUBJECT_MY_COLLECTION_ID = 'TRIAL_SUBJECT_MY_COLLECTION_ID',
  TRIAL_SUBJECT_NAME = 'TRIAL_SUBJECT_NAME',
  TRIAL_SUBJECT_ORG_COLLECTION_ID = 'TRIAL_SUBJECT_ORG_COLLECTION_ID',
  TRIAL_SUBJECT_SCHEMA_FIELD = 'TRIAL_SUBJECT_SCHEMA_FIELD',
  UNIT_SELECTOR = 'UNIT_SELECTOR'
}

export enum SqlColumnType {
  BOOLEAN = 'BOOLEAN',
  CHARACTER_VARYING = 'CHARACTER_VARYING',
  DATE = 'DATE',
  DOUBLE = 'DOUBLE',
  INTEGER = 'INTEGER',
  JSON = 'JSON',
  JSONB = 'JSONB',
  NUMERIC = 'NUMERIC',
  TIMESTAMP = 'TIMESTAMP',
  UUID = 'UUID'
}

export interface StageEntryMentioningNode {
  __typename: 'StageEntryMentioningNode';
  id: Scalars['StrictString']['output'];
  inputSamples: Array<ExecutionSampleNode>;
  registeredSamples: Array<ExecutionSampleNode>;
  stageEntry: StageEntryNode;
}

export interface StageEntryNode extends BaseEntryInterface, HasPermissionsInterface, SearchableInterface {
  __typename: 'StageEntryNode';
  createdAt: Scalars['StrictString']['output'];
  editUrl: Scalars['StrictString']['output'];
  entryDays: Array<EntryDayNode>;
  humanId: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  review: Maybe<ReviewNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
}

export type StageEntryOrInaccessibleInfoNode = InaccessibleInfoNode | StageEntryNode;

export interface StarNode {
  __typename: 'StarNode';
  id: Scalars['StrictString']['output'];
  isStarred: Scalars['StrictBoolean']['output'];
  objectId: Scalars['StrictString']['output'];
  userId: Scalars['StrictString']['output'];
}

export interface StarrableInterface {
  id: Scalars['StrictString']['output'];
  star: Maybe<StarNode>;
}

export type StarrableItemOrInaccessibleInfoNode = AnalysisTemplateNode | DatasetNode | EntryNode | FileNode | FolderNode | FormDefinitionNode | InaccessibleInfoNode | JellyfishNode | ProcedureNode | RequestV2DefinitionNode | SubtemplateNode | TemplateCollectionNode | TemplateNode;

export interface StaticSchemaInterfaceNode extends BaseSchemaInterfaceInterface, HasArchiveRecordInterface {
  __typename: 'StaticSchemaInterfaceNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  displayName: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
}

export enum Status {
  failed = 'failed',
  pending = 'pending',
  running = 'running',
  succeeded = 'succeeded'
}

export interface StepOutputReferenceNode {
  __typename: 'StepOutputReferenceNode';
  outputStepData: PipelineStepDataDomainNode;
  rawDataIndex: Maybe<Scalars['StrictInt']['output']>;
}

export interface StorableInput {
  colIndex?: InputMaybe<Scalars['StrictInt']['input']>;
  id: Scalars['StrictString']['input'];
  rowIndex?: InputMaybe<Scalars['StrictInt']['input']>;
}

export interface StorableInterface {
  ancestry: Array<StorableOrInaccessibleInfoNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  barcode: Maybe<BarcodeNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead. */
  creatorJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  labelParamsJson: Scalars['JSONScalar']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  parentStorable: Maybe<StorableOrInaccessibleInfoNode>;
  permissions: PermissionsNode;
  source: SourceInterface;
  starred: Scalars['StrictBoolean']['output'];
  storableSchema: StorableSchemaInterface;
  tagsJson: Scalars['JSONScalar']['output'];
  validationState: Maybe<ValidationStateNode>;
}


export interface StorableInterfaceparentStorableArgs {
  skipAuthCheck?: InputMaybe<Scalars['StrictBoolean']['input']>;
}

export type StorableOrInaccessibleInfoNode = BoxNode | ContainerNode | InaccessibleInfoNode | LocationNode | PlateNode;

export type StorableOrRegistryItemOrInaccessibleInfoNode = BasicFolderItemNode | BoxNode | ComplexPolymerNode | ContainerNode | EquipmentNode | InaccessibleInfoNode | LocationNode | MixtureNode | MoleculeNode | OligoConjugateNode | OligoDuplexNode | PlateNode | ProteinNode | SequenceNode;

export interface StorableSchemaInterface {
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  numValidationFailures: Scalars['StrictInt']['output'];
  prefix: Scalars['StrictString']['output'];
  registry: RegistryNode;
  relatedBenchlingApps: Array<BenchlingAppNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
  storablesFailingValidation: Array<StorableOrInaccessibleInfoNode>;
}


export interface StorableSchemaInterfaceallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export type StorableSchemaOrInaccessibleInfoNode = BoxSchemaNode | ContainerSchemaNode | InaccessibleInfoNode | LocationSchemaNode | PlateSchemaNode;

export enum Strand {
  FORWARD = 'FORWARD',
  NONE = 'NONE',
  REVERSE = 'REVERSE'
}

export interface StringPropertyNode {
  __typename: 'StringPropertyNode';
  value: Scalars['StrictString']['output'];
}

export type StringPropertyOrErrorNode = ErrorNode | StringPropertyNode;

export interface StructureGraphEdgeNode {
  __typename: 'StructureGraphEdgeNode';
  id: Scalars['StrictString']['output'];
  sourceHandle: HandleType;
  sourceId: Scalars['StrictString']['output'];
  targetHandle: HandleType;
  targetId: Scalars['StrictString']['output'];
}

export interface StructureGraphNodeDataInterface {
  entityId: Scalars['StrictString']['output'];
  polymerRef: Scalars['StrictString']['output'];
}

export type StructureGraphNodeDataNode = ConjugateStructureGraphNodeDataNode | NucleotideStructureGraphNodeDataNode;

export interface StructureGraphNodeNode {
  __typename: 'StructureGraphNodeNode';
  data: StructureGraphNodeDataNode;
  draggable: Scalars['StrictBoolean']['output'];
  handles: Array<HandleType>;
  id: Scalars['StrictString']['output'];
  position: PositionNode;
  selectable: Scalars['StrictBoolean']['output'];
  type: StructureGraphNodeType;
}

export enum StructureGraphNodeType {
  CONJUGATE = 'CONJUGATE',
  NUCLEOTIDE = 'NUCLEOTIDE'
}

export enum StructuredTableKind {
  BOX_CREATION = 'BOX_CREATION',
  INVENTORY = 'INVENTORY',
  LOOKUP = 'LOOKUP',
  MIXTURE_INGREDIENTS = 'MIXTURE_INGREDIENTS',
  MIXTURE_METADATA = 'MIXTURE_METADATA',
  PARAMETER = 'PARAMETER',
  PLATE_CREATION = 'PLATE_CREATION',
  PROCESS_OUTPUT = 'PROCESS_OUTPUT',
  PROCESS_TASK = 'PROCESS_TASK',
  REGISTRATION = 'REGISTRATION',
  RESULTS = 'RESULTS',
  RUN_OUTPUT_SAMPLES = 'RUN_OUTPUT_SAMPLES',
  TRANSFER = 'TRANSFER'
}

export interface StructuredTableNode {
  __typename: 'StructuredTableNode';
  hasApiRowsToAdd: Scalars['StrictBoolean']['output'];
  id: Scalars['StrictString']['output'];
  pendingTableRows: Array<ResultNode>;
}

export type StructuredTableOrInaccessibleInfoNode = InaccessibleInfoNode | StructuredTableNode;

export interface StudyAssociationNode {
  __typename: 'StudyAssociationNode';
  isAutoLinking: Scalars['StrictBoolean']['output'];
  study: StudyOrInaccessibleInfoNode;
}

export interface StudyDesignInterface {
  endDate: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  startDate: Maybe<Scalars['StrictString']['output']>;
  study: StudyNode;
  type: StudyDesignType;
}

export enum StudyDesignType {
  TRIAL_SAMPLE_TESTING = 'TRIAL_SAMPLE_TESTING'
}

export interface StudyNode extends BaseFolderItemInterface, CoreObjectArchivableInterface, HasArchiveRecordInterface, HasAuthorsInterface, HasPermissionsInterface, NotificationSchedulableInterface, SearchableInterface {
  __typename: 'StudyNode';
  activeProcedureRuns: Array<ProcedureRunOrInaccessibleInfoNode>;
  archiveData: ArchiveDataNode;
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  description: Maybe<Scalars['StrictString']['output']>;
  designEntry: Maybe<EntryOrInaccessibleInfoNode>;
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  humanId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  notificationSchedules: Array<NotificationScheduleDataNode>;
  permissions: PermissionsNode;
  phase: StudyPhase;
  procedureRun: Maybe<ProcedureRunOrInaccessibleInfoNode>;
  procedureRunCount: Scalars['StrictInt']['output'];
  procedureRuns: Array<ProcedureRunOrInaccessibleInfoNode>;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  sampleSummary: Maybe<SampleSummaryNode>;
  studyDesign: Maybe<StudyDesignInterface>;
  studySchema: StudySchemaNode;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
}


export interface StudyNodeactiveProcedureRunsArgs {
  limit: Scalars['StrictInt']['input'];
}

export type StudyOrInaccessibleInfoNode = InaccessibleInfoNode | StudyNode;

export enum StudyPhase {
  COMPLETE = 'COMPLETE',
  DESIGN = 'DESIGN',
  EXECUTION = 'EXECUTION'
}

export interface StudySampleTestPlanNode {
  __typename: 'StudySampleTestPlanNode';
  id: Scalars['StrictString']['output'];
  isReadyForExecution: Scalars['StrictBoolean']['output'];
  pinnedProcedureFlowchartVersion: Maybe<ProcedureFlowchartVersionOrInaccessibleInfoNode>;
  procedure: ProcedureOrInaccessibleInfoNode;
  sampleDefinition: SampleDefinitionNode;
  studyDesign: TrialSampleTestingStudyDesignNode;
}

export type StudySampleTestPlanOrInaccessibleInfoNode = InaccessibleInfoNode | StudySampleTestPlanNode;

export interface StudySchemaNode extends HasNameTemplatesInterface, PoliceableInterface, SchemaInterface {
  __typename: 'StudySchemaNode';
  allFields: Array<SchemaFieldNode>;
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  entryTemplates: Array<TemplateNodeOrInaccessibleInfoNode>;
  fields: Array<SchemaFieldNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  isDesignApprovalRequired: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  nameTemplates: Array<NameTemplateNode>;
  organization: OrganizationNode;
  permissions: PermissionsNode;
  prefix: Scalars['StrictString']['output'];
  relatedBenchlingApps: Array<BenchlingAppNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
  studyType: StudyType;
}


export interface StudySchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export type StudySchemaOrInaccessibleInfoNode = InaccessibleInfoNode | StudySchemaNode;

export enum StudyType {
  ASSAY_DEVELOPMENT = 'ASSAY_DEVELOPMENT',
  CLINICAL = 'CLINICAL',
  CUSTOM = 'CUSTOM',
  PRECLINICAL = 'PRECLINICAL',
  PROCESS_DEVELOPMENT = 'PROCESS_DEVELOPMENT'
}

export interface StudyableInterface {
  id: Scalars['StrictString']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
}

export type StudyableOrInaccessibleInfoNode = AnalysisNode | BasicFolderItemNode | BoxNode | BulkAssemblyNode | ContainerNode | DatasetNode | EntryNode | EquipmentNode | FileNode | InaccessibleInfoNode | MoleculeNode | PlateNode | ProcessTaskNode | ProteinNode | RequestV2SubmissionNode | SequenceNode | TestOrderNode | WorksheetNode;

export interface SubtemplateNode extends HasCreatorInterface, PublishableInterface, SearchableInterface, StarrableInterface, TemplateCollectibleInterface {
  __typename: 'SubtemplateNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorNode: CreatorInterface;
  currentPublishingRecord: Maybe<PublishingRecordOrInaccessibleInfoNode>;
  editUrl: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  publishingRecords: Array<PublishingRecordOrInaccessibleInfoNode>;
  star: Maybe<StarNode>;
  templateCollection: TemplateCollectionNode;
}

export type SubtemplateOrInaccessibleInfoNode = InaccessibleInfoNode | SubtemplateNode;

export enum SvixResponseStatus {
  FAILURE = 'FAILURE',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export enum TagSchemaAuthParentOption {
  FOLDER = 'FOLDER',
  PROJECT_FOLDER = 'PROJECT_FOLDER'
}

export interface TagSchemaConstraintNode {
  __typename: 'TagSchemaConstraintNode';
  areUniqueResiduesCaseSensitive: Scalars['StrictBoolean']['output'];
  fieldsJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictInt']['output'];
  source: Maybe<SchemaInterfaceNode>;
  status: TagSchemaConstraintStatus;
  uniqueCanonicalSmiles: Scalars['StrictBoolean']['output'];
  uniqueResidues: Scalars['StrictBoolean']['output'];
}

export enum TagSchemaConstraintStatus {
  ACTIVE = 'ACTIVE',
  COMPUTING = 'COMPUTING',
  INACTIVE = 'INACTIVE'
}

export enum TagSchemaContainableType {
  BATCH = 'BATCH',
  ENTITY = 'ENTITY',
  NONE = 'NONE'
}

export enum TagSchemaItemType {
  AA_SEQUENCE = 'AA_SEQUENCE',
  ANTIBODY = 'ANTIBODY',
  BASIC_FOLDER_ITEM = 'BASIC_FOLDER_ITEM',
  DNA_OLIGO = 'DNA_OLIGO',
  DNA_SEQUENCE = 'DNA_SEQUENCE',
  ENTRY = 'ENTRY',
  EQUIPMENT = 'EQUIPMENT',
  MIXED = 'MIXED',
  MIXTURE = 'MIXTURE',
  MOLECULE = 'MOLECULE',
  OLIGO_CONJUGATE = 'OLIGO_CONJUGATE',
  OLIGO_DUPLEX = 'OLIGO_DUPLEX',
  RNA_OLIGO = 'RNA_OLIGO',
  RNA_SEQUENCE = 'RNA_SEQUENCE'
}

export interface TagSchemaListingNode {
  __typename: 'TagSchemaListingNode';
  tagSchemas: Array<TagSchemaNode>;
  total: Scalars['StrictInt']['output'];
}

export interface TagSchemaListingSearchInput {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  includeFilteredSsis?: InputMaybe<Scalars['StrictBoolean']['input']>;
  oligoAwareFolderItemTypes?: InputMaybe<Array<OligoAwareFolderItemType>>;
  organizationId?: InputMaybe<Scalars['StrictString']['input']>;
  registryId?: InputMaybe<Scalars['StrictString']['input']>;
}

export interface TagSchemaNode extends AnalyticsDashboardLinkParentInterface, HasArchiveRecordInterface, HasNameTemplatesInterface, HasSchemaInterfacesInterface, HasValidationRulesInterface, PoliceableInterface, SchemaInterface {
  __typename: 'TagSchemaNode';
  activeMigration: Maybe<FieldDataMigrationNode>;
  allFields: Array<SchemaFieldNode>;
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  analyticsDashboardLink: Maybe<AnalyticsDashboardLinkNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  authParentOption: TagSchemaAuthParentOption;
  batchSchema: Maybe<BatchSchemaNode>;
  childEntityLinkConfig: Maybe<ChildEntityLinkConfigNode>;
  childEntityLinkConfigs: Array<ChildEntityLinkConfigNode>;
  childEntitySchemas: Array<TagSchemaNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  constraint: Maybe<TagSchemaConstraintNode>;
  containableType: TagSchemaContainableType;
  containerNameTemplateParts: Array<NameTemplatePartNode>;
  fields: Array<SchemaFieldNode>;
  fieldsJson: Scalars['JSONScalar']['output'];
  folderItemType: TagSchemaSupportedFolderItemType;
  hasAtLeastOneValidationRule: Scalars['StrictBoolean']['output'];
  hasData: Scalars['StrictBoolean']['output'];
  hoistedTagSchemaGraphsJson: Array<Scalars['JSONScalar']['output']>;
  hoistedTagSchemaOrderedPathOptionsJson: Maybe<Scalars['JSONScalar']['output']>;
  iconId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  includeRegistryIdInChips: Scalars['StrictBoolean']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  interfaceConfigs: Array<BaseSchemaInterfaceConfigInterface>;
  interfaces: Array<BaseSchemaInterfaceInterface>;
  isContainable: Scalars['StrictBoolean']['output'];
  itemType: TagSchemaItemType;
  labelingStrategies: Array<RegistryLabelingStrategy>;
  labelingStrategiesOverrideSource: Maybe<SchemaInterfaceNode>;
  mixtureSchemaConfig: Maybe<MixtureSchemaConfigurationNode>;
  name: Scalars['StrictString']['output'];
  nameTemplateFields: Array<Scalars['StrictString']['output']>;
  nameTemplateParts: Array<RegistryFileNamePartNode>;
  nameTemplates: Array<NameTemplateNode>;
  nameTemplatesOverrideSource: Maybe<SchemaInterfaceNode>;
  numItems: Scalars['StrictInt']['output'];
  parentLineagePaths: JSONScalarOrInaccessibleInfoNode;
  permissions: PermissionsNode;
  prefix: Scalars['StrictString']['output'];
  prefixSource: Maybe<SchemaInterfaceNode>;
  registry: RegistryNode;
  relatedBenchlingApps: Array<BenchlingAppNode>;
  schemaDescription: Scalars['StrictString']['output'];
  schemaField: SchemaFieldOrInaccessibleInfoNode;
  sequenceType: Maybe<TagSchemaSequenceSchemaType>;
  shouldCreateAsOligo: Scalars['StrictBoolean']['output'];
  shouldOrderNamePartsBySequence: Scalars['StrictBoolean']['output'];
  showResidues: Scalars['StrictBoolean']['output'];
  simpleRules: Array<SimpleRuleNode>;
  spreadsheetColumnsMappings: Array<SpreadsheetColumnsMappingNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
  useOrganizationCollectionAliasForDisplayLabel: Scalars['StrictBoolean']['output'];
  useRandomOrgAlias: Scalars['StrictBoolean']['output'];
  validationErrorLabelSummary: Maybe<TagSchemaValidationErrorLabelSummaryNode>;
  validationRules: Array<ValidationRuleNode>;
  validationRulesTemplateAndInputsMapping: Scalars['JSONScalar']['output'];
  validationStatusSummary: Maybe<TagSchemaValidationStatusSummaryNode>;
}


export interface TagSchemaNodeallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}


export interface TagSchemaNodechildEntityLinkConfigArgs {
  childSchemaId: Scalars['StrictString']['input'];
}


export interface TagSchemaNodeparentLineagePathsArgs {
  targetSchemaId: Scalars['StrictString']['input'];
}


export interface TagSchemaNodeschemaFieldArgs {
  id: Scalars['StrictString']['input'];
}

export type TagSchemaOrInaccessibleInfoNode = InaccessibleInfoNode | TagSchemaNode;

export enum TagSchemaSequenceSchemaType {
  DNA_SEQUENCE = 'DNA_SEQUENCE',
  MIXED = 'MIXED',
  OLIGO = 'OLIGO',
  RNA_OLIGO = 'RNA_OLIGO',
  RNA_SEQUENCE = 'RNA_SEQUENCE'
}

export enum TagSchemaSupportedFolderItemType {
  basic_folder_item = 'basic_folder_item',
  entry = 'entry',
  mixture = 'mixture',
  molecule = 'molecule',
  protein = 'protein',
  protocol = 'protocol',
  sequence = 'sequence'
}

export interface TagSchemaValidationErrorLabelSummaryNode {
  __typename: 'TagSchemaValidationErrorLabelSummaryNode';
  numConstraintViolation: Scalars['StrictInt']['output'];
  numInvalidLink: Scalars['StrictInt']['output'];
  numInvalidMultipleLink: Scalars['StrictInt']['output'];
  numInvalidValue: Scalars['StrictInt']['output'];
  numMissingRequired: Scalars['StrictInt']['output'];
  numOther: Scalars['StrictInt']['output'];
}

export interface TagSchemaValidationStatusSummaryNode {
  __typename: 'TagSchemaValidationStatusSummaryNode';
  numFailed: Scalars['StrictInt']['output'];
  numOverridden: Scalars['StrictInt']['output'];
  numPassed: Scalars['StrictInt']['output'];
  numValidating: Scalars['StrictInt']['output'];
}

export interface TaskTransitionExtensionNode {
  __typename: 'TaskTransitionExtensionNode';
  statusDisplayName: Scalars['StrictString']['output'];
  timestampUtcIsoformat: Scalars['StrictString']['output'];
}

export interface TeamListingNode {
  __typename: 'TeamListingNode';
  teams: Array<TeamNode>;
  total: Scalars['StrictInt']['output'];
}

export interface TeamListingSearchInput {
  organizationId?: InputMaybe<Scalars['StrictString']['input']>;
  query: Scalars['StrictString']['input'];
}

export interface TeamListingSortInput {
  sortDirection: SortDirection;
  sortKey: TeamListingSortKey;
}

export enum TeamListingSortKey {
  NAME = 'NAME',
  ORGANIZATION_NAME = 'ORGANIZATION_NAME'
}

export interface TeamNode extends GroupInterface, HasPermissionsInterface, PartyInterface, SearchableInterface {
  __typename: 'TeamNode';
  admin: Scalars['StrictBoolean']['output'];
  adminListing: AdminListingNode;
  admins: Scalars['JSONScalar']['output'];
  /** @deprecated Deprecated in favor of admins on GroupNodeMixin */
  adminsJson: Scalars['JSONScalar']['output'];
  autoProvisionedCapabilities: Array<ProvisionedCapabilityNode>;
  avatarUrl: Maybe<Scalars['StrictString']['output']>;
  description: Scalars['StrictString']['output'];
  handle: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  isSchemaAdmin: Scalars['StrictBoolean']['output'];
  member: Scalars['StrictBoolean']['output'];
  memberListing: MemberListingNode;
  members: Array<UserNode>;
  name: Scalars['StrictString']['output'];
  organization: OrganizationNode;
  permissions: PermissionsNode;
}


export interface TeamNodeadminListingArgs {
  limitOffsetInput: LimitOffsetInput;
  optionsInput: MembersListOptionsInput;
}


export interface TeamNodememberListingArgs {
  limitOffsetInput: LimitOffsetInput;
  optionsInput: MembersListOptionsInput;
}

export type TeamOrInaccessibleInfoNode = InaccessibleInfoNode | TeamNode;

export enum TeamRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

export interface TeamRoleNode {
  __typename: 'TeamRoleNode';
  role: TeamRole;
  team: TeamNode;
  user: UserNode;
}

export interface TemplateCollectibleInterface {
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorNode: CreatorInterface;
  editUrl: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  star: Maybe<StarNode>;
  templateCollection: TemplateCollectionNode;
}

export type TemplateCollectibleOrInaccessibleInfoNode = AnalysisTemplateNode | FormDefinitionNode | InaccessibleInfoNode | ProcedureNode | RequestV2DefinitionNode | SubtemplateNode | TemplateNode;

export interface TemplateCollectiblesListingNode {
  __typename: 'TemplateCollectiblesListingNode';
  collectibles: Array<TemplateCollectibleInterface>;
  total: Scalars['StrictInt']['output'];
}

export interface TemplateCollectionListingNode {
  __typename: 'TemplateCollectionListingNode';
  collections: Array<TemplateCollectionNode>;
  total: Scalars['StrictInt']['output'];
}

export interface TemplateCollectionListingSearchInput {
  archivePurposes?: InputMaybe<Array<InputMaybe<Scalars['StrictString']['input']>>>;
  onlySubtemplates?: InputMaybe<Scalars['StrictBoolean']['input']>;
  permissionsLevel?: InputMaybe<PermissionIntentFilter>;
  query?: InputMaybe<Scalars['StrictString']['input']>;
}

export interface TemplateCollectionNode extends HasPermissionsInterface, OwnableInterface, PoliceableInterface, SearchableInterface, StarrableInterface {
  __typename: 'TemplateCollectionNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  collectiblesListing: Maybe<TemplateCollectiblesListingNode>;
  counts: Scalars['JSONScalar']['output'];
  createdAt: Scalars['StrictString']['output'];
  description: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  ownerInfoJson: Scalars['JSONScalar']['output'];
  ownerJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
  procedures: Array<ProcedureNode>;
  star: Maybe<StarNode>;
  subtemplates: Array<SubtemplateNode>;
  /** @deprecated Replaced by collectibles_listing as of rollout of ELN_ENABLE_TEMPLATE_COLLECTION_PAGINATION */
  templateCollectibles: Array<TemplateCollectibleInterface>;
  templates: Array<TemplateNode>;
  url: Scalars['StrictString']['output'];
}


export interface TemplateCollectionNodecollectiblesListingArgs {
  archiveFilter?: InputMaybe<Array<InputMaybe<Scalars['StrictString']['input']>>>;
  limitOffsetInput?: InputMaybe<LimitOffsetInput>;
  searchInput?: InputMaybe<Scalars['StrictString']['input']>;
  typeFilter?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}

export type TemplateCollectionOrInaccessibleInfoNode = InaccessibleInfoNode | TemplateCollectionNode;

export interface TemplateNode extends HasCreatorInterface, PublishableInterface, SearchableInterface, StarrableInterface, TemplateCollectibleInterface {
  __typename: 'TemplateNode';
  archiveRecord: Maybe<ArchiveRecordNode>;
  createdAt: Scalars['StrictString']['output'];
  creator: PrincipalInterface;
  /** @deprecated Use creator instead */
  creatorNode: CreatorInterface;
  currentPublishingRecord: Maybe<PublishingRecordOrInaccessibleInfoNode>;
  editUrl: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  publishingRecords: Array<PublishingRecordOrInaccessibleInfoNode>;
  star: Maybe<StarNode>;
  tagSchema: Maybe<TagSchemaNode>;
  tagsJson: Array<Scalars['JSONScalar']['output']>;
  templateCollection: TemplateCollectionNode;
}

export type TemplateNodeOrInaccessibleInfoNode = InaccessibleInfoNode | TemplateNode;

export type TemplateOrInaccessibleInfoNode = InaccessibleInfoNode | TemplateNode;

export interface TenantAdminDataNode {
  __typename: 'TenantAdminDataNode';
  admins: Array<ActorNode>;
  configOptions: Array<ConfigOptionNode>;
  configOverrides: Array<ConfigOverrideNode>;
  id: Scalars['StrictString']['output'];
  insightsLabsConfiguration: Array<FeatureEnablementConfigNode>;
  ipConfiguration: IPConfigurationInfoNode;
  llmFeaturesConfiguration: LLMFeaturesConfigurationOrInaccessibleInfoNode;
  /** @deprecated Unpaginated and deprecated. Use Query.current_tenant_organization_listing instead. */
  organizations: Array<OrganizationNode>;
  permissionControls: PermissionControlsNode;
  /** @deprecated Unpaginated and deprecated. Use Query.current_tenant_team_listing instead. */
  teams: Array<TeamNode>;
  /** @deprecated Unpaginated and deprecated. Use Query.current_tenant_user_listing instead. */
  users: Array<UserNode>;
}


export interface TenantAdminDataNodeconfigOverridesArgs {
  keys: Array<InputMaybe<Scalars['StrictString']['input']>>;
}

export type TenantAdminDataOrInaccessibleInfoNode = InaccessibleInfoNode | TenantAdminDataNode;

export interface TenantNode {
  __typename: 'TenantNode';
  avatarUrl: Scalars['StrictString']['output'];
  dataPolicies: Array<DataPolicyNode>;
  displayName: Scalars['StrictString']['output'];
  globalIdentifier: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: TenantPermissionsNode;
  subdomain: Scalars['StrictString']['output'];
  tenantAdminData: TenantAdminDataOrInaccessibleInfoNode;
}

export interface TenantPermissionsNode {
  __typename: 'TenantPermissionsNode';
  admin: Scalars['StrictBoolean']['output'];
  /** @deprecated This permission is not needed anywhere on the FE. */
  canAdminOrganizations: Scalars['StrictBoolean']['output'];
  /** @deprecated This permission is not needed anywhere on the FE. */
  canAdminTeams: Scalars['StrictBoolean']['output'];
  canAdminUsers: Scalars['StrictBoolean']['output'];
  canCreateOrganizations: Scalars['StrictBoolean']['output'];
  /** @deprecated This permission should be checked in the parent Organization */
  canCreateTeams: Scalars['StrictBoolean']['output'];
  canCreateUsers: Scalars['StrictBoolean']['output'];
  canReadBenchlingApps: Scalars['StrictBoolean']['output'];
  canReadEventSubscriptions: Scalars['StrictBoolean']['output'];
  canReadOrganizations: Scalars['StrictBoolean']['output'];
  canReadTeams: Scalars['StrictBoolean']['output'];
}

export interface TentacleNode extends CoreObjectArchivableInterface, HasPermissionsInterface {
  __typename: 'TentacleNode';
  archiveData: ArchiveDataNode;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
}

export interface TestDefinitionNode extends CoreObjectArchivableInterface, HasPermissionsInterface, PoliceableInterface, SearchableInterface {
  __typename: 'TestDefinitionNode';
  archiveData: ArchiveDataNode;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  description: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  inheritedCollaborations: Array<CollaborationNode>;
  name: Scalars['StrictString']['output'];
  organization: OrganizationNode;
  permissions: PermissionsNode;
  /** @deprecated Is actually a union with inaccessible */
  resultSchema: ResultSchemaNode;
  resultSchemaCorrect: ResultSchemaOrInaccessibleInfoNode;
}

export type TestDefinitionOrInaccessibleInfoNode = InaccessibleInfoNode | TestDefinitionNode;

export interface TestOrderNode extends HasPermissionsInterface, SearchableInterface, StudyableInterface {
  __typename: 'TestOrderNode';
  analysisComment: Maybe<Scalars['StrictString']['output']>;
  container: Maybe<ContainerOrInaccessibleInfoNode>;
  createdAt: Scalars['StrictString']['output'];
  dilutionFactor: Maybe<Scalars['StrictInt']['output']>;
  id: Scalars['StrictString']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  procedure: Maybe<ProcedureOrInaccessibleInfoNode>;
  procedureMethodExecutionInstance: Maybe<ProcedureMethodExecutionInstanceOrInaccessibleInfoNode>;
  result: Maybe<ResultOrInaccessibleInfoNode>;
  sample: RegistryItemInterface;
  status: TestOrderStatus;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  /** @deprecated Is actually a union with inaccessible */
  testDefinition: TestDefinitionNode;
  testDefinitionCorrect: TestDefinitionOrInaccessibleInfoNode;
}

export type TestOrderOrInaccessibleInfoNode = InaccessibleInfoNode | TestOrderNode;

export interface TestOrderPlateAssociationNode {
  __typename: 'TestOrderPlateAssociationNode';
  testOrder: TestOrderOrInaccessibleInfoNode;
  wellPositions: Array<Scalars['StrictString']['output']>;
}

export enum TestOrderStatus {
  BLOCKED = 'BLOCKED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  INVALID = 'INVALID',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export interface TestOrderSummaryNode {
  __typename: 'TestOrderSummaryNode';
  procedure: ProcedureOrInaccessibleInfoNode;
  resolvedCount: Scalars['StrictInt']['output'];
  totalCount: Scalars['StrictInt']['output'];
}

export interface TimepointNode {
  __typename: 'TimepointNode';
  offset: TimepointRelativeTimeNode;
  window: TimepointWindowNode;
}

export interface TimepointRelativeTimeNode {
  __typename: 'TimepointRelativeTimeNode';
  unit: UnitNode;
  unitVersionNumber: Scalars['StrictInt']['output'];
  value: Scalars['StrictInt']['output'];
}

export interface TimepointWindowNode {
  __typename: 'TimepointWindowNode';
  end: TimepointRelativeTimeNode;
  start: TimepointRelativeTimeNode;
}

export interface TranscriptionMatchNode {
  __typename: 'TranscriptionMatchNode';
  end: Scalars['StrictInt']['output'];
  isReverseComplement: Scalars['StrictBoolean']['output'];
  rnaSequence: SequenceNode;
  start: Scalars['StrictInt']['output'];
}

export interface TreatmentGroupNode extends SearchableInterface {
  __typename: 'TreatmentGroupNode';
  description: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  isReadyForExecution: Scalars['StrictBoolean']['output'];
  label: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  studyDesign: TrialSampleTestingStudyDesignNode;
  targetNumberOfSubjects: Scalars['StrictInt']['output'];
}

export type TreatmentGroupOrInaccessibleInfoNode = InaccessibleInfoNode | TreatmentGroupNode;

export interface TrialSampleItemInterface {
  sampleDefinitionLinks: Maybe<Array<SampleDefinitionLinkNode>>;
}

export interface TrialSampleTestingStudyDesignNode extends HasPermissionsInterface, ReviewableInterface, StudyDesignInterface {
  __typename: 'TrialSampleTestingStudyDesignNode';
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  endDate: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  parentReviewLifecycles: Array<ReviewLifecycleNode>;
  permissions: PermissionsNode;
  review: Maybe<ReviewNode>;
  reviewSource: ProjectNode;
  sampleDefinitions: Array<SampleDefinitionNode>;
  sampleTestPlans: Array<StudySampleTestPlanNode>;
  startDate: Maybe<Scalars['StrictString']['output']>;
  study: StudyNode;
  treatmentGroups: Array<TreatmentGroupNode>;
  type: StudyDesignType;
  /** @deprecated Use permissions from HasPermissionsInterface instead. */
  userPermissionsJson: Scalars['JSONScalar']['output'];
}

export type UIBlockValue = UIBlockValueMulti | UIBlockValueSingle;

export interface UIBlockValueMulti {
  __typename: 'UIBlockValueMulti';
  values: Maybe<Array<Scalars['StrictString']['output']>>;
}

export interface UIBlockValueSingle {
  __typename: 'UIBlockValueSingle';
  value: Maybe<Scalars['StrictString']['output']>;
}

export interface UiBlockLeafNode {
  __typename: 'UiBlockLeafNode';
  blockValue: Maybe<UIBlockValue>;
  datasetId: Maybe<Scalars['StrictString']['output']>;
  datasetUploadStatus: Maybe<DatasetUploadStatus>;
  dropdownId: Maybe<Scalars['StrictString']['output']>;
  enabled: Maybe<Scalars['StrictBoolean']['output']>;
  fileTypes: Maybe<Array<Maybe<Scalars['StrictString']['output']>>>;
  id: Scalars['StrictString']['output'];
  itemType: Maybe<Scalars['StrictString']['output']>;
  label: Maybe<Scalars['StrictString']['output']>;
  maxFiles: Maybe<Scalars['StrictInt']['output']>;
  name: Maybe<Scalars['StrictString']['output']>;
  options: Maybe<Array<Maybe<Scalars['StrictString']['output']>>>;
  placeholder: Maybe<Scalars['StrictString']['output']>;
  required: Maybe<Scalars['StrictBoolean']['output']>;
  schemaId: Maybe<Scalars['StrictString']['output']>;
  text: Maybe<Scalars['StrictString']['output']>;
  type: BenchlingAppUiBlockType;
  userDefinedId: Scalars['StrictString']['output'];
  value: Maybe<Scalars['StrictString']['output']>;
}

export interface UiBlockNode {
  __typename: 'UiBlockNode';
  blockValue: Maybe<UIBlockValue>;
  children: Maybe<Array<UiBlockLeafNode>>;
  datasetId: Maybe<Scalars['StrictString']['output']>;
  datasetUploadStatus: Maybe<DatasetUploadStatus>;
  dropdownId: Maybe<Scalars['StrictString']['output']>;
  enabled: Maybe<Scalars['StrictBoolean']['output']>;
  fileTypes: Maybe<Array<Maybe<Scalars['StrictString']['output']>>>;
  id: Scalars['StrictString']['output'];
  itemType: Maybe<Scalars['StrictString']['output']>;
  label: Maybe<Scalars['StrictString']['output']>;
  maxFiles: Maybe<Scalars['StrictInt']['output']>;
  name: Maybe<Scalars['StrictString']['output']>;
  options: Maybe<Array<Maybe<Scalars['StrictString']['output']>>>;
  placeholder: Maybe<Scalars['StrictString']['output']>;
  required: Maybe<Scalars['StrictBoolean']['output']>;
  schemaId: Maybe<Scalars['StrictString']['output']>;
  text: Maybe<Scalars['StrictString']['output']>;
  type: BenchlingAppUiBlockType;
  userDefinedId: Scalars['StrictString']['output'];
  value: Maybe<Scalars['StrictString']['output']>;
}

export interface UncategorizedSampleDefinitionSummaryNode {
  __typename: 'UncategorizedSampleDefinitionSummaryNode';
  discrepancyCount: Scalars['StrictInt']['output'];
  receivedCount: Scalars['StrictInt']['output'];
}

export interface UnitBySymbolNode {
  __typename: 'UnitBySymbolNode';
  symbol: Scalars['StrictString']['output'];
  unit: UnitNode;
}

export interface UnitNode extends CoreObjectArchivableInterface, HasPermissionsInterface {
  __typename: 'UnitNode';
  aliases: Array<Scalars['StrictString']['output']>;
  archiveData: ArchiveDataNode;
  conversionFactor: Scalars['StrictDecimal']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  permissions: PermissionsNode;
  siName: Maybe<SIName>;
  symbol: Scalars['StrictString']['output'];
  unitType: UnitTypeNode;
  versionNumber: Scalars['StrictInt']['output'];
  versions: Array<UnitVersionNode>;
}

export interface UnitTypeNode extends CoreObjectArchivableInterface, HasPermissionsInterface {
  __typename: 'UnitTypeNode';
  archiveData: ArchiveDataNode;
  baseUnit: UnitNode;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  originalFormula: Maybe<Array<FormulaUnitTermNode>>;
  overrideIsConcentration: Maybe<Scalars['StrictBoolean']['output']>;
  overrideIsContainerQuantity: Maybe<Scalars['StrictBoolean']['output']>;
  permissions: PermissionsNode;
  terms: Array<UnitTypeTermNode>;
  units: Array<UnitNode>;
}

export interface UnitTypeTermNode {
  __typename: 'UnitTypeTermNode';
  exponent: Scalars['StrictInt']['output'];
  value: BaseUnitType;
}

export interface UnitVersionNode {
  __typename: 'UnitVersionNode';
  conversionFactor: Scalars['StrictDecimal']['output'];
  versionNumber: Scalars['StrictInt']['output'];
}

export enum UploadFlowType {
  ADD_ROWS_TO_RESULTS_TABLE = 'ADD_ROWS_TO_RESULTS_TABLE',
  BULK_CREATE_AND_REGISTER_ENTITIES = 'BULK_CREATE_AND_REGISTER_ENTITIES',
  BULK_CREATE_ENTITIES = 'BULK_CREATE_ENTITIES',
  BULK_UPDATE_ENTITIES = 'BULK_UPDATE_ENTITIES',
  IMPORT_TRIAL_SAMPLES = 'IMPORT_TRIAL_SAMPLES'
}

export enum UserAccessLevel {
  FULL_ACCESS = 'FULL_ACCESS',
  NO_ACCESS = 'NO_ACCESS',
  READ_ACCESS = 'READ_ACCESS'
}

export interface UserCapabilityNode {
  __typename: 'UserCapabilityNode';
  accessLevel: UserAccessLevel;
  capability: CapabilityNode;
  id: Scalars['StrictString']['output'];
  user: UserNode;
}

export interface UserListingNode {
  __typename: 'UserListingNode';
  total: Scalars['StrictInt']['output'];
  users: Array<UserNode>;
}

export type UserListingOrInaccessibleInfoNode = InaccessibleInfoNode | UserListingNode;

export interface UserListingSearchInput {
  accountStatus?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  capabilityKeys?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  isNotInOrganization?: InputMaybe<Scalars['StrictBoolean']['input']>;
  isNotInTeam?: InputMaybe<Scalars['StrictBoolean']['input']>;
  organizationId?: InputMaybe<Scalars['StrictString']['input']>;
  policyApiIds?: InputMaybe<Array<Scalars['StrictString']['input']>>;
  query: Scalars['StrictString']['input'];
  teamId?: InputMaybe<Scalars['StrictString']['input']>;
}

export interface UserListingSortInput {
  sortDirection: SortDirection;
  sortKey: UserListingSortKey;
}

export enum UserListingSortKey {
  API_KEY_CREATED_AT = 'API_KEY_CREATED_AT',
  EMAIL = 'EMAIL',
  HANDLE = 'HANDLE',
  JOINED_ON = 'JOINED_ON',
  LAST_SEEN = 'LAST_SEEN',
  NAME = 'NAME',
  PASSWORD_LAST_CHANGED_AT = 'PASSWORD_LAST_CHANGED_AT'
}

export interface UserNode extends CreatorInterface, PartyInterface, PrincipalInterface, SearchableInterface {
  __typename: 'UserNode';
  academic: Scalars['StrictBoolean']['output'];
  activeWarehouseLogins: Array<WarehouseLoginNode>;
  apiKey: Maybe<APIKeyNode>;
  avatarUrl: Maybe<Scalars['StrictString']['output']>;
  capabilities: Array<UserCapabilityNode>;
  email: Scalars['StrictString']['output'];
  handle: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  institution: Maybe<InstitutionNode>;
  institutionProjectBackupRecords: Array<InstitutionProjectBackupRecordNode>;
  isBenchlingAdmin: Scalars['StrictBoolean']['output'];
  isTenantAdmin: Scalars['StrictBoolean']['output'];
  joinedOn: Scalars['StrictString']['output'];
  lastSeen: Maybe<Scalars['StrictString']['output']>;
  name: Scalars['StrictString']['output'];
  organizationRoles: Array<OrganizationRoleNode>;
  organizations: Array<OrganizationNode>;
  passwordLastChangedAt: Maybe<Scalars['StrictString']['output']>;
  recommendations: Array<OrganizationNode>;
  referrers: Array<UserNode>;
  suspended: Scalars['StrictBoolean']['output'];
  teamRoles: Array<TeamRoleNode>;
  teams: Array<TeamNode>;
  tenantCollaborations: Array<CollaborationNode>;
  urlIdentifier: Scalars['StrictString']['output'];
  userProjectsListing: PartyPoliceablesListingNode;
  userRegistriesListing: PartyPoliceablesListingNode;
  verified: Scalars['StrictBoolean']['output'];
}


export interface UserNodeuserProjectsListingArgs {
  limitOffsetInput: LimitOffsetInput;
}


export interface UserNodeuserRegistriesListingArgs {
  limitOffsetInput: LimitOffsetInput;
}

export type UserOrInaccessibleInfoNode = InaccessibleInfoNode | UserNode;

export interface ValidEntitiesForFieldPathNode {
  __typename: 'ValidEntitiesForFieldPathNode';
  numValidEntities: Scalars['StrictInt']['output'];
  validEntities: Maybe<Array<RegistryItemInterface>>;
}

export enum ValidationErrorLabel {
  CONSTRAINT_VIOLATION = 'CONSTRAINT_VIOLATION',
  CONSTRAINT_VIOLATION_ACROSS_INTERFACE = 'CONSTRAINT_VIOLATION_ACROSS_INTERFACE',
  INVALID_LINK = 'INVALID_LINK',
  INVALID_MULTIPLE_LINK = 'INVALID_MULTIPLE_LINK',
  INVALID_VALUE = 'INVALID_VALUE',
  ITEM_TYPES_DISALLOWED = 'ITEM_TYPES_DISALLOWED',
  MISSING_REQUIRED = 'MISSING_REQUIRED',
  NON_LOCATION_ITEMS_DISALLOWED = 'NON_LOCATION_ITEMS_DISALLOWED',
  OVER_CAPACITY = 'OVER_CAPACITY',
  UNIQUE_CONSTRAINT_LOCK = 'UNIQUE_CONSTRAINT_LOCK'
}

export interface ValidationErrorRecordNode {
  __typename: 'ValidationErrorRecordNode';
  errorLabel: ValidationErrorLabel;
  id: Scalars['StrictInt']['output'];
  message: Scalars['StrictString']['output'];
  relatedItems: Array<StorableOrRegistryItemOrInaccessibleInfoNode>;
}

export interface ValidationRuleNode extends CoreObjectArchivableInterface, HasConditionInterface, HasPermissionsInterface {
  __typename: 'ValidationRuleNode';
  archiveData: ArchiveDataNode;
  conditionData: ConditionDataNode;
  description: Scalars['StrictString']['output'];
  errorMessage: Maybe<Scalars['StrictString']['output']>;
  evaluatorVersion: Maybe<Scalars['StrictString']['output']>;
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  negateResult: Maybe<Scalars['StrictBoolean']['output']>;
  overridable: Maybe<Scalars['StrictBoolean']['output']>;
  permissions: PermissionsNode;
}

export type ValidationRuleOrInaccessibleInfoNode = InaccessibleInfoNode | ValidationRuleNode;

export interface ValidationStateNode {
  __typename: 'ValidationStateNode';
  id: Scalars['StrictInt']['output'];
  status: AsyncValidationStatus;
  validationErrorRecords: Maybe<Array<ValidationErrorRecordNode>>;
}

export interface VisualHistoryEventMetadataFieldNode {
  __typename: 'VisualHistoryEventMetadataFieldNode';
  name: Scalars['StrictString']['output'];
  value: VisualHistoryEventMetadataFieldValueNode;
}

export interface VisualHistoryEventMetadataFieldTextValueNode {
  __typename: 'VisualHistoryEventMetadataFieldTextValueNode';
  text: Scalars['StrictString']['output'];
}

export type VisualHistoryEventMetadataFieldValueNode = EntityIdNode | EntityVersionIdNode | VisualHistoryEventMetadataFieldTextValueNode | VisualHistorySequenceAlignmentIdNode;

export interface VisualHistoryEventNode {
  __typename: 'VisualHistoryEventNode';
  createdAt: Scalars['StrictString']['output'];
  eventType: VisualHistoryEventType;
  eventVisualization: VisualHistoryPolymerMapNode;
  message: Scalars['StrictString']['output'];
  metadataFields: Array<VisualHistoryEventMetadataFieldNode>;
  resultingEntityVersion: EntityVersionIdNode;
  sourceInfo: Maybe<VisualHistoryEventSourceInfoNode>;
  user: Maybe<ActorOrInaccessibleInfoNode>;
}

export type VisualHistoryEventOrInaccessibleInfoNode = InaccessibleInfoNode | VisualHistoryEventNode;

export interface VisualHistoryEventSourceInfoNode {
  __typename: 'VisualHistoryEventSourceInfoNode';
  inputs: Array<VisualHistoryPolymerInputNode>;
  name: Scalars['StrictString']['output'];
}

export enum VisualHistoryEventType {
  ADD = 'ADD',
  CREATE = 'CREATE',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE'
}

export interface VisualHistoryInputPolymerMapNode {
  __typename: 'VisualHistoryInputPolymerMapNode';
  entityType: Scalars['StrictString']['output'];
  fragment: PolymerFeatureNode;
  length: Maybe<Scalars['StrictInt']['output']>;
  mapType: VisualHistoryPolymerMapType;
  startIndex: Scalars['StrictInt']['output'];
}

export interface VisualHistoryNode {
  __typename: 'VisualHistoryNode';
  entityVersion: EntityVersionIdNode;
  events: Array<VisualHistoryEventNode>;
}

export type VisualHistoryOrInaccessibleInfoNode = InaccessibleInfoNode | VisualHistoryNode;

export interface VisualHistoryPolymerInputNode {
  __typename: 'VisualHistoryPolymerInputNode';
  inputPolymerMap: VisualHistoryInputPolymerMapNode;
  metadataFields: Array<VisualHistoryEventMetadataFieldNode>;
  sourceEntityMetadata: VisualHistoryEventMetadataFieldNode;
}

export interface VisualHistoryPolymerMapNode {
  __typename: 'VisualHistoryPolymerMapNode';
  features: Array<PolymerFeatureNode>;
  length: Scalars['StrictInt']['output'];
  mapType: VisualHistoryPolymerMapType;
  overlays: Array<VisualHistoryPolymerMapOverlayNode>;
  startIndex: Scalars['StrictInt']['output'];
}

export interface VisualHistoryPolymerMapOverlayNode {
  __typename: 'VisualHistoryPolymerMapOverlayNode';
  color: Maybe<Scalars['StrictString']['output']>;
  end: Scalars['StrictInt']['output'];
  start: Scalars['StrictInt']['output'];
  type: VisualHistoryPolymerMapOverlayType;
}

export enum VisualHistoryPolymerMapOverlayType {
  DELETE = 'DELETE',
  INSERT = 'INSERT',
  UPDATE = 'UPDATE'
}

export enum VisualHistoryPolymerMapType {
  CIRCULAR = 'CIRCULAR',
  LINEAR = 'LINEAR'
}

export interface VisualHistorySequenceAlignmentIdNode {
  __typename: 'VisualHistorySequenceAlignmentIdNode';
  alignmentId: Scalars['StrictString']['output'];
  sequenceId: Scalars['StrictString']['output'];
}

export interface WarehouseColumnNode {
  __typename: 'WarehouseColumnNode';
  columnRelationships: Array<WarehouseRelationshipNode>;
  isMulti: Scalars['StrictBoolean']['output'];
  name: Scalars['StrictString']['output'];
  table: WarehouseTableNode;
  type: SqlColumnType;
}

export interface WarehouseInfoNode {
  __typename: 'WarehouseInfoNode';
  ipAllowlist: Array<Scalars['StrictString']['output']>;
  status: Scalars['StrictString']['output'];
}

export interface WarehouseLoginNode {
  __typename: 'WarehouseLoginNode';
  createdAt: Scalars['StrictString']['output'];
}

export interface WarehouseModelListingNode {
  __typename: 'WarehouseModelListingNode';
  warehouseModels: Array<WarehouseModelNode>;
}

export interface WarehouseModelNode {
  __typename: 'WarehouseModelNode';
  schemaName: Scalars['StrictString']['output'];
  tables: Array<WarehouseTableNode>;
}

export interface WarehouseRelationshipNode {
  __typename: 'WarehouseRelationshipNode';
  targetColumn: WarehouseColumnNode;
  type: RelationshipType;
}

export interface WarehouseTableListingNode {
  __typename: 'WarehouseTableListingNode';
  items: Array<WarehouseTableNode>;
}

export interface WarehouseTableNode {
  __typename: 'WarehouseTableNode';
  columns: Array<WarehouseColumnNode>;
  coreTableType: Maybe<CoreTableType>;
  perSchemaTableType: Maybe<PerSchemaTableType>;
  schema: Maybe<SchemaInterface>;
  schemaName: Scalars['StrictString']['output'];
  tableName: Scalars['StrictString']['output'];
}

export interface WebhookConfigurationNode {
  __typename: 'WebhookConfigurationNode';
  endpointPublicKeySet: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  webhookUrl: Scalars['StrictString']['output'];
}

export type WebhookConfigurationOrInaccessibleInfoNode = InaccessibleInfoNode | WebhookConfigurationNode;

export interface WebhookHeaderNode {
  __typename: 'WebhookHeaderNode';
  key: Scalars['StrictString']['output'];
  value: Scalars['StrictString']['output'];
}

export interface WebhookResponseNode {
  __typename: 'WebhookResponseNode';
  id: Scalars['StrictString']['output'];
  response: Scalars['StrictString']['output'];
  responseCode: Scalars['StrictInt']['output'];
  status: SvixResponseStatus;
  timestamp: Scalars['StrictString']['output'];
  truncateLimit: Scalars['StrictInt']['output'];
  truncated: Scalars['StrictBoolean']['output'];
  url: Scalars['StrictString']['output'];
}

export type WebhookResponseOrInaccessibleInfoNode = InaccessibleInfoNode | WebhookResponseNode;

export interface WorkflowNode extends HasAuthorsInterface, SearchableInterface {
  __typename: 'WorkflowNode';
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  description: Maybe<Scalars['StrictString']['output']>;
  editUrl: Scalars['StrictString']['output'];
  folder: Maybe<FolderNode>;
  humanId: Scalars['StrictString']['output'];
  id: Scalars['StrictString']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  source: ProjectNode;
}

export type WorkflowOrInaccessibleInfoNode = InaccessibleInfoNode | WorkflowNode;

export interface WorkflowRelevantItemNode {
  __typename: 'WorkflowRelevantItemNode';
  id: Scalars['StrictString']['output'];
  stageEntriesMentioning: Array<StageEntryMentioningNode>;
  workflow: WorkflowNode;
}

export interface WorklistItemInterface {
  id: Scalars['StrictString']['output'];
}

export type WorklistItemOrInaccessibleInfoNode = BasicFolderItemNode | BatchNode | ComplexPolymerNode | ContainerNode | EquipmentNode | InaccessibleInfoNode | MixtureNode | MoleculeNode | OligoConjugateNode | OligoDuplexNode | PlateNode | ProteinNode | SequenceNode;

export interface WorklistNode extends OwnableInterface, PoliceableInterface, SearchableInterface {
  __typename: 'WorklistNode';
  archivedItems: Array<WorklistItemOrInaccessibleInfoNode>;
  collaboratorsJson: Array<Scalars['JSONScalar']['output']>;
  id: Scalars['StrictString']['output'];
  inaccessibleItems: Array<InaccessibleInfoNode>;
  inheritedCollaborations: Array<CollaborationNode>;
  itemType: Scalars['StrictString']['output'];
  items: Array<WorklistItemOrInaccessibleInfoNode>;
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  ownerInfoJson: Scalars['JSONScalar']['output'];
  ownerJson: Scalars['JSONScalar']['output'];
  permissions: PermissionsNode;
}

export type WorklistOrInaccessibleInfoNode = InaccessibleInfoNode | WorklistNode;

export interface WorksheetNode extends BaseFolderItemInterface, CoreObjectArchivableInterface, HasDisplayIdInterface, HasPermissionsInterface, ReviewableInterface, SearchableInterface, StudyableInterface {
  __typename: 'WorksheetNode';
  archiveData: ArchiveDataNode;
  archiveRecord: Maybe<ArchiveRecordNode>;
  authors: Array<PrincipalInterface>;
  /** @deprecated Use authors instead */
  authorsJson: Array<Scalars['JSONScalar']['output']>;
  createdAt: Scalars['StrictString']['output'];
  displayId: Maybe<Scalars['StrictString']['output']>;
  editUrl: Scalars['StrictString']['output'];
  folder: FolderNode;
  id: Scalars['StrictString']['output'];
  isStudyable: Scalars['StrictBoolean']['output'];
  modifiedAt: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  parentReviewLifecycles: Array<ReviewLifecycleNode>;
  permissions: PermissionsNode;
  relevantConvertedFromItems: Maybe<RelevantItemsNode>;
  relevantItems: RelevantItemsNode;
  review: Maybe<ReviewNode>;
  reviewSource: ProjectNode;
  studies: Array<StudyOrInaccessibleInfoNode>;
  studyAssociations: Array<StudyAssociationNode>;
  tasks: Array<ProcessTaskOrInaccessibleInfoNode>;
  thirdPartyStorageServiceDataJson: Scalars['JSONScalar']['output'];
  /** @deprecated Use permissions from HasPermissionsInterface instead. */
  userPermissionsJson: Scalars['JSONScalar']['output'];
  worksheetStepGroups: Array<WorksheetStepGroupNode>;
}

export type WorksheetOrInaccessibleInfoNode = InaccessibleInfoNode | WorksheetNode;

export interface WorksheetStepGroupNode {
  __typename: 'WorksheetStepGroupNode';
  name: Scalars['StrictString']['output'];
  worksheetSteps: Array<WorksheetStepNode>;
}

export interface WorksheetStepNode {
  __typename: 'WorksheetStepNode';
  creationContextId: Maybe<Scalars['StrictString']['output']>;
  document: DocumentNode;
  tasks: Array<ProcessTaskOrInaccessibleInfoNode>;
  timeOffsetSeconds: Maybe<Scalars['StrictFloat']['output']>;
}

export interface _ProcessSchemaBaseInterface {
  allFields: Scalars['JSONScalar']['output'];
  allFieldsJson: Scalars['JSONScalar']['output'];
  allFieldsNodes: Array<SchemaFieldNode>;
  archiveRecord: Maybe<ArchiveRecordNode>;
  fields: Scalars['JSONScalar']['output'];
  fieldsJson: Scalars['JSONScalar']['output'];
  id: Scalars['StrictString']['output'];
  name: Scalars['StrictString']['output'];
  organization: Scalars['JSONScalar']['output'];
  prefix: Scalars['StrictString']['output'];
  relatedBenchlingApps: Array<BenchlingAppNode>;
  sqlIdentifier: Scalars['StrictString']['output'];
}


export interface _ProcessSchemaBaseInterfaceallFieldsNodesArgs {
  ids?: InputMaybe<Array<Scalars['StrictString']['input']>>;
}
